import * as utils from '@tencent/thumbplayer-utils';
import { stepTimerClassDecorator, KeySystems, tpGetSupportedKeySystemConfig, EvtEmitter, SimpleDefer, logMethodCallDecoratorCreator, ResizeObserver, TaskLoop, LoopMode, checkVolumeValidWithMessage, runValidators, VALIDATE_PASS_RESULT, performanceCostDecoratorCreator, HDR_CAPABILITY, costTimeEmitter, destroyProtectDecorator, once, StepTimer, KernelStepKey, requireModule, mountGlobal, getEventEmitterBinder, getEventTargetBinder, ResizeObserverPolyfilled } from '@tencent/thumbplayer-utils';
export { KeySystems as DrmKeySystems, EvtEmitter, HDR_CAPABILITY, KernelStepKey, LoopMode, ResizeObserver, ResizeObserverPolyfilled, SimpleDefer, StepTimer, TaskLoop, checkVolumeValidWithMessage, costTimeEmitter, destroyProtectDecorator, getEventEmitterBinder, getEventTargetBinder, logMethodCallDecoratorCreator as logMethodCallDecoratorCreater, logMethodCallDecoratorCreator, mountGlobal, once as onceDecorator, performanceCostDecoratorCreator, requireModule, stepTimerClassDecorator } from '@tencent/thumbplayer-utils';
import { _ as _$b } from '@swc/helpers/_/_assert_this_initialized';
import { _ as _$5 } from '@swc/helpers/_/_class_call_check';
import { _ as _$4 } from '@swc/helpers/_/_create_class';
import { _ as _$1 } from '@swc/helpers/_/_define_property';
import { _ as _$g } from '@swc/helpers/_/_get';
import { _ as _$h } from '@swc/helpers/_/_get_prototype_of';
import { _ as _$9 } from '@swc/helpers/_/_inherits';
import { _ as _$2 } from '@swc/helpers/_/_instanceof';
import { _ as _$e } from '@swc/helpers/_/_sliced_to_array';
import { _ as _$a } from '@swc/helpers/_/_create_super';
import { _ as _$7 } from '@swc/helpers/_/_ts_decorate';
import { _ as _$8 } from '@swc/helpers/_/_ts_metadata';
import { _ as _$c } from '@swc/helpers/_/_async_to_generator';
import { _ as _$6 } from '@swc/helpers/_/_object_spread';
import { _ as _$f } from '@swc/helpers/_/_object_spread_props';
import { _ } from '@swc/helpers/_/_to_consumable_array';
import { _ as _$d } from '@swc/helpers/_/_ts_generator';
import { _ as _$3 } from '@swc/helpers/_/_type_of';

/** Promise Finally的polyfill，主要针对chrome<66的移动端内核 */ if (!Promise.prototype.finally) {
    Promise.prototype.finally = function finallyConstructor(callback) {
        var constructor = this.constructor;
        return this.then(function(value) {
            return constructor.resolve(callback()).then(function() {
                return value;
            });
        }, function(reason) {
            return constructor.resolve(callback()).then(function() {
                return constructor.reject(reason);
            });
        });
    };
}

/**
 * 切换清晰度的模式
 */ var SetLevelMode;
(function(SetLevelMode) {
    /** 多video标签预加载切换 */ SetLevelMode["SOFT"] = "soft";
    /** 黑屏重置src切换 */ SetLevelMode["HARD"] = "hard";
    /** 无缝切换（依赖播放库实现） */ SetLevelMode["SMOOTH"] = "smooth";
})(SetLevelMode || (SetLevelMode = {}));
var PlayMode;
/**
 * 播放模式枚举：点播/直播
 */ (function(PlayMode) {
    PlayMode["VOD"] = "vod";
    PlayMode["LIVE"] = "live";
})(PlayMode || (PlayMode = {}));
/**
 * 表示内核支持所有的格式。（如果是部分支持，则为['mp4']、['flv']此类数组）
 */ var CAN_PLAY_ALL = null;
/**
 * 内部创建的video标签容器的class名
 */ var VIDEO_CONTAINER_CLASS = 'txp_videos_container';
var VIDEO_CONTAINER_STYLE = 'position:absolute;left:0;top:0;width:100%;height:100%;z-index:0;';
var EndState;
/**
 * 播放结束时的状态枚举，用于区分播放结束的原因
 * @enum {string}
 */ (function(EndState) {
    /** 正常结束（到底视频结束点播放完成） */ EndState["NORMAL"] = "normal";
    /** 中断播放（未播放完成时被结束） */ EndState["INTERRUPT"] = "interrupt";
    /** 播放出错 */ EndState["ERROR"] = "error";
})(EndState || (EndState = {}));
var VideoReadyState;
/**
 * video标签的ready state枚举
 */ (function(VideoReadyState) {
    VideoReadyState[VideoReadyState["HAVE_NOTHING"] = 0] = "HAVE_NOTHING";
    VideoReadyState[VideoReadyState["HAVE_METADATA"] = 1] = "HAVE_METADATA";
    VideoReadyState[VideoReadyState["HAVE_CURRENT_DATA"] = 2] = "HAVE_CURRENT_DATA";
    VideoReadyState[VideoReadyState["HAVE_FUTURE_DATA"] = 3] = "HAVE_FUTURE_DATA";
    VideoReadyState[VideoReadyState["HAVE_ENOUGH_DATA"] = 4] = "HAVE_ENOUGH_DATA";
})(VideoReadyState || (VideoReadyState = {}));
var VideoEvts;
/**
 * video标签事件列表
 */ (function(VideoEvts) {
    VideoEvts["loadstart"] = "loadstart";
    VideoEvts["timeupdate"] = "timeupdate";
    VideoEvts["durationchange"] = "durationchange";
    VideoEvts["volumechange"] = "volumechange";
    VideoEvts["canplay"] = "canplay";
    VideoEvts["playing"] = "playing";
    VideoEvts["pause"] = "pause";
    VideoEvts["waiting"] = "waiting";
    VideoEvts["seeking"] = "seeking";
    VideoEvts["seeked"] = "seeked";
    VideoEvts["loadeddata"] = "loadeddata";
    VideoEvts["loadedmetadata"] = "loadedmetadata";
    VideoEvts["ended"] = "ended";
    VideoEvts["error"] = "error";
    VideoEvts["progress"] = "progress";
    VideoEvts["ratechange"] = "ratechange";
    VideoEvts["resize"] = "resize";
    /** wasm FakeVideo 专用 */ VideoEvts["frameRender"] = "videoFrameRender";
})(VideoEvts || (VideoEvts = {}));
var VideoState;
/**
 * 标记播放器状态
 * @enum {string}
 */ (function(VideoState) {
    VideoState["IDLE"] = "idle";
    VideoState["LOAD_START"] = "loadStart";
    /** 当浏览器能够开始播放指定的音频/视频时，但尚未开始播放 */ VideoState["CANPLAY"] = "canplay";
    VideoState["PLAYING"] = "playing";
    VideoState["PAUSE"] = "pause";
    VideoState["SEEKING"] = "seeking";
    VideoState["SEEKED"] = "seeked";
    VideoState["BUFFERING"] = "buffering";
    /** 正常播放结束（包括外部中断播放），如果是播放出错则没有此状态 */ VideoState["END"] = "end";
})(VideoState || (VideoState = {}));
var ErrorCode;
/** @deprecated 后续请使用ErrorBase进行比对 */ (function(ErrorCode) {
    ErrorCode["UNKNOWN_ERR"] = "70011000";
    /** video标签抛出来的错误1：视频取回被终止 */ ErrorCode["MEDIA_ERR_ABORTED"] = "70016001";
    /** video标签抛出来的错误2：H5下载视频错误 */ ErrorCode["MEDIA_ERR_NETWORK"] = "70016002";
    /** video标签抛出来的错误3：H5视频解码错误 */ ErrorCode["MEDIA_ERR_DECODE"] = "70011102";
    /** video标签抛出来的错误4：H5不支持该音视频 */ ErrorCode["MEDIA_ERR_SRC_NOT_SUPPORTED"] = "70011103";
    /**
   * 初次播放超时
   * 注意：目前是判断从开始加载视频到canplay/playing的过程耗时，因此这里的原因可能是
   * 1. 加载视频超时（较大概率）
   * 2. 指定了起播时间，但是无法跳转到对应时间导致超时（目标点无buffer数据等）
   * 3. 其他无法触发canplay/playing事件，但又不报错的情况
   */ ErrorCode["ORG_LOAD_TIMEOUT"] = "70011104";
    /** 状态超过最大停滞时间 */ ErrorCode["STATE_STUCK"] = "70011105";
    /** 播放时间超过最大停滞时间 */ ErrorCode["ORG_PLAY_STUCK_ERR"] = "70011111";
    ErrorCode["NULL_URL"] = "70011112";
    ErrorCode["MISSING_KERNEL"] = "70011113";
    ErrorCode["KERNEL_NOT_SPT"] = "70011114";
})(ErrorCode || (ErrorCode = {}));
var PlaybackErrorCode;
(function(PlaybackErrorCode) {
    PlaybackErrorCode[PlaybackErrorCode["UNKNOWN_ERR"] = 0] = "UNKNOWN_ERR";
    /** video.error code=3 */ PlaybackErrorCode[PlaybackErrorCode["MEDIA_ERR_DECODE"] = 102] = "MEDIA_ERR_DECODE";
    /** video.error code=4 */ PlaybackErrorCode[PlaybackErrorCode["MEDIA_ERR_SRC_NOT_SUPPORTED"] = 103] = "MEDIA_ERR_SRC_NOT_SUPPORTED";
    /** 视频加载超时 */ PlaybackErrorCode[PlaybackErrorCode["ORG_LOAD_TIMEOUT"] = 104] = "ORG_LOAD_TIMEOUT";
    /** 状态超过最大停滞时间 */ PlaybackErrorCode[PlaybackErrorCode["STATE_STUCK"] = 105] = "STATE_STUCK";
    /** 播放时间超过最大停滞时间 */ PlaybackErrorCode[PlaybackErrorCode["ORG_PLAY_STUCK_ERR"] = 111] = "ORG_PLAY_STUCK_ERR";
    /** 没有传入有效的URL */ PlaybackErrorCode[PlaybackErrorCode["NULL_URL"] = 112] = "NULL_URL";
    /** 没有可用内核 */ PlaybackErrorCode[PlaybackErrorCode["MISSING_KERNEL"] = 113] = "MISSING_KERNEL";
    /** 当前环境不支持选定的内核 */ PlaybackErrorCode[PlaybackErrorCode["KERNEL_NOT_SPT"] = 114] = "KERNEL_NOT_SPT";
})(PlaybackErrorCode || (PlaybackErrorCode = {}));
var VideoElementNetworkErrorCode;
(function(VideoElementNetworkErrorCode) {
    /** code=1 */ VideoElementNetworkErrorCode[VideoElementNetworkErrorCode["MEDIA_ERR_ABORTED"] = 1] = "MEDIA_ERR_ABORTED";
    /** code=2 */ VideoElementNetworkErrorCode[VideoElementNetworkErrorCode["MEDIA_ERR_NETWORK"] = 2] = "MEDIA_ERR_NETWORK";
})(VideoElementNetworkErrorCode || (VideoElementNetworkErrorCode = {}));
var ErrorMsg;
/** @deprecated 已迁移至 i18nConfig 中，访问 i18nConfig.core.ERROR_XXX */ (function(ErrorMsg) {
    ErrorMsg["UNKNOWN"] = "未知错误";
    ErrorMsg["XHR_NET"] = "视频获取途中出现问题";
    // PRESET_MODULE_LOAD = 'preset module failed to load',
    ErrorMsg["PRELOAD_VIDEO_TIMEOUT"] = "视频播放超时";
    ErrorMsg["PLAY_STUCK"] = "视频无法继续播放";
    ErrorMsg["LOAD_STREAM_FAIL"] = "视频流获取途中出现问题";
    ErrorMsg["INNER"] = "内部错误";
    ErrorMsg["NULL_URL"] = "传入的地址为空";
})(ErrorMsg || (ErrorMsg = {}));
var PlayEvent;
/**
 * 播放事件定义
 */ (function(PlayEvent) {
    /** 重新播放 */ PlayEvent["RESTART"] = "restart";
    PlayEvent["TIME_UPDATE"] = "timeupdate";
    PlayEvent["METADATA_CHANGE"] = "metadataChange";
    PlayEvent["RATE_CHANGE"] = "rateChange";
    PlayEvent["VOLUME_CHANGE"] = "volumeChange";
    PlayEvent["DURATION_CHANGE"] = "durationChange";
    /** 自动播放被阻止 */ PlayEvent["AUTOPLAY_BLOCKED"] = "autoplayBlocked";
    /** 加载进度变化时（只有mse模式下有自定义加载，才会发出此事件） */ PlayEvent["LOAD_PROGRESS"] = "loadProgress";
    PlayEvent["STATE_CHANGE"] = "stateChange";
    /** 是否是否首次开播(即使当前播放列表有多个视频，也只有一次此事件，而且一定是看到画面) */ PlayEvent["FIRST_PLAYING"] = "firstPlaying";
    /** 每一段播放结束 */ PlayEvent["VIDEONODE_PLAY_OVER"] = "videoNodePlayOver";
    /** 每一段视频开始播放时候（可能并未看到画面，只是切到此视频开始加载） */ PlayEvent["VIDEONODE_START_PLAY"] = "videoNodeStartPlay";
    /** 每一段视频是否首次开播(一定是看到画面) */ PlayEvent["VIDEONODE_FIRST_PLAYING"] = "videoNodeFirstPlaying";
    /** 每一段视频准备播放（player列表的当前索引变化）* */ PlayEvent["VIDEONODE_CHANGE"] = "videoNodeChange";
    /** 播放列表发生变化（每次列表变化，都只是变化当前播放地址后面的列表） */ PlayEvent["LIST_CHANGE"] = "listChange";
    /** 通知外部是否显示loading动画 */ PlayEvent["SET_LOADING"] = "setLoading";
    /** 列表预加载开始事件，多视频预加载只会通知一次 */ PlayEvent["PRELOAD_START"] = "preloadStart";
    /** 单个视频预加载结束事件，多视频预加载每个视频都会通知 */ PlayEvent["PRELOAD_VIDEONODE_OVER"] = "preloadVideonodeOver";
    /** 单个视频预加载清除事件，多视频预加载每个视频都会通知 */ PlayEvent["PRELOAD_VIDEONODE_CLEAR"] = "preloadVideonodeClear";
    /** 单个视频预加载错误事件，多视频预加载每个视频都会通知 */ PlayEvent["PRELOAD_VIDEONODE_ERROR"] = "preloadVideonodeError";
    /** video标签的buffered属性变化时 */ PlayEvent["VIDEO_BUFFER_CHANGE"] = "videoBufferChange";
    /** 切换清晰度开始 */ PlayEvent["SETLEVEL_START"] = "setLevelStart";
    /** 切换清晰度成功or失败 */ PlayEvent["SETLEVEL_OVER"] = "setLevelOver";
    /** 切换音轨开始 */ PlayEvent["SET_AUDIO_TRACK_START"] = "setAudioTrackStart";
    /** 切换音轨成功or失败 */ PlayEvent["SET_AUDIO_TRACK_OVER"] = "setAudioTrackOver";
    PlayEvent["RESIZE"] = "resize";
    PlayEvent["STOPED"] = "stoped";
    PlayEvent["ERROR"] = "error";
    PlayEvent["RETRY_BACKURL"] = "retryBackUrl";
    /** 视频帧渲染时长（仅特定内核有效，例如wasm内核） */ PlayEvent["VIDEO_FRAME_RENDER"] = "videoFrameRender";
    /** 透传video的事件 */ PlayEvent["ELEMENT_EVTS"] = "elementEvts";
    /** 视频分辨率发生变化 */ PlayEvent["VIDEO_RESIZE"] = "videoResize";
    /** 全屏变化 */ PlayEvent["FULLSCREEN_CHANGE"] = "fullscreenChange";
    /**
   * 全屏状态变化事件
   * 与 FULLSCREEN_CHANGE 的区别是
   * 当 fs -> ffs 请求时，不会抛出退出 fs 的中间态事件
   */ PlayEvent["FULLSCREEN_MODE_CHANGE"] = "fullscreenModeChange";
    /** 播放器容器尺寸变化 */ PlayEvent["CONTAINER_RESIZE"] = "containerResize";
    /** 进入插入流播放 */ PlayEvent["ENTER_INSERT_STREAM"] = "enterInsertStream";
    /** 退出插入流播放 */ PlayEvent["EXIT_INSERT_STREAM"] = "exitInsertStream";
    /** 销毁内核 */ PlayEvent["KERNEL_DESTROY"] = "kernelDestroy";
})(PlayEvent || (PlayEvent = {}));
var PreloadEvent;
/**
 * @ignore
 */ (function(PreloadEvent) {
    /** 开始预加载 */ PreloadEvent["START"] = "START_PRELOAD";
    /**  停止预加载 */ PreloadEvent["STOP"] = "STOP_PRELOAD";
    /** 更新预加载信息 */ PreloadEvent["UPDATE"] = "UPDATE_PRELOAD_INFO";
})(PreloadEvent || (PreloadEvent = {}));
var VideoNodeEvent;
(function(VideoNodeEvent) {
    VideoNodeEvent["TIME_UPDATE"] = "vn_timeupdate";
    VideoNodeEvent["METADATA_CHANGE"] = "vn_metadataChange";
    VideoNodeEvent["VOLUME_CHANGE"] = "vn_volumeChange";
    VideoNodeEvent["DURATION_CHANGE"] = "vn_durationChange";
    VideoNodeEvent["PLAY_PROMISE_CATCHED"] = "vn_playPromiseCatched";
    /** 加载进度变化时（只有mse模式下有自定义加载，才会发出此事件） */ VideoNodeEvent["LOAD_PROGRESS"] = "vn_loadProgress";
    VideoNodeEvent["RATE_CHANGE"] = "vn_rateChange";
    /**
   * 当有数据append到sourcebuffer中时（只有mse模式下有自定义加载，才会发出此事件）
   * @ignore
   */ VideoNodeEvent["BUFFER_APPENDED"] = "vn_bufferAppended";
    VideoNodeEvent["STATE_CHANGE"] = "vn_stateChange";
    VideoNodeEvent["ERROR"] = "vn_error";
    /** videonode触发url重试 */ VideoNodeEvent["RETRY"] = "vn_retry";
    VideoNodeEvent["SET_LOADING"] = "vn_setLoading";
    /** video标签的buffered属性变化时 */ VideoNodeEvent["VIDEO_BUFFER_CHANGE"] = "vn_videoBufferChange";
    /** 切换清晰度开始 */ VideoNodeEvent["SETLEVEL_START"] = "vn_setLevelStart";
    /** 切换清晰度成功or失败 */ VideoNodeEvent["SETLEVEL_OVER"] = "vn_setLevelOver";
    /** 切换音轨开始 */ VideoNodeEvent["SET_AUDIO_TRACK_START"] = "vn_setAudioTrackStart";
    /** 切换音轨成功or失败 */ VideoNodeEvent["SET_AUDIO_TRACK_OVER"] = "vn_setAudioTrackOver";
    /** VideoNode中的地址变化 */ VideoNodeEvent["URL_CHANGE"] = "vn_urlChange";
    /** 是否是否首次开播 */ VideoNodeEvent["FIRST_PLAYING"] = "vn_firstPlaying";
    /** 透传video的事件 */ VideoNodeEvent["ELEMENT_EVTS"] = "vn_elementEvts";
    /** videonode正常结束 */ VideoNodeEvent["PLAY_OVER"] = "vn_playOver";
    /** 视频分辨率发生变化 */ VideoNodeEvent["VIDEO_RESIZE"] = "vn_videoResize";
    /** 视频帧渲染时长（仅特定内核有效，例如wasm内核） */ VideoNodeEvent["VIDEO_FRAME_RENDER"] = "vn_videoFrameRender";
    /** 进入插入流播放 */ VideoNodeEvent["ENTER_INSERT_STREAM"] = "enterInsertStream";
    /** 退出插入流播放 */ VideoNodeEvent["EXIT_INSERT_STREAM"] = "exitInsertStream";
})(VideoNodeEvent || (VideoNodeEvent = {}));
var PauseType;
/**
 * @ignore
 */ (function(PauseType) {
    PauseType["USER"] = "user";
    PauseType["INNER"] = "inner";
    PauseType["SYS"] = "sys";
})(PauseType || (PauseType = {}));
var PlayerLogLevel;
/** 开启播放器的日志等级 */ (function(PlayerLogLevel) {
    /** 不打开日志 */ PlayerLogLevel[PlayerLogLevel["NONE"] = 0] = "NONE";
    /** 开启core的日志 */ PlayerLogLevel[PlayerLogLevel["CORE"] = 1] = "CORE";
    /** 开启内核日志 */ PlayerLogLevel[PlayerLogLevel["KERNEL"] = 2] = "KERNEL";
})(PlayerLogLevel || (PlayerLogLevel = {}));
var PreloadType;
/**
 * 预加载策略类型
 */ (function(PreloadType) {
    /** 仅加载视频头部数据，最小流量消耗 */ PreloadType["META_DATA"] = "metadata";
    /** 由浏览器自行决定加载数据大小，仅赋值src属性 */ PreloadType["AUTO"] = "auto";
    /** 由浏览器自行决定加载数据大小，同时调用HTMLVideoElement的load()接口，可能会加载整个视频，属于最大流量消耗 */ PreloadType["AUTO_LOAD"] = "autoLoad";
})(PreloadType || (PreloadType = {}));
var Codec;
/** @deprecated codec枚举 */ (function(Codec) {
    Codec[Codec["H264"] = 0] = "H264";
    Codec[Codec["H265"] = 1] = "H265";
    Codec[Codec["AV1"] = 2] = "AV1";
})(Codec || (Codec = {}));
var VideoCodec;
/** 视频codec枚举 */ (function(VideoCodec) {
    /** 未知编码 */ VideoCodec["UNKNOWN"] = "unknown";
    VideoCodec["H264"] = "h264";
    VideoCodec["H265"] = "h265";
    VideoCodec["H266"] = "h266";
    VideoCodec["VP8"] = "vp8";
    VideoCodec["VP9"] = "vp9";
    VideoCodec["AV1"] = "av1";
    VideoCodec["DOLBY_VISION"] = "dolbyVision";
})(VideoCodec || (VideoCodec = {}));
var AudioCodec;
/** 音频codec枚举 */ (function(AudioCodec) {
    AudioCodec["AAC"] = "aac";
    AudioCodec["OPUS"] = "opus";
    // 名字暂定
    AudioCodec["AVS3A"] = "avs3a";
    AudioCodec["UNKNOWN"] = "unknown";
})(AudioCodec || (AudioCodec = {}));
var ContainerFormat;
/** 封装容器枚举 */ (function(ContainerFormat) {
    ContainerFormat["MPEG_TS"] = "mpegts";
    ContainerFormat["FMP4"] = "fmp4";
    ContainerFormat["MP4"] = "mp4";
})(ContainerFormat || (ContainerFormat = {}));
var VideoElementState;
/**
 * video标签的状态：被占用/被释放
 */ (function(VideoElementState) {
    VideoElementState["FREE"] = "0";
    VideoElementState["USED"] = "1";
})(VideoElementState || (VideoElementState = {}));
var CDN_PATH_PREFIX = 'https://vm.gtimg.cn/thumbplayer/';
var CacheSizeKey;
(function(CacheSizeKey) {
    CacheSizeKey["DEMUX"] = "demux_cache_size";
})(CacheSizeKey || (CacheSizeKey = {}));
var DrmType;
(function(DrmType) {
    DrmType["FAIRPLAY"] = "fairplay";
    DrmType["WIDEVINE"] = "widevine";
    DrmType["PLAYREADY"] = "playready";
    DrmType["CHACHA"] = "chacha";
    DrmType["NONE"] = "none";
})(DrmType || (DrmType = {}));
var VideoType;
/** 可播放格式能力枚举 */ (function(VideoType) {
    VideoType["HLS"] = "hls";
    VideoType["MP4"] = "mp4";
    VideoType["MOV"] = "mov";
    VideoType["FLV"] = "flv";
    VideoType["WEBRTC"] = "webrtc";
    VideoType["AVI"] = "avi";
    VideoType["MPEG"] = "mpeg";
    VideoType["WEBM"] = "webm";
    VideoType["OGG"] = "ogg";
    VideoType["OTHER"] = "other";
})(VideoType || (VideoType = {}));
var KernelName;
(function(KernelName) {
    KernelName["ORIGIN"] = "origin";
    KernelName["DEMUX_2_FMP4"] = "demux2fmp4";
    KernelName["FLV_JS"] = "flv.js";
    KernelName["HLS_JS"] = "hls.js";
    KernelName["WASM"] = "wasm";
    /** 用于灰度audiovivid的内核版本 */ KernelName["WASM_AUDIOVIVID"] = "wasmAudiovivid";
    KernelName["WEBRTC"] = "webrtc";
    KernelName["ELECTRON"] = "electron";
})(KernelName || (KernelName = {}));
var CoreStepKey;
(function(CoreStepKey) {
    /** 选择，创建内核 */ CoreStepKey["SEL_KERNEL"] = "selKernel";
    /** drm license请求前设置 */ CoreStepKey["LIC_REQ_SET"] = "licReqSet";
    /** drm license请求 */ CoreStepKey["LIC_REQ"] = "licReq";
    /** drm license请求后设置 */ CoreStepKey["LIC_RES_SET"] = "licResSet";
})(CoreStepKey || (CoreStepKey = {}));
var AudioTrackErrorMsg;
/** 音轨相关的错误文案 */ (function(AudioTrackErrorMsg) {
    AudioTrackErrorMsg["KERNEL_NOT_EXISTS"] = "kernel not exists";
    AudioTrackErrorMsg["NOT_SUPPORT"] = "not support";
    AudioTrackErrorMsg["STATE_INVALID"] = "state invalid";
})(AudioTrackErrorMsg || (AudioTrackErrorMsg = {}));
var TPColorPrimaries;
(function(TPColorPrimaries) {
    TPColorPrimaries["BT709"] = "bt709";
    TPColorPrimaries["BT601"] = "bt601";
    TPColorPrimaries["BT2020"] = "bt2020";
    TPColorPrimaries["BT2100"] = "bt2100";
})(TPColorPrimaries || (TPColorPrimaries = {}));
var TPTransferCharacteristics;
(function(TPTransferCharacteristics) {
    TPTransferCharacteristics["BT709"] = "bt709";
    TPTransferCharacteristics["BT601"] = "bt601";
    TPTransferCharacteristics["GAMMA22"] = "gamma2.2";
    TPTransferCharacteristics["GAMMA28"] = "gamma2.8";
    TPTransferCharacteristics["SRGB"] = "sRGB";
    TPTransferCharacteristics["BT2020"] = "bt2020";
    TPTransferCharacteristics["BT2100PQ"] = "bt2100-pq";
    TPTransferCharacteristics["BT2100HLG"] = "bt2100-hlg";
})(TPTransferCharacteristics || (TPTransferCharacteristics = {}));

/**
 * 默认的 i18n 文案配置
 */ var defaultI18nConfig = {
    common: {},
    core: {
        // Internal Error
        ERROR_MSG_UNKNOWN: '未知错误',
        ERROR_XHR_NET: '视频获取途中出现问题',
        ERROR_PRELOAD_VIDEO_TIMEOUT: '加载视频超时',
        ERROR_INNER: '视频无法继续播放',
        ERROR_LOAD_STREAM_FAIL: '视频流获取途中出现问题',
        ERROR_PLAY_STUCK: '播放缓冲出错',
        ERROR_NULL_URL: '传入的地址为空',
        // <video/> Error
        ERROR_MEDIA_ERR_ABORTED: '视频获取被终止',
        ERROR_MEDIA_ERR_NETWORK: '下载视频发生错误',
        ERROR_MEDIA_ERR_DECODE: '尝试解码出错',
        ERROR_MEDIA_ERR_SRC_NOT_SUPPORTED: '浏览器不支持该音视频',
        // KernelProxy Error
        ERROR_KERNEL_NOT_FOUND: '切换清晰度时找不到对应内核',
        // check-player-status.ts
        ERROR_STATUS_NOT_INITIALIZED: '播放器尚未初始化',
        ERROR_STATUS_NOT_PLAYING: '播放未开始',
        ERROR_STATUS_EMPTY_URL: '切换目标视频地址为空',
        ERROR_STATUS_VIDEO_INFO: '找不到当前播放信息',
        ERROR_STATUS_PLAYTIME_CHECK: '播放未开始',
        ERROR_STATUS_CLOSE_TO_END: '播放即将结束',
        ERROR_STATUS_TARGET_UNCHANGED: '切换的视频地址没有变化',
        ERROR_SETLEVEL_INPLAYING: '，请播放中切换',
        // DRM
        ERROR_DRM_UNKNOWN: '未知错误',
        ERROR_DRM_LICENSE_NOT_EXIST: '视频资源已加密，但未配置解密证书地址',
        ERROR_DRM_KEY_SYS_NOT_REQUESTED: '视频资源已加密，但尚未请求CDM',
        ERROR_DRM_KEY_NOT_EXIST: '视频资源已加密，但尚未获取到MediaKey',
        ERROR_DRM_KEY_SESSION_NOT_EXIST: '视频资源已加密，但CDM',
        ERROR_DRM_INIT_DATA_EMPTY: '视频资源已加密，但事件信息中没有用于创建请求的 initData',
        ERROR_DRM_KEY_SESSION_REQUEST_FAILED: '视频资源已加密，但 CDM Session 请求失败',
        ERROR_DRM_KEY_SYS_NOT_SUPPORTED: '$0 不支持',
        ERROR_DRM_KEY_SYS_ACCESS_FAILED: '访问CDM失败, keySystem $0',
        ERROR_DRM_KEY_SESSION_CREATION_FAILED: 'CDM Session 初始化失败',
        ERROR_DRM_HDCP: '你可能链接了不支持HDCP标准的显示器',
        ERROR_DRM_KEY_INTERNAL: '内部错误',
        ERROR_DRM_KEY_EXPIRED: 'MediaKey 已过期',
        ERROR_DRM_KEY_RELEASED: 'MediaKey 已从CDM中注销',
        ERROR_DRM_MEDIA_KEYS_SET_FAILED: 'failed to set media keys',
        ERROR_DRM_KEY_SESSION_UPDATE_FAILED: 'CDM Session 更新失败，请检查证书解析',
        ERROR_DRM_LICENSE_REQUEST_FAILED: '证书请求失败 $0',
        ERROR_DRM_FPS_SET_KEY_FAILED: 'Webkit MediaKey创建失败',
        ERROR_DRM_FPS_CERTIFICATE_NOT_EXIST: '视频资源已加密，但 Fairplay 服务端证书未配置',
        ERROR_DRM_EME_MEDIA_KEYS_SETUP_TIMEOUT: 'EME MediaKeys 初始化超时'
    }
};
/**
 * i18n 文案配置，可通过文案字符串 / 文案生成函数来定制文案内容
 */ var i18nConfig = defaultI18nConfig;

var lsTool = {
    getData: utils.getLocalStorage,
    setData: utils.setLocalStorage,
    delData: utils.delLocalStorage
};
/** @deprecated 为了兼容某些插件用引入thumbplayer-core的日志函数保留空函数 */ function logTool() {}
var videoTool = {
    getBuffered: utils.tpGetVideoBuffered,
    checkTimeInBuffer: utils.tpCheckTimeInBuffer,
    clear: utils.tpClearVideoElement,
    destroyElement: utils.tpDestroyVideoElement,
    captureVideo: utils.tpCaptureVideoElement,
    resizeElement: utils.tpResizeVideoElement,
    appendElement: utils.tpAppendVideoElement,
    removeElement: utils.tpRemoveVideoElement,
    setElementFitType: utils.tpSetVideoElementFitType,
    isAutoPlayBlockedMessage: utils.isAutoPlayBlockedMessage,
    supportSameTimePlay: utils.supportSameTimePlay,
    cannotDetectAutoPlayBlock: utils.cannotDetectAutoPlayBlock,
    supportMediaFragmentsURISpec: utils.supportMediaFragmentsURISpec,
    getVideoPlaybackQuality: utils.getVideoPlaybackQuality,
    supportMSE: utils.supportMSE,
    supportVideoFormat: utils.supportVideoFormat,
    supportAV1: utils.supportAV1,
    supportHevc: utils.supportHevc,
    supportO266: utils.supportO266,
    supportHEVCMain10: utils.supportHEVCMain10,
    isVideoCanPlayType: utils.isVideoCanPlayType,
    isMediaSourceTypeSupported: utils.supportMediaSourceType,
    isMediaCapabilitiesTypeSupported: utils.supportMediaCapabilitiesType,
    isHDRSupported: utils.supportHDR,
    isDolbyVisionSupported: utils.supportDolbyVision,
    isDolbyAtomsSupported: utils.supportDolbyAtoms,
    getMediaSource: utils.getMediaSource,
    isEncryptionSupported: utils.supportEncryption,
    supportWidevine: utils.supportWidevine,
    supportFairplay: utils.supportFairplay,
    supportWebGL: utils.supportWebGL,
    isWebRTCSupported: utils.supportWebRTC,
    isPositionBuffered: utils.isVideoElementBufferedOnPos,
    getNextBufferedStart: utils.getVideoElementNextBufferedStart,
    getLastBufferedEnd: utils.getVideoElementLastBufferedEnd,
    isHardwareAccelerated: utils.isHardwareAccelerated,
    collectGPUInfo: utils.collectGPUInfo,
    isWasmSupported: utils.supportWasm,
    isSimdSupported: utils.supportSimd,
    isSupportSABTrails: utils.supportSABTrails,
    isWasmKernelSupported: utils.supportWasmKernel,
    supportFetchStream: utils.supportFetchStream,
    /** @deprecated */ getDefaultMaxBufferTime: function() {
        return 0;
    }
};
var netTool = {
    setJSONPTarget: utils.tpSetJsonpTarget,
    jsonp: utils.tpJsonp,
    img: utils.tpImgReq,
    fetch: utils.tpFetch,
    xhr: utils.tpXhr
};
var domTool = {
    insertStyle: utils.tpInsertStyle,
    loadScript: utils.tpLoadScript,
    attr: utils.tpElementAttr,
    /** @deprecated */ removeAttr: function() {},
    css: utils.tpElementCss,
    append: utils.tpAppendElement,
    /** @deprecated */ prepend: function() {},
    addClass: utils.tpAddClass,
    removeClass: utils.tpRemoveClass,
    hasClass: utils.tpHasClass,
    hide: utils.tpHideElement,
    show: utils.tpShowElement,
    text: utils.tpElementText,
    html: utils.tpElementHtml,
    /** @deprecated */ creatDom: utils.tpCreateDom,
    createDom: utils.tpCreateDom,
    getDomSize: utils.tpGetDomSize,
    createVideoDom: utils.tpCreateVideoDom
};
var jsonTool = {
    safelyStringify: utils.jsonSafelyStringify
};
var cookieTool = {
    set: utils.tpSetCookie,
    get: utils.tpGetCookie,
    del: utils.tpDeleteCookie
};
var hashTool = {
    md5: utils.tpMD5
};
var encodingTool = {
    base64: utils.TPBase64,
    utf8: utils.TPUTF8,
    utf16: utils.TPUTF16,
    hex: utils.TPHex,
    setMask: utils.tpSetMask
};
var stringTool = {
    /** @deprecated */ arrayToString: utils.TPUTF16.fromUint16Array,
    /** @deprecated */ base64ToUint8Array: utils.TPBase64.toUint8Array,
    /** @deprecated */ arrayBufferToBase64: utils.TPBase64.fromUint8Array,
    /** @deprecated */ stringToArray: utils.TPUTF16.toUint16Array
};
var urlTool = {
    shiftAlphabet: utils.shiftAlphabet,
    obfuscatePathComponent: utils.obfuscatePathComponent,
    object2string: utils.tpObject2string,
    convertUrlParam: utils.tpConvertUrlParam,
    getRootDomain: utils.tpGetRootDomain,
    getTopFrameUrl: utils.tpGetTopFrameUrl,
    isInFrame: utils.tpIsInFrame,
    getDomainOfURL: utils.tpGetDomainOfURL,
    getUrlParamByKey: utils.tpGetUrlParamByKey,
    getUrlParams: utils.tpGetUrlParams,
    updateUrlParam: utils.tpUpdateUrlParam,
    getFileName: utils.tpGetFileName,
    getFileExtension: utils.tpGetFileExtension,
    isWebRTCLink: utils.tpIsWebRTCLink,
    removeSearchParams: utils.tpRemoveUrlSearchParams
};
var commonTool = {
    merge: utils.merge,
    supportES6: utils.supportES6,
    isObject: utils.tpIsObject,
    createGUID: utils.tpCreateGUID,
    xss: utils.tpXss,
    findDiscontinuityTimeRangeAtPlaytime: utils.findDiscontinuityTimeRangeAtPlaytime,
    mergeTimeRanges: utils.tpMergeTimeRanges,
    compareVersion: utils.compareVersions,
    formatPlayTime: utils.tpFormatPlayTime,
    dateFormat: utils.tpDateFormat,
    isPageHidden: utils.tpIsPageHidden,
    setTimeoutByRAF: utils.setTimeoutByRAF,
    assignApiToPrototype: utils.assignApiToPrototype,
    /** @deprecated */ base64ToArrayBuffer: function() {}
};
/** ua解析工具 */ var uaTool = utils.getUaTool();
function getMaxAgeStr(time) {
    if (time <= 0) {
        // 如果指定max_age是0的话，则相当于缓存过期无限制，不需要设置max_age=xxx
        return '';
    }
    return "max_age=".concat(Math.min(31536000, time)); // 最大值1年
}

/**
 * 编译 i18n 文案，传入对应参数，这里支持两种参数传入方式
 * 1. 以参数列表的方式进行排序，在字符串中以参数索引方式进行引用
 * ```ts
 * // i18nConfig.zhCN.preview = "试看 $0 秒，前往 $1 观看完整版"
 * compile(i18nConfig.zhCN.preview, '10', '腾讯视频');
 * // => "试看 10 秒，前往腾讯视频观看完整版"
 * ```
 * 2. 以 Record<string, unknown> 的方式进行传入，编译字符串使用设置的对应 keyName 引用
 * ```ts
 * // i18nConfig.zhCN.preview = "试看 $time 秒，前往 $qq_web 观看完整版"
 * compile(i18nConfig.zhCN.preview, { time: 10, qq_web: '腾讯视频' });
 * ```
 * 此外，还支持将 i18n 文案字符串定义为回调函数，参数列表为回调函数中的调用参数
 * // i18nConfig.zhCN.preview = (time, dest) => `试看 ${time} 秒,前往 ${dest} 观看完整版`
 */ function compile(message) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    if (typeof message === 'function') {
        return message.apply(void 0, _(args));
    }
    var result = message;
    for(var i = 0; i < args.length; i++){
        result = result.replace("$".concat(i), String(args[i]));
    }
    return result;
}
var i18nTool = {
    compile: compile
};

/**
 * 对比两个UrlConfig是否是同一个视频节点
 */ function compareUrlConfig(a, b) {
    if (!a || !b) {
        return false;
    }
    // 如果有uid，先对比uid
    if (a.uid && b.uid && a.uid === b.uid) {
        return true;
    }
    // 然后直接对比UrlConfig对象的引用
    if (a === b) {
        return true;
    }
    return false;
}
/**
 * 通过后缀名判断VideoType，用于判断内核
 * @param extension 文件后缀名
 * @returns 返回对应VIDEO_TYPE
 */ function fileExtension2VideoType(extension) {
    var lcExtension = extension === null || extension === void 0 ? void 0 : extension.toLocaleLowerCase();
    // 通过后缀名判断VideoType，用于判断内核
    switch(lcExtension){
        case 'm3u8':
        case 'm3u':
            return VideoType.HLS;
        case 'mp4':
        case 'mov':
            return VideoType.MP4;
        case 'flv':
        case 'f4v':
            return VideoType.FLV;
        case 'avi':
            return VideoType.AVI;
        case 'mpeg':
            return VideoType.MPEG;
        case 'webm':
            return VideoType.WEBM;
        case 'ogg':
            return VideoType.OGG;
    }
    return VideoType.OTHER;
}
/**
 * 检查UrlConfig作为参数时是否是合法的。例如UrlConfig的url参数为空，则会返回错误。
 * @param value 地址信息（或列表）
 * @param kernelName 播放内核名称
 * @returns 如果不能播放返回错误信息，如果可以播放返回undefined
 */ function checkUrlConfigVailed(value) {
    if (!value) {
        return {
            code: ErrorCode.NULL_URL,
            message: compile(i18nConfig.core.ERROR_NULL_URL),
            fatal: true
        };
    }
    // 先拿到所有可以支持的视频类型列表
    var vailed = function(conf) {
        // 先判断是否有空url
        var nullUrl = !conf.url;
        if (nullUrl) {
            return {
                code: ErrorCode.NULL_URL,
                message: compile(i18nConfig.core.ERROR_NULL_URL),
                fatal: true
            };
        }
        return;
    };
    if (_$2(value, Array)) {
        // UrlConfig数组中只要有一个通不过验证，则返回那个错误信息。否则返回void 0
        for(var i = 0, len = value.length; i < len; i++){
            var error = vailed(value[i]);
            if (error) {
                return error;
            }
        }
        return;
    }
    return vailed(value);
}
/**
 * 根据UrlConfig的地址拿到后缀，然后判断视频类型
 * @returns 返回视频类型的字符串，例如mp4，或者hls等
 */ function getUrlConfigVideoType(urlConfig) {
    var url = (urlConfig || {}).url;
    if (!url || url.startsWith('blob:')) {
        return VideoType.OTHER;
    }
    if (url.startsWith('webrtc:')) {
        return VideoType.WEBRTC;
    }
    var extension = urlTool.getFileExtension(url);
    var videoType = fileExtension2VideoType(extension);
    return videoType;
}
/**
 * 从config传入的video标签数组查找未使用的video标签（是否在文档流中）
 * @param videoElements video元素对象
 * @returns 空闲的IVideoElement
 */ function findFreeBaseVideoElement(videoElements) {
    if (!videoElements || videoElements.length === 0) {
        throw new Error('videoElements is null or length equal 0');
    }
    var freeVideoElement = null;
    for(var i = 0; i < videoElements.length; i++){
        var el = videoElements[i];
        if (typeof el.dataset.used === 'undefined' || el.dataset.used === VideoElementState.FREE) {
            freeVideoElement = videoElements[i];
            break;
        }
    }
    if (!freeVideoElement) {
        throw new Error('Unable to find free video element!');
    }
    freeVideoElement.dataset.used = VideoElementState.USED;
    return freeVideoElement;
}
var _obj$3;
/** videonode的事件到播放器事件的映射 */ var videoEvt2PlayerEvtMap = (_obj$3 = {}, _$1(_obj$3, VideoNodeEvent.DURATION_CHANGE, PlayEvent.DURATION_CHANGE), _$1(_obj$3, VideoNodeEvent.VOLUME_CHANGE, PlayEvent.VOLUME_CHANGE), _$1(_obj$3, VideoNodeEvent.ERROR, PlayEvent.ERROR), _$1(_obj$3, VideoNodeEvent.METADATA_CHANGE, PlayEvent.METADATA_CHANGE), _$1(_obj$3, VideoNodeEvent.SETLEVEL_OVER, PlayEvent.SETLEVEL_OVER), _$1(_obj$3, VideoNodeEvent.SETLEVEL_START, PlayEvent.SETLEVEL_START), _$1(_obj$3, VideoNodeEvent.SET_LOADING, PlayEvent.SET_LOADING), _$1(_obj$3, VideoNodeEvent.STATE_CHANGE, PlayEvent.STATE_CHANGE), _$1(_obj$3, VideoNodeEvent.TIME_UPDATE, PlayEvent.TIME_UPDATE), _$1(_obj$3, VideoNodeEvent.VIDEO_BUFFER_CHANGE, PlayEvent.VIDEO_BUFFER_CHANGE), _$1(_obj$3, VideoNodeEvent.LOAD_PROGRESS, PlayEvent.LOAD_PROGRESS), _$1(_obj$3, VideoNodeEvent.FIRST_PLAYING, PlayEvent.VIDEONODE_FIRST_PLAYING), _$1(_obj$3, VideoNodeEvent.RATE_CHANGE, PlayEvent.RATE_CHANGE), _$1(_obj$3, VideoNodeEvent.RETRY, PlayEvent.RETRY_BACKURL), _$1(_obj$3, VideoNodeEvent.ELEMENT_EVTS, PlayEvent.ELEMENT_EVTS), _$1(_obj$3, VideoNodeEvent.PLAY_OVER, PlayEvent.STOPED), _$1(_obj$3, VideoNodeEvent.VIDEO_RESIZE, PlayEvent.VIDEO_RESIZE), _$1(_obj$3, VideoNodeEvent.VIDEO_FRAME_RENDER, PlayEvent.VIDEO_FRAME_RENDER), _$1(_obj$3, VideoNodeEvent.SET_AUDIO_TRACK_OVER, PlayEvent.SET_AUDIO_TRACK_OVER), _$1(_obj$3, VideoNodeEvent.SET_AUDIO_TRACK_START, PlayEvent.SET_AUDIO_TRACK_START), _$1(_obj$3, VideoNodeEvent.ENTER_INSERT_STREAM, PlayEvent.ENTER_INSERT_STREAM), _$1(_obj$3, VideoNodeEvent.EXIT_INSERT_STREAM, PlayEvent.EXIT_INSERT_STREAM), _obj$3);
// VideoNode 抛出这些事件，因为过于频繁，所以不打印
var IGNORE_EVT_TYPE = [
    VideoNodeEvent.TIME_UPDATE,
    VideoNodeEvent.LOAD_PROGRESS,
    VideoNodeEvent.VIDEO_BUFFER_CHANGE,
    VideoNodeEvent.VIDEO_FRAME_RENDER
];
// IVideoElement 抛出这些事件，因为过于频繁，所以不打印
var IGNORE_VIDEO_EVT = [
    VideoEvts.timeupdate,
    VideoEvts.progress,
    VideoEvts.frameRender
];

/** 缓存已经打印的日志字符串 */ var logCache = {};
/** 获取某个播放器实例的日志缓存 */ function getLogCache(instanceId) {
    return logCache[instanceId];
}
/** 清除某个播放器实例的日志缓存 */ function clearLogCache(instanceId) {
    logCache[instanceId] = [];
}
function mallocLogCache(instanceId) {
    if (!logCache[instanceId]) {
        logCache[instanceId] = [];
    }
}
function appendLogCache(instanceId, payload) {
    var _logCache_instanceId;
    (_logCache_instanceId = logCache[instanceId]) === null || _logCache_instanceId === void 0 ? void 0 : _logCache_instanceId.push(payload);
}

var LOG_CACHE_LIMIT = 4000;
var noop = function() {};
var dummyConsole = {
    trace: noop,
    debug: noop,
    info: noop,
    log: noop,
    warn: noop,
    error: noop
};
var LogMode;
(function(LogMode) {
    /** 在控制台中输出 */ LogMode[LogMode["console"] = 1] = "console";
    /** 存入缓存中 */ LogMode[LogMode["cache"] = 2] = "cache";
})(LogMode || (LogMode = {}));

var patchedConsole = Object.assign({}, dummyConsole);
/** 启用全局console的开关函数 */ function enable(levels) {
    (levels || Object.keys(dummyConsole)).forEach(function(key) {
        var _self_console;
        patchedConsole[key] = ((_self_console = self.console) === null || _self_console === void 0 ? void 0 : _self_console[key]) || noop;
    });
}
/**
 * 在console中输出日志
 */ function consoleOutput(level, logPrefix) {
    for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++){
        args[_key - 2] = arguments[_key];
    }
    var _patchedConsole;
    (_patchedConsole = patchedConsole)[level].apply(_patchedConsole, [
        logPrefix
    ].concat(_(args)));
}

/**
 * 是否可以直接输出的日志类型，例如string类型可以直接输出（而不需要stringify）
 */ function checkDirectLogType(logValue) {
    return [
        'string',
        'number',
        'bigint',
        'boolean',
        'symbol',
        'undefined'
    ].indexOf(typeof logValue === "undefined" ? "undefined" : _$3(logValue)) !== -1;
}
/**
 * 将logger.log(a, b, c)中的参数列表进行参数序列化。
 * （没有直接用json.stringify是避免打印出现较多无效字符，例如被[]和""包裹的情况）
 */ function stringifyLogArgs(args) {
    var ignoreKeyList = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
    var argStrArr = [];
    if (args) {
        argStrArr = args.map(function(arg) {
            if (checkDirectLogType(arg)) {
                // 直接输出
                return arg;
            }
            return stringifyLog(arg, ignoreKeyList);
        });
    }
    return argStrArr.join(' ');
}
/**
 * 序列化日志数据为字符串
 */ function stringifyLog(data) {
    var ignoreKeyList = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
    return jsonTool.safelyStringify(data, function(key, logValue) {
        if (ignoreKeyList.indexOf(key) !== -1) {
            // 如果打印的key在黑名单，不打印
            return '';
        }
        if (!logValue || _$2(logValue, Array) || checkDirectLogType(logValue)) {
            return logValue;
        }
        if (typeof logValue === 'function') {
            // 函数不要转换成真实函数字符串
            return '[function]';
        }
        if (logValue.constructor !== Object) {
            // 仅{}和new Object()可以被JSON.stringify展开
            return "".concat(logValue);
        }
        return logValue;
    });
}
/**
 * 下载日志txt文本
 */ function dumpLog(data) {
    var element = document.createElement('a');
    var output = data.join('\n\n');
    element.setAttribute('href', "data:text/plain;charset=utf-8,".concat(encodeURIComponent(output)));
    element.setAttribute('download', "tp-log-".concat(Date.now(), ".txt"));
    element.style.display = 'none';
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
}
function getLogTime() {
    var time = new Date();
    var timeStr = "".concat(time.getHours(), ":").concat(time.getMinutes(), ":").concat(time.getSeconds()) + ".".concat("0000".concat(time.getMilliseconds()).slice(-3));
    return timeStr;
}

/**
 * 绑定播放器实例的日志工具，将日志字符串cache起来使用
 */ var Logger = /*#__PURE__*/ function() {
    function Logger(playerId, scopeName, logModeConfig) {
        _$5(this, Logger);
        /** 日志输出/存储配置 */ _$1(this, "logModeConfig", void 0);
        _$1(this, "playerId", void 0);
        _$1(this, "scopeName", void 0);
        if (typeof playerId !== 'string') {
            // 旧版本的audio-effect/core传入的不是string，先兼容下
            playerId = '0000000000000000';
        }
        this.playerId = playerId;
        this.scopeName = scopeName;
        if (!this.playerId) {
            throw new Error('Missing logger id');
        }
        mallocLogCache(playerId);
        // 默认仅使用log, warn, error的日志
        this.logModeConfig = _$6({
            trace: LogMode.console,
            debug: LogMode.console,
            info: LogMode.console,
            log: LogMode.cache | LogMode.console,
            warn: LogMode.cache | LogMode.console,
            error: LogMode.cache | LogMode.console
        }, logModeConfig);
    }
    _$4(Logger, [
        {
            key: "trace",
            value: // 日志写入接口
            function trace() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                this.callApi.apply(this, [
                    'trace'
                ].concat(_(args)));
            }
        },
        {
            key: "debug",
            value: function debug() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                this.callApi.apply(this, [
                    'debug'
                ].concat(_(args)));
            }
        },
        {
            key: "info",
            value: function info() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                this.callApi.apply(this, [
                    'info'
                ].concat(_(args)));
            }
        },
        {
            key: "log",
            value: function log() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                this.callApi.apply(this, [
                    'log'
                ].concat(_(args)));
            }
        },
        {
            key: "warn",
            value: function warn() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                this.callApi.apply(this, [
                    'warn'
                ].concat(_(args)));
            }
        },
        {
            key: "error",
            value: function error() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                this.callApi.apply(this, [
                    'error'
                ].concat(_(args)));
            }
        },
        {
            key: "cache",
            value: /**
   * 仅cache日志用于上传，不在devtools打印
   */ function cache() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                var level = 'log';
                var logPrefix = this.getLogPrefix();
                this.callApiForCache.apply(this, [
                    level,
                    logPrefix
                ].concat(_(args)));
            }
        },
        {
            key: "getLogPrefix",
            value: function getLogPrefix() {
                var _this = this, playerId = _this.playerId, scopeName = _this.scopeName;
                var logPrefix = "[".concat(playerId.slice(-8), "][").concat(getLogTime(), "]").concat(scopeName ? "[".concat(scopeName, "]") : '');
                return logPrefix;
            }
        },
        {
            key: "callApi",
            value: function callApi(level) {
                for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                    args[_key - 1] = arguments[_key];
                }
                var startTime = performance.now();
                var logPrefix = this.getLogPrefix();
                if (this.logModeConfig[level] & LogMode.console) {
                    consoleOutput.apply(void 0, [
                        level,
                        logPrefix
                    ].concat(_(args)));
                }
                this.callApiForCache.apply(this, [
                    level,
                    logPrefix
                ].concat(_(args)));
                if (typeof Logger.totalTimeCostMap[this.playerId] !== 'undefined') {
                    var rcd = Logger.totalTimeCostMap[this.playerId];
                    rcd.cost += Math.round(performance.now() - startTime);
                    rcd.cnt += 1;
                }
            }
        },
        {
            key: "callApiForCache",
            value: function callApiForCache(level, logPrefix) {
                for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++){
                    args[_key - 2] = arguments[_key];
                }
                if (this.logModeConfig[level] & LogMode.cache) {
                    var payload = "[".concat(level, "]").concat(logPrefix, " ").concat(stringifyLogArgs(args, this.getStringifyLogIgnoreKeys()));
                    if (payload.length >= LOG_CACHE_LIMIT) {
                        payload = "".concat(payload.slice(0, LOG_CACHE_LIMIT), "...(").concat(payload.length, ")");
                    }
                    this.cacheLog(payload);
                }
            }
        },
        {
            key: "getStringifyLogIgnoreKeys",
            value: /**
   * 日志转字符串时候需要忽略的key列表
   */ function getStringifyLogIgnoreKeys() {
                return [
                    'm3u8'
                ];
            }
        },
        {
            key: "cacheLog",
            value: // 慎改，外部有劫持
            function cacheLog(payload) {
                appendLogCache(this.playerId, payload);
            }
        },
        {
            key: "ignoreKeyList",
            get: // 慎改，外部有劫持
            /**
   * 输出日志时忽略某些key值，例如加密相关敏感字端
   */ function get() {
                // chachaParam等关键词为了避免敏感词检索，由外部劫持后定义
                return [];
            }
        }
    ], [
        {
            key: "timeStart",
            value: function timeStart(instanceId) {
                Logger.totalTimeCostMap[instanceId] = {
                    cost: 0,
                    cnt: 0
                };
            }
        },
        {
            key: "timeEnd",
            value: function timeEnd(instanceId) {
                return Logger.totalTimeCostMap[instanceId] || {
                    cost: 0,
                    cnt: 0
                };
            }
        }
    ]);
    return Logger;
}();
_$1(Logger, "totalTimeCostMap", {});
/** @deprecated */ _$1(Logger, "level", 0);

/**
 * @deprecated
 * DRM相关错误码
 */ // eslint-disable-next-line @typescript-eslint/naming-convention
var DRM_ERR_CODE;
(function(DRM_ERR_CODE) {
    DRM_ERR_CODE["UNKNOWN"] = "70090000";
    DRM_ERR_CODE["KEY_SYS_ACCESS_FAILED"] = "70090001";
    DRM_ERR_CODE["KEY_SESSION_CREATION_FAILED"] = "70090002";
    DRM_ERR_CODE["KEY_SYS_NOT_SUPPORTED"] = "70090003";
    DRM_ERR_CODE["KEY_SYS_NOT_REQUESTED"] = "70090004";
    DRM_ERR_CODE["KEY_SESSION_NOT_EXIST"] = "70090005";
    DRM_ERR_CODE["KEY_NOT_EXIST"] = "70090006";
    DRM_ERR_CODE["INIT_DATA_EMPTY"] = "70090007";
    DRM_ERR_CODE["FPS_SET_KEY_FAILED"] = "70090008";
    DRM_ERR_CODE["FPS_CERTIFICATE_NOT_EXIST"] = "7009009";
    DRM_ERR_CODE["HDCP_ERROR"] = "70090010";
    DRM_ERR_CODE["LICENSE_REQUEST_FAILED"] = "70090011";
    DRM_ERR_CODE["LICENSE_NOT_EXIST"] = "70090012";
    DRM_ERR_CODE["KEY_SESSION_REQUEST_FAILED"] = "70090013";
    DRM_ERR_CODE["KEY_SESSION_UPDATE_FAILED"] = "70090014";
    DRM_ERR_CODE["KEY_EXPIRED"] = "70090015";
    DRM_ERR_CODE["KEY_RELEASED"] = "70090016";
    DRM_ERR_CODE["KEY_INTERNAL_ERROR"] = "70090017";
    DRM_ERR_CODE["MEDIA_KEYS_SET_FAILED"] = "70090018";
})(DRM_ERR_CODE || (DRM_ERR_CODE = {}));
var DrmErrorCode;
(function(DrmErrorCode) {
    DrmErrorCode[DrmErrorCode["UNKNOWN"] = 0] = "UNKNOWN";
    DrmErrorCode[DrmErrorCode["KEY_SYS_ACCESS_FAILED"] = 1] = "KEY_SYS_ACCESS_FAILED";
    DrmErrorCode[DrmErrorCode["KEY_SESSION_CREATION_FAILED"] = 2] = "KEY_SESSION_CREATION_FAILED";
    DrmErrorCode[DrmErrorCode["KEY_SYS_NOT_SUPPORTED"] = 3] = "KEY_SYS_NOT_SUPPORTED";
    DrmErrorCode[DrmErrorCode["KEY_SYS_NOT_REQUESTED"] = 4] = "KEY_SYS_NOT_REQUESTED";
    DrmErrorCode[DrmErrorCode["KEY_SESSION_NOT_EXIST"] = 5] = "KEY_SESSION_NOT_EXIST";
    DrmErrorCode[DrmErrorCode["KEY_NOT_EXIST"] = 6] = "KEY_NOT_EXIST";
    DrmErrorCode[DrmErrorCode["INIT_DATA_EMPTY"] = 7] = "INIT_DATA_EMPTY";
    DrmErrorCode[DrmErrorCode["FPS_SET_KEY_FAILED"] = 8] = "FPS_SET_KEY_FAILED";
    DrmErrorCode[DrmErrorCode["FPS_CERTIFICATE_NOT_EXIST"] = 9] = "FPS_CERTIFICATE_NOT_EXIST";
    DrmErrorCode[DrmErrorCode["HDCP_ERROR"] = 10] = "HDCP_ERROR";
    DrmErrorCode[DrmErrorCode["LICENSE_REQUEST_FAILED"] = 11] = "LICENSE_REQUEST_FAILED";
    DrmErrorCode[DrmErrorCode["LICENSE_NOT_EXIST"] = 12] = "LICENSE_NOT_EXIST";
    DrmErrorCode[DrmErrorCode["KEY_SESSION_REQUEST_FAILED"] = 13] = "KEY_SESSION_REQUEST_FAILED";
    DrmErrorCode[DrmErrorCode["KEY_SESSION_UPDATE_FAILED"] = 14] = "KEY_SESSION_UPDATE_FAILED";
    DrmErrorCode[DrmErrorCode["KEY_EXPIRED"] = 15] = "KEY_EXPIRED";
    DrmErrorCode[DrmErrorCode["KEY_RELEASED"] = 16] = "KEY_RELEASED";
    DrmErrorCode[DrmErrorCode["KEY_INTERNAL_ERROR"] = 17] = "KEY_INTERNAL_ERROR";
    DrmErrorCode[DrmErrorCode["MEDIA_KEYS_SET_FAILED"] = 18] = "MEDIA_KEYS_SET_FAILED";
    DrmErrorCode[DrmErrorCode["LICENSE_REQUEST_SETUP_EXCEPTION"] = 19] = "LICENSE_REQUEST_SETUP_EXCEPTION";
    DrmErrorCode[DrmErrorCode["LICENSE_RESPONSE_SETUP_EXCEPTION"] = 20] = "LICENSE_RESPONSE_SETUP_EXCEPTION";
    DrmErrorCode[DrmErrorCode["EME_MEDIA_KEYS_SETUP_TIMEOUT"] = 21] = "EME_MEDIA_KEYS_SETUP_TIMEOUT";
    DrmErrorCode[DrmErrorCode["KEY_SESSION_UPDATE_NO_DATA"] = 22] = "KEY_SESSION_UPDATE_NO_DATA";
})(DrmErrorCode || (DrmErrorCode = {}));

function transformInitData(initData, contentId, certificate) {
    var contentIdBuffer = encodingTool.utf16.toUint16Array(contentId);
    // Format:
    // [initData]
    // [4 byte: idLength]
    // [idLength byte: id]
    // [4 byte:certificateLength]
    // [certificateLength byte: certificate]
    var size = initData.byteLength + 4 + contentIdBuffer.byteLength + 4 + certificate.byteLength;
    var offset = 0;
    var buffer = new ArrayBuffer(size);
    var dataView = new DataView(buffer);
    var initDataArray = new Uint8Array(buffer, offset, initData.byteLength);
    initDataArray.set(initData);
    offset += initDataArray.byteLength;
    dataView.setUint32(offset, contentIdBuffer.byteLength, true);
    offset += 4;
    var idArray = new Uint16Array(buffer, offset, contentIdBuffer.length);
    idArray.set(contentIdBuffer);
    offset += idArray.byteLength;
    dataView.setUint32(offset, certificate.byteLength, true);
    offset += 4;
    var certificateArray = new Uint8Array(buffer, offset, certificate.byteLength);
    certificateArray.set(certificate);
    return new Uint8Array(buffer, 0, buffer.byteLength);
}
function getContentId(initData) {
    var _asString_split__split, _asString_split_, _asString_split;
    var asString = encodingTool.utf16.fromTypeArray(initData);
    var contentId = (_asString_split = asString.split('skd://')) === null || _asString_split === void 0 ? void 0 : (_asString_split_ = _asString_split[1]) === null || _asString_split_ === void 0 ? void 0 : (_asString_split__split = _asString_split_.split('?')) === null || _asString_split__split === void 0 ? void 0 : _asString_split__split[0];
    return contentId;
}

function builtMessageXML(message) {
    return new DOMParser().parseFromString(String.fromCharCode.apply(null, new Uint16Array(message)), 'application/xml');
}
function getChallenge(doc) {
    var el = doc.getElementsByTagName('Challenge')[0];
    try {
        return atob(el.childNodes[0].nodeValue);
    } catch (e) {
        throw 'cannot parse <Challenge> from init message';
    }
}
function builtHeadersFromXML(doc) {
    var headers = {};
    var headerNames = doc.getElementsByTagName('name');
    var headerValues = doc.getElementsByTagName('value');
    if (headerNames.length !== headerValues.length) {
        throw 'header names and values are not match';
    }
    for(var i = 0; i < headerNames.length; i++){
        headers[headerNames[i].childNodes[0].nodeValue] = headerValues[i].childNodes[0].nodeValue;
    }
    return headers;
}

var i18nCore$1 = i18nConfig.core;
var ERR = 'error';
/**
 * DRM模块，支持Apple Fairplay Streaming和Widevine
 *
 * fairplay和widevine均可以通过EME标准接口实现，区别仅在fps需要服务端证书和两者的license请求包数据不同
 *
 * ! fairplay需要在macOS 10.14.4，ios 12.2以上才支持EME接口, webkit需要最低macOS 10.10.3, iOS 11.2
 */ var DRM = /*#__PURE__*/ function(EvtEmitter) {
    _$9(DRM, EvtEmitter);
    var _super = _$a(DRM);
    function DRM(media, config, instanceId) {
        _$5(this, DRM);
        var _this;
        _this = _super.call(this);
        _$1(_$b(_this), "logger", void 0);
        /** 是否处于启用的状态 */ _$1(_$b(_this), "started", false);
        /**
   * 配置信息
   */ _$1(_$b(_this), "config", void 0);
        /**
   * eme mediaKey创建的超时计时器
   *
   * @private
   * @type {(number | null)}
   */ _$1(_$b(_this), "emeMediaKeySetupTimeout", null);
        /**
   * HTML5 video element
   */ _$1(_$b(_this), "media", void 0);
        /**
   * 当前的keySession信息，包含mediaKey，session，initData等
   */ _$1(_$b(_this), "mediaKeyDescriptor", null);
        /**
   * mediaKey promise，给EME实现的版本使用
   */ _$1(_$b(_this), "mediaKeyPromise", null);
        _$1(_$b(_this), "destroyed", false);
        _$1(_$b(_this), "instanceId", void 0);
        /**
   * ====================================================================================
   * 标准EME实现的加密播放流程
   * 1. 创建mediaKey
   * 2. 通过mediaKey创建mediaKeySession，创建session请求信息，同时把mediaKey绑定到video上
   * 3. 监听mediaKeySession的message事件，请求license
   * 4. 更新session解密信息
   */ /**
   * HTML5 video encrypted事件监听
   * @event encrypted
   */ _$1(_$b(_this), "onVideoEncrypted", function(event) {
            _this.logger.log('media encrypted', event);
            if (!_this.mediaKeyPromise) {
                _this.emit(ERR, {
                    code: DrmErrorCode.KEY_SYS_NOT_REQUESTED,
                    message: compile(i18nCore$1.ERROR_DRM_KEY_SYS_NOT_REQUESTED)
                });
                return;
            }
            _this.mediaKeyPromise.then(function() {
                if (!_this.mediaKeyDescriptor) {
                    _this.emit(ERR, {
                        code: DrmErrorCode.KEY_NOT_EXIST,
                        message: compile(i18nCore$1.ERROR_DRM_KEY_NOT_EXIST)
                    });
                    return;
                }
                // 这里主要是避免重复设置mediaKey，但是原则上这个事件应该只派发一次
                if (_this.mediaKeyDescriptor.hasInitialized) {
                    _this.logger.warn('Media key-session has been initialized but requested again');
                    return;
                }
                if (!_this.mediaKeyDescriptor.mediaKeys) {
                    _this.emit(ERR, {
                        code: DrmErrorCode.KEY_NOT_EXIST,
                        message: compile(i18nCore$1.ERROR_DRM_KEY_NOT_EXIST)
                    });
                    return;
                }
                if (!_this.mediaKeyDescriptor.mediaKeySession) {
                    _this.emit(ERR, {
                        code: DrmErrorCode.KEY_SESSION_NOT_EXIST,
                        message: compile(i18nConfig.ERROR_DRM_KEY_SESSION_NOT_EXIST)
                    });
                    return;
                }
                if (!event.initData) {
                    _this.emit(ERR, {
                        code: DrmErrorCode.INIT_DATA_EMPTY,
                        message: compile(i18nCore$1.ERROR_DRM_INIT_DATA_EMPTY)
                    });
                    return;
                }
                _this.mediaKeyDescriptor.mediaKeySession.generateRequest(event.initDataType, event.initData).then(function() {
                    _this.logger.log('media key session request generated');
                }).catch(function() {
                    _this.emit(ERR, {
                        code: DrmErrorCode.KEY_SESSION_REQUEST_FAILED,
                        message: compile(i18nConfig.ERROR_DRM_KEY_SESSION_REQUEST_FAILED)
                    });
                    return;
                });
                _this.mediaKeyDescriptor.initData = event.initData;
                _this.mediaKeyDescriptor.hasInitialized = true;
            });
        });
        /**
   * HTML5 video webkitneededkey事件监听
   */ _$1(_$b(_this), "onVideoWebkitneedkey", function(event) {
            // 通过initData解析contentId，sdk://xxxx的格式
            var contentId = _this.config.fpsCustomContentId(event.initData);
            var cert = DRM.serverCertificate[KeySystems.FairPlayWebKit];
            if (!cert) {
                _this.emit(ERR, {
                    code: DrmErrorCode.FPS_CERTIFICATE_NOT_EXIST,
                    message: compile(i18nCore$1.ERROR_DRM_FPS_CERTIFICATE_NOT_EXIST)
                });
                return;
            }
            // webkit这里需要重新拼接init信息，格式为assetId + certificate
            var initData = _this.config.fpsCustomTransformInitData(event.initData, contentId, cert);
            _this.mediaKeyDescriptor.initData = initData;
            // 避免重复创建session，防止请求的包数据错误
            if (_this.mediaKeyDescriptor.mediaKeySession) {
                _this.logger.warn('Media key-session has already been initialized');
                return;
            }
            _this.mediaKeyDescriptor.mediaKeySession = _this.createSessionWithMediaKey(_this.mediaKeyDescriptor.mediaKeys, initData);
            _this.mediaKeyDescriptor.assetID = contentId;
            _this.mediaKeyDescriptor.mediaKeySession.onwebkitkeyadded = _this.onFPSKeySessionKeyAdded;
            _this.mediaKeyDescriptor.mediaKeySession.onwebkitkeyerror = _this.onFPSKeySessionKeyError;
            _this.mediaKeyDescriptor.mediaKeySession.onwebkitkeymessage = function(event) {
                _this.onMediaKeySessionMessage(_this.mediaKeyDescriptor.mediaKeySession, event);
            };
        });
        _$1(_$b(_this), "onFPSKeySessionKeyAdded", function(_event) {
        // 目前没发现用途，主要是debug
        });
        _$1(_$b(_this), "onFPSKeySessionKeyError", function(_event) {
            var err = _this.mediaKeyDescriptor.mediaKeySession.error;
            if (err.systemCode) {
                var errCodeMap = {
                    // https://developer.apple.com/forums/thread/64204
                    1212433232: [
                        DrmErrorCode.HDCP_ERROR,
                        compile(i18nCore$1.ERROR_DRM_HDCP)
                    ]
                };
                if (errCodeMap[err.systemCode]) {
                    _this.emit(ERR, {
                        code: errCodeMap[err.systemCode][0],
                        message: errCodeMap[err.systemCode][1]
                    });
                }
                return;
            }
            _this.emit(ERR, {
                code: DrmErrorCode.UNKNOWN,
                message: compile(i18nCore$1.ERROR_DRM_UNKNOWN)
            });
        });
        _this.media = media;
        _this.instanceId = instanceId;
        _this.logger = new Logger(_this.instanceId, 'drm');
        _this.config = _$6({
            keySystem: null,
            fpsCustomContentId: getContentId,
            fpsCustomTransformInitData: transformInitData
        }, config);
        return _this;
    }
    _$4(DRM, [
        {
            key: "isFairPlay",
            get: /** 是否是fairplay */ function get() {
                var ks = this.config.keySystem;
                return ks === KeySystems.FairPlay || ks === KeySystems.FairPlayWebKit;
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                this.reset();
                this.removeAllListeners();
                this.logger = null;
                this.destroyed = true;
            }
        },
        {
            key: "configure",
            value: /**
   * 更新配置参数，主要用于更新license地址和服务器证书等
   * @param config 配置参数
   */ function configure(config) {
                var _this = this;
                this.config = _$6({}, this.config, config);
                if (this.config.certificate) {
                    Object.keys(this.config.certificate).forEach(function(key) {
                        DRM.serverCertificate[key] = _this.config.certificate[key];
                    });
                }
            }
        },
        {
            key: "hasStarted",
            value: /**
   * DRM模块是否已启用
   */ function hasStarted() {
                return this.started;
            }
        },
        {
            key: "init",
            value: /**
   * 初始化drm流程，需要外部主动调用
   * @param config 可选配置参数
   */ function init(config) {
                var _this = this;
                return _$c(function() {
                    return _$d(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.reset()
                                ];
                            case 1:
                                _state.sent();
                                if (config) {
                                    _this.configure(config);
                                }
                                if (!(typeof DRM.serverCertificate[_this.config.keySystem] === 'string')) return [
                                    3,
                                    3
                                ];
                                return [
                                    4,
                                    _this.requestServerCertificate(_this.config.keySystem, DRM.serverCertificate[_this.config.keySystem])
                                ];
                            case 2:
                                _state.sent();
                                _state.label = 3;
                            case 3:
                                if (_this.destroyed) {
                                    // 调用方可能在play()以后马上destroy，例如feeds页面快速滚动的情况，
                                    // 如果马上销毁这个init上面两个await的异步操作可能没执行完毕，导致播放器被销毁以后，还在继续往下执行导致报错。
                                    return [
                                        2
                                    ];
                                }
                                _this.bind();
                                _this.logger.log('drm module initialized');
                                _this.logger.cache('drm config', _this.config);
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "reset",
            value: /**
   * 重置。注销事件监听，销毁keySession等。
   * ! setMediaKeys 需要在src为空时调用，否则会抛出异常
   */ function reset() {
                var _this = this;
                return _$c(function() {
                    var _obj, jobs, session;
                    return _$d(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this.started = false;
                                if (!_this.config.keySystem || !_this.mediaKeyDescriptor) return [
                                    2
                                ];
                                _this.clearEMEMediaKeySetupTimeout();
                                // webkit和EME实现有不同的清理逻辑
                                jobs = (_obj = {}, _$1(_obj, KeySystems.FairPlayWebKit, _this.cleanupFPSSession), _$1(_obj, KeySystems.FairPlay, _this.cleanupMediaKeySession), _$1(_obj, KeySystems.Widevine, _this.cleanupMediaKeySession), _$1(_obj, KeySystems.PlayReady, _this.cleanupMediaKeySession), _$1(_obj, KeySystems.PlayReadyHardware, _this.cleanupMediaKeySession), _obj);
                                _this.videoEncryptedEventPicker(false);
                                if (!jobs[_this.config.keySystem]) return [
                                    3,
                                    4
                                ];
                                session = _this.mediaKeyDescriptor.mediaKeySession;
                                _this.mediaKeyPromise = null;
                                _this.mediaKeyDescriptor = null;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    jobs[_this.config.keySystem].call(_this, session)
                                ];
                            case 2:
                                _state.sent();
                                return [
                                    3,
                                    4
                                ];
                            case 3:
                                _state.sent();
                                return [
                                    3,
                                    4
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "bind",
            value: /**
   * 绑定事件，创建mediaKey
   */ function bind() {
                // 如果进来的时候没有keySystem则不执行任何逻辑
                var userKeySystem = this.config.keySystem;
                if (!userKeySystem) {
                    return;
                }
                if (!DRM.isKeySystemSupported(userKeySystem)) {
                    this.logger.warn("当前环境不支持 ".concat(userKeySystem));
                    return;
                }
                this.started = true;
                // 这个promise会在session创建后resolve
                this.mediaKeyPromise = this.createKeySystemAccess(userKeySystem);
                this.videoEncryptedEventPicker(true);
            }
        },
        {
            key: "cleanupMediaKeySession",
            value: /**
   * 标准EME实现的清理方法。
   */ function cleanupMediaKeySession(mediaKeySession) {
                if (!this.media || !mediaKeySession) return Promise.resolve();
                mediaKeySession.onmessage = null;
                mediaKeySession.onkeystatuseschange = null;
                // 不处理close和setMediaKey过程中的报错
                mediaKeySession.close().catch(function() {});
                return this.media.setMediaKeys(null);
            }
        },
        {
            key: "videoEncryptedEventPicker",
            value: /**
   * 根据keySystem监听video的加密事件
   * @param toggle true为监听，false为取消监听
   */ function videoEncryptedEventPicker() {
                var toggle = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
                var _obj;
                var supportedEvents = (_obj = {}, _$1(_obj, KeySystems.FairPlayWebKit, [
                    'webkitneedkey',
                    this.onVideoWebkitneedkey
                ]), _$1(_obj, KeySystems.Widevine, [
                    'encrypted',
                    this.onVideoEncrypted
                ]), _$1(_obj, KeySystems.FairPlay, [
                    'encrypted',
                    this.onVideoEncrypted
                ]), _$1(_obj, KeySystems.PlayReady, [
                    'encrypted',
                    this.onVideoEncrypted
                ]), _$1(_obj, KeySystems.PlayReadyHardware, [
                    'encrypted',
                    this.onVideoEncrypted
                ]), _obj);
                var _supportedEvents_this_config_keySystem = _$e(supportedEvents[this.config.keySystem], 2), event = _supportedEvents_this_config_keySystem[0], handler = _supportedEvents_this_config_keySystem[1];
                if (toggle) this.media.addEventListener(event, handler);
                else this.media.removeEventListener(event, handler);
            }
        },
        {
            key: "createSessionWithMediaKey",
            value: /**
   * 根据keySystem创建mediaKey session
   * @param mediaKey EME mediaKey
   * @param sessionInitData 加密事件抛出的initData，fps webkit使用
   */ function createSessionWithMediaKey(mediaKey, sessionInitData) {
                var _obj;
                var creator = (_obj = {}, _$1(_obj, KeySystems.FairPlayWebKit, this.createFPSWebkitSession), _$1(_obj, KeySystems.Widevine, this.createMediaKeySession), _$1(_obj, KeySystems.FairPlay, this.createMediaKeySession), _$1(_obj, KeySystems.PlayReady, this.createMediaKeySession), _$1(_obj, KeySystems.PlayReadyHardware, this.createMediaKeySession), _obj);
                return creator[this.config.keySystem].call(this, mediaKey, sessionInitData);
            }
        },
        {
            key: "createKeySystemAccess",
            value: /**
   * 创建用于CDM访问的mediaKey
   * @param keySystem 加密类型
   */ function createKeySystemAccess(keySystem) {
                var _obj;
                var creator = (_obj = {}, _$1(_obj, KeySystems.Widevine, this.requestKeySystemAccess), _$1(_obj, KeySystems.FairPlay, this.requestKeySystemAccess), _$1(_obj, KeySystems.FairPlayWebKit, this.requestFPSMediaKeys), _$1(_obj, KeySystems.PlayReady, this.requestKeySystemAccess), _$1(_obj, KeySystems.PlayReadyHardware, this.requestKeySystemAccess), _obj);
                return creator[this.config.keySystem].call(this, keySystem);
            }
        },
        {
            key: "requestLicense",
            value: /**
   * 根据keySystem请求license
   * @param data license请求的数据
   * @param callback license xhr请求的onload回调
   */ function requestLicense(data, callback) {
                if (!this.config.licenseUrl) {
                    this.emit(ERR, {
                        code: DrmErrorCode.LICENSE_NOT_EXIST,
                        message: compile(i18nCore$1.ERROR_DRM_LICENSE_NOT_EXIST)
                    });
                    return;
                }
                var _obj;
                var request = (_obj = {}, _$1(_obj, KeySystems.FairPlayWebKit, this.createFPSLicenseRequest), _$1(_obj, KeySystems.Widevine, this.createWidevineLicenseRequest), _$1(_obj, KeySystems.PlayReady, this.createPlayReadyLicenseRequest), _$1(_obj, KeySystems.FairPlay, this.createFPSLicenseRequest), _$1(_obj, KeySystems.PlayReadyHardware, this.createPlayReadyLicenseRequest), _obj);
                return request[this.config.keySystem].call(this, data, callback);
            }
        },
        {
            key: "requestServerCertificate",
            value: /**
   * 请求服务端证书
   * @param keySystem 加密类型
   * @param url 证书地址
   */ function requestServerCertificate(keySystem, url) {
                return _$c(function() {
                    var data;
                    return _$d(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    netTool.xhr({
                                        method: 'GET',
                                        responseType: 'arraybuffer',
                                        url: url
                                    })
                                ];
                            case 1:
                                data = _state.sent().data;
                                DRM.serverCertificate[keySystem] = new Uint8Array(data);
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "requestKeySystemAccess",
            value: /**
   * 第一步，创建CDM access
   */ function requestKeySystemAccess(keySystem) {
                var _this = this;
                return _$c(function() {
                    var keySystemConfig, keySystemAccess;
                    return _$d(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                // 这里用了默认的codec和contentType，需要允许外部指定
                                keySystemConfig = tpGetSupportedKeySystemConfig(keySystem);
                                if (!keySystemConfig) {
                                    _this.emit(ERR, {
                                        code: DrmErrorCode.KEY_SYS_NOT_SUPPORTED,
                                        message: compile(i18nCore$1.ERROR_DRM_KEY_SYS_NOT_SUPPORTED, keySystem)
                                    });
                                    return [
                                        2
                                    ];
                                }
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    self.navigator.requestMediaKeySystemAccess(keySystem, [
                                        keySystemConfig
                                    ])
                                ];
                            case 2:
                                keySystemAccess = _state.sent();
                                _this.logger.log('media key system access obtained', keySystemAccess.keySystem);
                                return [
                                    2,
                                    _this.onMediaKeySystemObtained(keySystem, keySystemAccess)
                                ];
                            case 3:
                                _state.sent();
                                _this.emit(ERR, {
                                    code: DrmErrorCode.KEY_SYS_ACCESS_FAILED,
                                    message: compile(i18nCore$1.ERROR_DRM_KEY_SYS_ACCESS_FAILED, keySystem)
                                });
                                return [
                                    2
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "onMediaKeySystemObtained",
            value: /**
   * 第二步，创建mediaKey
   */ function onMediaKeySystemObtained(keySystem, mediaKeySystemAccess) {
                var _this = this;
                return _$c(function() {
                    var mediaKeys;
                    return _$d(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this.createEMEMediaKeySetupTimeout(_this.config.emeMediaKeySetupTimeout);
                                return [
                                    4,
                                    mediaKeySystemAccess.createMediaKeys()
                                ];
                            case 1:
                                mediaKeys = _state.sent();
                                _this.logger.log('media keys created');
                                _this.mediaKeyDescriptor = {
                                    hasInitialized: false,
                                    mediaKeySession: null,
                                    mediaKeySystemAccess: mediaKeySystemAccess,
                                    mediaKeys: mediaKeys,
                                    closed: false
                                };
                                _state.label = 2;
                            case 2:
                                _state.trys.push([
                                    2,
                                    5,
                                    ,
                                    6
                                ]);
                                if (!(keySystem === KeySystems.FairPlay)) return [
                                    3,
                                    4
                                ];
                                return [
                                    4,
                                    mediaKeys.setServerCertificate(DRM.serverCertificate[KeySystems.FairPlay])
                                ];
                            case 3:
                                _state.sent();
                                _state.label = 4;
                            case 4:
                                _this.createSessionWithMediaKey(mediaKeys);
                                return [
                                    2,
                                    mediaKeys
                                ];
                            case 5:
                                _state.sent();
                                _this.clearEMEMediaKeySetupTimeout();
                                _this.emit(ERR, {
                                    code: DrmErrorCode.KEY_SESSION_CREATION_FAILED,
                                    message: compile(i18nCore$1.ERROR_DRM_KEY_SESSION_CREATION_FAILED)
                                });
                                return [
                                    2
                                ];
                            case 6:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "createMediaKeySession",
            value: /**
   * 第三步，创建mediaKeySession，监听message事件
   */ function createMediaKeySession(mediaKeys) {
                var _this = this;
                var _keySession_closed;
                // 这里避免重复创建导致session信息错误
                if (this.mediaKeyDescriptor.mediaKeySession) {
                    this.clearEMEMediaKeySetupTimeout();
                    this.logger.warn('Media key-session has already been initialized');
                    return;
                }
                // https://www.w3.org/TR/encrypted-media/#dom-mediakeystatus
                // EME spec中定义的key status
                var keyStatusMap = {
                    'output-restricted': [
                        DrmErrorCode.HDCP_ERROR,
                        compile(i18nCore$1.ERROR_DRM_HDCP)
                    ],
                    'output-downscaled': [
                        DrmErrorCode.HDCP_ERROR,
                        compile(i18nCore$1.ERROR_DRM_HDCP)
                    ],
                    'status-pending': null,
                    'internal-error': [
                        DrmErrorCode.KEY_INTERNAL_ERROR,
                        compile(i18nCore$1.ERROR_DRM_KEY_INTERNAL)
                    ],
                    usable: null,
                    expired: [
                        DrmErrorCode.KEY_EXPIRED,
                        compile(i18nCore$1.ERROR_DRM_KEY_EXPIRED)
                    ],
                    released: [
                        DrmErrorCode.KEY_RELEASED,
                        compile(i18nCore$1.ERROR_DRM_KEY_RELEASED)
                    ]
                };
                var keySession = mediaKeys.createSession();
                this.logger.log('media key session created');
                this.mediaKeyDescriptor.mediaKeySession = keySession;
                if (typeof ((_keySession_closed = keySession.closed) === null || _keySession_closed === void 0 ? void 0 : _keySession_closed.then) === 'function') {
                    keySession.closed.then(function() {
                        if (_this.mediaKeyDescriptor) {
                            _this.logger.log('media key session closed');
                            _this.mediaKeyDescriptor.closed = true;
                        }
                    });
                }
                this.mediaKeyDescriptor.mediaKeySession.onkeystatuseschange = function(e) {
                    var _e_target_keyStatuses_forEach, _e_target_keyStatuses, _e_target;
                    (_e_target = e.target) === null || _e_target === void 0 ? void 0 : (_e_target_keyStatuses = _e_target.keyStatuses) === null || _e_target_keyStatuses === void 0 ? void 0 : (_e_target_keyStatuses_forEach = _e_target_keyStatuses.forEach) === null || _e_target_keyStatuses_forEach === void 0 ? void 0 : _e_target_keyStatuses_forEach.call(_e_target_keyStatuses, function(status) {
                        if (!_this.mediaKeyDescriptor) return;
                        if (keyStatusMap[status]) {
                            var _keyStatusMap_status = _$e(keyStatusMap[status], 2), code = _keyStatusMap_status[0], message = _keyStatusMap_status[1];
                            _this.emit(ERR, {
                                code: code,
                                message: message
                            });
                        }
                    });
                };
                this.mediaKeyDescriptor.mediaKeySession.onmessage = function(event) {
                    _this.onMediaKeySessionMessage(keySession, event);
                };
                this.media.setMediaKeys(mediaKeys).then(function() {
                    _this.clearEMEMediaKeySetupTimeout();
                    _this.logger.log('media keys set');
                }).catch(function(e) {
                    _this.clearEMEMediaKeySetupTimeout();
                    _this.logger.error('media keys set failed', e);
                    _this.emit(ERR, {
                        code: DrmErrorCode.MEDIA_KEYS_SET_FAILED,
                        message: compile(i18nCore$1.ERROR_DRM_MEDIA_KEYS_SET_FAILED)
                    });
                });
            }
        },
        {
            key: "onMediaKeySessionMessage",
            value: /**
   * 第四步，请求license并更新session解密信息
   *
   * 这里webkit和EME的实现相同，两者共用一个方法处理
   */ function onMediaKeySessionMessage(keySession, event) {
                this.logger.log('received media key session message', event);
                // workaround: 20230523 M113版本的Chrome当使用4.10.2652.0版本的Widevine CDM时，会出现密钥失效的问题
                // 这里做一个兼容，从证书protobuf中读取到特征字段后直接抛出错误引导用户重启浏览器进程
                if (this.config.enableChromeM113Workaround && uaTool.browser.chrome && commonTool.compareVersion(uaTool.browser.version, '113') === 0) {
                    try {
                        if (new TextDecoder().decode(event.message).includes('4.10.2652.0')) {
                            this.emit(ERR, {
                                code: DrmErrorCode.KEY_SESSION_UPDATE_FAILED,
                                message: '当前浏览器版本解密模块存在问题导致无法播放, 请尝试升级或重启浏览器进行修复[CDM=4.10.2652.0]',
                                fatal: true
                            });
                            return;
                        }
                    } catch (e) {}
                }
                var _this = this;
                this.requestLicense(event, function() {
                    var _ref = _$c(function(response) {
                        var _this_mediaKeyDescriptor, data, e, _e_code, updatePromise, e1;
                        return _$d(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    if ((_this_mediaKeyDescriptor = _this.mediaKeyDescriptor) === null || _this_mediaKeyDescriptor === void 0 ? void 0 : _this_mediaKeyDescriptor.closed) return [
                                        2
                                    ];
                                    _state.label = 1;
                                case 1:
                                    _state.trys.push([
                                        1,
                                        6,
                                        ,
                                        7
                                    ]);
                                    data = response.data;
                                    if (!_this.config.licenseResponseSetup) return [
                                        3,
                                        5
                                    ];
                                    _state.label = 2;
                                case 2:
                                    _state.trys.push([
                                        2,
                                        4,
                                        ,
                                        5
                                    ]);
                                    _this.timeStart(CoreStepKey.LIC_RES_SET);
                                    return [
                                        4,
                                        _this.config.licenseResponseSetup(data)
                                    ];
                                case 3:
                                    data = _state.sent() || data;
                                    _this.timeEnd(CoreStepKey.LIC_RES_SET);
                                    return [
                                        3,
                                        5
                                    ];
                                case 4:
                                    e = _state.sent();
                                    if (_this.mediaKeyDescriptor.closed) return [
                                        2
                                    ];
                                    _this.emit(ERR, {
                                        code: DrmErrorCode.LICENSE_RESPONSE_SETUP_EXCEPTION,
                                        detail: (_e_code = e.code) !== null && _e_code !== void 0 ? _e_code : 0,
                                        message: compile(i18nCore$1.ERROR_DRM_LICENSE_REQUEST_FAILED)
                                    });
                                    return [
                                        2
                                    ];
                                case 5:
                                    if (!data) {
                                        // 如果无法解析或解析出不合法结果，报错并终止
                                        _this.logger.error('license response is empty', response.data, data);
                                        _this.emit(ERR, {
                                            code: DrmErrorCode.KEY_SESSION_UPDATE_NO_DATA,
                                            message: compile(i18nCore$1.ERROR_DRM_KEY_SESSION_UPDATE_FAILED)
                                        });
                                        return [
                                            2
                                        ];
                                    }
                                    updatePromise = keySession.update(data);
                                    // 兼容一下webkit fps，只有标准EME实现update才会返回promise
                                    updatePromise === null || updatePromise === void 0 ? void 0 : updatePromise.catch(function(err) {
                                        if (_this.mediaKeyDescriptor.closed) return;
                                        _this.logger.error('media key session update failed', err === null || err === void 0 ? void 0 : err.message, err);
                                        _this.emit(ERR, {
                                            code: DrmErrorCode.KEY_SESSION_UPDATE_FAILED,
                                            message: compile(i18nCore$1.ERROR_DRM_KEY_SESSION_UPDATE_FAILED)
                                        });
                                        return;
                                    });
                                    return [
                                        3,
                                        7
                                    ];
                                case 6:
                                    e1 = _state.sent();
                                    if (_this.mediaKeyDescriptor.closed) return [
                                        2
                                    ];
                                    _this.emit(ERR, {
                                        code: DrmErrorCode.LICENSE_REQUEST_FAILED,
                                        detail: e1.code,
                                        message: compile(i18nCore$1.ERROR_DRM_LICENSE_REQUEST_FAILED)
                                    });
                                    return [
                                        3,
                                        7
                                    ];
                                case 7:
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                    return function(response) {
                        return _ref.apply(this, arguments);
                    };
                }());
            }
        },
        {
            key: "createWidevineLicenseRequest",
            value: /**
   * 创建widevine license的xhr请求
   * ! widevine的请求数据为event.message
   */ function createWidevineLicenseRequest(event, callback) {
                var _this = this;
                return _$c(function() {
                    var message, opts;
                    return _$d(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                message = event.message;
                                opts = {
                                    method: 'POST',
                                    responseType: 'arraybuffer',
                                    body: message,
                                    url: _this.config.licenseUrl,
                                    headers: {
                                        'Content-Type': 'application/x-www-form-urlencoded'
                                    }
                                };
                                return [
                                    4,
                                    _this.requestLicenseBySystem(opts, callback)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "createPlayReadyLicenseRequest",
            value: /**
   * 创建playready的license请求
   */ function createPlayReadyLicenseRequest(event, callback) {
                var _this = this;
                return _$c(function() {
                    var message, keyMessageXML, opts;
                    return _$d(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                message = event.message;
                                keyMessageXML = builtMessageXML(message);
                                opts = {
                                    method: 'POST',
                                    responseType: 'arraybuffer',
                                    body: getChallenge(keyMessageXML),
                                    url: _this.config.licenseUrl,
                                    headers: builtHeadersFromXML(keyMessageXML)
                                };
                                return [
                                    4,
                                    _this.requestLicenseBySystem(opts, callback)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "createFPSLicenseRequest",
            value: /**
   * 创建fps license的xhr请求
   * ! fps的基础请求数据为spc=data, 其中data是base64编码的event.message
   */ function createFPSLicenseRequest(event, callback) {
                var _this = this;
                return _$c(function() {
                    var message, spcMessage, opts;
                    return _$d(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                message = event.message;
                                spcMessage = encodeURIComponent(encodingTool.base64.fromUint8Array(message));
                                opts = {
                                    method: 'POST',
                                    responseType: 'arraybuffer',
                                    body: "spc=".concat(spcMessage, "&assetId=").concat(_this.mediaKeyDescriptor.assetID),
                                    url: _this.config.licenseUrl,
                                    headers: {
                                        'Content-Type': 'application/x-www-form-urlencoded'
                                    }
                                };
                                return [
                                    4,
                                    _this.requestLicenseBySystem(opts, callback)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "requestLicenseBySystem",
            value: function requestLicenseBySystem(opts, callback) {
                var _this = this;
                return _$c(function() {
                    var e, _e_code, rsp, error, code;
                    return _$d(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!_this.config.licenseRequestSetup) return [
                                    3,
                                    4
                                ];
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                _this.timeStart(CoreStepKey.LIC_REQ_SET);
                                return [
                                    4,
                                    _this.config.licenseRequestSetup(opts)
                                ];
                            case 2:
                                opts = _state.sent();
                                _this.timeEnd(CoreStepKey.LIC_REQ_SET);
                                return [
                                    3,
                                    4
                                ];
                            case 3:
                                e = _state.sent();
                                _this.emit(ERR, {
                                    code: DrmErrorCode.LICENSE_REQUEST_SETUP_EXCEPTION,
                                    detail: (_e_code = e.code) !== null && _e_code !== void 0 ? _e_code : 0,
                                    message: compile(i18nConfig.core.ERROR_DRM_LICENSE_REQUEST_FAILED)
                                });
                                return [
                                    3,
                                    4
                                ];
                            case 4:
                                _state.trys.push([
                                    4,
                                    6,
                                    ,
                                    7
                                ]);
                                _this.timeStart(CoreStepKey.LIC_REQ);
                                return [
                                    4,
                                    netTool.xhr(opts)
                                ];
                            case 5:
                                rsp = _state.sent();
                                _this.timeEnd(CoreStepKey.LIC_REQ);
                                callback(rsp);
                                return [
                                    3,
                                    7
                                ];
                            case 6:
                                error = _state.sent();
                                code = (error || {}).code;
                                _this.emit(ERR, {
                                    code: DrmErrorCode.LICENSE_REQUEST_FAILED,
                                    detail: code,
                                    message: compile(i18nConfig.core.ERROR_DRM_LICENSE_REQUEST_FAILED)
                                });
                                return [
                                    3,
                                    7
                                ];
                            case 7:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "requestFPSMediaKeys",
            value: /**
   * ====================================================================================
   * Apple Fairplay Webkit标准的加密播放流程
   * 1. 创建webkit mediaKey
   * 2. 绑定mediakey到video，这里需要先绑定后创建session
   * 3. 监听webkitneededkey，拼装initData并创建session
   * 4. 监听session的message事件，创建license请求
   * 5. 更新session的解密信息
   */ /**
   * 创建webkit mediaKey
   */ function requestFPSMediaKeys() {
                var mediaKey = new window.WebKitMediaKeys(KeySystems.FairPlayWebKit);
                // ! fps1.0 need to set key before create session
                this.media.webkitSetMediaKeys(mediaKey);
                // 这里如果设置失败了，在createSession的时候会因为没有mediakey而报错
                this.mediaKeyDescriptor = {
                    mediaKeySession: null,
                    initData: null,
                    hasInitialized: false,
                    mediaKeySystemAccess: null,
                    mediaKeys: this.media.webkitKeys,
                    closed: false
                };
                return Promise.resolve(mediaKey);
            }
        },
        {
            key: "createFPSWebkitSession",
            value: /**
   * 创建webkit mediakey的session
   */ function createFPSWebkitSession(mediaKeys, initData) {
                this.clearEMEMediaKeySetupTimeout();
                // 这里取到的mediaKey是绑定在video标签上的，如果绑定失败了会在这里抛出
                if (!mediaKeys) {
                    this.emit(ERR, {
                        code: DrmErrorCode.FPS_SET_KEY_FAILED,
                        message: compile(i18nCore$1.ERROR_DRM_FPS_SET_KEY_FAILED)
                    });
                    return;
                }
                // 创建session失败时返回为null
                // todo 其实如果sessionId为空也应该判别为失败
                var session = mediaKeys.createSession('video/mp4', initData);
                if (!session) {
                    this.emit(ERR, {
                        code: DrmErrorCode.KEY_SESSION_CREATION_FAILED,
                        message: compile(i18nCore$1.ERROR_DRM_KEY_SESSION_CREATION_FAILED)
                    });
                    return;
                }
                return session;
            }
        },
        {
            key: "cleanupFPSSession",
            value: /**
   * 清理webkit mediakey session
   */ function cleanupFPSSession(mediaKeySession) {
                if (!mediaKeySession) return Promise.resolve();
                this.media.webkitSetMediaKeys(null);
                mediaKeySession.onwebkitkeyadded = null;
                mediaKeySession.onwebkitkeyerror = null;
                mediaKeySession.onwebkitkeymessage = null;
                return Promise.resolve();
            }
        },
        {
            key: "createEMEMediaKeySetupTimeout",
            value: function createEMEMediaKeySetupTimeout() {
                var _this = this;
                var timeout = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 5000;
                this.clearEMEMediaKeySetupTimeout();
                this.emeMediaKeySetupTimeout = window.setTimeout(function() {
                    _this.logger.error('EME media keys setup timeout', _this.media.mediaKeys);
                    _this.emit(ERR, {
                        code: DrmErrorCode.EME_MEDIA_KEYS_SETUP_TIMEOUT,
                        message: compile(i18nCore$1.ERROR_DRM_EME_MEDIA_KEYS_SETUP_TIMEOUT)
                    });
                }, timeout);
            }
        },
        {
            key: "clearEMEMediaKeySetupTimeout",
            value: function clearEMEMediaKeySetupTimeout() {
                if (this.emeMediaKeySetupTimeout) {
                    window.clearTimeout(this.emeMediaKeySetupTimeout);
                    this.emeMediaKeySetupTimeout = null;
                }
            }
        }
    ], [
        {
            key: "isKeySystemSupported",
            value: /**
   * 检测环境是否支持指定的keySystem
   * @param keySystem EME key system name, e.g. com.apple.fps.1_0
   */ function isKeySystemSupported(keySystem) {
                var _self_WebKitMediaKeys, _condition_keySystem;
                var _obj;
                var condition = (_obj = {}, _$1(_obj, KeySystems.FairPlayWebKit, [
                    (_self_WebKitMediaKeys = self.WebKitMediaKeys) === null || _self_WebKitMediaKeys === void 0 ? void 0 : _self_WebKitMediaKeys.isTypeSupported(keySystem, 'video/mp4')
                ]), // 这里只检查EME接口是否存在
                _$1(_obj, KeySystems.FairPlay, [
                    uaTool.browser.safari,
                    self.MediaKeys,
                    self.navigator.requestMediaKeySystemAccess
                ]), _$1(_obj, KeySystems.Widevine, [
                    self.MediaKeys,
                    self.navigator.requestMediaKeySystemAccess
                ]), _$1(_obj, KeySystems.PlayReady, [
                    self.MediaKeys,
                    self.navigator.requestMediaKeySystemAccess
                ]), _$1(_obj, KeySystems.PlayReadyHardware, [
                    self.MediaKeys,
                    self.navigator.requestMediaKeySystemAccess
                ]), _obj);
                return (_condition_keySystem = condition[keySystem]) === null || _condition_keySystem === void 0 ? void 0 : _condition_keySystem.every(Boolean);
            }
        }
    ]);
    return DRM;
}(EvtEmitter);
/**
   * 服务器证书缓存，目前只有fairplay会用到
   */ _$1(DRM, "serverCertificate", {});
DRM = _$7([
    stepTimerClassDecorator,
    _$8("design:type", Function),
    _$8("design:paramtypes", [
        typeof IVideoElement === "undefined" ? Object : IVideoElement,
        typeof Partial === "undefined" ? Object : Partial,
        String
    ])
], DRM);
var DRM$1 = DRM;

var AutoPlayPolicy = /*#__PURE__*/ function() {
    function AutoPlayPolicy(videoElement, extra) {
        _$5(this, AutoPlayPolicy);
        _$1(this, "videoElement", void 0);
        _$1(this, "triggerDefer", void 0);
        _$1(this, "logger", void 0);
        this.logger = new Logger(extra.instanceId, 'AutoPlayPolicy');
        this.videoElement = videoElement;
    }
    _$4(AutoPlayPolicy, [
        {
            key: "userTrigger",
            value: /**
   * 触发自动播放的原理就是调用了play以后马上调用pause，这里会分成两种情况：
   * 1. 如果video.readyState为0（https://developer.mozilla.org/zh-CN/docs/Web/API/HTMLMediaElement/readyState），这里可以
   * 捕获到如下错误，捕获到错误以后触发完成。
   * chrome: The play() request was interrupted by a call to pause()
   * safari/ios: The operation was aborted
   *
   * 2. 如果video.readyState不为0（可能已经设置src或者已经有数据），直接触发完成。
   */ function userTrigger() {
                var _this = this;
                this.triggerDefer = new SimpleDefer();
                this.logger.log('userTrigger(), start');
                var catchTimeoutId;
                // video调用一次play和pause，通常情况会catch住一个video抛出来的interrupt异常，如果被自动播放阻止，则为另一个异常
                var catchHandler = function(e) {
                    if (catchTimeoutId > 0) {
                        clearTimeout(catchTimeoutId);
                        catchTimeoutId = 0;
                    }
                    _this.logger.log('userTrigger(), catch: ', e.name, e.message);
                    if (videoTool.isAutoPlayBlockedMessage(e.message)) {
                        _this.triggerDefer.reject(e);
                    } else {
                        _this.logger.log('userTrigger() over, catched.');
                        _this.triggerDefer.resolve();
                    }
                };
                var playPromise = this.videoElement.play();
                this.videoElement.pause();
                if (this.videoElement.readyState === 0) {
                    // eslint-disable-next-line @typescript-eslint/no-misused-promises
                    if (playPromise) {
                        playPromise.catch(catchHandler);
                    }
                    // 某些浏览器环境video.play没有返回promise或者play后马上pause不会有catch，这种情况用超时来判断
                    catchTimeoutId = window.setTimeout(function() {
                        _this.logger.log('userTrigger() over, timeout.');
                        _this.triggerDefer.resolve();
                    }, 300);
                } else {
                    this.logger.log('userTrigger() over, sync.');
                    var delayTime = uaTool.browser.safari && !uaTool.mobile ? 400 : 0;
                    // 同步触发的话，play马上pause，那么这两个事件是非常接近的。可能会导致外部来不及处理，所以延迟一下。
                    // 但这里调试遇到safari需要点两次播放按钮的问题，具体如下：
                    // 1. setTimeout的delay为0时，safari点播放按钮，状态为loadStart,canplay,playing，此时画面不动，需要再点一次
                    // 2. setTimeout的delay为400ms（实验值）时，safari点播放按钮，状态为loadStart,canplay,playing，可正常起播
                    // 3. 我们把这个setTimeout改成Promise.resolve，发现safari点播放按钮有时候可以成功播放，有时候无法成功播放，
                    // 状态均为 loadStart,canplay,playing,pause,playing
                    // 4. 去掉这个延迟，即不用setTimeout或Promise，也可能出现点一下播放按钮可播放，或者点两下才可播的情况，
                    // 状态均为 loadStart,canplay,playing,pause,playing
                    // 所以这里猜测safari浏览器自动播放被阻止后调用play, pause（autoplay-policy内的逻辑），再调用play（外部调用恢复播放）存在异步
                    // 调用bug，浏览器兼容性暂无法解决，用上述2的方法延迟处理
                    window.setTimeout(function() {
                        _this.triggerDefer.resolve();
                    }, delayTime);
                }
                return this.triggerDefer.promise;
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                this.videoElement = null;
            }
        }
    ]);
    return AutoPlayPolicy;
}();

var BuiltInErrorType;
(function(BuiltInErrorType) {
    /** 原生错误 */ BuiltInErrorType["Native"] = "native";
    /** 网络错误 */ BuiltInErrorType["Network"] = "network";
    /** 加密错误 */ BuiltInErrorType["Encryption"] = "encryption";
    /** 自定义错误 */ BuiltInErrorType["Custom"] = "custom";
})(BuiltInErrorType || (BuiltInErrorType = {}));
var _obj$2;
var ErrorTypeCodeMap = (_obj$2 = {}, _$1(_obj$2, "native", 11), _$1(_obj$2, "network", 16), _$1(_obj$2, "encryption", 90), _$1(_obj$2, "custom", -1), _obj$2);
var MediaElementNetworkErrorCode = [
    1 /** MEDIA_ERR_ABORTED */ ,
    2 /** MEDIA_ERR_NETWORK */ 
];
var MediaElementPlaybackErrorCode = [
    3 /** MEDIA_ERR_DECODE */ ,
    4 /** MEDIA_ERR_SRC_NOT_SUPPORTED */ 
];
var MediaElementNativeDetail;
(function(MediaElementNativeDetail) {
    /** 不支持avc播放 */ MediaElementNativeDetail[MediaElementNativeDetail["BaselineAVCNotSupported"] = 2] = "BaselineAVCNotSupported";
    /** 未开启硬件加速 */ MediaElementNativeDetail[MediaElementNativeDetail["HardwareAcceleratedOff"] = 1] = "HardwareAcceleratedOff";
    /**
   * 服务端返回了200/206。返回的数据无法播放
   */ MediaElementNativeDetail[MediaElementNativeDetail["NetworkOk"] = 4] = "NetworkOk";
    /**
   * 服务端有数据返回（responseStart和responseEnd表示第一个字节时开始，在收到最后一个字节后立即结束）。可能的情况有：
   * 1. 考虑cdn返回403
   * 2. 考虑返回的数据无法播放
   */ MediaElementNativeDetail[MediaElementNativeDetail["NetworkResponsed"] = 8] = "NetworkResponsed";
    /** 握手成功，但服务端未返回任何数据 */ MediaElementNativeDetail[MediaElementNativeDetail["NetworkConnected"] = 16] = "NetworkConnected";
    /** 网络不通 */ MediaElementNativeDetail[MediaElementNativeDetail["NetworkOffline"] = 32] = "NetworkOffline";
})(MediaElementNativeDetail || (MediaElementNativeDetail = {}));

/**
 * 错误基类，兼容已有的IVideoError
 *
 * @export
 * @class ErrorBase
 * @typedef {ErrorBase}
 * @implements {IVideoError}
 */ var ErrorBase = /*#__PURE__*/ function() {
    function ErrorBase(type, config) {
        _$5(this, ErrorBase);
        /** 调试用的错误文案，不作为展示信息 */ _$1(this, "debugMessage", void 0);
        /** 错误文案 */ _$1(this, "message", void 0);
        /** 是否为致命错误 */ _$1(this, "fatal", void 0);
        /** 错误类型 */ _$1(this, "type", void 0);
        /** 主错误码 */ _$1(this, "errorCode", void 0);
        /** 详细错误码 */ _$1(this, "detail", null);
        var code = config.code, detail = config.detail, message = config.message, fatal = config.fatal, debugMessage = config.debugMessage;
        this.type = type;
        this.errorCode = code;
        this.detail = detail !== null && detail !== void 0 ? detail : null;
        this.fatal = fatal !== null && fatal !== void 0 ? fatal : false;
        this.message = message !== null && message !== void 0 ? message : compile(defaultI18nConfig.core.ERROR_MSG_UNKNOWN);
        this.debugMessage = debugMessage;
    }
    _$4(ErrorBase, [
        {
            key: "code",
            get: /** 外显的完整错误码 */ function get() {
                var base = this.type === BuiltInErrorType.Custom ? "".concat(this.errorCode) : "".concat(ThumbPlayerErrorPrefix).concat(ErrorTypeCodeMap[this.type]).concat(patchCode(this.errorCode));
                if (this.detail) {
                    return "".concat(base, ".").concat(this.detail);
                }
                return base;
            }
        },
        {
            key: "equals",
            value: /**
   * 通过code比较两个error是否相同
   */ function equals(other) {
                var strict = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
                if (_$2(other, ErrorBase)) {
                    return this.type === other.type && this.errorCode === other.errorCode && (strict ? this.detail === other.detail : true);
                }
                return this.code === (other === null || other === void 0 ? void 0 : other.code);
            }
        },
        {
            key: "toString",
            value: // log工具，用于序列化错误对象
            function toString() {
                return this.serialize();
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                return this.serialize();
            }
        },
        {
            key: "serialize",
            value: function serialize() {
                var _this_debugMessage, _ref;
                return "error=".concat(this.code, ";fatal=").concat(+this.fatal, ";msg=").concat((_ref = (_this_debugMessage = this.debugMessage) !== null && _this_debugMessage !== void 0 ? _this_debugMessage : this.message) !== null && _ref !== void 0 ? _ref : '');
            }
        }
    ]);
    return ErrorBase;
}();
/** 中台播放器的固定错误码前缀 */ var ThumbPlayerErrorPrefix = '700';
/** string padStart的简化版 */ function patchCode(code) {
    return "000".concat(code).slice(-3);
}

// 历史原因，命名不符合tslint规范，但函数可能已经被业务使用。
var PlayerError = /*#__PURE__*/ function() {
    function PlayerError() {
        _$5(this, PlayerError);
    }
    _$4(PlayerError, null, [
        {
            key: "CustomError",
            value: function CustomError(config) {
                return new ErrorBase(BuiltInErrorType.Custom, config);
            }
        },
        {
            key: "NativeError",
            value: /**
   * 生成原生错误对象，type=11
   *
   * @public
   * @static
   * @param {ErrorConfig} config
   */ function NativeError(config) {
                return new ErrorBase(BuiltInErrorType.Native, config);
            }
        },
        {
            key: "NetworkError",
            value: /**
   * 生成介质网络错误对象，type=16，code分配规则如下：
   * 0-99: 预留为core层面或原生video网络错误
   * 100-199: 预留为hlsjs网络错误
   * 200-299: 预留为flvjs网络错误
   * 300-399: 预留为demux内核网络错误
   * 400-499: 预留为wasm内核网络错误
   * 500-599: 预留为rtc内核网络错误
   * 600-699: 预留为electron内核网络错误
   * 700-999: reserved
   * @public
   * @static
   * @param {ErrorConfig} config
   */ function NetworkError(config) {
                return new ErrorBase(BuiltInErrorType.Network, config);
            }
        },
        {
            key: "EncryptionError",
            value: /**
   * 生成加密错误对象，type=90
   *
   * @public
   * @static
   * @param {ErrorConfig} config
   */ function EncryptionError(config) {
                return new ErrorBase(BuiltInErrorType.Encryption, config);
            }
        }
    ]);
    return PlayerError;
}();

var NetTimingObserver = /*#__PURE__*/ function() {
    function NetTimingObserver() {
        var _this = this;
        _$5(this, NetTimingObserver);
        _$1(this, "originObserver", null);
        _$1(this, "intervalObserverID", 0);
        _$1(this, "isRunningInner", false);
        _$1(this, "urlMap", {});
        _$1(this, "filterPerformanceEntrys", function(entrys) {
            var entryList = entrys.getEntries();
            if (!entryList || entryList.length <= 0) {
                return;
            }
            Object.keys(_this.urlMap).forEach(function(url) {
                var urlItem = _this.urlMap[url];
                if (urlItem.entry) {
                    // 已经被记录了：没有PerformanceObserver时interval监测的始终是performance.getEntrys()的列表，所以检查到一次就ok了
                    return;
                }
                var entry = entryList.find(function(entry) {
                    return entry.name === url;
                });
                if (entry) {
                    var _urlItem_opts_callback, _urlItem_opts;
                    urlItem.entry = entry;
                    (_urlItem_opts_callback = (_urlItem_opts = urlItem.opts).callback) === null || _urlItem_opts_callback === void 0 ? void 0 : _urlItem_opts_callback.call(_urlItem_opts, entry);
                }
            });
        });
    }
    _$4(NetTimingObserver, [
        {
            key: "destroy",
            value: function destroy() {
                this.stop();
                this.urlMap = null;
            }
        },
        {
            key: "start",
            value: function start() {
                if (this.isRunningInner) {
                    return;
                }
                this.isRunningInner = true;
                if (typeof window.PerformanceObserver === 'undefined') {
                    this.observerByInterval();
                } else {
                    this.observerByOrigin();
                }
            }
        },
        {
            key: "stop",
            value: function stop() {
                this.isRunningInner = false;
                if (this.originObserver) {
                    this.originObserver.disconnect();
                    this.originObserver = null;
                }
                if (this.intervalObserverID !== 0) {
                    window.clearInterval(this.intervalObserverID);
                    this.intervalObserverID = 0;
                }
            }
        },
        {
            key: "isRunning",
            get: function get() {
                return this.isRunningInner;
            }
        },
        {
            key: "push",
            value: function push(opts) {
                var url = opts.url;
                this.urlMap[url] = {
                    entry: undefined,
                    opts: opts
                };
            }
        },
        {
            key: "getEntry",
            value: function getEntry(url) {
                var _this_urlMap_url;
                return ((_this_urlMap_url = this.urlMap[url]) === null || _this_urlMap_url === void 0 ? void 0 : _this_urlMap_url.entry) || [];
            }
        },
        {
            key: "remove",
            value: function remove(opts) {
                var _this = this;
                var url = opts.url, removeTag = opts.tag;
                if (removeTag) {
                    // 如果传入了tag，按tag删除
                    Object.keys(this.urlMap).forEach(function(url) {
                        if (_this.urlMap[url].opts.tag === removeTag) {
                            delete _this.urlMap[url];
                        }
                    });
                } else {
                    delete this.urlMap[url];
                }
            }
        },
        {
            key: "observerByOrigin",
            value: function observerByOrigin() {
                this.originObserver = new PerformanceObserver(this.filterPerformanceEntrys);
                this.originObserver.observe({
                    entryTypes: [
                        'resource'
                    ]
                });
            }
        },
        {
            key: "observerByInterval",
            value: function observerByInterval() {
                var _this = this;
                this.intervalObserverID = window.setInterval(function() {
                    _this.filterPerformanceEntrys(performance);
                }, 1000);
            }
        }
    ]);
    return NetTimingObserver;
}();
/**
 * 收集跟视频加载相关的网络信息
 */ var NetTiming = /*#__PURE__*/ function() {
    function NetTiming() {
        _$5(this, NetTiming);
    }
    _$4(NetTiming, null, [
        {
            key: "isSupported",
            value: function isSupported() {
                return 'function' === typeof performance.getEntries;
            }
        },
        {
            key: "observer",
            value: /**
   * 监测某个url的加载。
   */ function observer(instanceId, opts) {
                if (!this.isSupported() || !instanceId || !opts) {
                    return;
                }
                var observer = this.observers[instanceId];
                if (!observer) {
                    observer = new NetTimingObserver();
                    this.observers[instanceId] = observer;
                }
                if (!observer.isRunning) {
                    observer.start();
                }
                observer.push(opts);
            }
        },
        {
            key: "unobserver",
            value: function unobserver(instanceId, opts) {
                var _this_observers_instanceId;
                if (!instanceId || !opts) {
                    return;
                }
                (_this_observers_instanceId = this.observers[instanceId]) === null || _this_observers_instanceId === void 0 ? void 0 : _this_observers_instanceId.remove(opts);
            }
        },
        {
            key: "getEntry",
            value: /**
   * 获得某个url对应的一组监测数据（一个url可能存在多个网络数据，例如重复加载）
   */ function getEntry(instanceId, url) {
                var _this_observers_instanceId;
                if (!instanceId || !url) {
                    return undefined;
                }
                return (_this_observers_instanceId = this.observers[instanceId]) === null || _this_observers_instanceId === void 0 ? void 0 : _this_observers_instanceId.getEntry(url);
            }
        },
        {
            key: "disconnect",
            value: function disconnect(instanceId) {
                if (!instanceId) {
                    return;
                }
                var observer = this.observers[instanceId];
                if (observer) {
                    observer.destroy();
                    delete this.observers[instanceId];
                }
            }
        }
    ]);
    return NetTiming;
}();
_$1(NetTiming, "observers", {});
function getVideoNetworkDetail(currentUrl, instanceId) {
    if (!currentUrl || currentUrl.indexOf('blob:') === 0) {
        // blob地址排除
        return 0;
    }
    var entry = NetTiming.getEntry(instanceId, currentUrl); // ts的PerformanceEntry定义不完整所以as any
    if (!entry) {
        return 0;
    }
    if (entry.responseStatus === 200 || entry.responseStatus === 206) {
        // 测试发现403等情况responseStatus还是0，很奇怪。所以仅用responseStatus判断成功的情况
        return MediaElementNativeDetail.NetworkOk;
    }
    if (0 < entry.responseStart && entry.responseStart <= entry.responseEnd && entry.transferSize > 0) {
        return MediaElementNativeDetail.NetworkResponsed;
    }
    if (0 < entry.connectStart && entry.connectStart <= entry.connectEnd) {
        return MediaElementNativeDetail.NetworkConnected;
    }
    if (navigator.onLine === false) {
        return MediaElementNativeDetail.NetworkOffline;
    }
    // 其他情况，例如地址错误（404，502等）或者 cdn未返回Timing-Allow-Origin的header
    return 0;
}

/**
  * 从各种内核的原始信息中解析出的标准的错误信息
  * @param errorData 各种内核的错误信息
  * @returns  标准化的错误信息
  */ function commonErrorParse(errorData) {
    if (_$2(errorData, ErrorBase)) return errorData;
    if (errorData) {
        var code = errorData.code, message = errorData.message;
        // 检查errorData的错误码是不是tp格式的
        if (/^(700)(\d{2})(\d{3})(\.(\d+))?$/g.test(code)) {
            return errorData;
        }
        return PlayerError.NativeError({
            code: PlaybackErrorCode.UNKNOWN_ERR,
            detail: code,
            message: message || compile(i18nConfig.core.ERROR_MSG_UNKNOWN),
            debugMessage: message
        });
    }
    return PlayerError.NativeError({
        code: PlaybackErrorCode.UNKNOWN_ERR,
        message: compile(i18nConfig.core.ERROR_MSG_UNKNOWN)
    });
}
/**
 * 将 <video /> 标签的抛出的 Error 对象中的 code 状态码转换为对应错误对象
 * 这里因为要考虑 i18n 的可配置，因此不能直接写成枚举，而是要包在函数内以便外部覆盖
 */ function getVideoError(videoTag, instanceId) {
    var _videoTag_error;
    var code = (_videoTag_error = videoTag.error) === null || _videoTag_error === void 0 ? void 0 : _videoTag_error.code;
    var errorCodeMap = {
        1: VideoElementNetworkErrorCode.MEDIA_ERR_ABORTED,
        2: VideoElementNetworkErrorCode.MEDIA_ERR_NETWORK,
        3: PlaybackErrorCode.MEDIA_ERR_DECODE,
        4: PlaybackErrorCode.MEDIA_ERR_SRC_NOT_SUPPORTED
    };
    var messageMap = {
        1: compile(i18nConfig.core.ERROR_MEDIA_ERR_ABORTED),
        2: compile(i18nConfig.core.ERROR_MEDIA_ERR_NETWORK),
        3: compile(i18nConfig.core.ERROR_MEDIA_ERR_DECODE),
        4: compile(i18nConfig.core.ERROR_MEDIA_ERR_SRC_NOT_SUPPORTED)
    };
    var numberCode = +code;
    var message = messageMap[numberCode];
    if (MediaElementNetworkErrorCode.includes(numberCode)) {
        return PlayerError.NetworkError({
            code: errorCodeMap[numberCode],
            fatal: false,
            message: message
        });
    }
    if (MediaElementPlaybackErrorCode.includes(numberCode)) {
        var detail = 0;
        if (!videoTool.isVideoCanPlayType('video/mp4; codecs="avc1.42E01E"')) {
            detail |= MediaElementNativeDetail.BaselineAVCNotSupported;
        }
        if (!videoTool.isHardwareAccelerated()) {
            detail |= MediaElementNativeDetail.HardwareAcceleratedOff;
        }
        if (numberCode === 4 && instanceId) {
            detail |= getVideoNetworkDetail(videoTag.src, instanceId);
        }
        return PlayerError.NativeError({
            code: errorCodeMap[numberCode],
            fatal: false,
            detail: detail,
            message: message
        });
    }
}

var CheckHealth = /*#__PURE__*/ function(EvtEmitter) {
    _$9(CheckHealth, EvtEmitter);
    var _super = _$a(CheckHealth);
    function CheckHealth(vn) {
        _$5(this, CheckHealth);
        var _this;
        _this = _super.call(this);
        _$1(_$b(_this), "videoNode", void 0);
        _$1(_$b(_this), "videoNodeEvtMap", void 0);
        /** 记录当前状态的开始时间戳 */ _$1(_$b(_this), "stateStartTimeStamp", 0);
        /** 上一帧的播放时间点 */ _$1(_$b(_this), "preFramePlaytime", 0);
        /** 已经在playtime无变化时停滞的帧数 */ _$1(_$b(_this), "playtimeStalledFrameCount", 0);
        _this.videoNode = vn;
        _this.setVideoNodeEvts(true);
        return _this;
    }
    _$4(CheckHealth, [
        {
            key: "loop",
            value: /**
   * 循环调用此函数来检查播放健康情况
   */ function loop() {
                var curTimeStamp = +new Date();
                // 检查状态变化和检查时间变化的逻辑是分开的。实际上这两个逻辑是类似的，都是在某个状态下播放进度长时间停滞。但是分开的原因是在直播的场景下
                // 发现hls.js内核会停留在seeking状态并且不断seek，此时播放进度是不断变化的
                // 因此无法将每个状态的停滞逻辑基于播放进度停滞来编写，而是状态停滞用一个函数，播放进度停滞用一个函数。
                this.checkStateStalled(curTimeStamp);
                this.checkPlaytimeStalled();
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                this.setVideoNodeEvts(false);
                this.removeAllListeners();
                this.stateStartTimeStamp = 0;
                this.videoNode = null;
                this.videoNodeEvtMap = null;
                this.preFramePlaytime = 0;
                this.playtimeStalledFrameCount = 0;
            }
        },
        {
            key: "setVideoNodeEvts",
            value: function setVideoNodeEvts(value) {
                var _this = this;
                if (!this.videoNode) {
                    return;
                }
                if (!this.videoNodeEvtMap) {
                    this.videoNodeEvtMap = _$1({}, VideoNodeEvent.STATE_CHANGE, this.videoNodeStateChange.bind(this));
                }
                Object.keys(this.videoNodeEvtMap).forEach(function(key) {
                    if (value) {
                        _this.videoNode.on(key, _this.videoNodeEvtMap[key]);
                    } else {
                        _this.videoNode.off(key, _this.videoNodeEvtMap[key]);
                    }
                });
            }
        },
        {
            key: "videoNodeStateChange",
            value: function videoNodeStateChange() {
                // 设置每个状态扭转时的起始时间戳
                this.stateStartTimeStamp = +new Date();
            }
        },
        {
            key: "checkStateStalled",
            value: /**
   * 检查是否在某些状态下长时间停滞
   */ function checkStateStalled(curTimeStamp) {
                var _this_videoNode = this.videoNode, config = _this_videoNode.config, state = _this_videoNode.state;
                if ([
                    VideoState.BUFFERING,
                    VideoState.SEEKING
                ].indexOf(state) === -1) {
                    // 只检查这些状态的停滞
                    return;
                }
                if (this.stateStartTimeStamp <= 0 || config.maxStateStalledTime <= 0) {
                    return;
                }
                if (curTimeStamp - this.stateStartTimeStamp > config.maxStateStalledTime) {
                    // 重试前把当前状态的开始时间戳重置。因为重试过程中状态可能无变化（例如一直是buffering状态），重置后可避免重复的重试。
                    this.stateStartTimeStamp = 0;
                    this.emit("state-stuck", {
                        code: ErrorCode.STATE_STUCK,
                        message: compile(i18nConfig.core.ERROR_PLAY_STUCK),
                        state: state
                    });
                }
            }
        },
        {
            key: "checkPlaytimeStalled",
            value: /**
 * 检查在playing状态下playtime是否长时间停滞
 */ function checkPlaytimeStalled() {
                var _this_videoNode = this.videoNode, config = _this_videoNode.config, state = _this_videoNode.state, videoElement = _this_videoNode.videoElement;
                if (state !== VideoState.PLAYING || videoElement.duration <= 0 || videoElement.currentTime <= 0 || config.maxPlaytimeStalledTime <= 0) {
                    return;
                }
                if (this.preFramePlaytime > 0) {
                    if (this.preFramePlaytime !== videoElement.currentTime) {
                        // 只要播放进度有变化，就重置停滞的帧数
                        this.playtimeStalledFrameCount = 0;
                    } else {
                        // 否则开始检查停滞的时长
                        this.playtimeStalledFrameCount++;
                        if (this.playtimeStalledFrameCount * 16.7 > config.maxPlaytimeStalledTime) {
                            this.playtimeStalledFrameCount = 0;
                            this.emit("playtime-stuck", {
                                code: ErrorCode.ORG_PLAY_STUCK_ERR,
                                message: compile(i18nConfig.core.ERROR_PLAY_STUCK),
                                state: state
                            });
                        }
                    }
                }
                this.preFramePlaytime = videoElement.currentTime;
            }
        }
    ]);
    return CheckHealth;
}(EvtEmitter);
var HEALTH_EVTS;
(function(HEALTH_EVTS) {
    HEALTH_EVTS["STATE_STUCK"] = "state-stuck";
    HEALTH_EVTS["PLAYTIME_STUCK"] = "playtime-stuck";
})(HEALTH_EVTS || (HEALTH_EVTS = {}));

var CheckVideoNodeStatus = /*#__PURE__*/ function() {
    function CheckVideoNodeStatus(vn) {
        _$5(this, CheckVideoNodeStatus);
        _$1(this, "videoNode", void 0);
        this.videoNode = vn;
    }
    _$4(CheckVideoNodeStatus, [
        {
            key: "checkIsSetLevelOver",
            value: /**
 * 检查当前切换清晰度是否已经结束，以方便执行下一步骤
 * @param evtName 事件名，切换清晰度完成可能在多个事件中检查。
 * @returns 返回为空表示setLevel未结束，非空表示结束
 */ function checkIsSetLevelOver() {
                var evtName = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : VideoEvts.playing, targetPlaytime = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
                var _this_videoNode;
                if (!((_this_videoNode = this.videoNode) === null || _this_videoNode === void 0 ? void 0 : _this_videoNode.videoElement)) {
                    throw new Error('Target VideoNode is null!');
                }
                if (!this.videoNode.getLevelSwitching()) {
                    // 返回为空就是没有结束
                    return null;
                }
                // 播放中检查
                var succInPlaying = false;
                // Seek后的检查
                var succInSeeked = false;
                // Timeupdate检查
                var succInTimeupdate = false;
                if (this.videoNode.config.type === PlayMode.LIVE) {
                    // 直播开播以后就直接判断切换清晰度成功，并且没有seek的情况
                    succInPlaying = evtName === VideoEvts.playing;
                    succInTimeupdate = evtName === VideoEvts.timeupdate;
                } else {
                    var isMFSupport = videoTool.supportMediaFragmentsURISpec(this.videoNode.config.enableMediaFragmentsURI);
                    // 支持#t的时候切换清晰度是直接在url带上了目标位置，开播即到达目标播放位置
                    succInPlaying = evtName === VideoEvts.playing && isMFSupport;
                    // 不支持#t标准的浏览器环境下，切换到下一个清晰度了还需要调用seek操作才能到达播放目标位置，因此在seeked状态检测
                    succInSeeked = evtName === VideoEvts.seeked && !isMFSupport;
                    // timeupdate中是兜底的检测，下一个清晰度的时间超过了容忍值0.3S切换时记录的时间则切换成功
                    var toleranceMinGap = 0.3;
                    var toleranceGap = this.videoNode.videoElement.currentTime - targetPlaytime >= toleranceMinGap;
                    succInTimeupdate = evtName === VideoEvts.timeupdate && toleranceGap;
                }
                if (succInPlaying || succInSeeked || succInTimeupdate) {
                    // 只要其中一个为true，就返回非空表示结束
                    return {
                        succInPlaying: succInPlaying,
                        succInSeeked: succInSeeked,
                        succInTimeupdate: succInTimeupdate
                    };
                }
                // 返回为空就是没有结束
                return null;
            }
        },
        {
            key: "checkCanSetLevel",
            value: /**
   * 检查当前videonode是否可以切换清晰度
   * @returns {canSetLevel:boolean,message:string} canSetLevel表示是否能切换，message表示具体信息描述和不能切换原因
   */ function checkCanSetLevel() {
                if (!this.videoNode) {
                    return {
                        canSetLevel: false,
                        message: 'videoNode is null'
                    };
                }
                if (!this.videoNode.played) {
                    // 如果根本没能起播，是无法切换清晰度的
                    return {
                        canSetLevel: false,
                        message: 'setLevel(), play is not triggered.'
                    };
                }
                if (this.videoNode.getLevelSwitching()) {
                    // 切换清晰度正在进行中，需要继续等待
                    return {
                        canSetLevel: false,
                        message: 'setLevel(), in progress.'
                    };
                }
                if (!this.videoNode.currentVideoInfo || this.videoNode.currentVideoInfo.playtime <= 0) {
                    // 如果currentVideoInfo为空，也暂时无法切换清晰度
                    return {
                        canSetLevel: false,
                        message: 'setLevel(), setLevel can\'t start.'
                    };
                }
                if (this.videoNode.config.type === PlayMode.VOD && this.videoNode.currentVideoInfo.playtime + 1 >= this.videoNode.currentVideoInfo.duration) {
                    // 点播下如果播放接近结束（一秒内），可以认为切换清晰度是无意义的
                    return {
                        canSetLevel: false,
                        message: 'setLevel(), video is about to end.'
                    };
                }
                return {
                    canSetLevel: true,
                    message: 'setLevel(), can set level now'
                };
            }
        },
        {
            key: "checkCanSeek",
            value: /**
   * 检查当前video是否能seek,在调用seek前检查
   * @param seekOpts seek相关信息
   * @returns {canSeek:boolean,message:string} canSeek表示是否能seek，message表示具体信息描述和不能seek原因
   */ function checkCanSeek(seekOpts) {
                var _this_videoNode;
                if (!((_this_videoNode = this.videoNode) === null || _this_videoNode === void 0 ? void 0 : _this_videoNode.currentVideoInfo)) {
                    // 如果vn或者vn.currentVideoInfo为空，无法Seek
                    return {
                        canSeek: false,
                        message: 'seek(), because videonode or videoInfo is null'
                    };
                }
                if (this.videoNode.videoElement.duration <= 0) {
                    // 如果video元素duration小于等于0，不能seek。在MSE上会有拼接导致duration产生变化，所以没有使用currentVideoInfo
                    return {
                        canSeek: false,
                        message: 'seek(), cannot seek when the duration is 0'
                    };
                }
                var _ref = seekOpts || {}, _ref_seektime = _ref.seektime, seektime = _ref_seektime === void 0 ? NaN : _ref_seektime, _ref_userActivation = _ref.userActivation, userActivation = _ref_userActivation === void 0 ? false : _ref_userActivation, _ref_setLevelMode = _ref.setLevelMode, setLevelMode = _ref_setLevelMode === void 0 ? SetLevelMode.HARD : _ref_setLevelMode;
                if (Number.isNaN(seektime)) {
                    // 如果没有传入seektime不，无法seek
                    return {
                        canSeek: false,
                        message: 'target time is NaN'
                    };
                }
                if (seektime - this.videoNode.currentVideoInfo.duration >= 1) {
                    // seek比duration还多出1S，也不能seek
                    // 为什么是1S？是因为以下原因，需要做保护性矫正，check执行后都会减去1S保证不出现上面问题：
                    // 1. safari/x5下可能出现直接seek到视频的最结尾（seek时间等于视频时长）后，video不发出end事件出来，所以检测如果这种情况，把time值回退1s
                    // 2. chrome环境seek到最最后面，可能会卡死在seeking状态
                    return {
                        canSeek: false,
                        message: "seek(), return because too large time, uid=".concat(this.videoNode.currentVideoInfo.uid, "/idx=").concat(this.videoNode.idx, "/time=").concat(seektime) + "/duration=".concat(this.videoNode.currentVideoInfo.duration)
                    };
                }
                if (typeof setLevelMode !== 'undefined' && setLevelMode !== SetLevelMode.SMOOTH && this.videoNode.getLevelSwitching() && userActivation) {
                    // 非平滑切换时，“外部”不能seek（内部是可以seek的，例如某些浏览器切清晰度的时候，下一个清晰度需要seek到目标时间点）。
                    // 因为加载下一个清晰度加了#t参数，如果当前清晰度进行seek操作，那么下一个清晰度加载ok以后跟上一个清晰度seek后的时间就无法对齐
                    return {
                        canSeek: false,
                        message: 'seek(), cannot seek when hard/soft level switching'
                    };
                }
                return {
                    canSeek: true,
                    message: 'seek(), can seek now'
                };
            }
        },
        {
            key: "checkCanSetAudioTrack",
            value: /**
   * 检查是否能设置音轨
   * @param audioTrackOpts 音轨相关信息
   * @returns {canSetAudioTrack:boolean,message:string} canSetAudioTrack表示是否能设置音轨，message表示具体信息描述和不能设置原因
   */ function checkCanSetAudioTrack(audioTrackDefer) {
                if (audioTrackDefer) {
                    // 当前正在切换中，返回不能切换
                    return {
                        canSetAudioTrack: false,
                        message: 'setAudioTrack(), in progress'
                    };
                }
                if (!this.videoNode) {
                    // 如果vn为空，无法设置音轨
                    return {
                        canSetAudioTrack: false,
                        message: 'setAudioTrack(), because videonode is null'
                    };
                }
                if (!this.videoNode.hasAltAudio) {
                    // 如果不存在可以切换的音轨，返回不能切换
                    return {
                        canSetAudioTrack: false,
                        message: 'setAudioTrack(), current content does not contain alternative audio track'
                    };
                }
                if (!this.videoNode.played) {
                    // 如果vn并没有起播，无法切换音轨
                    return {
                        canSetAudioTrack: false,
                        message: 'setAudioTrack(), can only be invoked after content plays'
                    };
                }
                return {
                    canSetAudioTrack: true,
                    message: 'setAudioTrack(), can set audio track now'
                };
            }
        },
        {
            key: "destroy",
            value: /** 销毁 */ function destroy() {
                this.videoNode = null;
            }
        }
    ]);
    return CheckVideoNodeStatus;
}();

/**
 * 提供给kernel往外派发自定义事件，例如hls内核派发跟thls.js相关的事件出去。
 */ var kernelEvtBus = new EvtEmitter();
/**
 * 预加载过程中，内核派发给播放器上层的事件对象
 */ var preloadEvtBus = new EvtEmitter();

/**
 * 直播延迟控制器模块，具体的延迟计算方式和控制策略由callback处理
 *
 * @export
 * @class LatencyController
 * @typedef {LatencyController}
 */ var LatencyController = /*#__PURE__*/ function() {
    function LatencyController(media, config, onLatencyExceeded, onLatencyDropped, latencyCalculationMethod) {
        var _this = this;
        _$5(this, LatencyController);
        _$1(this, "media", void 0);
        _$1(this, "playerConfig", void 0);
        _$1(this, "onLatencyExceeded", function() {});
        _$1(this, "onLatencyDropped", function() {});
        _$1(this, "latencyCalculationMethod", defaultLatencyCalculationMethod);
        _$1(this, "state", void 0);
        _$1(this, "setupEvents", function() {
            _this.media.addEventListener('timeupdate', _this.onTimeUpdate);
        });
        _$1(this, "onTimeUpdate", function() {
            var _this_media = _this.media, buffered = _this_media.buffered, currentTime = _this_media.currentTime, paused = _this_media.paused;
            if (paused) return;
            var latency = _this.latencyCalculationMethod(currentTime, buffered);
            if (latency < 0 || isNaN(latency)) return;
            if (latency > _this.config.expectedLatency && _this.state !== 1) {
                _this.onLatencyExceeded(currentTime, latency, _this.media);
                _this.state = 1;
            } else if (latency <= _this.config.minLatency && _this.state !== 0) {
                _this.onLatencyDropped(currentTime, latency, _this.media);
                _this.state = 0;
            }
        });
        this.media = media;
        this.playerConfig = config;
        this.state = 0;
        if (typeof onLatencyExceeded === 'function') this.onLatencyExceeded = onLatencyExceeded;
        if (typeof onLatencyDropped === 'function') this.onLatencyDropped = onLatencyDropped;
        if (typeof latencyCalculationMethod === 'function') this.latencyCalculationMethod = latencyCalculationMethod;
        this.setupEvents();
    }
    _$4(LatencyController, [
        {
            key: "config",
            get: function get() {
                return _$6({}, defaultConfig, this.playerConfig.latencyConfig);
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                this.media.removeEventListener('timeupdate', this.onTimeUpdate);
                this.onLatencyExceeded = null;
                this.onLatencyDropped = null;
                this.latencyCalculationMethod = null;
            }
        }
    ]);
    return LatencyController;
}();
var defaultConfig = {
    expectedLatency: 5,
    minLatency: 2,
    syncSpeed: 1.75
};
function defaultLatencyCalculationMethod(currentTime, buffered) {
    if (!(buffered.length > 0 && currentTime > 0)) return -1;
    for(var i = 0; i < buffered.length; i++){
        var start = buffered.start(i);
        var end = buffered.end(i);
        if (currentTime >= start && currentTime <= end) {
            return end - currentTime;
        }
    }
}

var Loading = /*#__PURE__*/ function() {
    function Loading(evtEmiter) {
        _$5(this, Loading);
        _$1(this, "delayTimeoutId", 0);
        _$1(this, "evtEmiter", void 0);
        this.evtEmiter = evtEmiter;
    }
    _$4(Loading, [
        {
            key: "show",
            value: /**
   * 发送展示loading事件
   * @param delayShowTimeMS 延迟展示Loading时间，单位毫秒，0为立即展示
   */ function show() {
                var _this = this;
                var delayShowTimeMS = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
                if (!this.evtEmiter) {
                    return;
                }
                this.clearDelay();
                if (delayShowTimeMS === 0) {
                    this.evtEmiter.emit(VideoNodeEvent.SET_LOADING, {
                        show: true
                    });
                    return;
                }
                this.delayTimeoutId = window.setTimeout(function() {
                    _this.evtEmiter.emit(VideoNodeEvent.SET_LOADING, {
                        show: true
                    });
                }, delayShowTimeMS);
            }
        },
        {
            key: "hide",
            value: /**
   * 隐藏loading事件，如果有延迟展示也会清除
   */ function hide() {
                if (!this.evtEmiter) {
                    return;
                }
                this.clearDelay();
                this.evtEmiter.emit(VideoNodeEvent.SET_LOADING, {
                    show: false
                });
            }
        },
        {
            key: "clearDelay",
            value: /**
   * 清除延迟展示的loading，外部在destroy时可以调用
   */ function clearDelay() {
                if (this.delayTimeoutId > 0) {
                    window.clearTimeout(this.delayTimeoutId);
                    this.delayTimeoutId = 0;
                }
            }
        }
    ]);
    return Loading;
}();

/**
 * IVideoElement 监控模块，用于获取视频播放性能数据
 * BaseVideoNode 将数据同步到 IVideoInfo.qualityInfo 字段中
 */ var PerformanceMonitor = /*#__PURE__*/ function() {
    function PerformanceMonitor(video) {
        _$5(this, PerformanceMonitor);
        _$1(this, "video", void 0);
        this.video = video;
    }
    _$4(PerformanceMonitor, [
        {
            key: "report",
            value: function report() {
                var _videoTool_getVideoPlaybackQuality = videoTool.getVideoPlaybackQuality(this.video), totalVideoFrames = _videoTool_getVideoPlaybackQuality.totalVideoFrames, droppedVideoFrames = _videoTool_getVideoPlaybackQuality.droppedVideoFrames;
                var frameDroppedInPercentage = droppedVideoFrames / totalVideoFrames * 100;
                if (isNaN(frameDroppedInPercentage)) {
                    frameDroppedInPercentage = -1;
                }
                return {
                    droppedVideoFrames: droppedVideoFrames,
                    totalVideoFrames: totalVideoFrames,
                    frameDroppedInPercentage: frameDroppedInPercentage
                };
            }
        }
    ]);
    return PerformanceMonitor;
}();

var _obj$1;
/**
 * 当前状态的前置状态表，例如loadStart上一个状态表为[idle]
 */ var VALID_PREVIOUS_STATE_MAP = (_obj$1 = {}, _$1(_obj$1, VideoState.LOAD_START, [
    VideoState.IDLE
]), _$1(_obj$1, VideoState.CANPLAY, [
    VideoState.LOAD_START
]), _$1(_obj$1, VideoState.PLAYING, [
    VideoState.CANPLAY,
    VideoState.SEEKED,
    VideoState.PAUSE,
    VideoState.BUFFERING
]), _$1(_obj$1, VideoState.BUFFERING, [
    VideoState.PLAYING
]), _$1(_obj$1, VideoState.PAUSE, [
    VideoState.PLAYING,
    VideoState.BUFFERING
]), _$1(_obj$1, VideoState.SEEKING, [
    VideoState.CANPLAY,
    VideoState.PLAYING,
    VideoState.PAUSE,
    VideoState.BUFFERING,
    VideoState.SEEKING
]), _$1(_obj$1, VideoState.SEEKED, [
    VideoState.SEEKING
]), _$1(_obj$1, VideoState.END, [
    VideoState.LOAD_START,
    VideoState.CANPLAY,
    VideoState.SEEKING,
    VideoState.SEEKED,
    VideoState.BUFFERING,
    VideoState.PLAYING,
    VideoState.PAUSE
]), _$1(_obj$1, VideoState.IDLE, [
    VideoState.END
]), _obj$1);
/**
 * 切清晰度时的合法状态。例如无缝切换时，实际上是可以进行pause等操作的。
 */ var VALID_STATE_IN_LEVEL_SWITCHING = [
    VideoState.PAUSE,
    VideoState.PLAYING,
    VideoState.END,
    VideoState.IDLE
];
var logMethodCall$7 = logMethodCallDecoratorCreator('StateMgr');
/**
 * VideoNode的状态机管理，根据video事件转换为播放状态机。[状态图参考](document/state.png)
 */ var StateMgr = /*#__PURE__*/ function() {
    function StateMgr(vn) {
        _$5(this, StateMgr);
        _$1(this, "logger", void 0);
        _$1(this, "videoNode", void 0);
        var _obj;
        _$1(this, "videoEvtHandler", (_obj = {}, _$1(_obj, VideoEvts.canplay, this.onCanplayEvt.bind(this)), _$1(_obj, VideoEvts.playing, this.setPlaying.bind(this)), _$1(_obj, VideoEvts.waiting, this.setWaiting.bind(this)), _$1(_obj, VideoEvts.pause, this.onPauseEvt.bind(this)), _$1(_obj, VideoEvts.seeking, this.onSeekingEvt.bind(this)), _$1(_obj, VideoEvts.seeked, this.onSeekedEvt.bind(this)), _obj));
        this.videoNode = vn;
        this.logger = new Logger(vn.config.instanceId, 'StateMgr');
    }
    _$4(StateMgr, [
        {
            key: "destroy",
            value: function destroy() {
                this.videoNode = null;
            }
        },
        {
            key: "validCallState",
            value: function validCallState(tarState) {
                var _VALID_PREVIOUS_STATE_MAP_tarState;
                return (_VALID_PREVIOUS_STATE_MAP_tarState = VALID_PREVIOUS_STATE_MAP[tarState]) === null || _VALID_PREVIOUS_STATE_MAP_tarState === void 0 ? void 0 : _VALID_PREVIOUS_STATE_MAP_tarState.includes(this.videoNode.state);
            }
        },
        {
            key: "setEnded",
            value: function setEnded() {
                this.setVideoNodeState(VideoState.END);
                // end状态以后紧跟idle状态（历史原因导致这两个状态现在没有什么区别，但需要兼容老的调用方）
                this.setVideoNodeState(VideoState.IDLE);
            }
        },
        {
            key: "setLoadStart",
            value: function setLoadStart() {
                this.setVideoNodeState(VideoState.LOAD_START);
            }
        },
        {
            key: "setCanplay",
            value: function setCanplay() {
                this.setVideoNodeState(VideoState.CANPLAY);
            }
        },
        {
            key: "setWaiting",
            value: function setWaiting() {
                this.setVideoNodeState(VideoState.BUFFERING);
            }
        },
        {
            key: "setPlaying",
            value: function setPlaying() {
                this.setVideoNodeState(VideoState.PLAYING);
            }
        },
        {
            key: "onSetLevelOver",
            value: function onSetLevelOver() {
                if (!this.videoNode) {
                    // 可能已经被销毁
                    return;
                }
                if (this.videoNode.state === VideoState.PAUSE) {
                    // 在暂停状态切换清晰度，切换成功以后是播放状态，因此需要修改为playing状态
                    this.setVideoNodeState(VideoState.PLAYING);
                }
            }
        },
        {
            key: "receiveVideoEvt",
            value: /**
   * 收到video标签事件以后进行处理
   * @param evtName video标签事件名
   */ function receiveVideoEvt(evtName) {
                var _this_videoEvtHandler_evtName, _this_videoEvtHandler;
                if (!this.videoNode) {
                    // 可能已经被销毁
                    return;
                }
                (_this_videoEvtHandler_evtName = (_this_videoEvtHandler = this.videoEvtHandler)[evtName]) === null || _this_videoEvtHandler_evtName === void 0 ? void 0 : _this_videoEvtHandler_evtName.call(_this_videoEvtHandler);
            }
        },
        {
            key: "setVideoNodeState",
            value: /**
   * 设置VideoNode的状态，此状态是排除非法状态、兼容性处理以后完全处理好的状态。
   * @param state 状态名
   */ function setVideoNodeState(state) {
                if (!this.videoNode) {
                    // 可能已经被销毁
                    return;
                }
                if (this.videoNode.getLevelSwitching() && !VALID_STATE_IN_LEVEL_SWITCHING.includes(state)) {
                    // 切换清晰度时过滤一部分状态
                    this.logger.log("can not set state 2 ".concat(state, " when level switching"));
                    return;
                }
                if (!VALID_PREVIOUS_STATE_MAP[state].includes(this.videoNode.state)) {
                    // 上一个状态必须符合前置状态表
                    this.logger.log("can not set state from ".concat(this.videoNode.state, " to ").concat(state));
                    return;
                }
                this.videoNode.state = state;
            }
        },
        {
            key: "onCanplayEvt",
            value: function onCanplayEvt() {
                // ios的waiting以后是canplay和canplaythrough（没有playing事件）这里需要判断以后额外加一个事件。
                // 另外发现safari播放直播时，从静音到恢复音量，video的事件变化为playing->waiting->canplay，所以会丢失playing状态。
                var applePlat = uaTool.os.ios || uaTool.browser.safari;
                if (applePlat && this.isVideoElementPlaying() && this.videoNode.state === VideoState.BUFFERING) {
                    this.setVideoNodeState(VideoState.PLAYING);
                } else {
                    this.setVideoNodeState(VideoState.CANPLAY);
                }
            }
        },
        {
            key: "onPauseEvt",
            value: function onPauseEvt() {
                this.setVideoNodeState(VideoState.PAUSE);
            }
        },
        {
            key: "onSeekingEvt",
            value: function onSeekingEvt() {
                this.setVideoNodeState(VideoState.SEEKING);
            }
        },
        {
            key: "onSeekedEvt",
            value: function onSeekedEvt() {
                this.setVideoNodeState(VideoState.SEEKED);
                var applePlat = uaTool.os.ios || uaTool.browser.safari;
                if (applePlat && this.isVideoElementPlaying()) {
                    // 播放中seek，ios的seeked事件以后不是playing状态。这里需要额外增加playing状态
                    this.setVideoNodeState(VideoState.PLAYING);
                }
            }
        },
        {
            key: "isVideoElementPlaying",
            value: /**
   * video标签是否在播放状态
   */ function isVideoElementPlaying() {
                return !this.videoNode.videoElement.paused && !this.videoNode.videoElement.ended;
            }
        }
    ]);
    return StateMgr;
}();
_$7([
    logMethodCall$7,
    _$8("design:type", Function),
    _$8("design:paramtypes", []),
    _$8("design:returntype", void 0)
], StateMgr.prototype, "destroy", null);
_$7([
    logMethodCall$7,
    _$8("design:type", Function),
    _$8("design:paramtypes", [
        typeof VideoState === "undefined" ? Object : VideoState
    ]),
    _$8("design:returntype", void 0)
], StateMgr.prototype, "validCallState", null);
_$7([
    logMethodCall$7,
    _$8("design:type", Function),
    _$8("design:paramtypes", []),
    _$8("design:returntype", void 0)
], StateMgr.prototype, "setEnded", null);
_$7([
    logMethodCall$7,
    _$8("design:type", Function),
    _$8("design:paramtypes", []),
    _$8("design:returntype", void 0)
], StateMgr.prototype, "setLoadStart", null);
_$7([
    logMethodCall$7,
    _$8("design:type", Function),
    _$8("design:paramtypes", []),
    _$8("design:returntype", void 0)
], StateMgr.prototype, "setCanplay", null);
_$7([
    logMethodCall$7,
    _$8("design:type", Function),
    _$8("design:paramtypes", []),
    _$8("design:returntype", void 0)
], StateMgr.prototype, "setWaiting", null);
_$7([
    logMethodCall$7,
    _$8("design:type", Function),
    _$8("design:paramtypes", []),
    _$8("design:returntype", void 0)
], StateMgr.prototype, "setPlaying", null);

var VideoFillType;
/** 引用方式枚举 */ (function(VideoFillType) {
    VideoFillType["COVER"] = "cover";
    VideoFillType["CONTAIN"] = "contain";
})(VideoFillType || (VideoFillType = {}));
var VideoResizeAutoFill = /*#__PURE__*/ function() {
    function VideoResizeAutoFill(videoElement) {
        var minFillBlackBorder = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 10;
        _$5(this, VideoResizeAutoFill);
        /** video元素对象 */ _$1(this, "videoElement", void 0);
        /** video元素的尺寸观察 */ _$1(this, "videoResizeObserver", void 0);
        /** 默认最小自动黑边范围，默认10像素 */ _$1(this, "minFillBlackBorder", 10);
        this.videoElement = videoElement;
        this.minFillBlackBorder = minFillBlackBorder;
        this.addToObserver();
    }
    _$4(VideoResizeAutoFill, [
        {
            key: "resizeAutoFill",
            value: /**
  * video标签默认样式object-fit: contain，这样高宽比不匹配时候，会被添加黑边。
  * 该方法用于当视频显示尺寸和播放器尺寸有很小的误差时候（例如出现了10px以下的黑边），那就直接铺满video画面(object-fit: cover)避免黑边
  * 的产生，这种情况下人眼看不出比例的实际变化
  * 在视频原始尺寸发生变化和video元素尺寸发生变化两种情况下，需要调用此函数检查。
  */ function resizeAutoFill() {
                if (!_$2(this.videoElement, HTMLVideoElement)) {
                    // TODO：265暂时没有方案处理小黑边
                    return;
                }
                if (this.minFillBlackBorder <= 0) {
                    // 如果没有设置最小适配黑边，就无需计算，默认即可
                    return;
                }
                if (this.videoElement.videoWidth === 0 || this.videoElement.videoHeight === 0) {
                    // 在多video模式下，video元素宽高是0，继续往下计算是没有意义的
                    return;
                }
                var videoElementSize = domTool.getDomSize(this.videoElement);
                var videoElementWidth = videoElementSize.width, videoElementHeight = videoElementSize.height;
                // 这是假设为contain模式，算出来的画面宽度
                var picWidth = this.videoElement.videoWidth * (videoElementHeight / this.videoElement.videoHeight);
                // 这是假设为contain模式，算出来的画面高度
                var picHeight = this.videoElement.videoHeight * (videoElementWidth / this.videoElement.videoWidth);
                if (picWidth < videoElementWidth && picWidth >= videoElementWidth - this.minFillBlackBorder) {
                    // 画面宽度小于容器宽度左右出现了黑边，并且小于阀值
                    videoTool.setElementFitType(this.videoElement, "cover");
                } else if (picHeight < videoElementHeight && picHeight >= videoElementHeight - this.minFillBlackBorder) {
                    // 画面高度小于容器高度上下出现了黑边，并且小于阀值
                    videoTool.setElementFitType(this.videoElement, "cover");
                } else {
                    // 容忍黑边
                    videoTool.setElementFitType(this.videoElement, "contain");
                }
            }
        },
        {
            key: "destroy",
            value: /**
   * 销毁，并停止监听video元素
   */ function destroy() {
                if (!this.videoElement || !_$2(this.videoElement, HTMLVideoElement)) {
                    // 在非video播放模式下，不能通过这个Observer调整尺寸
                    return;
                }
                if (!this.videoResizeObserver) {
                    return;
                }
                this.videoResizeObserver.disconnect();
                this.videoResizeObserver.unobserve(this.videoElement);
                this.videoResizeObserver = null;
                this.videoElement = null;
            }
        },
        {
            key: "addToObserver",
            value: /**
   * 添加到Observer做自动容器适应
   */ function addToObserver() {
                var _this = this;
                if (!this.videoElement) {
                    return;
                }
                if (!_$2(this.videoElement, HTMLVideoElement)) {
                    // 在非video播放模式下，不能通过这个Observer调整尺寸
                    return;
                }
                this.videoResizeObserver = new ResizeObserver(function() {
                    _this.resizeAutoFill();
                });
                this.videoResizeObserver.observe(this.videoElement);
            }
        }
    ]);
    return VideoResizeAutoFill;
}();

var logMethodCall$6 = logMethodCallDecoratorCreator('BaseVideoNode');
var BaseVideoNode = /*#__PURE__*/ function(EvtEmitter) {
    _$9(BaseVideoNode, EvtEmitter);
    var _super = _$a(BaseVideoNode);
    function BaseVideoNode(config) {
        _$5(this, BaseVideoNode);
        var _this;
        var _config_videoElementConfig;
        _this = _super.call(this);
        _$1(_$b(_this), "onAccurateTimeupdate", void 0);
        _$1(_$b(_this), "_config", void 0);
        _$1(_$b(_this), "_video", void 0);
        _$1(_$b(_this), "_state", void 0);
        _$1(_$b(_this), "_playbackRate", void 0);
        _$1(_$b(_this), "_idx", void 0);
        _$1(_$b(_this), "_videoInfo", void 0);
        _$1(_$b(_this), "_pauseType", void 0);
        _$1(_$b(_this), "_videoElementContainer", void 0);
        _$1(_$b(_this), "_autoPlayPolicy", void 0);
        _$1(_$b(_this), "_played", false);
        /** video标签事件监听器映射 */ _$1(_$b(_this), "_videoEventMap", void 0);
        _$1(_$b(_this), "_eventMap", void 0);
        /** 各种事件是否已添加的映射 */ _$1(_$b(_this), "_eventAddedMap", void 0);
        _$1(_$b(_this), "_evtBlocking", false);
        _$1(_$b(_this), "_pauseCloseToEndStateCheckTimeoutId", 0);
        /** seek操作的目标播放点 */ _$1(_$b(_this), "_targetSeekTime", -1);
        /** 外部传入的startTime，起播后置0 */ _$1(_$b(_this), "_userStartTime", 0);
        /** 切换清晰度的defer */ _$1(_$b(_this), "_levelSwitchingDefer", void 0);
        /** 是否是用户seek */ _$1(_$b(_this), "_isUserSeek", false);
        _$1(_$b(_this), "isUserSwitchAudioTrack", false);
        _$1(_$b(_this), "loading", void 0);
        _$1(_$b(_this), "_logger", void 0);
        _$1(_$b(_this), "_drm", void 0);
        /** 主循环, 基于RAF */ _$1(_$b(_this), "mainTaskLoop", void 0);
        _$1(_$b(_this), "checkPlayHealth", void 0);
        /** 首次缓冲超时的计时器id */ _$1(_$b(_this), "loadTimeoutId", 0);
        /** VideoNode的状态管理器，所有状态的修改都在管理器中完成 */ _$1(_$b(_this), "stateMgr", void 0);
        _$1(_$b(_this), "levelSwitchTargetPlaytime", -1);
        /** 切换清晰度方式 */ _$1(_$b(_this), "setLevelMode", SetLevelMode.SOFT);
        /** 是否存在外挂音轨 */ _$1(_$b(_this), "altAudio", false);
        /** 调用 video.play() 的返回 Promise */ _$1(_$b(_this), "playPromise", void 0);
        /** 音轨切换的defer */ _$1(_$b(_this), "audioTrackSwitchingDefer", void 0);
        _$1(_$b(_this), "performanceMonitor", void 0);
        _$1(_$b(_this), "audioController", void 0);
        _$1(_$b(_this), "isDestroyed", false);
        /** video尺寸自适应，并补齐黑边 */ _$1(_$b(_this), "videoResizeAutoFill", null);
        /** videoNode内部状态检查，用于seek、setlevel等提前判断 */ _$1(_$b(_this), "vnStatusChecker", void 0);
        /** 直播延迟控制器 */ _$1(_$b(_this), "latencyController", null);
        _$1(_$b(_this), "lastLogPlayTimeTimeStampMs", 0);
        _this._logger = new Logger(config.instanceId, 'BaseVideoNode');
        _this._config = config;
        _this.stateMgr = new StateMgr(_$b(_this));
        _this.checkPlayHealth = new CheckHealth(_$b(_this));
        _this.loading = new Loading(_$b(_this));
        _this.setHealthEvents();
        _this.mainTaskLoop = new TaskLoop(_this.mainLoopInProcess.bind(_$b(_this)), LoopMode.RAF);
        _this._video = _this.findFreeVideoElement();
        _this._autoPlayPolicy = new AutoPlayPolicy(_this._video, {
            instanceId: config.instanceId
        });
        _this._state = VideoState.IDLE;
        _this._playbackRate = 1;
        _this._idx = 0;
        _this._videoInfo = null;
        _this._pauseType = void 0;
        var _obj;
        // 绑定各种VideoNode播放事件
        _this._videoEventMap = (_obj = {}, _$1(_obj, VideoEvts.loadstart, _this.onVideoEventLoadStart.bind(_$b(_this))), _$1(_obj, VideoEvts.timeupdate, _this.onVideoEventTimeUpdate.bind(_$b(_this))), _$1(_obj, VideoEvts.durationchange, _this.onVideoEventDurationChange.bind(_$b(_this))), _$1(_obj, VideoEvts.volumechange, _this.onVideoEventVolumeChange.bind(_$b(_this))), _$1(_obj, VideoEvts.canplay, _this.onVideoEventCanplay.bind(_$b(_this))), _$1(_obj, VideoEvts.playing, _this.onVideoEventPlaying.bind(_$b(_this))), _$1(_obj, VideoEvts.pause, _this.onVideoEventPause.bind(_$b(_this))), _$1(_obj, VideoEvts.waiting, _this.onVideoEventWaiting.bind(_$b(_this))), _$1(_obj, VideoEvts.seeking, _this.onVideoEventSeeking.bind(_$b(_this))), _$1(_obj, VideoEvts.seeked, _this.onVideoEventSeeked.bind(_$b(_this))), _$1(_obj, VideoEvts.loadeddata, _this.onVideoEventLoadeddata.bind(_$b(_this))), _$1(_obj, VideoEvts.loadedmetadata, _this.onVideoEventLoadedmetadata.bind(_$b(_this))), _$1(_obj, VideoEvts.ended, _this.onVideoEventEnded.bind(_$b(_this))), _$1(_obj, VideoEvts.error, _this.onVideoEventError.bind(_$b(_this))), _$1(_obj, VideoEvts.progress, _this.onVideoEventProgress.bind(_$b(_this))), _$1(_obj, VideoEvts.ratechange, _this.onVideoEventRateChange.bind(_$b(_this))), _$1(_obj, VideoEvts.resize, _this.onVideoEventResize.bind(_$b(_this))), _obj);
        _this._drm = new DRM$1(_this._video, config.drmConfig, config.instanceId);
        _this._drm.on('error', _this.onDrmError.bind(_$b(_this)));
        _this._eventMap = {
            video: _this.onVideoEvents.bind(_$b(_this))
        };
        _this._eventAddedMap = {};
        _this._videoElementContainer = config.videoElementsContainer;
        videoTool.appendElement(_this._video, _this._videoElementContainer);
        _this.performanceMonitor = new PerformanceMonitor(_this._video);
        if (!((_config_videoElementConfig = config.videoElementConfig) === null || _config_videoElementConfig === void 0 ? void 0 : _config_videoElementConfig.objectFit)) {
            // 只要是外部设置了video标签的填充样式，则不执行自动填充逻辑
            _this.videoResizeAutoFill = new VideoResizeAutoFill(_this._video, _this._config.minFillBlackBorder);
        }
        _this.vnStatusChecker = new CheckVideoNodeStatus(_$b(_this));
        if (config.audioEffectController) {
            // 如果配置没有传入 audioEffectController，意味着不启用音效
            _this.audioController = new config.audioEffectController(_this._video, new Logger(config.instanceId, 'AudioController'));
        }
        if (config.type === PlayMode.LIVE) {
            _this.latencyController = new LatencyController(_this._video, config, _this.onLatencyExceeded.bind(_$b(_this)), _this.onLatencyDropped.bind(_$b(_this)), _this.latencyCalculationMethod.bind(_$b(_this)));
        }
        return _this;
    }
    _$4(BaseVideoNode, [
        {
            key: "triggerAutoplay",
            value: /** 第一次播放时（此时必须是用户触发），在js的同一个事件循环里直接调用一次video标签的play方法。*/ function triggerAutoplay() {
                var _this = this;
                // 触发自动播放时候会调用video的play和pause方法，这时候的调用发出的事件需要丢弃
                this._evtBlocking = true;
                return this._autoPlayPolicy.userTrigger().then(function() {
                    return _this._evtBlocking = false;
                }).catch(function(e) {
                    _this._evtBlocking = false;
                    // 抛出错误让调用方catch
                    throw e;
                });
            }
        },
        {
            key: "videoplay",
            value: function videoplay() {
                var _this = this;
                var _this__videoInfo, _this_audioController;
                this._logger.log("videoplay(), uid=".concat((_this__videoInfo = this._videoInfo) === null || _this__videoInfo === void 0 ? void 0 : _this__videoInfo.uid, "/state=").concat(this.state, "/idx=").concat(this.idx));
                var playPromise = this._video.play();
                // eslint-disable-next-line @typescript-eslint/no-misused-promises
                if (playPromise) {
                    playPromise.catch(function(e) {
                        _this._logger.warn("".concat(_this.idx, " play() catch: ").concat(e.name, ", ").concat(e.message));
                        var isAutoPlayBlocked = videoTool.isAutoPlayBlockedMessage(e.message);
                        if (isAutoPlayBlocked) {
                            // 自动播放被阻止一定无法起播，可能用户在等待状态，此时要去掉loading动画
                            _this.loading.hide();
                        }
                        _this.emit(VideoNodeEvent.PLAY_PROMISE_CATCHED, {
                            videoInfo: _this._videoInfo,
                            isAutoPlayBlocked: isAutoPlayBlocked
                        });
                    });
                } else {
                    // 兼容 IE，play 返回 undefined 的情况下，直接返回一个 resolve 的 Promise
                    playPromise = Promise.resolve();
                }
                (_this_audioController = this.audioController) === null || _this_audioController === void 0 ? void 0 : _this_audioController.createContextAndConnect();
                this._video.playbackRate = this._playbackRate;
                this.playPromise = playPromise;
                return playPromise;
            }
        },
        {
            key: "pause",
            value: function pause() {
                var type = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : PauseType.USER;
                if (!this._played) {
                    this._logger.warn('pause(), VideoNode has not been played');
                    return;
                }
                if (!this.stateMgr.validCallState(VideoState.PAUSE)) {
                    this._logger.log("call pause in invaild state ".concat(this._state));
                    return;
                }
                this.pauseInner(type);
            }
        },
        {
            key: "resume",
            value: function resume() {
                throw new Error('not implements');
            }
        },
        {
            key: "stop",
            value: function stop() {
                this.stopInner();
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                var _this_latencyController, _this__autoPlayPolicy, _this_stateMgr, _this__drm, _this_checkPlayHealth, _this_loading, _this_mainTaskLoop, _this_videoResizeAutoFill, _this_vnStatusChecker, _this_audioController;
                if (this.isDestroyed) {
                    return;
                }
                this.isDestroyed = true;
                this.stopInner();
                (_this_latencyController = this.latencyController) === null || _this_latencyController === void 0 ? void 0 : _this_latencyController.destroy();
                this.latencyController = null;
                if (this._video) {
                    if (this._eventMap) {
                        this.setVideoEvents(false);
                        this._eventMap = null;
                    }
                    videoTool.clear(this._video);
                    videoTool.removeElement(this._video, this._videoElementContainer);
                    this._video.dataset.used = VideoElementState.FREE;
                }
                (_this__autoPlayPolicy = this._autoPlayPolicy) === null || _this__autoPlayPolicy === void 0 ? void 0 : _this__autoPlayPolicy.destroy();
                this._autoPlayPolicy = null;
                (_this_stateMgr = this.stateMgr) === null || _this_stateMgr === void 0 ? void 0 : _this_stateMgr.destroy();
                this.stateMgr = null;
                this.removeAllListeners();
                (_this__drm = this._drm) === null || _this__drm === void 0 ? void 0 : _this__drm.destroy();
                this._drm = null;
                this._video = null;
                this._videoInfo = null;
                this._videoElementContainer = null;
                this._played = false;
                this._config = null;
                (_this_checkPlayHealth = this.checkPlayHealth) === null || _this_checkPlayHealth === void 0 ? void 0 : _this_checkPlayHealth.destroy();
                this.checkPlayHealth = null;
                (_this_loading = this.loading) === null || _this_loading === void 0 ? void 0 : _this_loading.clearDelay();
                this.loading = null;
                (_this_mainTaskLoop = this.mainTaskLoop) === null || _this_mainTaskLoop === void 0 ? void 0 : _this_mainTaskLoop.destroy();
                this.mainTaskLoop = null;
                this.performanceMonitor = null;
                (_this_videoResizeAutoFill = this.videoResizeAutoFill) === null || _this_videoResizeAutoFill === void 0 ? void 0 : _this_videoResizeAutoFill.destroy();
                this.videoResizeAutoFill = null;
                (_this_vnStatusChecker = this.vnStatusChecker) === null || _this_vnStatusChecker === void 0 ? void 0 : _this_vnStatusChecker.destroy();
                this.vnStatusChecker = null;
                (_this_audioController = this.audioController) === null || _this_audioController === void 0 ? void 0 : _this_audioController.destroy();
                this.audioController = null;
                this._logger.log('VideoNode has been destroyed!');
            }
        },
        {
            key: "setLevel",
            value: function setLevel() {
                var mode = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : SetLevelMode.HARD;
                if (!this.checkCanSetLevel()) {
                    return Promise.reject(new Error('setLevel can\'t start'));
                }
                this._logger.log('setLevel(), succ exec: ', this._videoInfo);
                var levelSwitchTargetPlaytime = this._videoInfo.playtime;
                this.load(this._videoInfo, {
                    startTime: levelSwitchTargetPlaytime
                });
                this.play();
                var defer = new SimpleDefer();
                this._levelSwitchingDefer = defer;
                this.levelSwitchTargetPlaytime = levelSwitchTargetPlaytime;
                this.loading.show();
                this.emit(VideoNodeEvent.SETLEVEL_START, {
                    videoInfo: this._videoInfo,
                    mode: mode
                });
                return defer.promise;
            }
        },
        {
            key: "getLevelSwitching",
            value: /** 是否正在切换清晰度 */ function getLevelSwitching() {
                return !!this._levelSwitchingDefer;
            }
        },
        {
            key: "setAudioTrack",
            value: function setAudioTrack(_id) {
                if (!this.checkCanSetAudioTrack()) {
                    return Promise.reject(AudioTrackErrorMsg.STATE_INVALID);
                }
                // base不支持切换音轨
                return Promise.reject(AudioTrackErrorMsg.NOT_SUPPORT);
            }
        },
        {
            key: "hasAltAudio",
            value: /** 是否存在外挂音轨 */ function hasAltAudio() {
                return this.altAudio;
            }
        },
        {
            key: "isCurrentContentDRMEncrypted",
            value: /** 当前播放的资源是否是DRM加密的 */ function isCurrentContentDRMEncrypted() {
                // 没有播放内容的话默认是不加密的
                if (this._state === VideoState.IDLE) {
                    return false;
                }
                return this._drm.hasStarted();
            }
        },
        {
            key: "volume",
            get: function get() {
                if (this._video.muted) {
                    return 0;
                }
                return this._video.volume;
            },
            set: function set(value) {
                var checkRet = checkVolumeValidWithMessage(value);
                if (!checkRet.valid) {
                    this._logger.warn(checkRet.message);
                    return;
                }
                var change2Unmute = this._video.muted && value > 0;
                this._video.volume = value;
                this._video.muted = value <= 0;
                if (this._played && change2Unmute) {
                    var // 如果是静音状态下，可能能自动播放视频，但是AudioContext已经被阻止了:
                    // The AudioContext was not allowed to start. It must be resumed (or created) after a user gesture on the page. https://goo.gl/7K7WLu
                    // 此种状态如果恢复静音，需要调用一下AudioContext的resume
                    _this_audioController;
                    (_this_audioController = this.audioController) === null || _this_audioController === void 0 ? void 0 : _this_audioController.createContextAndConnect();
                }
            }
        },
        {
            key: "volumeGain",
            get: function get() {
                var _this_audioController;
                return (_this_audioController = this.audioController) === null || _this_audioController === void 0 ? void 0 : _this_audioController.getGainValue();
            },
            set: function set(gain) {
                var _this__videoInfo, _this_audioController;
                if (gain < 0 || gain > 2) {
                    this._logger.warn('The volume gain range is [0,2]');
                    return;
                }
                // 如果没有context或者video尚未起播，webaudio会存在自动起播问题，所以需要在起播后设置
                if (!((_this__videoInfo = this._videoInfo) === null || _this__videoInfo === void 0 ? void 0 : _this__videoInfo.hasFirstPlaying)) {
                    return;
                }
                (_this_audioController = this.audioController) === null || _this_audioController === void 0 ? void 0 : _this_audioController.setGainValue(gain);
            }
        },
        {
            key: "audioEffect",
            get: function get() {
                var _this_audioController;
                return (_this_audioController = this.audioController) === null || _this_audioController === void 0 ? void 0 : _this_audioController.getEffect();
            },
            set: function set(effectName) {
                var _this__videoInfo, _this_audioController;
                // 如果没有context或者video尚未起播，webaudio会存在自动起播问题，所以需要在起播后设置
                if (!((_this__videoInfo = this._videoInfo) === null || _this__videoInfo === void 0 ? void 0 : _this__videoInfo.hasFirstPlaying)) {
                    return;
                }
                (_this_audioController = this.audioController) === null || _this_audioController === void 0 ? void 0 : _this_audioController.setEffect(effectName);
            }
        },
        {
            key: "playtime",
            get: /** 播放进度（不一定是video标签的currentTime，如果是不间断播放，video标签时间不断增长，但该属性只是单个播放段上的偏移播放时间）*/ function get() {
                return this._videoInfo ? this._videoInfo.playtime : 0;
            }
        },
        {
            key: "state",
            get: function get() {
                return this._state;
            },
            set: function set(value) {
                var _this__videoInfo;
                if (this._state === value) {
                    return;
                }
                var oldState = this._state;
                this._state = value;
                if (this._videoInfo) {
                    this._videoInfo.state = this._state;
                }
                this._logger.log("set state(), uid=".concat((_this__videoInfo = this._videoInfo) === null || _this__videoInfo === void 0 ? void 0 : _this__videoInfo.uid, "/idx=").concat(this._idx, "/old=").concat(oldState, "/new=").concat(value));
                var evtData = {
                    videoInfo: this._videoInfo,
                    new: value,
                    old: oldState
                };
                // 以下状态需要增加特殊字段派发出去
                if (value === VideoState.PAUSE) {
                    evtData.pauseType = this._pauseType || PauseType.SYS; // 既不是程序触发也不是用户触发（那就是系统莫名其妙触发）
                    this._pauseType = void 0;
                } else if (value === VideoState.SEEKING) {
                    evtData.seekingTime = this._targetSeekTime;
                    evtData.isUserSeek = this._isUserSeek;
                    this._targetSeekTime = -1;
                } else if (value === VideoState.SEEKED) {
                    evtData.isUserSeek = this._isUserSeek;
                }
                this.setLoadingOnStateChange();
                this.emit(VideoNodeEvent.STATE_CHANGE, evtData);
            }
        },
        {
            key: "played",
            get: /** 获取当时视频播放是否已经起播过 */ function get() {
                return this._played;
            }
        },
        {
            key: "useWorker",
            get: /** 是否使用了worker来进行流的处理。各个内核需要复写，所以不能通过readonly方式写成属性，先eslint-disalbe吧 */ // eslint-disable-next-line @typescript-eslint/class-literal-property-style
            function get() {
                return false;
            }
        },
        {
            key: "idx",
            get: function get() {
                return this._idx;
            },
            set: function set(value) {
                this._idx = value;
                this._video.dataset.idx = "".concat(value);
            }
        },
        {
            key: "videoElement",
            get: function get() {
                return this._video;
            }
        },
        {
            key: "videoSize",
            get: function get() {
                return {
                    width: this._video.videoWidth,
                    height: this._video.videoHeight
                };
            }
        },
        {
            key: "videoBuffered",
            get: function get() {
                return videoTool.getBuffered(this._video);
            }
        },
        {
            key: "config",
            get: function get() {
                return this._config;
            }
        },
        {
            key: "playbackRate",
            get: function get() {
                return this._video.playbackRate;
            },
            set: function set(value) {
                this._playbackRate = value;
                // 如果不支持倍速的浏览器，会出现: "NotSupportedError" DOMException
                try {
                    this._video.playbackRate = value;
                } catch (e) {
                    this._logger.warn("set playbackRate: ".concat(e === null || e === void 0 ? void 0 : e.message));
                }
            }
        },
        {
            key: "currentVideoInfo",
            get: function get() {
                return this._videoInfo;
            }
        },
        {
            key: "supportPlaybackRate",
            get: function get() {
                // x5的mse不支持倍速
                return !uaTool.browser.x5;
            }
        },
        {
            key: "duration",
            get: function get() {
                var vduration = this._videoInfo ? this._videoInfo.duration : 0;
                // 没有赋值src的时候HTMLVIDEOELEMENT.duration可能返回NaN
                return Number.isNaN(vduration) ? 0 : vduration;
            }
        },
        {
            key: "latencyCalculationMethod",
            value: /**
   * 计算当前直播延迟
   *
   * @protected
   */ function latencyCalculationMethod(_currentTime, _buffered) {
                // base未实现，子类实现
                return -1;
            }
        },
        {
            key: "onLatencyExceeded",
            value: /**
   * 当前直播延迟超出期望延迟时的回调
   *
   * @protected
   */ function onLatencyExceeded(_currentTime, _latency, _media) {
            // base未实现，子类实现
            }
        },
        {
            key: "onLatencyDropped",
            value: /**
   * 当前直播延迟回落到期望延迟时的回调
   *
   * @protected
   */ function onLatencyDropped(_currentTime, _latency, _media) {
            // base未实现，子类实现
            }
        },
        {
            key: "setHealthEvents",
            value: function setHealthEvents() {
                var _this = this;
                var healthEvtHandler = function(e) {
                    _this._logger.warn("get health evt!!! evt=".concat(e.type, "/uid=").concat(_this._videoInfo.uid, "/idx=").concat(_this._idx, "/state=").concat(_this._state));
                    _this.errorHandler(e.data);
                };
                this.checkPlayHealth.on(HEALTH_EVTS.STATE_STUCK, healthEvtHandler);
                this.checkPlayHealth.on(HEALTH_EVTS.PLAYTIME_STUCK, healthEvtHandler);
            }
        },
        {
            key: "setVideoEvents",
            value: /** 设置video标签的事件监听 */ function setVideoEvents(value) {
                var _this = this;
                var _this__videoInfo;
                if (this._eventAddedMap.videoEventAdded === value) {
                    return;
                }
                this._logger.log("setVideoEvents(), idx=".concat(this._idx, "/value=").concat(value, "/uid=").concat((_this__videoInfo = this._videoInfo) === null || _this__videoInfo === void 0 ? void 0 : _this__videoInfo.uid));
                this._eventAddedMap.videoEventAdded = value;
                Object.keys(this._videoEventMap).forEach(function(key) {
                    if (value) {
                        _this._video.addEventListener(key, _this._eventMap.video);
                    } else {
                        _this._video.removeEventListener(key, _this._eventMap.video);
                    }
                });
            }
        },
        {
            key: "onVideoEvents",
            value: /**
   * 对video标签的事件做处理
   * @param e 播放事件参数
   */ function onVideoEvents(e) {
                var _this = this;
                // 这些条件下，事件都丢弃（evtBlocking会在自动播放触发前设置，自动播放触发结束后恢复）
                if (this.state === VideoState.IDLE || !this._videoInfo || this._evtBlocking) {
                    var _this__videoInfo;
                    this._logger.log("videoevt discard, idx=".concat(this._idx, "/uid=").concat((_this__videoInfo = this._videoInfo) === null || _this__videoInfo === void 0 ? void 0 : _this__videoInfo.uid, "/evttype=").concat(e.type, "/") + "state=".concat(this.state, "/evtBlocking=").concat(this._evtBlocking));
                    return;
                }
                if (!IGNORE_VIDEO_EVT.includes(e.type)) {
                    this._logger.log("videoevt, uid=".concat(this._videoInfo.uid, "/idx=").concat(this.idx, "/type=").concat(e.type, "/") + "time=".concat(this._video.currentTime, "/duration=").concat(this._video.duration));
                }
                // 由于状态机会过滤掉很多事件，因此额外将video标签的所有事件抛出
                this.emit(VideoNodeEvent.ELEMENT_EVTS, {
                    videoInfo: this._videoInfo,
                    elementEvtType: e.type
                });
                var closeToEnd = Math.abs(this._videoInfo.duration - this._videoInfo.playtime) < 0.1 && this._videoInfo.duration > 0;
                if (e.type === 'pause' && closeToEnd) {
                    // 某些浏览器会在结束之前抛出pause事件，如果原封不动的抛出事件可能会导致引用方误判。因此做一个延迟，如果马上收到ended事件，则不会派发。
                    this._pauseCloseToEndStateCheckTimeoutId = window.setTimeout(function() {
                        if (_this._videoEventMap[e.type]) {
                            _this._videoEventMap[e.type](e);
                        }
                    }, 0);
                    return;
                }
                if (e.type === 'ended' && this._pauseCloseToEndStateCheckTimeoutId > 0) {
                    window.clearTimeout(this._pauseCloseToEndStateCheckTimeoutId);
                    this._pauseCloseToEndStateCheckTimeoutId = 0;
                }
                if (this._videoEventMap[e.type]) {
                    this._videoEventMap[e.type](e);
                }
            }
        },
        {
            key: "onVideoEventPlaying",
            value: function onVideoEventPlaying() {
                var _this = this;
                return _$c(function() {
                    return _$d(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this._logger.log("playing, volume=".concat(_this._video.volume, ", muted=").concat(_this._video.muted));
                                _this.setCheckLoadTimeoutEnable(false);
                                // 起播后要重置seeking标记
                                _this._isUserSeek = false;
                                // 移动端chrome播放直播貌似收到loadedmetadata事件时候还可能为0，因此在这里再赋值一次给videoinfo
                                _this.updateVideoSize();
                                if (uaTool.browser.x5) {
                                    // 如果是先调用video.load()，x5浏览器在playing之前获取到的duration一直是0，包括在durationchange事件里面
                                    // 所以这里在playing的时候再获取一遍了，出bug的ua：
                                    // Mozilla/5.0 (Linux; Android 9; Redmi Note 7 Pro Build/PKQ1.181203.001; wv) AppleWebKit/537.36
                                    // (KHTML, like Gecko) Version/4.0 Chrome/77.0.3865.120 MQQBrowser/6.2 TBS/045224
                                    _this.onVideoEventDurationChange();
                                }
                                if (!uaTool.browser.safari) return [
                                    3,
                                    4
                                ];
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    _this.playPromise
                                ];
                            case 2:
                                _state.sent();
                                return [
                                    3,
                                    4
                                ];
                            case 3:
                                _state.sent();
                                // playPromise reject，不继续进行操作
                                return [
                                    2
                                ];
                            case 4:
                                if (!_this._videoInfo.hasFirstPlaying) {
                                    _this.emit(VideoNodeEvent.FIRST_PLAYING, {
                                        videoInfo: _this._videoInfo
                                    });
                                }
                                _this.stateMgr.receiveVideoEvt(VideoEvts.playing);
                                // 在事件中videoInfo可能已被销毁，所以判断一下是否存在
                                if (_this._videoInfo) {
                                    // 在firstPlaying事件发出后、状态修改以后，再修改此变量。因为外部判断首次播放可能使用的!videoNode.hasFirstPlaying
                                    _this._videoInfo.hasFirstPlaying = true;
                                    _this._videoInfo.stateWhenErrorHappen = null;
                                }
                                _this._userStartTime = 0;
                                _this.checkSetLevelOver(VideoEvts.playing);
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "onVideoEventCanplay",
            value: function onVideoEventCanplay() {
                this.setCheckLoadTimeoutEnable(false);
                if (!this._videoInfo) {
                    return;
                }
                if (!this._videoInfo.qualityInfo.canplaytime) {
                    this._videoInfo.qualityInfo.canplaytime = videoTool.getBuffered(this._video);
                }
                this.stateMgr.receiveVideoEvt(VideoEvts.canplay);
            }
        },
        {
            key: "onVideoEventPause",
            value: function onVideoEventPause() {
                if (this._pauseType !== PauseType.INNER) {
                    // 过滤掉播放器内部调用的pause，例如切清晰度前程序调用的pause
                    this.stateMgr.receiveVideoEvt(VideoEvts.pause);
                }
            }
        },
        {
            key: "onVideoEventEnded",
            value: function onVideoEventEnded() {
                this._logger.log('setEndInner(), reason=endedEvt');
                this.setEndInner();
            }
        },
        {
            key: "onVideoEventSeeked",
            value: function onVideoEventSeeked() {
                this.updatePlaytime(this._video.currentTime);
                this.stateMgr.receiveVideoEvt(VideoEvts.seeked);
                this.checkSetLevelOver(VideoEvts.seeked);
                this.resumeAfterSeek();
                // 重置userSeek标签
                this._isUserSeek = false;
            }
        },
        {
            key: "onVideoEventLoadStart",
            value: /** 提供给有需要的继承类复写 */ function onVideoEventLoadStart() {}
        },
        {
            key: "onVideoEventWaiting",
            value: function onVideoEventWaiting() {
                this.stateMgr.receiveVideoEvt(VideoEvts.waiting);
            }
        },
        {
            key: "onVideoEventSeeking",
            value: function onVideoEventSeeking() {
                this.stateMgr.receiveVideoEvt(VideoEvts.seeking);
            }
        },
        {
            key: "onVideoEventProgress",
            value: function onVideoEventProgress() {
                this.emit(VideoNodeEvent.VIDEO_BUFFER_CHANGE, {
                    videoInfo: this._videoInfo,
                    bufferRange: this.videoBuffered
                });
            }
        },
        {
            key: "onVideoEventLoadedmetadata",
            value: function onVideoEventLoadedmetadata() {
                this.updateVideoSize();
                this.emit(VideoNodeEvent.METADATA_CHANGE, {
                    videoInfo: this._videoInfo
                });
            }
        },
        {
            key: "onVideoEventResize",
            value: function onVideoEventResize() {
                this.updateVideoSize(true);
            }
        },
        {
            key: "onVideoEventRateChange",
            value: function onVideoEventRateChange() {
                var playbackRate = this._video.playbackRate;
                this._playbackRate = playbackRate;
                this.emit(VideoNodeEvent.RATE_CHANGE, {
                    playbackRate: playbackRate,
                    videoInfo: this._videoInfo
                });
            }
        },
        {
            key: "onVideoEventDurationChange",
            value: function onVideoEventDurationChange() {
                if (this._video.duration > 0 && this._video.duration !== this._videoInfo.duration) {
                    this._videoInfo.duration = this._video.duration;
                    this._logger.log("onVideoEventDurationChange(), uid=".concat(this._videoInfo.uid, "/duration=").concat(this._videoInfo.duration, "/") + "idx=".concat(this.idx));
                    this.emit(VideoNodeEvent.DURATION_CHANGE, {
                        videoInfo: this._videoInfo
                    });
                }
            }
        },
        {
            key: "onVideoEventVolumeChange",
            value: function onVideoEventVolumeChange() {
                this.emit(VideoNodeEvent.VOLUME_CHANGE, {
                    volume: this.volume,
                    videoInfo: this._videoInfo
                });
            }
        },
        {
            key: "onVideoEventTimeUpdate",
            value: function onVideoEventTimeUpdate() {
                this.logPlayTime(this._video.currentTime);
                if (this._video.currentTime === 0) {
                    return;
                }
                this.updatePlaytime(this._video.currentTime);
                this.checkSetLevelOver(VideoEvts.timeupdate);
                // 部分浏览器中直播状态下出现buffer后只抛出canplay事件，不抛出playing事件
                // 导致状态扭转出现异常，所以我们在timeupdate中检查，如果处于buffering状态
                // 且readystate >=3，强制扭转为playing，避免被识别为卡死
                if (this._state === VideoState.BUFFERING && this._video.readyState >= VideoReadyState.HAVE_FUTURE_DATA) {
                    this.stateMgr.setPlaying();
                }
            }
        },
        {
            key: "onAudioTrackSwitched",
            value: function onAudioTrackSwitched(id) {
                var fail = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
                if (this.audioTrackSwitchingDefer) {
                    this.audioTrackSwitchingDefer.resolve({
                        userTrigger: this.isUserSwitchAudioTrack,
                        id: id,
                        fail: fail
                    });
                    this.audioTrackSwitchingDefer = null;
                    this.emit(VideoNodeEvent.SET_AUDIO_TRACK_OVER, {
                        videoInfo: this._videoInfo,
                        id: id,
                        fail: fail,
                        userTrigger: this.isUserSwitchAudioTrack
                    });
                }
            }
        },
        {
            key: "onVideoEventLoadeddata",
            value: function onVideoEventLoadeddata() {
                this.emit(VideoNodeEvent.VIDEO_BUFFER_CHANGE, {
                    videoInfo: this._videoInfo,
                    bufferRange: this.videoBuffered
                });
            }
        },
        {
            key: "onVideoEventError",
            value: function onVideoEventError(_evt) {
                var _this__video = this._video, videoErr = _this__video.error, readyState = _this__video.readyState;
                var ignoreVideoError = this._config.ignoreVideoError;
                // video 的 error 回调抛出，但是 video.error 为 null 的情况下，也许 video 还是能播的
                // 判断下 ignoreVideoError 情况，如果为 true，则直接让播放流程继续下去
                if (!videoErr && ignoreVideoError) {
                    return this._logger.warn('ignore video error due to video.error is null and ignoreVideoError is true');
                }
                this._logger.warn("@BaseVideoNode.onVideoEventError(), videoErr = ".concat(videoErr === null || videoErr === void 0 ? void 0 : videoErr.message, ", readyState = ").concat(readyState));
                this.errorHandler();
            }
        },
        {
            key: "onDrmError",
            value: function onDrmError(event) {
                var _event_data = event.data, code = _event_data.code, message = _event_data.message, detail = _event_data.detail;
                var error = PlayerError.EncryptionError({
                    code: code,
                    detail: detail,
                    message: message
                });
                this._videoInfo.error = error;
                this.stopInner(false, this._videoInfo);
            }
        },
        {
            key: "checkCanSetLevel",
            value: /** 检查是否能切换清晰度 */ function checkCanSetLevel() {
                var setLevelDetail = this.vnStatusChecker.checkCanSetLevel();
                if (setLevelDetail.canSetLevel) {
                    return true;
                }
                this._logger.warn(setLevelDetail.message);
                return false;
            }
        },
        {
            key: "checkSetLevelOver",
            value: /**
   * 检查切换清晰度是否结束
   * @param evtName 事件名，切换清晰度完成可能在多个事件中检查。
   */ function checkSetLevelOver(evtName) {
                if (!this.vnStatusChecker) {
                    // BaseVideoNode可能已经销毁
                    return;
                }
                var setLevelDetail = this.vnStatusChecker.checkIsSetLevelOver(evtName, this.levelSwitchTargetPlaytime);
                if (setLevelDetail) {
                    this._logger.log('setLevelOver(), reason: ' + "succOnPlaying=".concat(setLevelDetail.succInPlaying, "/succOnSeeked=").concat(setLevelDetail.succInSeeked, "/succOnTimeupdate=").concat(setLevelDetail.succInTimeupdate));
                    this.setLevelOver();
                }
            }
        },
        {
            key: "setLevelOver",
            value: /** 切换清晰度结束 */ function setLevelOver() {
                if (!this._levelSwitchingDefer) {
                    return;
                }
                this._levelSwitchingDefer.resolve();
                this._levelSwitchingDefer = null;
                this.levelSwitchTargetPlaytime = -1;
                this.loading.hide();
                this.stateMgr.onSetLevelOver();
                this.emit(VideoNodeEvent.SETLEVEL_OVER, {
                    videoInfo: this._videoInfo
                });
            }
        },
        {
            key: "checkCanSeek",
            value: /**
 * 检查是否可以切换清晰度。
 * @param time 切换时间
 * @returns 是否可执行切换动作
 */ function checkCanSeek(time) {
                var userActivation = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
                var seekDetail = this.vnStatusChecker.checkCanSeek({
                    seektime: time,
                    userActivation: userActivation,
                    setLevelMode: this.setLevelMode
                });
                if (seekDetail.canSeek) {
                    return true;
                }
                this._logger.warn(seekDetail.message);
                return false;
            }
        },
        {
            key: "checkCanSetAudioTrack",
            value: /** 检查是否可以切换音轨 */ function checkCanSetAudioTrack() {
                var setAudioTrackDetail = this.vnStatusChecker.checkCanSetAudioTrack(this.audioTrackSwitchingDefer);
                if (setAudioTrackDetail.canSetAudioTrack) {
                    return true;
                }
                this._logger.warn(setAudioTrackDetail.message);
                return false;
            }
        },
        {
            key: "findFreeVideoElement",
            value: /** 从config传入的video标签数组查找未使用的video标签（是否在文档流中），提供标准查找方法但部分内核需要复写 */ function findFreeVideoElement() {
                return findFreeBaseVideoElement(this._config.videoElements);
            }
        },
        {
            key: "setMainLoopEnable",
            value: /** 设置播放主循环是否启用。用于每帧检查播放进度、监控缓冲状态下是否卡死等 */ function setMainLoopEnable(value) {
                if (value) {
                    this.mainTaskLoop.start();
                } else {
                    this.mainTaskLoop.stop();
                }
            }
        },
        {
            key: "mainLoopInProcess",
            value: /** 主循环执行函数 */ function mainLoopInProcess() {
                var _this_audioController;
                this.updateAccuratePlaytime();
                this.checkPlayHealth.loop();
                (_this_audioController = this.audioController) === null || _this_audioController === void 0 ? void 0 : _this_audioController.loop();
            }
        },
        {
            key: "updateAccuratePlaytime",
            value: /** 更新更精确的时间，普通video事件的间隔时间精确到0.2~0.3s，此函数中精确到0.0167s */ function updateAccuratePlaytime() {
                var // 如果外部有传入回调函数用于播放时间粒度更小的事务执行，在此调用外部回调
                _this_onAccurateTimeupdate, _this;
                // 这里有3个条件，不满足任意case，跳过检查
                // 1. 播放器要处于playing状态，我们认为是在“播放中”
                // 2. video的duration要为正（兼容wasm内核没有ready state的情况）
                // 3. video的ready state小于4（兼容不存在ready state的case，不能使用 !== 4)
                if (this._state !== VideoState.PLAYING || this._video.duration <= 0 || this._video.readyState < VideoReadyState.HAVE_ENOUGH_DATA) {
                    return;
                }
                (_this_onAccurateTimeupdate = (_this = this).onAccurateTimeupdate) === null || _this_onAccurateTimeupdate === void 0 ? void 0 : _this_onAccurateTimeupdate.call(_this, this._video.currentTime, this._video.duration);
                // 更新更精确的时间
                this.updatePlaytime(this._video.currentTime, true);
            }
        },
        {
            key: "updatePlaytime",
            value: function updatePlaytime(value) {
                var silentEvt = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
                if (!this._videoInfo) {
                    return;
                }
                var _this_performanceMonitor_report = this.performanceMonitor.report(), totalVideoFrames = _this_performanceMonitor_report.totalVideoFrames, droppedVideoFrames = _this_performanceMonitor_report.droppedVideoFrames, frameDroppedInPercentage = _this_performanceMonitor_report.frameDroppedInPercentage;
                this._videoInfo.qualityInfo.droppedVideoFrames = droppedVideoFrames;
                this._videoInfo.qualityInfo.totalVideoFrames = totalVideoFrames;
                this._videoInfo.qualityInfo.frameDroppedInPercentage = frameDroppedInPercentage;
                if (this._videoInfo.playtime !== value) {
                    this._videoInfo.playtime = value;
                }
                if (!silentEvt) {
                    this.emit(VideoNodeEvent.TIME_UPDATE, {
                        videoInfo: this._videoInfo
                    });
                }
            }
        },
        {
            key: "setCheckLoadTimeoutEnable",
            value: function setCheckLoadTimeoutEnable(isSetTimer) {
                var _this = this;
                this.loadTimeoutId && clearTimeout(this.loadTimeoutId);
                if (!isSetTimer) return;
                var maxPreloadTimeout = this._config.maxPreloadTimeout;
                if (maxPreloadTimeout <= 0) return;
                this.loadTimeoutId = setTimeout(function() {
                    if (document.visibilityState === 'hidden') {
                        return;
                    }
                    _this.errorHandler(PlayerError.NativeError({
                        code: PlaybackErrorCode.ORG_LOAD_TIMEOUT,
                        detail: commonTool.isPageHidden(),
                        fatal: false,
                        message: compile(i18nConfig.core.ERROR_PRELOAD_VIDEO_TIMEOUT)
                    }));
                }, maxPreloadTimeout);
            }
        },
        {
            key: "resumeAfterSeek",
            value: /** 拖动以后恢复播放或恢复播放状态 */ function resumeAfterSeek() {
                if (!this._played || this._video.ended || !this._isUserSeek) {
                    // 未开播前（比如只是预加载视频）or 视频已经播放结束 or 不是用户的seek操作，不需要在seek以后恢复播放
                    return;
                }
                // 状态机定义中统一规定无论何种状态下seek，seek成功以后变为playing状态
                if (!this._video.paused) {
                    // 如果不是暂停状态（播放状态下拖动），强行恢复到playing状态
                    // （一般浏览器都会在seeked事件以后紧跟canplay、playing事件出来，少数浏览器保持seeked状态。但强行设置playing状态也没关系，如果后续
                    // 又来canplay、playing状态都不会覆盖已经强行设置的playing状态，因为不符合状态表而被过滤）
                    this.stateMgr.setPlaying();
                    return;
                }
                // 如果是暂停状态下seek，结束以后也恢复播放
                if (!this._config.remainPauseStateAfterSeek) {
                    // 但这里除开一种情况，外部指定要保留暂停状态！
                    this.videoplay();
                }
            }
        },
        {
            key: "pauseInner",
            value: function pauseInner() {
                var type = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : PauseType.INNER;
                var _this__videoInfo;
                this._logger.log("pause(), uid=".concat((_this__videoInfo = this._videoInfo) === null || _this__videoInfo === void 0 ? void 0 : _this__videoInfo.uid, "/state=").concat(this.state, "/idx=").concat(this.idx, "/type=").concat(type));
                this._pauseType = type;
                this._video.pause();
            }
        },
        {
            key: "setEndInner",
            value: function setEndInner() {
                if (this._state !== VideoState.END && this._state !== VideoState.IDLE) {
                    this._logger.log("setEndInner(), idx=".concat(this._idx, "/uid=").concat(this._videoInfo.uid, "/playtime=").concat(this._videoInfo.playtime) + "/duration=".concat(this._videoInfo.duration, "}"));
                    // 这里不能直接停止（调用videoNode的stop），因为在列表播放时，即使当前视频停止，也可能会append地址进来继续播放，需要复用一些变量。
                    // （参考代码位置①来理解）
                    this.stateMgr.setEnded(); // 本段播放结束
                    this.emit(VideoNodeEvent.PLAY_OVER, {
                        isUserStop: false,
                        endState: EndState.NORMAL,
                        videoInfo: this._videoInfo
                    });
                }
            }
        },
        {
            key: "stopInner",
            value: function stopInner(keepState, videoInfo) {
                var _this__videoInfo;
                if (!this._video || !this._videoInfo) {
                    return;
                }
                this.setMainLoopEnable(false);
                this.setCheckLoadTimeoutEnable(false);
                this.lastLogPlayTimeTimeStampMs = 0;
                // 停掉之后直接重置seek标记
                this._isUserSeek = false;
                this._logger.log("stopInner(), uid/state/idx: ".concat((_this__videoInfo = this._videoInfo) === null || _this__videoInfo === void 0 ? void 0 : _this__videoInfo.uid, "/").concat(this.state, "/").concat(this.idx));
                this.setVideoEvents(false);
                if (this._config.clearVideoAfterStop) {
                    // 调用videoTool.clear接口清除video标签画面
                    videoTool.clear(this._video);
                } else {
                    // 如果保留画面，播放结束仅暂停，等下一次load时才会清理
                    this._video.pause();
                }
                if (this._config.createVideoNodeWhenLoad) {
                    // 如果确定是load时会重新创建新的VideoNode，那么此VideoNode在停止时需要释放video标签。
                    this._video.dataset.used = VideoElementState.FREE;
                }
                if (this._videoInfo) {
                    this._videoInfo.extraVars.isLoadstarted = false;
                    this._videoInfo = null;
                }
                if (this._pauseCloseToEndStateCheckTimeoutId > 0) {
                    window.clearTimeout(this._pauseCloseToEndStateCheckTimeoutId);
                    this._pauseCloseToEndStateCheckTimeoutId = 0;
                }
                if (this.state === VideoState.IDLE) {
                    // 当前视频段已经播放结束，状态机被重置为idle。但是并没有清除videoInfo等变量。如果重播，会默认调用stop方法，导致
                    // 重复的end、idle状态变化，类似end -> idle -> （重播）-> end -> idle。return语句排除这种情况。
                    // （参考代码位置①）
                    return;
                }
                if (!keepState) {
                    this.stateMgr.setEnded();
                    this._played = false;
                    // 不保持状态的时候，才会清理正在切清晰度的变量。
                    // （例如切换清晰度时出错，会重试备份地址，调用stopInner传入keepState为true，此时还在切清晰度，不能清理此变量）
                    this._levelSwitchingDefer = null;
                    if (videoInfo === null || videoInfo === void 0 ? void 0 : videoInfo.error) {
                        this.emit(VideoNodeEvent.ERROR, {
                            videoInfo: videoInfo
                        });
                    }
                }
            }
        },
        {
            key: "updateVideoSize",
            value: /** 更新视频尺寸 */ function updateVideoSize() {
                var isNativeEvt = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
                var vw = this._video.videoWidth;
                var vh = this._video.videoHeight;
                if (this._videoInfo && (this._videoInfo.videoWidth !== vw || this._videoInfo.videoHeight !== vh)) {
                    var _this_videoResizeAutoFill;
                    this._videoInfo.videoWidth = vw;
                    this._videoInfo.videoHeight = vh;
                    this.emit(VideoNodeEvent.VIDEO_RESIZE, {
                        videoInfo: this._videoInfo,
                        isNative: isNativeEvt
                    });
                    (_this_videoResizeAutoFill = this.videoResizeAutoFill) === null || _this_videoResizeAutoFill === void 0 ? void 0 : _this_videoResizeAutoFill.resizeAutoFill();
                }
            }
        },
        {
            key: "setLoadingOnStateChange",
            value: /** 当播放状态变化时设置loading动画是否展示 */ function setLoadingOnStateChange() {
                // 未开播之前的状态变化，都不显示loading
                if (!this._played) {
                    this.loading.hide();
                    return;
                }
                // 播放中缓冲和开始Seek状态需要显示loading动画
                if ([
                    VideoState.BUFFERING,
                    VideoState.SEEKING
                ].includes(this._state)) {
                    var delayTimeMS = 500;
                    // 变为seeking、buffering等状态，显示loading动画，但是延迟一定时间展示，避免出现loading动画很快出现又消失
                    this.loading.show(delayTimeMS);
                    return;
                }
                // 下面逻辑判断何时去掉loading动画
                if (// 直播只有canplay状态才去掉loading动画，[注意]直播时canplay不去掉loading动画的原因是：
                // 当某些浏览器（wechat-ios）不支持自动播放时调用load接口无法加载数据，BaseVideoNode会强行派发一个canplay状态出去，然后等用户点击
                // 用户点击播放以后调用play，此时才真正开始加载数据并播放。此种场景如果canplay状态去掉了loading动画，play以后就会有较长时间的黑屏而
                // 没有loading，体验较差。因此，直播在canplay的时候不去掉loading动画，而是在autoplayBlock/playing两种情况下去掉。这样可以保证体验
                this._config.type === PlayMode.LIVE && VideoState.CANPLAY !== this._state || this._config.type === PlayMode.VOD) {
                    this.loading.hide();
                }
            }
        },
        {
            key: "errorHandler",
            value: /**
   * 出错时的处理函数
   * @param errorData 原始错误数据
   */ function errorHandler(errorData) {
                var error = this.parseErrorData(errorData);
                this._logger.log('video encounter error', error);
                var isCurrentPositionBuffered = videoTool.isPositionBuffered(this._video);
                this._logger.log("current position buffered=".concat(isCurrentPositionBuffered));
                if (!isCurrentPositionBuffered) {
                    this._logger.warn('current position is not buffered, check close range');
                    this._logger.warn("next buffered start=".concat(videoTool.getNextBufferedStart(this._video)));
                    this._logger.warn("last buffered end=".concat(videoTool.getLastBufferedEnd(this._video)));
                }
                // 开始执行重试
                this.retryWhenError(error);
            }
        },
        {
            key: "retryWhenError",
            value: function retryWhenError(error) {
                // 需要先存一下，避免stopInner()把this._videoInfo置空
                var nextVideoInfo = this._videoInfo;
                var retryUrlRet = this.setRetryUrl(nextVideoInfo);
                // 根据url上的过期时间戳判断urlconfig是否可用
                var expireTimeStamp = nextVideoInfo.config.expireTimeStamp;
                var isUrlExpired = typeof expireTimeStamp === 'undefined' ? false : expireTimeStamp < +new Date();
                if (this._videoInfo.stateWhenErrorHappen === null) {
                    // 连续重试只记录一次，因此要判断下null
                    this._videoInfo.stateWhenErrorHappen = this._state;
                }
                // 不是最终错误 && urlconfig没有过期 && 有下一个重新地址，这几个条件满足时重试
                if (!error.fatal && !isUrlExpired && retryUrlRet) {
                    var retryCount = nextVideoInfo.getRetryCount();
                    this._logger.log('retryOnError(), retryCount=', retryCount);
                    this.emit(VideoNodeEvent.RETRY, _$6({
                        error: error,
                        retryCount: retryCount,
                        videoInfo: nextVideoInfo
                    }, retryUrlRet));
                    this.stopInner(true);
                    // 重试的话强行进入buffering状态
                    this.stateMgr.setWaiting();
                    // 上一句扭转的buffering状态可能不成功（例如是seeking状态卡死导致的重试），所以在出错重试时强制显示loading动画
                    if (this._state !== VideoState.BUFFERING) {
                        this.loading.show();
                    }
                    this.doRetry(nextVideoInfo);
                    return;
                }
                this._logger.log('retryOnError(), fatal.');
                // 无法执行重试，最终失败
                this._videoInfo.error = error;
                // 如果正在切换清晰度，reject promise，抛出异常
                if (this._levelSwitchingDefer) {
                    this._levelSwitchingDefer.reject(error);
                }
                this.stopInner(false, this._videoInfo);
            }
        },
        {
            key: "parseErrorData",
            value: /**
   * 从各种内核的原始信息中解析出的标准的错误信息，basenode只处理未知和标准video错误转换，其他内核需要自行复写
   * @param errorData 原始错误数据
   * @returns 处理过的错误信息
   */ function parseErrorData(errorData) {
                var _this__config;
                // 注意这里return IVideoError是为了兼容还没有实现ErrorBase的内核
                if (errorData) {
                    // 这里将errorData全部标准化为ErrorBase的格式，方便后续处理
                    return commonErrorParse(errorData);
                }
                var _getVideoError;
                // 如果没有任何错误信息，尝试从video标签上获取，如果还是没有则视为未知错误
                return (_getVideoError = getVideoError(this._video, (_this__config = this._config) === null || _this__config === void 0 ? void 0 : _this__config.instanceId)) !== null && _getVideoError !== void 0 ? _getVideoError : PlayerError.NativeError({
                    code: PlaybackErrorCode.UNKNOWN_ERR,
                    fatal: false,
                    message: compile(i18nConfig.core.ERROR_MSG_UNKNOWN),
                    debugMessage: jsonTool.safelyStringify(this._video.error)
                });
            }
        },
        {
            key: "doRetry",
            value: /** 开始执行重试 */ function doRetry(videoInfo) {
                // 重试的时间获取：
                // 如果video组建时间大于0先拿video组件上的时间，再拿videoInfo的playtime兜底。这是因为seek操作时候如果出现错误重试，videoInfo上的
                // playtime并没有更新，但是video.currentTime已经被设置过来了，video.currentTime就是重试后真实起播点
                var playtime = videoInfo.playtime, stateWhenErrorHappen = videoInfo.stateWhenErrorHappen;
                var retryPlaytime = this._video.currentTime > 0 ? this._video.currentTime : playtime;
                var startTime = this._played ? retryPlaytime : this._userStartTime;
                this._logger.log("do retry [url], stateWhenErrorHappen=".concat(stateWhenErrorHappen));
                // 注意，这个地方要把重试的时间复制回videoInfo上，避免连续失败无法获取时间的问题
                videoInfo.playtime = startTime;
                if (!this._played || stateWhenErrorHappen === VideoState.PAUSE) {
                    this.load(videoInfo, {
                        startTime: startTime
                    });
                } else {
                    this.play(videoInfo, {
                        startTime: startTime
                    });
                }
            }
        },
        {
            key: "setRetryUrl",
            value: /**
   * 给IVideoInfo设置准备重试的地址
   * @param vinfo IVideoInfo对象
   * @returns 返回设置重试地址的结果，其中包含设置前和设置后的地址。如果设置失败，返回null值
   */ function setRetryUrl(vinfo) {
                var loadingUrl = vinfo.loadingUrl;
                var prevUrl = loadingUrl;
                var hasNextBackup = vinfo.setNextBackUrl();
                if (hasNextBackup) {
                    return {
                        prevUrl: prevUrl,
                        curUrl: vinfo.loadingUrl
                    };
                }
                return null;
            }
        },
        {
            key: "emitKernelEvt",
            value: /**
   * 转发内核特殊事件，例如hls内核中，外部可能会监听hls.js事件抛出的一些数据。
   * <br>[注意]需要说明的是，我们使用全局的evtBus来派发内核特殊事件，为了避免多个播放器实例的事件串了，我们会在抛出的数据中携带播放器实例的id
   * @param evt 事件名称
   * @param data 事件数据
   */ function emitKernelEvt(evt, data) {
                kernelEvtBus.emit(evt, _$f(_$6({}, data), {
                    playerInstanceId: this.config.instanceId
                }));
            }
        },
        {
            key: "adjustSeekTime",
            value: function adjustSeekTime(time) {
                var targetTime = time;
                if ((uaTool.browser.x5 || uaTool.browser.safari) && Math.abs(targetTime - this._videoInfo.duration) <= 1) {
                    // bug：
                    // safari / x5下可能出现直接seek到视频的最结尾（seek时间等于视频时长）后，video不发出end事件出来，所以检测如果这种情况，把time值回退1s
                    targetTime = this._videoInfo.duration - 1;
                }
                return targetTime;
            }
        },
        {
            key: "logPlayTime",
            value: /**
   * 打印当前<video/>的时间。但是有一个1秒的频率控制
   */ function logPlayTime(playtime) {
                if (this._config.type === PlayMode.LIVE) {
                    // 担心直播打印太多
                    return;
                }
                var LOG_GAP_MS = 1000;
                var nowTimeStampMs = Date.now();
                if (this.lastLogPlayTimeTimeStampMs === 0 || nowTimeStampMs - this.lastLogPlayTimeTimeStampMs >= LOG_GAP_MS) {
                    this._logger.log('playtime', playtime);
                    this.lastLogPlayTimeTimeStampMs = nowTimeStampMs;
                }
            }
        }
    ]);
    return BaseVideoNode;
}(EvtEmitter);
_$7([
    logMethodCall$6,
    _$8("design:type", Function),
    _$8("design:paramtypes", [
        typeof PauseType === "undefined" ? Object : PauseType
    ]),
    _$8("design:returntype", void 0)
], BaseVideoNode.prototype, "pause", null);
_$7([
    logMethodCall$6,
    _$8("design:type", Function),
    _$8("design:paramtypes", []),
    _$8("design:returntype", void 0)
], BaseVideoNode.prototype, "stop", null);
_$7([
    logMethodCall$6,
    _$8("design:type", Function),
    _$8("design:paramtypes", []),
    _$8("design:returntype", void 0)
], BaseVideoNode.prototype, "destroy", null);
_$7([
    logMethodCall$6,
    _$8("design:type", Function),
    _$8("design:paramtypes", [
        typeof SetLevelMode === "undefined" ? Object : SetLevelMode
    ]),
    _$8("design:returntype", typeof Promise === "undefined" ? Object : Promise)
], BaseVideoNode.prototype, "setLevel", null);
_$7([
    logMethodCall$6,
    _$8("design:type", Function),
    _$8("design:paramtypes", [
        Object
    ]),
    _$8("design:returntype", typeof Promise === "undefined" ? Object : Promise)
], BaseVideoNode.prototype, "setAudioTrack", null);
_$7([
    logMethodCall$6,
    _$8("design:type", Function),
    _$8("design:paramtypes", [
        Boolean
    ]),
    _$8("design:returntype", void 0)
], BaseVideoNode.prototype, "setCheckLoadTimeoutEnable", null);
_$7([
    logMethodCall$6,
    _$8("design:type", Function),
    _$8("design:paramtypes", [
        typeof PauseType === "undefined" ? Object : PauseType
    ]),
    _$8("design:returntype", void 0)
], BaseVideoNode.prototype, "pauseInner", null);
_$7([
    logMethodCall$6,
    _$8("design:type", Function),
    _$8("design:paramtypes", []),
    _$8("design:returntype", void 0)
], BaseVideoNode.prototype, "setEndInner", null);
_$7([
    logMethodCall$6,
    _$8("design:type", Function),
    _$8("design:paramtypes", [
        Boolean,
        typeof IVideoInfo === "undefined" ? Object : IVideoInfo
    ]),
    _$8("design:returntype", void 0)
], BaseVideoNode.prototype, "stopInner", null);
_$7([
    logMethodCall$6,
    _$8("design:type", Function),
    _$8("design:paramtypes", [
        typeof IVideoError === "undefined" ? Object : IVideoError
    ]),
    _$8("design:returntype", void 0)
], BaseVideoNode.prototype, "retryWhenError", null);

var logMethodCall$5 = logMethodCallDecoratorCreator('OrgVideoNode');
var OrgVideoNode = /*#__PURE__*/ function(BaseVideoNode) {
    _$9(OrgVideoNode, BaseVideoNode);
    var _super = _$a(OrgVideoNode);
    function OrgVideoNode(config) {
        _$5(this, OrgVideoNode);
        var _this;
        _this = _super.call(this, config);
        _$1(_$b(_this), "needPlaySeektime", void 0);
        _$1(_$b(_this), "canplayDefer", void 0);
        _$1(_$b(_this), "waitVideoLoadStartEvtDefer", void 0);
        _this._logger = new Logger(config.instanceId, 'OrgVideoNode');
        return _this;
    }
    _$4(OrgVideoNode, [
        {
            key: "onVideoEventCanplay",
            value: function onVideoEventCanplay() {
                var _this_canplayDefer;
                (_this_canplayDefer = this.canplayDefer) === null || _this_canplayDefer === void 0 ? void 0 : _this_canplayDefer.resolve();
                _$g(_$h(OrgVideoNode.prototype), "onVideoEventCanplay", this).call(this);
            }
        },
        {
            key: "onVideoEventLoadedmetadata",
            value: function onVideoEventLoadedmetadata() {
                _$g(_$h(OrgVideoNode.prototype), "onVideoEventLoadedmetadata", this).call(this);
                if ((uaTool.os.ios || uaTool.browser.safari) && [
                    PreloadType.META_DATA,
                    PreloadType.AUTO
                ].includes(this._config.preloadType)) {
                    // ios和mac safari如果是只加载头部数据，不会发出canplay事件。这时候就需要强制成canplay，然后才可以清除预加载超时，并能触发播放
                    this.onVideoEventCanplay();
                }
            }
        },
        {
            key: "onVideoEventLoadeddata",
            value: function onVideoEventLoadeddata() {
                _$g(_$h(OrgVideoNode.prototype), "onVideoEventLoadeddata", this).call(this);
                // ios要在canplay以后才能seek，所以在这里检查开播以后需要跳转到哪个起播点
                this.checkPlayInitSeek();
            }
        },
        {
            key: "onVideoEventTimeUpdate",
            value: function onVideoEventTimeUpdate() {
                _$g(_$h(OrgVideoNode.prototype), "onVideoEventTimeUpdate", this).call(this);
                // x5要在timeupdate以后才能seek，所以在这里检查开播以后需要跳转到哪个起播点
                this.checkPlayInitSeek();
            }
        },
        {
            key: "onVideoEventLoadStart",
            value: function onVideoEventLoadStart() {
                this.resolveWaitVideoLoadStartEvt();
            }
        },
        {
            key: "load",
            value: function load(videoInfo, opts) {
                var _this = this;
                if (!videoInfo.loadingUrl) {
                    return false;
                }
                this.stopInner(true);
                this._drm.init(videoInfo.config.drmConfig);
                this._videoInfo = videoInfo;
                this._videoInfo.extraVars.isLoadstarted = true;
                this.setVideoEvents(true);
                this.stateMgr.setLoadStart();
                this.assignStartTime((opts === null || opts === void 0 ? void 0 : opts.startTime) || 0);
                NetTiming.observer(this._config.instanceId, {
                    url: this._videoInfo.loadingUrl,
                    tag: "".concat(this._videoInfo.uid, "_video"),
                    callback: function(entry) {
                        _this._logger.log('loading url perf entry, ', entry);
                    }
                });
                this._video.src = this._videoInfo.loadingUrl;
                this._logger.log("load(), uid=".concat(this._videoInfo.uid));
                if (this._config.preloadType === PreloadType.AUTO_LOAD) {
                    this._video.load();
                }
                this.setCheckLoadTimeoutEnable(true);
                this.canplayDefer = new SimpleDefer();
                this.waitVideoLoadStartEvt().then(function() {
                    // 收到了loadStart事件
                    _this._logger.log('load(), video load succ...');
                }).catch(function() {
                    _this._logger.error('load(), video load cannot be trigger...');
                    // 没收到loadStart事件，等待超时
                    _this.onVideoEventCanplay();
                });
                return true;
            }
        },
        {
            key: "play",
            value: function play(videoInfo, opts) {
                var _this = this;
                this._logger.log("play(), uid=".concat(videoInfo === null || videoInfo === void 0 ? void 0 : videoInfo.uid, "/idx=").concat(this.idx, "/state=").concat(this.state));
                this._played = true;
                if (videoInfo && !videoInfo.extraVars.isLoadstarted) {
                    // 如果没有开始加载，尝试加载视频
                    this.load(videoInfo, opts);
                }
                var playPromise = null;
                if (uaTool.browser.safari && this.canplayDefer) {
                    // 调用load以后，如果马上play，目前safari会无法检测到自动播放，因此safari的话等canplay后再调用play播放
                    // 看下面示例代码在safari中的运行可以看到这里修改的原因
                    // var videoTag = document.querySelector('video');
                    // videoTag.src = '//' + location.host + '/assets/u3139lwnb4l.mp4'
                    // videoTag.load();
                    // // 如果马上调用
                    // videoTag.play().catch(function (e) {
                    //   console.this._logger.log(`play() catch: ${e.name}, ${e.message}`);// AbortError, The operation was aborted
                    // });
                    // // 如果在canplay后调用
                    // videoTag.addEventListener('canplay', function() {
                    //   videoTag.play().catch(function (e) {
                    // NotAllowedError, The request is not allowed by ...
                    //   console.this._logger.log(`play() catch: ${e.name}, ${e.message}`);
                    // });
                    // // })
                    this.canplayDefer.promise.then(function() {
                        _this.videoplay();
                    });
                } else {
                    playPromise = this.videoplay();
                }
                this.setMainLoopEnable(true);
                return playPromise;
            }
        },
        {
            key: "assignStartTime",
            value: /**
   * 指定起播时间
   * @param startTime 起播时间点
   * @returns void
   */ function assignStartTime(startTime) {
                if (this._config.type === PlayMode.LIVE) {
                    // 指定起播点只有点播模式下才生效
                    return;
                }
                this._userStartTime = startTime;
                var playtime = !Number.isNaN(startTime) && startTime >= 0 ? startTime : 0;
                if (playtime <= 0) {
                    return;
                }
                if (videoTool.supportMediaFragmentsURISpec(this._config.enableMediaFragmentsURI) && !this._videoInfo.loadingUrl.startsWith('blob:')) {
                    this._logger.log('assignStartTime by #t');
                    // url直接指定#t参数，但blob地址不支持指定播放起点
                    this._videoInfo.setLoadingUrlStartTime(playtime);
                } else {
                    this._logger.log('assignStartTime with seek()');
                    // 开播以后seek到目标点
                    this.needPlaySeektime = playtime;
                }
            }
        },
        {
            key: "checkPlayInitSeek",
            value: function checkPlayInitSeek() {
                if (this.needPlaySeektime > 0 && this._videoInfo && this._video.duration > 0) {
                    // 判断的最后一个条件是因为一般video的duration<=0时都无法seek
                    this._logger.log("checkPlayInitSeek(), idx=".concat(this.idx, "/seektime=").concat(this.needPlaySeektime));
                    this.seek(this.needPlaySeektime);
                    this.needPlaySeektime = 0;
                }
            }
        },
        {
            key: "stopInner",
            value: function stopInner(keepState, videoInfo) {
                this.canplayDefer = null;
                this.needPlaySeektime = 0;
                if (this._config && this._videoInfo) {
                    NetTiming.unobserver(this._config.instanceId, {
                        tag: "".concat(this._videoInfo.uid, "_video")
                    });
                }
                _$g(_$h(OrgVideoNode.prototype), "stopInner", this).call(this, keepState, videoInfo);
            }
        },
        {
            key: "seek",
            value: function seek(value) {
                var isUser = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
                var time = value;
                if (!this.checkCanSeek(time, isUser)) {
                    return false;
                }
                time = this.adjustSeekTime(time);
                this._isUserSeek = isUser;
                this._logger.log("seek(), uid".concat(this._videoInfo.uid, "/idx=").concat(this.idx, "/time=").concat(time, "/duration=").concat(this._video.duration, "/") + "state=".concat(this.state));
                this._targetSeekTime = time;
                this._video.currentTime = time;
                return true;
            }
        },
        {
            key: "updateAccuratePlaytime",
            value: function updateAccuratePlaytime() {
                _$g(_$h(OrgVideoNode.prototype), "updateAccuratePlaytime", this).call(this);
                var leftTime = Math.abs(this._video.duration - this._video.currentTime);
                var advanceEndTime = this._config.originKernelConfig.advanceEndTime;
                if (advanceEndTime > 0 && leftTime <= advanceEndTime) {
                    // 根据配置的时间提前结束当前的播放
                    this._logger.log('setEndInner(), reason=leftTimeCheck');
                    this.setEndInner();
                }
            }
        },
        {
            key: "setEndInner",
            value: function setEndInner() {
                if (this.state !== VideoState.END && this.state !== VideoState.IDLE) {
                    if (this.onAccurateTimeupdate) {
                        this.onAccurateTimeupdate(0);
                    }
                    this.updatePlaytime(this._video.currentTime); // 更新更精确的时间
                }
                _$g(_$h(OrgVideoNode.prototype), "setEndInner", this).call(this);
            }
        },
        {
            key: "waitVideoLoadStartEvt",
            value: /**
 * ios的微信浏览器和x5浏览器在没有用户手势之前，调用video.load()接口，并不会有数据请求，也不会收到video组件的loadStart、canplay事件。
 * 因此我们等待一下video组件的loadStart事件，如果收到了，说明触发了数据加载，可以成功触发后续的canplay事件。但是如果一定时间后没有收到
 * loadStart事件，那么可以判断video.load()接口调用并没有任何反应。
 */ function waitVideoLoadStartEvt() {
                var _this = this;
                this.waitVideoLoadStartEvtDefer = new SimpleDefer();
                // 50ms后都没有收到loadStart事件，说明video组件在调用load以后并不会触发加载行为
                var WAIT_TIME_MS = 50;
                window.setTimeout(function() {
                    if (_this.waitVideoLoadStartEvtDefer.state !== 'rejected') {
                        _this.waitVideoLoadStartEvtDefer.reject();
                    }
                }, WAIT_TIME_MS);
                return this.waitVideoLoadStartEvtDefer.promise;
            }
        },
        {
            key: "resolveWaitVideoLoadStartEvt",
            value: function resolveWaitVideoLoadStartEvt() {
                if (this.waitVideoLoadStartEvtDefer) {
                    this.waitVideoLoadStartEvtDefer.resolve();
                }
            }
        }
    ]);
    return OrgVideoNode;
}(BaseVideoNode);
_$7([
    logMethodCall$5,
    _$8("design:type", Function),
    _$8("design:paramtypes", [
        typeof IVideoInfo === "undefined" ? Object : IVideoInfo,
        Object
    ]),
    _$8("design:returntype", void 0)
], OrgVideoNode.prototype, "play", null);
_$7([
    logMethodCall$5,
    _$8("design:type", Function),
    _$8("design:paramtypes", [
        Boolean,
        typeof IVideoInfo === "undefined" ? Object : IVideoInfo
    ]),
    _$8("design:returntype", void 0)
], OrgVideoNode.prototype, "stopInner", null);
_$7([
    logMethodCall$5,
    _$8("design:type", Function),
    _$8("design:paramtypes", [
        Number,
        void 0
    ]),
    _$8("design:returntype", void 0)
], OrgVideoNode.prototype, "seek", null);

var logMethodCall$4 = logMethodCallDecoratorCreator('OrgIOSVideoNode');
// 暂停的阈值时长
var PAUSE_TIME_THRESHOLD = 5 * 1000;
/**
 * iOS 原生播放专用 VideoNode，用于兼容 iOS 播放中的 bug
 */ var OrgIOSVideoNode = /*#__PURE__*/ function(OrgVideoNode) {
    _$9(OrgIOSVideoNode, OrgVideoNode);
    var _super = _$a(OrgIOSVideoNode);
    function OrgIOSVideoNode() {
        _$5(this, OrgIOSVideoNode);
        var _this;
        _this = _super.apply(this, arguments);
        /** 上次调用 pause 时的播放时间 */ _$1(_$b(_this), "lastPausePlayTime", null);
        /** 上次调用 pause 时的时间戳 */ _$1(_$b(_this), "lastPauseTimeStamp", null);
        /** 是否屏蔽 seek 事件 */ _$1(_$b(_this), "disableSeekEvt", false);
        return _this;
    }
    _$4(OrgIOSVideoNode, [
        {
            key: "setLevel",
            value: function setLevel() {
                var mode = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : SetLevelMode.HARD;
                this.clearPauseMemTime();
                return _$g(_$h(OrgIOSVideoNode.prototype), "setLevel", this).call(this, mode);
            }
        },
        {
            key: "onVideoEventPause",
            value: function onVideoEventPause() {
                /**
     * Webkit Bug:
     * 这里 iOS 15 存在一个 Bug，当暂停播放后，将浏览器切换到后台约 10s，再切回来播放
     * 则起播时间和上次暂停的不一致，起播时间可能会增加 0.5 ~ 3分钟
     * @see https://git.woa.com/ThumbPlayerMaster/ThumbPlayerH5/thumbplayer-h5/issues/98
     */ if (this.isOriginHlsPlaying()) {
                    this.lastPausePlayTime = this._video.currentTime;
                    this.lastPauseTimeStamp = Date.now();
                }
                return _$g(_$h(OrgIOSVideoNode.prototype), "onVideoEventPause", this).call(this);
            }
        },
        {
            key: "onVideoEventSeeking",
            value: function onVideoEventSeeking() {
                this.clearPauseMemTime();
                if (this.disableSeekEvt) {
                    return;
                }
                return _$g(_$h(OrgIOSVideoNode.prototype), "onVideoEventSeeking", this).call(this);
            }
        },
        {
            key: "onVideoEventSeeked",
            value: function onVideoEventSeeked() {
                if (this.disableSeekEvt) {
                    this.disableSeekEvt = false;
                    return;
                }
                _$g(_$h(OrgIOSVideoNode.prototype), "onVideoEventSeeked", this).call(this);
            }
        },
        {
            key: "onVideoEventPlaying",
            value: function onVideoEventPlaying() {
                // 如果是特定版本的 iOS 设备，在起播时，如果 pause 的时间超过阈值，则强行 seek 回来
                if (OrgIOSVideoNode.shouldUseResumeFix && this.lastPausePlayTime && Date.now() - this.lastPauseTimeStamp > PAUSE_TIME_THRESHOLD) {
                    this.disableSeekEvt = true;
                    this._video.currentTime = this.lastPausePlayTime;
                }
                this.clearPauseMemTime();
                return _$g(_$h(OrgIOSVideoNode.prototype), "onVideoEventPlaying", this).call(this);
            }
        },
        {
            key: "clearPauseMemTime",
            value: function clearPauseMemTime() {
                this.lastPausePlayTime = null;
                this.lastPauseTimeStamp = null;
            }
        },
        {
            key: "isOriginHlsPlaying",
            value: /**
   * 从 loadingURL 判断是否在原生播放 HLS
   * @return 是否为 hls
   */ function isOriginHlsPlaying() {
                var loadingUrl = this.currentVideoInfo.loadingUrl;
                var ext = urlTool.getFileExtension(loadingUrl);
                return fileExtension2VideoType(ext) === VideoType.HLS;
            }
        }
    ], [
        {
            key: "shouldUseResumeFix",
            get: /**
   * 是否启用 Bug 兼容处理：https://git.woa.com/ThumbPlayerMaster/ThumbPlayerH5/thumbplayer-h5/issues/98
   * iOS 15 ，如果 < iOS 15.0 则不做处理
   */ function get() {
                return uaTool.os.ios && commonTool.compareVersion(uaTool.os.version, '15.0') >= 0;
            }
        }
    ]);
    return OrgIOSVideoNode;
}(OrgVideoNode);
_$7([
    logMethodCall$4,
    _$8("design:type", Function),
    _$8("design:paramtypes", [
        void 0
    ]),
    _$8("design:returntype", void 0)
], OrgIOSVideoNode.prototype, "setLevel", null);

/**
 * 播放的视频流流探测
 */ function detectStream(url) {
    return _detectStream.apply(this, arguments);
}
function _detectStream() {
    _detectStream = _$c(function(url) {
        var detectData, _ref, data, target, startTimestamp, downloadSize, downloadCostTime, e, catchData, error, target1;
        return _$d(this, function(_state) {
            switch(_state.label){
                case 0:
                    detectData = {
                        httpCode: -1
                    };
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        netTool.xhr({
                            url: url,
                            retryCount: 0,
                            responseType: 'arraybuffer',
                            range: [
                                0,
                                102400
                            ]
                        })
                    ];
                case 2:
                    _ref = _state.sent(), data = _ref.data, target = _ref.target, startTimestamp = _ref.startTimestamp;
                    detectData.httpCode = target.status;
                    // 使用资源返回的真实长度计算下载速度，单位kb/s
                    downloadSize = data.byteLength / 1024;
                    downloadCostTime = (+new Date() - startTimestamp) / 1000;
                    detectData.downloadSpeed = "".concat(Math.floor(downloadSize / downloadCostTime), "kb/s");
                    try {
                        detectData.headers = target.getAllResponseHeaders();
                    } catch (e) {}
                    return [
                        3,
                        4
                    ];
                case 3:
                    e = _state.sent();
                    catchData = e || {};
                    error = catchData.error, target1 = catchData.target;
                    detectData.httpCode = target1 === null || target1 === void 0 ? void 0 : target1.status;
                    detectData.error = error;
                    return [
                        3,
                        4
                    ];
                case 4:
                    return [
                        2,
                        detectData
                    ];
            }
        });
    });
    return _detectStream.apply(this, arguments);
}

var i18nCore = i18nConfig.core;
var CheckPlayerStatus = /*#__PURE__*/ function() {
    function CheckPlayerStatus(player) {
        var _this = this;
        _$5(this, CheckPlayerStatus);
        _$1(this, "setLevelValidator", {
            NOT_INITIALIZED: function() {
                if (!_this.player) {
                    return {
                        isValid: false,
                        message: compile(i18nCore.ERROR_STATUS_NOT_INITIALIZED)
                    };
                }
                return VALIDATE_PASS_RESULT;
            },
            NOT_PLAYING: function() {
                if (!_this.player.played) {
                    return {
                        isValid: false,
                        message: compile(i18nCore.ERROR_STATUS_NOT_PLAYING)
                    };
                }
                return VALIDATE_PASS_RESULT;
            },
            EMPTY_URL: function(setLevelUrl) {
                if (!setLevelUrl) {
                    return {
                        isValid: false,
                        message: compile(i18nCore.ERROR_STATUS_EMPTY_URL)
                    };
                }
                return VALIDATE_PASS_RESULT;
            },
            EMPTY_VIDEO_INFO: function() {
                if (!_this.player.currentVideoInfo) {
                    return {
                        isValid: false,
                        message: compile(i18nCore.ERROR_STATUS_VIDEO_INFO)
                    };
                }
                return VALIDATE_PASS_RESULT;
            },
            PLAYTIME_CHECK: function() {
                if (_this.player.currentVideoInfo.playtime <= 0) {
                    return {
                        isValid: false,
                        message: compile(i18nCore.ERROR_STATUS_PLAYTIME_CHECK)
                    };
                }
                return VALIDATE_PASS_RESULT;
            },
            CLOSE_TO_END: function() {
                var _this_player = _this.player, videoInfo = _this_player.currentVideoInfo;
                if (_this.player.config.type === PlayMode.VOD && videoInfo.playtime + 1 >= videoInfo.duration && videoInfo.duration !== Infinity) {
                    return {
                        isValid: false,
                        message: compile(i18nCore.ERROR_STATUS_CLOSE_TO_END)
                    };
                }
                return VALIDATE_PASS_RESULT;
            },
            TARGET_NOT_CHANGE: function(setLevelUrl) {
                var currentVideoInfo = _this.player.currentVideoInfo;
                if (setLevelUrl === currentVideoInfo.loadingUrl) {
                    return {
                        isValid: false,
                        message: compile(i18nCore.ERROR_STATUS_TARGET_UNCHANGED)
                    };
                }
                return VALIDATE_PASS_RESULT;
            }
        });
        _$1(this, "player", void 0);
        this.player = player;
    }
    _$4(CheckPlayerStatus, [
        {
            key: "checkSetLevelMode",
            value: /**
   * 默认选择清晰度切换模式
   * @param vnlistLen videoNode列表个数
   * @param forceSetLevelMode 外部强制指定的清晰度切换模式
   * @returns 清晰度切换模式
   */ function checkSetLevelMode(vnlistLen, forceSetLevelMode) {
                if (vnlistLen < 2) {
                    // 如果小于两个video标签，只能黑屏切换清晰度
                    return SetLevelMode.HARD;
                }
                if (forceSetLevelMode) {
                    return forceSetLevelMode;
                }
                return SetLevelMode.SOFT;
            }
        },
        {
            key: "checkCanAppend",
            value: /**
   * 检测是否当前满足append环境条件
   * @param urlConfig 待append的视频URL对象
   * @returns {canAppend:boolean,message:string}canAppend表示是否支持Append，message表示具体信息描述和不能append原因
   */ function checkCanAppend(urlConfig) {
                var _this_player;
                // basePlayer或相关配置为空，不能拼接或者预加载
                if (!((_this_player = this.player) === null || _this_player === void 0 ? void 0 : _this_player.config)) {
                    return {
                        canAppend: false,
                        message: 'BasePlayer or basePlayer.config is null'
                    };
                }
                // 如果不是List播放，不能拼接或者预加载
                if (!this.player.config.isPlayList) {
                    return {
                        canAppend: false,
                        message: 'Only supported when [isPlayList] is true'
                    };
                }
                // 如果尚未起播过，不能拼接或者预加载
                if (!this.player.played) {
                    return {
                        canAppend: false,
                        message: 'Player has not been played'
                    };
                }
                // 检查UrlConfig作为参数时是否是合法的，如果返回错误，也不能拼接或者预加载
                var checkUrlConfigError = checkUrlConfigVailed(urlConfig);
                if (checkUrlConfigError) {
                    return {
                        canAppend: false,
                        message: "urlconfig err=".concat(checkUrlConfigError)
                    };
                }
                return {
                    canAppend: true,
                    message: 'Can append video now'
                };
            }
        },
        {
            key: "checkCanPreloadEnvi",
            value: /**
   * 检测是否当前满足preload环境条件
   * @param urlConfigs 待preload的视频UrlConfig数组对象
   * @returns {canPreload:boolean,message:string}canPreload表示是否支持preload，message表示具体信息描述和不能preload原因
   */ function checkCanPreloadEnvi(urlConfigs) {
                // 判断条件与checkCanAppend相同，复用逻辑
                var preloadDetail = this.checkCanAppend(urlConfigs);
                if (!preloadDetail.canAppend) {
                    return {
                        canPreload: false,
                        message: preloadDetail.message
                    };
                }
                // 继承是否支持逻辑判断
                if (!this.player.supportPreload) {
                    return {
                        canPreload: false,
                        message: 'preloadNext() fail, browser not support preload.'
                    };
                }
                return {
                    canPreload: true,
                    message: 'Can preload video now'
                };
            }
        },
        {
            key: "checkCanPreloadEachConfig",
            value: /**
   * 检查单个UrlConfig是否当前满足preload播放条件
   * @param urlConfig 待preload的视频URL对象
   * @returns {canPreload:boolean,message:string}canPreload表示是否支持preload，message表示具体信息描述和不能preload原因
   */ function checkCanPreloadEachConfig(urlConfig) {
                var _this_player;
                if (!((_this_player = this.player) === null || _this_player === void 0 ? void 0 : _this_player.videoInfos)) {
                    return {
                        canPreload: false,
                        message: 'preloadInner() fail, because player or videoInfo is null.'
                    };
                }
                var idx = this.player.videoInfos.findIndex(function(value) {
                    return compareUrlConfig(value.config, urlConfig);
                });
                // 已经播放过了，没必要预加载了
                if (idx !== -1 && idx <= this.player.curUrlIdx) {
                    return {
                        canPreload: false,
                        message: 'preloadInner() fail, because this videoInfo has been played.'
                    };
                }
                // 如果跨过下一个视频预加载下下个，或者下下下个视频，是不允许的
                if (idx !== -1 && idx > this.player.curUrlIdx + 1) {
                    return {
                        canPreload: false,
                        message: 'preloadInner() fail, can not skip next to preload.'
                    };
                }
                // 如果列表中有下一个播放地址，而预加载的又不是下一个，那就没必要了吧
                // 如果basePlayer.nextVideoInfo为空，可能存在新的视频信息逻辑，所以此处nextVideoInfo必须存在
                if (this.player.nextVideoInfo && !compareUrlConfig(this.player.nextVideoInfo.config, urlConfig)) {
                    return {
                        canPreload: false,
                        message: 'preloadInner() fail, the next has been appended, you only can preload next.'
                    };
                }
                // 已经在预加载列表中了
                var index = this.player.preloadVideoInfos.findIndex(function(value) {
                    return compareUrlConfig(value.config, urlConfig);
                });
                var hasPreload = index !== -1;
                if (hasPreload) {
                    return {
                        canPreload: false,
                        message: 'preloadInner() fail, the VideoInfo has been preloaded.'
                    };
                }
                return {
                    canPreload: true,
                    message: 'Can preload video now'
                };
            }
        },
        {
            key: "checkSetLevelError",
            value: /**
   * 判断当前播放器切换清晰度外在条件是否满足，并返回对应信息（展示在tips上）
   * @param levelUrl 切换的目标URL
   * @returns 返回描述信息，如果为null代表满足条件
   */ function checkSetLevelError(levelUrl) {
                var validateResult = runValidators(Object.values(this.setLevelValidator), function(validatorRunner) {
                    return validatorRunner(levelUrl);
                });
                if (!validateResult.isValid) {
                    return validateResult.message;
                }
                return null;
            }
        },
        {
            key: "checkCanPlayNext",
            value: /**
   * 检查列表播放是否需要继续播放下一个视频
   * @returns {canPlayNext:boolean,message:string} 是否可以继续播放下一个视频
   */ function checkCanPlayNext() {
                var _this_player;
                if (!((_this_player = this.player) === null || _this_player === void 0 ? void 0 : _this_player.videoInfos)) {
                    return {
                        canPlayNext: false,
                        message: 'Player or player.videoInfo is null'
                    };
                }
                if (!this.player.played) {
                    return {
                        canPlayNext: false,
                        message: 'Player has not been played'
                    };
                }
                if (!this.player.nextVideoInfo) {
                    // list播放完毕
                    return {
                        canPlayNext: false,
                        message: "Playlist over>>>, total len: ', ".concat(this.player.videoInfos.length)
                    };
                }
                return {
                    canPlayNext: true,
                    message: "checkPlayNext(), curUrlIdx=".concat(this.player.curUrlIdx, "/urlLength=").concat(this.player.videoInfos.length, "/") + "nextStartTime: ".concat(this.player.nextVideoInfo.playtime)
                };
            }
        },
        {
            key: "checkAutoPreloadNext",
            value: /**
   * 检查是否自动预加载下一个视频
   * @param leftTime 离上一个视频播放的结束时间
   * @returns {canPreload:boolean,message:string} 是否可预加载下一个视频
   */ function checkAutoPreloadNext(leftTime) {
                var _this_player;
                if (!((_this_player = this.player) === null || _this_player === void 0 ? void 0 : _this_player.currentVideoInfo)) {
                    return {
                        canPreload: false,
                        message: 'Player or player.currentVideoInfo is null'
                    };
                }
                if (!this.player.nextVideoInfo || this.player.preloadVideoInfos.indexOf(this.player.nextVideoInfo) !== -1) {
                    return {
                        canPreload: false,
                        message: 'nextVideoInfo is null or nextVideoInfo is already preload now'
                    };
                }
                var autoPreloadLeftTime = this.player.currentVideoInfo.config.autoPreloadLeftTime;
                if (autoPreloadLeftTime <= 0) {
                    return {
                        canPreload: false,
                        message: 'Can not preload,autoPreloadLeftTime <= 0'
                    };
                }
                // 如果指定的时间大于等于时长，那么只要当前视频时间大于0就会尝试预加载下一个
                if (autoPreloadLeftTime >= this.player.currentVideoInfo.duration && this.player.currentVideoInfo.playtime > 0 || autoPreloadLeftTime >= leftTime) {
                    return {
                        canPreload: true,
                        message: 'Can preload now'
                    };
                }
                return {
                    canPreload: false,
                    message: 'Can not preload,autoPreloadLeftTime is illegal'
                };
            }
        },
        {
            key: "destroy",
            value: /** 销毁 */ function destroy() {
                this.player = null;
            }
        }
    ]);
    return CheckPlayerStatus;
}();

var ScreenWakeLock = /*#__PURE__*/ function() {
    function ScreenWakeLock() {
        _$5(this, ScreenWakeLock);
        _$1(this, "wakeLock", null);
    }
    _$4(ScreenWakeLock, [
        {
            key: "isAlive",
            get: /**
   * 获取当前是否激活睡眠锁状态
   */ function get() {
                return !!this.wakeLock;
            }
        },
        {
            key: "keepAlive",
            value: /**
   * 设置激活睡眠锁状态
   */ function keepAlive(alive) {
                if (alive) {
                    return this.requestWakeLock();
                }
                return this.realseWakeLock();
            }
        },
        {
            key: "requestWakeLock",
            value: /**
   * 激活机器睡眠锁，避免息屏，保持观看中屏幕常亮
   */ function requestWakeLock() {
                var _this = this;
                return _$c(function() {
                    return _$d(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (_this.wakeLock) {
                                    return [
                                        2
                                    ];
                                }
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    window.navigator.wakeLock.request('screen')
                                ];
                            case 2:
                                _this.wakeLock = _state.sent();
                                return [
                                    3,
                                    4
                                ];
                            case 3:
                                _state.sent();
                                // 在某些情况下保持常亮会失败，例如低电量模式等
                                // 但即使失败也无需处理，因为用户不感知，也无需提示
                                _this.wakeLock = null;
                                return [
                                    3,
                                    4
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "realseWakeLock",
            value: /**
  * 释放机器睡眠锁
  */ function realseWakeLock() {
                var _this = this;
                return _$c(function() {
                    return _$d(this, function(_state) {
                        if (!_this.wakeLock) {
                            return [
                                2
                            ];
                        }
                        _this.wakeLock.release();
                        _this.wakeLock = null;
                        return [
                            2
                        ];
                    });
                })();
            }
        }
    ]);
    return ScreenWakeLock;
}();

/** guid随机串的长度 */ var GUID_LEN = 8;
var VideoInfo = /*#__PURE__*/ function() {
    function VideoInfo(opts, playerConfig) {
        _$5(this, VideoInfo);
        _$1(this, "uidInner", void 0);
        _$1(this, "configInner", void 0);
        _$1(this, "nextBackUrlIdxInner", void 0);
        _$1(this, "retryCountInner", void 0);
        _$1(this, "extraVarsInner", void 0);
        _$1(this, "loadingUrlInner", void 0);
        _$1(this, "qualityInfoInner", void 0);
        _$1(this, "playerConfigInner", void 0);
        _$1(this, "logger", void 0);
        _$1(this, "playtime", 0);
        _$1(this, "currentAudioTrack", NaN);
        _$1(this, "buffered", void 0);
        _$1(this, "duration", 0);
        _$1(this, "performance", {});
        _$1(this, "startTime", 0);
        _$1(this, "state", VideoState.IDLE);
        _$1(this, "fileSize", 0);
        _$1(this, "videoWidth", 0);
        _$1(this, "videoHeight", 0);
        _$1(this, "hasFirstPlaying", false);
        _$1(this, "error", void 0);
        _$1(this, "codecs", void 0);
        _$1(this, "startPts", 0);
        _$1(this, "discontinuityTimeRanges", []);
        _$1(this, "videoFrameRate", 0);
        _$1(this, "audioTracks", []);
        _$1(this, "currentLevelIndex", -1);
        _$1(this, "levels", []);
        _$1(this, "currentLevel", null);
        _$1(this, "isAutoLevel", false);
        _$1(this, "stateWhenErrorHappen", null);
        _$1(this, "getMetrics", null);
        _$1(this, "colorSpace", {
            primaries: null,
            transfer: null
        });
        _$1(this, "pixelFormat", null);
        _$1(this, "bitDepth", null);
        _$1(this, "originalStartTimeS", 0);
        _$1(this, "seekingTimeS", 0);
        this.logger = new Logger(playerConfig.instanceId, 'VideoInfo');
        this.extraVarsInner = {};
        this.qualityInfoInner = {};
        this.uidInner = commonTool.createGUID(GUID_LEN);
        this.configInner = opts;
        this.playerConfigInner = playerConfig;
        this.codecs = this.configInner.codec ? _$6({}, this.configInner.codec) : {
            video: '',
            audio: ''
        };
        this.reset();
        this.logger.log("new VideoInfo(), uid: ".concat(this.uid));
    }
    _$4(VideoInfo, [
        {
            key: "toJSON",
            value: function toJSON() {
                return this.serializedString();
            }
        },
        {
            key: "toString",
            value: function toString() {
                return this.serializedString();
            }
        },
        {
            key: "config",
            get: function get() {
                return this.configInner;
            }
        },
        {
            key: "qualityInfo",
            get: function get() {
                return this.qualityInfoInner;
            }
        },
        {
            key: "uid",
            get: function get() {
                return this.uidInner;
            }
        },
        {
            key: "loadingUrl",
            get: function get() {
                return this.loadingUrlInner;
            }
        },
        {
            key: "extraVars",
            get: function get() {
                return this.extraVarsInner;
            }
        },
        {
            key: "inheritedStartTimeS",
            get: function get() {
                if (this.seekingTimeS > 0 && this.hasFirstPlaying) {
                    // 播放过程中调用seek，seeked状态之前并不会更新playtime，因此seeking操作时如果发生切换内核等操作时，需要取seeking发生时的播放时间
                    return this.seekingTimeS;
                }
                if (this.originalStartTimeS > 0 && !this.hasFirstPlaying) {
                    // VideoInfo的playtime只会在timeupdate、seeked等几个事件回调中更新，因此未起播时候获取的playtime一定是0。
                    // 因此，未起播时，如果有外部传入的起播时间，返回这个时间。
                    return this.originalStartTimeS;
                }
                return this.playtime;
            }
        },
        {
            key: "reset",
            value: function reset() {
                // 重置地址索引
                this.nextBackUrlIdxInner = 0;
                // 重置重试次数限制
                this.retryCountInner = 0;
                this.performance = {};
                // 先使用传入的url开始加载，后续可能会换成备份地址列表中的地址
                this.loadingUrlInner = this.configInner.url;
                // reset的时候同时清理音轨信息
                this.audioTracks = [];
            }
        },
        {
            key: "setLoadingUrlStartTime",
            value: function setLoadingUrlStartTime(startTime) {
                if (this.loadingUrlInner && startTime > 0) {
                    this.loadingUrlInner = "".concat(this.loadingUrlInner.split('#t=')[0], "#t=").concat(startTime);
                }
            }
        },
        {
            key: "setDependVideoInfo",
            value: function setDependVideoInfo(preVideoInfo) {
                this.startTime = preVideoInfo ? preVideoInfo.startTime + preVideoInfo.duration : 0;
                this.logger.log("setDependVideoInfo succ, uid/starttime: ".concat(this.uid, "/").concat(this.startTime));
                return true;
            }
        },
        {
            key: "setNextBackUrl",
            value: /**
   * 切换下一个备用地址
   */ function setNextBackUrl() {
                var _this_configInner_backupUrls;
                var backupUrlLen = ((_this_configInner_backupUrls = this.configInner.backupUrls) === null || _this_configInner_backupUrls === void 0 ? void 0 : _this_configInner_backupUrls.length) || 0;
                var maxRetryCount = Math.max(this.playerConfigInner.backupUrlsMaxRetryCount, backupUrlLen);
                if (!this.configInner.url || this.retryCountInner >= maxRetryCount) return false;
                this.retryCountInner++;
                if (backupUrlLen > 0) {
                    // 有重试地址，循环重试备用地址列表，直到maxRetryCount
                    if (this.nextBackUrlIdxInner >= backupUrlLen) {
                        this.loadingUrlInner = this.configInner.backupUrls[0];
                        this.nextBackUrlIdxInner = 0;
                    } else {
                        this.loadingUrlInner = this.configInner.backupUrls[this.nextBackUrlIdxInner];
                        this.nextBackUrlIdxInner++;
                    }
                } else {
                    // 没有备用地址，直接用当前地址重试多次
                    this.loadingUrlInner = this.configInner.url;
                }
                return true;
            }
        },
        {
            key: "getRetryCount",
            value: function getRetryCount() {
                return this.retryCountInner;
            }
        },
        {
            key: "destroy",
            value: /**
   * videoinfo销毁（需要注意的是，作为信息载体，很多信息在销毁后不需要清空，因为播放器或者引用方仍然需要知道）
   */ function destroy() {
                this.extraVarsInner = null;
            }
        },
        {
            key: "serializedString",
            value: function serializedString() {
                var _this_error, _this_error1;
                return "VideoInfo{u:".concat(this.loadingUrlInner, ",t:").concat(this.playtime, ",s:").concat(this.state, ",ec:").concat(((_this_error = this.error) === null || _this_error === void 0 ? void 0 : _this_error.code) || '', ",em:").concat(((_this_error1 = this.error) === null || _this_error1 === void 0 ? void 0 : _this_error1.message) || '', ",r:").concat(this.nextBackUrlIdxInner, "}");
            }
        }
    ]);
    return VideoInfo;
}();

var logMethodCall$3 = logMethodCallDecoratorCreator('BasePlayer');
var BasePlayer = /*#__PURE__*/ function(EvtEmitter) {
    _$9(BasePlayer, EvtEmitter);
    var _super = _$a(BasePlayer);
    function BasePlayer(opts) {
        _$5(this, BasePlayer);
        var _this;
        _this = _super.call(this);
        _$1(_$b(_this), "_videoInfos", void 0);
        _$1(_$b(_this), "_curUrlIdx", void 0);
        _$1(_$b(_this), "_curVideoNode", void 0);
        _$1(_$b(_this), "_preloaders", void 0);
        _$1(_$b(_this), "_vnList", void 0);
        _$1(_$b(_this), "_eventMap", void 0);
        _$1(_$b(_this), "_played", void 0);
        _$1(_$b(_this), "_firstPlaying", false);
        /** 是否具有用户手势（跟自动播放相关的一个名词，具体google。这个变量在视频首帧起播以后变为true，只有destroy以后会重置） */ _$1(_$b(_this), "_hasUserGestures", false);
        _$1(_$b(_this), "_config", void 0);
        _$1(_$b(_this), "_triggerAutoplayPromise", void 0);
        _$1(_$b(_this), "_volume", 1);
        _$1(_$b(_this), "volumeGainInner", 0);
        _$1(_$b(_this), "audioEffectInner", 'default');
        _$1(_$b(_this), "_playbackRate", 1);
        /** 播放被阻止的状态中 */ _$1(_$b(_this), "_playBlocking", false);
        /** 检测播放被阻止的变量 */ _$1(_$b(_this), "_checkPlayBlocked", void 0);
        /** 切清晰度之前的url地址信息，方便切换失败的话回滚videoInfo.config的地址 */ _$1(_$b(_this), "_urlBeforeSetLevel", void 0);
        _$1(_$b(_this), "_logger", void 0);
        /** videoNode事件处理函数的映射 */ _$1(_$b(_this), "videoEvtHandlerMap", void 0);
        /** 屏幕睡眠控制 */ _$1(_$b(_this), "screenWakeLock", void 0);
        /** 最后一次播放的video info，允许在播放器stop后外部依然可以访问currentVideoInfo */ _$1(_$b(_this), "lastVideoInfo", null);
        /** basePlayer内部状态检查，用于seek、setlevel等提前判断 */ _$1(_$b(_this), "playerStatusChecker", void 0);
        _$1(_$b(_this), "setAudioEffectTimeoutId", 0);
        _$1(_$b(_this), "destroyed", false);
        _this._logger = new Logger(opts.instanceId, 'BasePlayer');
        _this._config = opts;
        _this._videoInfos = []; // 地址列表
        _this._curUrlIdx = -1; // 当前的播放地址索引
        _this._curVideoNode = null;
        _this._preloaders = [];
        _this._vnList = [];
        _this._eventMap = {
            videonode: _this.videonodeEventHandler.bind(_$b(_this)),
            document: _this.visibilityChangeHandler.bind(_$b(_this))
        };
        _this._played = false;
        var _obj;
        _this.videoEvtHandlerMap = (_obj = {}, _$1(_obj, VideoNodeEvent.RATE_CHANGE, _this.onVideoNodeRateChange.bind(_$b(_this))), _$1(_obj, VideoNodeEvent.STATE_CHANGE, _this.onVideoNodeStateChange.bind(_$b(_this))), _$1(_obj, VideoNodeEvent.PLAY_PROMISE_CATCHED, _this.onVideoNodePlayPromiseCatched.bind(_$b(_this))), _$1(_obj, VideoNodeEvent.FIRST_PLAYING, _this.onVideoNodeFirstPlaying.bind(_$b(_this))), _$1(_obj, VideoNodeEvent.PLAY_OVER, _this.onVideoNodePlayOver.bind(_$b(_this))), _$1(_obj, VideoNodeEvent.ERROR, _this.onVideoNodeError.bind(_$b(_this))), _obj);
        _this.screenWakeLock = new ScreenWakeLock();
        _this.playerStatusChecker = new CheckPlayerStatus(_$b(_this));
        document.addEventListener('visibilitychange', _this._eventMap.document);
        if (!_this._config.createVideoNodeWhenLoad) {
            _this.createVideoNodes(_this._config.maxVideoNodeCount);
        }
        return _this;
    }
    _$4(BasePlayer, [
        {
            key: "load",
            value: function load(value, extra) {
                var _this = this;
                return _$c(function() {
                    return _$d(this, function(_state) {
                        if (!value || _$2(value, Array) && value.length <= 0) {
                            _this.clearBeforeLoad();
                            return [
                                2
                            ];
                        }
                        _this.loadInner(value, extra);
                        return [
                            2
                        ];
                    });
                })();
            }
        },
        {
            key: "play",
            value: function play(value, extra) {
                var _this = this;
                return _$c(function() {
                    return _$d(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this._logger.log('play()');
                                if (_this.state === VideoState.IDLE && !value) {
                                    // idle状态，没有参数时候直接return
                                    _this._logger.warn('play(), no urlConfig when idle state');
                                    return [
                                        2
                                    ];
                                }
                                _this._checkPlayBlocked = true;
                                if (!(_this._vnList.length <= 1 || _this._hasUserGestures)) return [
                                    3,
                                    1
                                ];
                                _this._logger.log('play(), skip triggerAutoplay().');
                                _this.triggerPlayResolve(value, extra);
                                return [
                                    3,
                                    4
                                ];
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    _this.triggerAutoplay()
                                ];
                            case 2:
                                _state.sent();
                                _this.triggerPlayResolve(value, extra);
                                return [
                                    3,
                                    4
                                ];
                            case 3:
                                _state.sent();
                                if (_this.destroyed) {
                                    return [
                                        2
                                    ];
                                }
                                // 如果在点播模式下，调用play接口的时候自动播放被阻止，那就默认给调用一下load方法，此时应用方只需要在点击事件中空调用一下play接口
                                if (_this._config.type === PlayMode.VOD && value) {
                                    _this.loadInner(value, extra);
                                }
                                return [
                                    3,
                                    4
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "triggerAutoplay",
            value: function triggerAutoplay() {
                var _this = this;
                // eslint-disable-next-line @typescript-eslint/no-misused-promises
                if (this._triggerAutoplayPromise) {
                    return this._triggerAutoplayPromise;
                }
                this._logger.log('triggerAutoplay(), start');
                var allPromise = [];
                var len = this._vnList.length;
                for(var i = 0; i < len; i++){
                    var videoNodePromise = this._vnList[i].triggerAutoplay();
                    allPromise.push(videoNodePromise);
                }
                this._triggerAutoplayPromise = Promise.all(allPromise);
                this._triggerAutoplayPromise.catch(function(e) {
                    _this._logger.log('play() triggerAutoplay catched: ', e);
                    _this.playBlocked();
                });
                return this._triggerAutoplayPromise;
            }
        },
        {
            key: "seek",
            value: function seek(time) {
                var _this__curVideoNode;
                if (this.state === VideoState.IDLE) {
                    // 播放idle状态，即使seek回去，也没法调用play()继续播放了。这里就直接return掉了。想播放结束了seek回去播，那不如重新播放并指定位置？
                    return false;
                }
                if (time < 0 || !((_this__curVideoNode = this._curVideoNode) === null || _this__curVideoNode === void 0 ? void 0 : _this__curVideoNode.currentVideoInfo)) {
                    return false;
                }
                // seek操作发生时，记录一个时间戳
                this._curVideoNode.currentVideoInfo.seekingTimeS = time;
                // 通过接口调用的seek都应该视为用户行为
                return this._curVideoNode.seek(time, true);
            }
        },
        {
            key: "pause",
            value: function pause(pauseType) {
                if (!this._played) {
                    this._logger.warn('pause(), player has not been played');
                    return;
                }
                this.pauseInner(pauseType || PauseType.USER);
            }
        },
        {
            key: "stop",
            value: function stop() {
                var endState = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : EndState.INTERRUPT;
                if (this.state === VideoState.IDLE) {
                    return;
                }
                this.stopInner(endState, true);
            }
        },
        {
            key: "setLevel",
            value: function setLevel(urlOrUrlConfig, backupUrls, extraConfig) {
                var url;
                if (typeof urlOrUrlConfig === 'string') {
                    url = urlOrUrlConfig;
                } else {
                    url = urlOrUrlConfig.url;
                    backupUrls = urlOrUrlConfig.backupUrls;
                    extraConfig = urlOrUrlConfig;
                }
                var errMag = this.playerStatusChecker.checkSetLevelError(url);
                if (errMag) {
                    this._logger.warn("setLevel(), ".concat(errMag));
                    return Promise.reject(new Error(errMag));
                }
                this._urlBeforeSetLevel = {
                    url: url,
                    backupUrls: backupUrls
                };
                this.currentVideoInfo.config.url = url;
                if (backupUrls) {
                    this.currentVideoInfo.config.backupUrls = backupUrls;
                }
                if (extraConfig) {
                    Object.assign(this._urlBeforeSetLevel, extraConfig);
                    Object.assign(this.currentVideoInfo.config, extraConfig);
                }
                this.currentVideoInfo.reset();
                return this.setLevelInner(this.currentVideoInfo.config);
            }
        },
        {
            key: "appendNext",
            value: function appendNext(urlConfig) {
                // 预检查是否当前播放环境是否支持append
                var appendDetail = this.playerStatusChecker.checkCanAppend(urlConfig);
                if (!appendDetail.canAppend) {
                    this._logger.warn(appendDetail.message);
                    return false;
                }
                // 播放列表中已经存在该视频配置
                var existVideoInfo = this._videoInfos.find(function(e) {
                    return compareUrlConfig(e.config, urlConfig);
                });
                if (existVideoInfo) {
                    this._logger.warn("appendNext(), duplicate append! uid[".concat(existVideoInfo.uid, "]"));
                    return false;
                }
                // 判断预加载列表中是否有一样的url地址，没有则创建新的IVideoInfo
                var appendVideoInfo = this.preloadVideoInfos.find(function(e) {
                    return compareUrlConfig(e.config, urlConfig);
                });
                if (!appendVideoInfo) {
                    appendVideoInfo = new VideoInfo(urlConfig, this._config);
                }
                // 除了即将添加的播放数据保留，其他的预加载全部清理掉
                this.clearAllPreloadInner(appendVideoInfo);
                // 覆盖式添加到当前播放地址的下一个
                this._videoInfos = this._videoInfos.slice(0, this._curUrlIdx + 1);
                this._videoInfos = this._videoInfos.concat(appendVideoInfo);
                this._logger.log('appendNext() succ, appendVideoInfo=', appendVideoInfo);
                this.emit(PlayEvent.LIST_CHANGE);
                // append以后可能需要判断是否马上播放下一个等操作
                this.appendAfter(appendVideoInfo);
                return true;
            }
        },
        {
            key: "preloadNext",
            value: function preloadNext() {
                var _this = this;
                for(var _len = arguments.length, confs = new Array(_len), _key = 0; _key < _len; _key++){
                    confs[_key] = arguments[_key];
                }
                // 预检查是否当前播放环境是否支持preload
                var preloadDetail = this.playerStatusChecker.checkCanPreloadEnvi(confs);
                if (!preloadDetail.canPreload) {
                    this._logger.warn(preloadDetail.message);
                    return false;
                }
                var preloadVideoInfos = [];
                confs.forEach(function(conf) {
                    var preloadEachUrlDetail = _this.playerStatusChecker.checkCanPreloadEachConfig(conf);
                    if (!preloadEachUrlDetail.canPreload) {
                        _this._logger.warn(preloadEachUrlDetail.message);
                        return;
                    }
                    if (_this.nextVideoInfo && compareUrlConfig(conf, _this.nextVideoInfo.config)) {
                        // 预加载的地址中已经有播放列表中的下一个（可能先appendNext到播放列表中了，稍后才调用preloadNext接口预加载）
                        preloadVideoInfos.push(_this.nextVideoInfo);
                    } else {
                        // 否则创建一个新的视频信息，开始预加载
                        preloadVideoInfos.push(new VideoInfo(conf, _this._config));
                    }
                });
                this.preloadInner.apply(this, [
                    false,
                    {
                        startTime: 0,
                        kernelName: this.kernelName
                    }
                ].concat(_(preloadVideoInfos)));
                return true;
            }
        },
        {
            key: "clearAllPreload",
            value: function clearAllPreload() {
                this.clearAllPreloadInner();
            }
        },
        {
            key: "playNext",
            value: function playNext(_opts) {
                if (!this._played) {
                    this._logger.warn('playNext(), player has not been played');
                    return;
                }
                this.playNextInner({
                    isInterrupt: true
                });
            }
        },
        {
            key: "hasAppended",
            value: function hasAppended(value) {
                return !!this._videoInfos.find(function(e) {
                    return compareUrlConfig(e.config, value);
                });
            }
        },
        {
            key: "hasPreloaded",
            value: function hasPreloaded(value) {
                return !!this.preloadVideoInfos.find(function(e) {
                    return compareUrlConfig(e.config, value);
                });
            }
        },
        {
            key: "setAudioTrack",
            value: function setAudioTrack(_id) {
                return Promise.reject(AudioTrackErrorMsg.NOT_SUPPORT);
            }
        },
        {
            key: "getAudioTrackList",
            value: function getAudioTrackList() {
                if (!this.currentVideoInfo) return [];
                return this.currentVideoInfo.audioTracks;
            }
        },
        {
            key: "getCurrentAudioTrack",
            value: function getCurrentAudioTrack() {
                if (!this.currentVideoInfo) return NaN;
                return this.currentVideoInfo.currentAudioTrack;
            }
        },
        {
            key: "resizeVideoElements",
            value: function resizeVideoElements(value) {
                var videoElements = this.videoElements;
                if (!value || !videoElements || videoElements.length <= 0) {
                    return;
                }
                videoElements.forEach(function(videoElement) {
                    videoTool.resizeElement(videoElement, value);
                });
                this.emit(PlayEvent.RESIZE, value);
            }
        },
        {
            key: "resize",
            value: function resize(value) {
                this.resizeVideoElements(value);
            }
        },
        {
            key: "captureVideo",
            value: function captureVideo(dx, dy, dw, dh) {
                var _video_captureVideo;
                var _this = this, video = _this.currentVideoElement;
                if (!video) return;
                if (_$2(video, HTMLVideoElement)) {
                    try {
                        var data = videoTool.captureVideo(video, {
                            dx: dx,
                            dy: dy,
                            dw: dw,
                            dh: dh
                        });
                        return Promise.resolve(data);
                    } catch (err) {
                        return Promise.reject(err);
                    }
                }
                return (_video_captureVideo = video.captureVideo) === null || _video_captureVideo === void 0 ? void 0 : _video_captureVideo.call(video, dx, dy, dw, dh);
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                var // 释放屏幕常亮
                _this_screenWakeLock, _this_playerStatusChecker;
                this.stopInner();
                if (this._vnList) {
                    var len = this._vnList.length;
                    for(var i = 0; i < len; i++){
                        this._vnList[i].destroy();
                    }
                }
                if (this._preloaders) {
                    this._preloaders.forEach(function(preloader) {
                        preloader.clear();
                    });
                    this._preloaders = null;
                }
                document.removeEventListener('visibilitychange', this._eventMap.document);
                this.removeAllListeners();
                (_this_screenWakeLock = this.screenWakeLock) === null || _this_screenWakeLock === void 0 ? void 0 : _this_screenWakeLock.keepAlive(false);
                this.screenWakeLock = null;
                this._videoInfos = null;
                this._curVideoNode = null;
                this._vnList = null;
                this._eventMap = null;
                this.lastVideoInfo = null;
                (_this_playerStatusChecker = this.playerStatusChecker) === null || _this_playerStatusChecker === void 0 ? void 0 : _this_playerStatusChecker.destroy();
                this.playerStatusChecker = null;
                this.destroyed = true;
            }
        },
        {
            key: "duration",
            get: function get() {
                return this._curVideoNode ? this._curVideoNode.duration : 0;
            }
        },
        {
            key: "playtime",
            get: function get() {
                return this._curVideoNode ? this._curVideoNode.playtime : 0;
            }
        },
        {
            key: "state",
            get: function get() {
                return this._curVideoNode ? this._curVideoNode.state : VideoState.IDLE;
            }
        },
        {
            key: "played",
            get: function get() {
                return this._played;
            }
        },
        {
            key: "playbackRate",
            get: function get() {
                return this._playbackRate;
            },
            set: function set(value) {
                this._playbackRate = value;
                var len = this._vnList.length;
                for(var i = 0; i < len; i++){
                    this._vnList[i].playbackRate = value;
                }
            }
        },
        {
            key: "supportPlaybackRate",
            get: // eslint-disable-next-line @typescript-eslint/class-literal-property-style
            function get() {
                return true;
            }
        },
        {
            key: "supportPreload",
            get: // eslint-disable-next-line @typescript-eslint/class-literal-property-style
            function get() {
                return true;
            }
        },
        {
            key: "volume",
            get: function get() {
                return this._volume;
            },
            set: function set(value) {
                this._volume = value;
                var len = this._vnList.length;
                for(var i = 0; i < len; i++){
                    this._vnList[i].volume = value;
                }
            }
        },
        {
            key: "volumeGain",
            get: function get() {
                return this.volumeGainInner;
            },
            set: function set(gain) {
                this.volumeGainInner = gain;
                if (this._curVideoNode) {
                    this._curVideoNode.volumeGain = gain;
                }
            }
        },
        {
            key: "audioEffect",
            get: function get() {
                return this.audioEffectInner;
            },
            set: function set(effectName) {
                this.audioEffectInner = effectName;
                if (this._curVideoNode) {
                    this._curVideoNode.audioEffect = effectName;
                }
            }
        },
        {
            key: "useWorker",
            get: function get() {
                return this._curVideoNode ? this._curVideoNode.useWorker : false;
            }
        },
        {
            key: "videoElements",
            get: function get() {
                var _this__vnList;
                return (_this__vnList = this._vnList) === null || _this__vnList === void 0 ? void 0 : _this__vnList.map(function(vn) {
                    return vn.videoElement;
                });
            }
        },
        {
            key: "currentVideoElement",
            get: /** 获取当前videonode的video元素 */ function get() {
                return this._curVideoNode ? this._curVideoNode.videoElement : null;
            }
        },
        {
            key: "videoInfos",
            get: function get() {
                return this._videoInfos;
            }
        },
        {
            key: "preloadVideoInfos",
            get: function get() {
                return this._preloaders.map(function(preloader) {
                    return preloader.videoInfo;
                });
            }
        },
        {
            key: "videoSize",
            get: function get() {
                return this._curVideoNode ? this._curVideoNode.videoSize : {
                    width: 0,
                    height: 0
                };
            }
        },
        {
            key: "videoBuffered",
            get: function get() {
                return this._curVideoNode ? this._curVideoNode.videoBuffered : [
                    {
                        start: 0,
                        end: 0
                    }
                ];
            }
        },
        {
            key: "currentVideoInfo",
            get: function get() {
                return this._curVideoNode ? this._curVideoNode.currentVideoInfo : this.lastVideoInfo;
            }
        },
        {
            key: "nextVideoInfo",
            get: /** 列表播放的下一个视频信息，如果超限返回undefined */ function get() {
                return this._videoInfos[this._curUrlIdx + 1];
            }
        },
        {
            key: "currentVideoInfoIdx",
            get: function get() {
                return this._curVideoNode ? this._videoInfos.indexOf(this._curVideoNode.currentVideoInfo) : -1;
            }
        },
        {
            key: "totalVideoInfoCount",
            get: function get() {
                return this._videoInfos.length;
            }
        },
        {
            key: "config",
            get: /** 获取当前内核的配置信息 */ function get() {
                return this._config;
            }
        },
        {
            key: "curUrlIdx",
            get: /** 获取当前Url序号 */ function get() {
                return this._curUrlIdx;
            }
        },
        {
            key: "log",
            value: function log() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                var _this__logger;
                var _this__logger1;
                (_this__logger1 = this._logger) === null || _this__logger1 === void 0 ? void 0 : (_this__logger = _this__logger1).log.apply(_this__logger, _(args));
            }
        },
        {
            key: "loadInner",
            value: /** 加载视频player内部实现方法，用于各个内核继承和内部调用 */ function loadInner(value, extra) {
                var _this = this;
                // 调用播放器load方法，就一定会先停止先前的播放
                this.clearBeforeLoad();
                var checkUrlConfigError = checkUrlConfigVailed(value);
                if (checkUrlConfigError) {
                    this.emit(PlayEvent.ERROR, {
                        videoInfo: {
                            error: checkUrlConfigError
                        }
                    });
                    return false;
                }
                if (this._config.createVideoNodeWhenLoad) {
                    this._vnList.forEach(function(videoNode) {
                        return videoNode.destroy();
                    });
                    this._vnList.length = 0;
                    this.createVideoNodes(this._config.maxVideoNodeCount);
                }
                // 相当于重新开始播放，通知外部重新播放事件
                this.emit(PlayEvent.RESTART);
                var _ref = extra || {}, _ref_startTime = _ref.startTime, startTime = _ref_startTime === void 0 ? 0 : _ref_startTime;
                this._videoInfos = [].concat(value).map(function(conf) {
                    return new VideoInfo(conf, _this._config);
                });
                this.emit(PlayEvent.LIST_CHANGE);
                // 第一个视频不管是否支持预加载，都可以调用load接口
                var _this__videoInfos = _$e(this._videoInfos, 1), firstVideoInfo = _this__videoInfos[0];
                // 第一个视频的VideoInfo记录一下外部传入的原始起播时间
                firstVideoInfo.originalStartTimeS = startTime;
                this.preloadInner(true, _$f(_$6({}, extra), {
                    startTime: startTime,
                    kernelName: this.kernelName
                }), firstVideoInfo);
                return true;
            }
        },
        {
            key: "pauseInner",
            value: /** 暂停播放player内部实现方法，用于各个内核继承和内部调用 */ function pauseInner() {
                var type = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : PauseType.INNER;
                if (this.state === VideoState.PAUSE) {
                    return;
                }
                if (this._curVideoNode) {
                    this._curVideoNode.pause(type);
                }
            }
        },
        {
            key: "resumeInner",
            value: function resumeInner() {
                var _this__curVideoNode;
                if (!this._played) {
                    return;
                }
                // duration为0的情况可能是video设置了src并且调用了播放，但是被阻止播放，此时duration是0
                // playtime < duration是限制只能在视频未结束调用（在视频结束调用play可能会从头开始播放）
                if (((_this__curVideoNode = this._curVideoNode) === null || _this__curVideoNode === void 0 ? void 0 : _this__curVideoNode.currentVideoInfo) && (this._curVideoNode.duration === 0 || this._curVideoNode.playtime < this._curVideoNode.duration)) {
                    this._curVideoNode.videoplay();
                }
            }
        },
        {
            key: "stopInner",
            value: function stopInner() {
                var endState = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : EndState.NORMAL, dispatchEvt = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false, videoInfo = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
                var _this__config;
                // 要先清掉预加载，否则下面stop每个videonode的时候可能还会收到videonode的事件，例如end事件，然后这个end事件
                // 会触发尝试播放下一个视频，此时如果预加载信息还在，可能会使用未清除的预加载继续播放。
                if (((_this__config = this._config) === null || _this__config === void 0 ? void 0 : _this__config.type) === PlayMode.VOD) {
                    this.clearAllPreloadInner();
                }
                // 存一下videoInfos数组，马上置空this._videoInfos。这里为了避免在列表播放时，当前videoNode播放时外部停止了播放，
                // 当前videoNode会发出end，idle事件，然后checkPlayNext里面尝试播放下一个videoNode。这不符合外部停止播放的预期。
                // 因此先置空videoInfos，此时this.nextVideoInfo为空，就不会继续尝试播放下一个videoNode了
                var videoInfos = this._videoInfos;
                // 缓存一下last video info
                this.lastVideoInfo = videoInfo !== null && videoInfo !== void 0 ? videoInfo : this.currentVideoInfo;
                this._videoInfos = [];
                if (this._vnList) {
                    var len = this._vnList.length;
                    for(var i = 0; i < len; i++){
                        // 先销毁videonode再移除videonode上的事件，便于销毁时仍能监听到videonode发出的idle等事件
                        this._vnList[i].stop();
                        this.setPlayEvents(this._vnList[i], false);
                    }
                }
                this._curUrlIdx = -1;
                if (videoInfos) {
                    videoInfos.forEach(function(vi) {
                        vi.destroy();
                    });
                }
                if (this.setAudioEffectTimeoutId > 0) {
                    clearTimeout(this.setAudioEffectTimeoutId);
                    this.setAudioEffectTimeoutId = 0;
                }
                this._firstPlaying = false;
                this._played = false;
                this._curVideoNode = null;
                var error = videoInfo === null || videoInfo === void 0 ? void 0 : videoInfo.error;
                var endStateValue = error ? EndState.ERROR : endState;
                this._logger.log("stopInner(), endState=".concat(endStateValue));
                // 派发stop和error事件
                if (!dispatchEvt) {
                    return;
                }
                this.emit(PlayEvent.STOPED, {
                    videoInfo: videoInfo,
                    isUserStop: endState === EndState.INTERRUPT,
                    endState: endStateValue
                });
                if (error) {
                    this.emit(PlayEvent.ERROR, {
                        videoInfo: videoInfo
                    });
                }
            }
        },
        {
            key: "preloadInner",
            value: /** 预加载播放player内部实现方法，用于各个内核继承和内部调用 */ function preloadInner(isFirstLoad, extra) {
                for(var _len = arguments.length, preloadVideoInfos = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++){
                    preloadVideoInfos[_key - 2] = arguments[_key];
                }
                this._logger.log("preloadInner(".concat(isFirstLoad, ", extra)"));
                var preloaders = [];
                var len = preloadVideoInfos.length;
                if (len <= 0) {
                    return;
                }
                for(var i = 0; i < len; i++){
                    if (!preloadVideoInfos[i]) {
                        continue;
                    }
                    this.clearPreloader(preloadVideoInfos[i]);
                    var preloader = this.preparePreloader(isFirstLoad, preloadVideoInfos[i]);
                    if (preloader) {
                        // 设置预加载的依赖
                        preloadVideoInfos[i].setDependVideoInfo(this.currentVideoInfo);
                        preloader.load(isFirstLoad, this, preloadVideoInfos[i], extra);
                        preloaders.push(preloader);
                    }
                }
                this._preloaders = this._preloaders.concat(preloaders);
                this._logger.log('preload(), preloader\'s length: ', this._preloaders.length);
                // 最后才发出事件，避免外部监听预加载开始事件以后马上操作预加载列表。
                if (preloaders.length > 0) {
                    this.emit(PlayEvent.PRELOAD_START, {
                        preloadVideoInfos: preloaders.map(function(preloader) {
                            return preloader.videoInfo;
                        })
                    });
                }
            }
        },
        {
            key: "playNextInner",
            value: function playNextInner(opts) {
                var isInterrupt = (opts || {}).isInterrupt;
                this._logger.log("playNextInner(), curUrlIdx=".concat(this._curUrlIdx, "/") + "urlLength=".concat(this._videoInfos.length, "/isInterrupt=").concat(isInterrupt));
                var isMinTime = Math.abs(this.playtime - this.duration) <= this._config.interruptPlayNextMinTime;
                if (isInterrupt && isMinTime && this.state === VideoState.PLAYING) {
                    // 时间太短，马上会跳段了而不需要打断，所以这里加了一个判断
                    this._logger.log('playNextInner(), playNext right now! return!');
                    return;
                }
                if (this._curUrlIdx + 1 >= this._videoInfos.length) {
                    this._logger.warn('There is no next VideoInfo.');
                    return;
                }
                this._curUrlIdx += 1;
                this.setPlayEvents(this._curVideoNode, false);
                // 打断式切换要先停止当前的播放
                if (isInterrupt) {
                    this._curVideoNode.pause(PauseType.INNER);
                }
                // 这个时候this._videoInfos[this._curUrlIdx]的值和this.currentVideoNode是不一样的。
                var videoInfo = this._videoInfos[this._curUrlIdx];
                // 除了即将播放的视频数据保留，其他的全部清理掉
                this.clearAllPreloadInner(videoInfo);
                if (isInterrupt) {
                    // 如果是打断式切换，派发当前段播放结束。事件结束后再开始播下一个
                    this.emit(PlayEvent.VIDEONODE_PLAY_OVER, {
                        videoInfo: this.currentVideoInfo
                    });
                }
                this.playInner();
            }
        },
        {
            key: "clearAllPreloadInner",
            value: /**
  * 清理所有预加载内部调用
  * @param exceptVideoInfo 保留的预加载视频
  */ function clearAllPreloadInner(exceptVideoInfo) {
                var _this = this;
                if (!this._preloaders || this._preloaders.length <= 0) {
                    return;
                }
                var removePreloaders = this._preloaders.filter(function(preloader) {
                    return preloader.videoInfo !== exceptVideoInfo;
                });
                // 一个一个清理预加载列表中的视频数据
                removePreloaders.forEach(function(removePreloader) {
                    _this.clearPreloader(removePreloader.videoInfo);
                });
            }
        },
        {
            key: "clearBeforeLoad",
            value: /** 在视频加载前清理 */ function clearBeforeLoad() {
                var // 在重新load时清理所有video标签（当配置项clearVideoAfterStop为false时，在stop时可能并未清理video标签）
                _this__vnList;
                (_this__vnList = this._vnList) === null || _this__vnList === void 0 ? void 0 : _this__vnList.forEach(function(videoNode) {
                    videoTool.clear(videoNode.videoElement);
                });
                this.stopInner(this._played ? EndState.INTERRUPT : EndState.NORMAL, this._played, this._played ? this.currentVideoInfo : null);
            }
        },
        {
            key: "clearPreloader",
            value: /** 内部实现的清理单个视频的预加载, 会从预加载的数组删除预加载地址 */ function clearPreloader(videoInfo, keepLoadedData) {
                if (!this._preloaders || this._preloaders.length <= 0) {
                    return;
                }
                if (!videoInfo) {
                    return;
                }
                var idx = this.findPreloadIdxByVideoInfo(videoInfo);
                if (idx === -1) {
                    // 根本没有预加载过
                    return;
                }
                var _this__preloaders_splice = _$e(this._preloaders.splice(idx, 1), 1), preloader = _this__preloaders_splice[0];
                preloader.clear(keepLoadedData);
            }
        },
        {
            key: "findPreloadIdxByVideoInfo",
            value: /** 查找预加载VideoInfo序号 */ function findPreloadIdxByVideoInfo(videoInfo) {
                if (!videoInfo) {
                    return -1;
                }
                return this._preloaders.findIndex(function(preloader) {
                    return preloader.videoInfo === videoInfo;
                });
            }
        },
        {
            key: "decideSetLevelMode",
            value: /** 选择清晰度的切换模式，各个内核可以选择复写 */ function decideSetLevelMode(forceSetLevelMode) {
                return this.playerStatusChecker.checkSetLevelMode(this._vnList.length, forceSetLevelMode);
            }
        },
        {
            key: "createVideoNode",
            value: /** 创建单个的VideoNode */ function createVideoNode(conf) {
                return uaTool.os.ios ? new OrgIOSVideoNode(conf) : new OrgVideoNode(conf);
            }
        },
        {
            key: "createVideoNodes",
            value: /**  创建VideoNode列表，每种内核的列表长度可能不一样。 */ function createVideoNodes(count) {
                for(var i = 0; i < count; i++){
                    var vn = this.createVideoNode(this._config);
                    vn.idx = i;
                    // 如果有createVideoNodeWhenLoad配置项，VideoNode是在load接口中创建的，因此还需要再次赋值一次volume避免音量丢失
                    vn.volume = this._volume;
                    vn.playbackRate = this._playbackRate;
                    if (_$2(vn.videoElement, HTMLElement)) {
                        vn.videoElement.dataset.idx = "".concat(i);
                    }
                    this._vnList.push(vn);
                }
            }
        },
        {
            key: "setPlayEvents",
            value: /** 给videoNode添加或者移除播放监听 */ function setPlayEvents(vn, isSet) {
                var _this = this;
                if (!vn) {
                    return;
                }
                if (isSet) {
                    this.setPlayEvents(vn, false);
                }
                this._logger.log("set VideoNode evts, idx=".concat(vn.idx, "/isSet=").concat(isSet));
                Object.keys(VideoNodeEvent).forEach(function(k) {
                    var evtHandler = isSet ? vn.on : vn.off;
                    evtHandler.apply(vn, [
                        VideoNodeEvent[k],
                        _this._eventMap.videonode
                    ]);
                });
            }
        },
        {
            key: "videonodeEventHandler",
            value: /** videoNode事件监听回调 */ function videonodeEventHandler(e) {
                this.logVideoNodeEvts(e);
                // 是否需要将videoNode的事件转发为player的事件。默认需要转发。但执行每个对应事件回调时也会返回是否需要转发。
                var shouldDispatchPlayEvt = true;
                // 对videoNode发出的事件的内部处理
                if (this.videoEvtHandlerMap[e.type]) {
                    shouldDispatchPlayEvt = this.videoEvtHandlerMap[e.type](e);
                }
                // 如果有对应的player事件，转发videonode事件
                if (shouldDispatchPlayEvt && e.type in videoEvt2PlayerEvtMap) {
                    this.emit(videoEvt2PlayerEvtMap[e.type], e.data);
                }
            }
        },
        {
            key: "onVideoNodeRateChange",
            value: function onVideoNodeRateChange(e) {
                var playbackRate = e.data.playbackRate;
                this._playbackRate = playbackRate;
                return true;
            }
        },
        {
            key: "onVideoNodeStateChange",
            value: /** 处理videoNode播放状态变化 */ function onVideoNodeStateChange(e) {
                if (e.data.new === VideoState.PAUSE && e.data.pauseType === PauseType.INNER) {
                    this._logger.log('inner pause does not emit event.');
                    return false;
                }
                if (e.data.new === VideoState.PLAYING) {
                    this._checkPlayBlocked = false;
                    this._curVideoNode.currentVideoInfo.seekingTimeS = 0;
                }
                // 播放状态变为Playing时，设置屏幕常亮
                this.screenWakeLock.keepAlive(e.data.new === VideoState.PLAYING);
                return true;
            }
        },
        {
            key: "onVideoNodePlayPromiseCatched",
            value: /** 处理videoNode起播Promise捕获 */ function onVideoNodePlayPromiseCatched(e) {
                if (this._checkPlayBlocked && e.data.isAutoPlayBlocked) {
                    this._checkPlayBlocked = false;
                    this.playBlocked();
                }
                return true;
            }
        },
        {
            key: "onVideoNodeFirstPlaying",
            value: /** 处理videoNode首次起播 */ function onVideoNodeFirstPlaying(_e) {
                var _this = this;
                if (!this._firstPlaying) {
                    // FIRST_PLAYING无论有多少个videonode，都只对外转发一次
                    this.emit(PlayEvent.FIRST_PLAYING, {
                        videoInfo: this.currentVideoInfo
                    });
                    this._firstPlaying = true;
                    this._hasUserGestures = true;
                }
                // 同步音效状态（只能在每个VideoNode起播以后，才能有效设置）
                this.setAudioEffectTimeoutId = setTimeout(function() {
                    // 这个setTimeout 0是因为VideoNode发出这个事件在修改videoNode.videoInfo.hasFirstPlaying之前，如果
                    // 不延迟一下，设置volumeGain和audioEffect都会被return
                    if (_this._curVideoNode.volumeGain !== _this.volumeGainInner) {
                        _this.volumeGain = _this.volumeGainInner;
                    }
                    if (_this._curVideoNode.audioEffect !== _this.audioEffectInner) {
                        _this.audioEffect = _this.audioEffectInner;
                    }
                }, 0);
                return true;
            }
        },
        {
            key: "onVideoNodePlayOver",
            value: /** 处理videoNode播放结束，检查下一个播放 */ function onVideoNodePlayOver(_e) {
                if (!this._config.isPlayList && !this.nextVideoInfo) {
                    var videoInfo = this.currentVideoInfo;
                    // videonode里面正常结束，需要在player这一层调用stopInner重置一些变量，但如果是两个场景不需要stopInner
                    // 1. 如果播放列表中还有下一个视频等待播放
                    // 2. 如果是灵活的列表播放场景（isPlayList=true），播放器可能还会继续被append视频播放，因此不能被停止，而是等待用户添加视频
                    this.stopInner(EndState.NORMAL, true, videoInfo);
                    // 在停止当前播放以后，发出当前段播放结束事件
                    this.emit(PlayEvent.VIDEONODE_PLAY_OVER, {
                        videoInfo: videoInfo
                    });
                } else {
                    // 在播放下一段之前，发出当前段播放结束
                    this.emit(PlayEvent.VIDEONODE_PLAY_OVER, {
                        videoInfo: this.currentVideoInfo
                    });
                    this.checkPlayNext();
                }
                return false;
            }
        },
        {
            key: "onVideoNodeError",
            value: /** 处理videoNode播放错误 */ function onVideoNodeError(e) {
                var videoInfo = (e.data || {}).videoInfo;
                // this.detectSourceOnError(videoInfo);
                this.stopInner(EndState.ERROR, true, videoInfo);
                // stopInner第二个参数为true，直接发出error和stop事件了，不需要派发事件
                return false;
            }
        },
        {
            key: "logVideoNodeEvts",
            value: /** 打印VideoNode事件关键信息，但排除开一些高频事件的打印 */ function logVideoNodeEvts(e) {
                var _this__curVideoNode_currentVideoInfo, _this__curVideoNode;
                // 过滤掉频繁产生的 VideoNode 事件
                if (IGNORE_EVT_TYPE.includes(e.type)) {
                    return;
                }
                // 过滤掉频繁产生的 IVideoElement 事件
                if (e.type === VideoNodeEvent.ELEMENT_EVTS && IGNORE_VIDEO_EVT.includes(e.data.elementEvtType)) {
                    return;
                }
                var logData = e.data;
                if (e.type === VideoNodeEvent.STATE_CHANGE) {
                    logData = "[".concat(e.data.old, "->").concat(e.data.new, "]");
                } else if (e.type === VideoNodeEvent.ELEMENT_EVTS) {
                    logData = "[elementEvtType=".concat(e.data.elementEvtType, "]");
                }
                this._logger.log("get VideoNode evt, type=".concat(e.type, "/uid=").concat((_this__curVideoNode = this._curVideoNode) === null || _this__curVideoNode === void 0 ? void 0 : (_this__curVideoNode_currentVideoInfo = _this__curVideoNode.currentVideoInfo) === null || _this__curVideoNode_currentVideoInfo === void 0 ? void 0 : _this__curVideoNode_currentVideoInfo.uid, "/data="), logData);
            }
        },
        {
            key: "playBlocked",
            value: function playBlocked() {
                var _this = this;
                this._playBlocking = true;
                this._triggerAutoplayPromise = null;
                setTimeout(function() {
                    // setTimeout避免在block事件的监听回调里面调用play的时候还没有调用load而播放器状态为state
                    // (修复autoblock事件太晚导致静音自动播不生效问题)
                    _this.emit(PlayEvent.AUTOPLAY_BLOCKED, {
                        videoInfo: _this.currentVideoInfo
                    });
                }, 0);
                this.setLoading(false);
            }
        },
        {
            key: "checkPlayNext",
            value: function checkPlayNext() {
                var playNextDetail = this.playerStatusChecker.checkCanPlayNext();
                this._logger.log(playNextDetail.message);
                if (playNextDetail.canPlayNext) {
                    this.playNextInner();
                }
            }
        },
        {
            key: "checkAutoPreloadNext",
            value: /**
  * 检查是否需要自动预加载下一个视频
  * @param leftTime 离视频播放的结束时间
  */ function checkAutoPreloadNext(leftTime) {
                var preloadDetail = this.playerStatusChecker.checkAutoPreloadNext(leftTime);
                if (preloadDetail.canPreload) {
                    this.preloadInner(false, {
                        startTime: 0,
                        kernelName: this.kernelName
                    }, this.nextVideoInfo);
                }
            }
        },
        {
            key: "setCurVideoNode",
            value: /** 修改当前_curVideoNode指向 */ function setCurVideoNode(vn) {
                var isForceSet = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
                if (this._curVideoNode === vn && !isForceSet) {
                    return;
                }
                if (this._curVideoNode) {
                    this._curVideoNode.onAccurateTimeupdate = null;
                    this.setPlayEvents(this._curVideoNode, false);
                }
                if (vn) {
                    this._curVideoNode = vn;
                    this._curVideoNode.onAccurateTimeupdate = this.checkAccuratePlaytime.bind(this);
                    this.setPlayEvents(this._curVideoNode, true);
                }
            }
        },
        {
            key: "detectSourceOnError",
            value: /** 在播放错误时，使用range请求获取当前播放的视频的一段数据用于探测远程资源 */ function detectSourceOnError(videoInfo) {
                var _this = this;
                var _ref = videoInfo || {}, loadingUrl = _ref.loadingUrl, uid = _ref.uid;
                if (!loadingUrl) {
                    this._logger.error('detectSourceOnError, url=null');
                    return;
                }
                detectStream(loadingUrl).then(function(data) {
                    _this._logger.error('detectSourceOnError=', _$6({
                        uid: uid
                    }, data));
                }).catch(function(e) {
                    _this._logger.error('detectSourceOnError err', e === null || e === void 0 ? void 0 : e.message);
                });
            }
        },
        {
            key: "setLoading",
            value: /** 在播放器层的loading动画展示时机逻辑 */ function setLoading(show) {
                this.emit(PlayEvent.SET_LOADING, {
                    show: show
                });
            }
        },
        {
            key: "visibilityChangeHandler",
            value: /** 在页面不可见时，出现状态切换，申请常亮可能被系统拒绝。因此在页面恢复可见时，重新设置屏幕常亮 */ function visibilityChangeHandler() {
                this.screenWakeLock.keepAlive(this.state === VideoState.PLAYING);
            }
        },
        {
            key: "triggerPlayResolve",
            value: /** 对播放列表Play方法的不同情况处理 */ function triggerPlayResolve(urlConfig, extra) {
                var _this = this;
                if (urlConfig) {
                    // 只要有urlConfig参数，需要重新开始播放
                    if (this.loadInner(urlConfig, extra)) {
                        this.setLoading(true);
                        this.triggerPlayAfterLoad();
                    }
                    return;
                }
                // 没有urlConfig参数，需要按以下几个情况分别处理
                if (!this._played) {
                    // 情况一：外部调用load后，再调用play(或点击play按钮)，需要显示下loading（可能是调用了load接口，但还没有预加载完）
                    this.setLoading(true);
                    this.triggerPlayAfterLoad();
                    return;
                }
                if (this._playBlocking || videoTool.cannotDetectAutoPlayBlock()) {
                    // 情况二：看看是否被自动播放阻止（或者根本就无法检测到自动播放被拦截），直接恢复播放即可
                    this._playBlocking = false;
                    // safari播放被阻止后，再次调用play接口会先走triggerAuthplay，再走到resumeInner，但是马上调用无效（原因未知），
                    // setTimeout可解决。其他浏览器没有这个问题，因此这里干脆延迟一个循环再执行。
                    setTimeout(function() {
                        var _this__curVideoNode_videoBuffered, _this__curVideoNode;
                        if (((_this__curVideoNode = _this._curVideoNode) === null || _this__curVideoNode === void 0 ? void 0 : (_this__curVideoNode_videoBuffered = _this__curVideoNode.videoBuffered) === null || _this__curVideoNode_videoBuffered === void 0 ? void 0 : _this__curVideoNode_videoBuffered.length) <= 0) {
                            // 可能是某些浏览器被自动播放阻止后，根本没有加载数据和派发loadStart事件（调用video.load()接口），点击恢复
                            // 播放需要继续加载数据才能看到画面，此时为黑屏状态，因此当没有buffer数据时，需要展示加载loading
                            _this.setLoading(true);
                        }
                        _this.resumeInner();
                    }, 0);
                    return;
                }
                if ([
                    VideoState.PAUSE,
                    VideoState.CANPLAY,
                    VideoState.SEEKED
                ].indexOf(this.state) !== -1) {
                    // 情况三：（兜底逻辑）视频在以下状态【暂停、可以开播、seeked】，恢复播放即可
                    this.resumeInner();
                    return;
                }
                // 三种情况都不匹配，play接口做不了任何事情，已经兜底不会出现这种情况，打印日志以定位后续某情况走到该分支
                this._logger.log('play() has been called, but cannot do nothing.');
            }
        },
        {
            key: "triggerPlayAfterLoad",
            value: /** 如果预加载过第一个视频，那么等待预加载成功后开始播放 */ function triggerPlayAfterLoad() {
                if (this._played || this._curUrlIdx !== -1) {
                    return;
                }
                var _this__videoInfos = _$e(this._videoInfos, 1), firstVideoInfo = _this__videoInfos[0];
                if (firstVideoInfo) {
                    this._played = true;
                    this._curUrlIdx = 0;
                    this.playInner();
                }
            }
        }
    ]);
    return BasePlayer;
}(EvtEmitter);
_$7([
    logMethodCall$3,
    _$8("design:type", Function),
    _$8("design:paramtypes", [
        Object,
        Object
    ]),
    _$8("design:returntype", Promise)
], BasePlayer.prototype, "load", null);
_$7([
    logMethodCall$3,
    _$8("design:type", Function),
    _$8("design:paramtypes", [
        Number
    ]),
    _$8("design:returntype", void 0)
], BasePlayer.prototype, "seek", null);
_$7([
    logMethodCall$3,
    _$8("design:type", Function),
    _$8("design:paramtypes", [
        Object
    ]),
    _$8("design:returntype", void 0)
], BasePlayer.prototype, "stop", null);
_$7([
    logMethodCall$3,
    _$8("design:type", Function),
    _$8("design:paramtypes", [
        Object,
        Array,
        typeof IUrlConfig === "undefined" ? Object : IUrlConfig
    ]),
    _$8("design:returntype", typeof Promise === "undefined" ? Object : Promise)
], BasePlayer.prototype, "setLevel", null);
_$7([
    logMethodCall$3,
    _$8("design:type", Function),
    _$8("design:paramtypes", [
        typeof IUrlConfig === "undefined" ? Object : IUrlConfig
    ]),
    _$8("design:returntype", void 0)
], BasePlayer.prototype, "appendNext", null);
_$7([
    logMethodCall$3,
    _$8("design:type", Function),
    _$8("design:paramtypes", [
        Array
    ]),
    _$8("design:returntype", void 0)
], BasePlayer.prototype, "preloadNext", null);
_$7([
    logMethodCall$3,
    _$8("design:type", Function),
    _$8("design:paramtypes", [
        Object
    ]),
    _$8("design:returntype", void 0)
], BasePlayer.prototype, "playNext", null);
_$7([
    logMethodCall$3,
    _$8("design:type", Function),
    _$8("design:paramtypes", [
        Object
    ]),
    _$8("design:returntype", typeof Promise === "undefined" ? Object : Promise)
], BasePlayer.prototype, "setAudioTrack", null);
_$7([
    logMethodCall$3,
    _$8("design:type", Function),
    _$8("design:paramtypes", [
        Object
    ]),
    _$8("design:returntype", void 0)
], BasePlayer.prototype, "resizeVideoElements", null);
_$7([
    logMethodCall$3,
    _$8("design:type", Function),
    _$8("design:paramtypes", []),
    _$8("design:returntype", void 0)
], BasePlayer.prototype, "destroy", null);
_$7([
    logMethodCall$3,
    _$8("design:type", Function),
    _$8("design:paramtypes", []),
    _$8("design:returntype", void 0)
], BasePlayer.prototype, "resumeInner", null);
_$7([
    logMethodCall$3,
    _$8("design:type", Function),
    _$8("design:paramtypes", [
        Object,
        void 0,
        typeof IVideoInfo === "undefined" ? Object : IVideoInfo
    ]),
    _$8("design:returntype", void 0)
], BasePlayer.prototype, "stopInner", null);
_$7([
    logMethodCall$3,
    _$8("design:type", Function),
    _$8("design:paramtypes", [
        Object
    ]),
    _$8("design:returntype", void 0)
], BasePlayer.prototype, "playNextInner", null);
_$7([
    logMethodCall$3,
    _$8("design:type", Function),
    _$8("design:paramtypes", []),
    _$8("design:returntype", void 0)
], BasePlayer.prototype, "playBlocked", null);
_$7([
    logMethodCall$3,
    _$8("design:type", Function),
    _$8("design:paramtypes", []),
    _$8("design:returntype", void 0)
], BasePlayer.prototype, "checkPlayNext", null);

var defaultOriginKernelConfig = {
    /**
   * @deprecated
   * 默认创建的最大VideoNode数量。此值会影响到可以同时预加载的视频数，例如如果需要同时预加载3个视频，这个值就需要指定为3+1
   * <br>【注】：仅原生播放内核时有效
   */ maxVideoNodeCount: 1,
    /**
   * 提前结束播放的时间（考虑到某些视频最后只有音频，有需求需要剪掉视频最末尾的一段播放，x5浏览器是0.1s）
   * <br>【注】：仅原生播放内核时有效
   */ advanceEndTime: 0,
    /**
   * 原生播放内核实现切换时，为了拼接顺畅，可能会把下一个视频提前一点点播放
   * <br>【注】：仅原生播放内核时有效
   */ prePlayNextTime: 0
};
function mergeKernelConfig(config) {
    if (!config.originKernelConfig) {
        config.originKernelConfig = {};
    }
    // 补齐默认配置项
    Object.keys(defaultOriginKernelConfig).forEach(function(key) {
        if (typeof config.originKernelConfig[key] === 'undefined') {
            config.originKernelConfig[key] = defaultOriginKernelConfig[key];
        }
    });
    return config;
}

var logMethodCall$2 = logMethodCallDecoratorCreator('OrgPreLoader');
var OrgPreLoader = /*#__PURE__*/ function() {
    function OrgPreLoader(playerConfig) {
        _$5(this, OrgPreLoader);
        _$1(this, "playerConfig", void 0);
        _$1(this, "videoInfoInner", void 0);
        _$1(this, "evtMaps", void 0);
        _$1(this, "deferInner", void 0);
        _$1(this, "evtDispatcher", void 0);
        _$1(this, "logger", void 0);
        this.playerConfig = playerConfig;
        this.deferInner = new SimpleDefer();
        this.logger = new Logger(playerConfig.instanceId, 'OrgPreLoader');
        var _obj;
        this.evtMaps = (_obj = {}, _$1(_obj, VideoNodeEvent.STATE_CHANGE, this.firstLoadStateChangeHandler.bind(this)), _$1(_obj, VideoNodeEvent.ERROR, this.errorHandler.bind(this)), _obj);
    }
    _$4(OrgPreLoader, [
        {
            key: "promise",
            get: function get() {
                return this.deferInner.promise;
            }
        },
        {
            key: "videoInfo",
            get: function get() {
                return this.videoInfoInner;
            }
        },
        {
            key: "getVideoNode",
            value: function getVideoNode() {
                var _this_videoInfoInner;
                return (_this_videoInfoInner = this.videoInfoInner) === null || _this_videoInfoInner === void 0 ? void 0 : _this_videoInfoInner.extraVars.preloadVideoNode;
            }
        },
        {
            key: "errorHandler",
            value: function errorHandler(e) {
                this.preloadFail(e.data.videoInfo.error);
            }
        },
        {
            key: "firstLoadStateChangeHandler",
            value: function firstLoadStateChangeHandler(e) {
                if (e.data.new === VideoState.CANPLAY) {
                    this.preloadSucc();
                }
            }
        },
        {
            key: "preloadSucc",
            value: function preloadSucc() {
                this.logger.log("preload url ready>>>>>> uid=".concat(this.videoInfoInner.uid));
                this.clearInner(true);
                this.evtDispatcher.emit(PlayEvent.PRELOAD_VIDEONODE_OVER, {
                    videoInfo: this.videoInfoInner
                });
                this.deferInner.resolve();
            }
        },
        {
            key: "preloadFail",
            value: function preloadFail(error) {
                this.logger.log("preload url fail>>>>>> uid: ".concat(this.videoInfoInner.uid));
                this.clearInner();
                this.evtDispatcher.emit(PlayEvent.PRELOAD_VIDEONODE_ERROR, {
                    videoInfo: this.videoInfoInner
                });
                this.videoInfoInner.error = error;
                this.deferInner.reject(error);
            }
        },
        {
            key: "setVideoNodeEvents",
            value: function setVideoNodeEvents(value) {
                var _this = this;
                var videoNode = this.getVideoNode();
                Object.keys(this.evtMaps).forEach(function(key) {
                    if (value) {
                        videoNode.on(key, _this.evtMaps[key]);
                    } else {
                        videoNode.off(key, _this.evtMaps[key]);
                    }
                });
            }
        },
        {
            key: "load",
            value: function load(isFirstLoad, evtDispatcher, videoInfo, extra) {
                this.videoInfoInner = videoInfo;
                this.evtDispatcher = evtDispatcher;
                this.setVideoNodeEvents(true);
                this.logger.log("load(), isFirstLoad=".concat(isFirstLoad));
                this.getVideoNode().load(videoInfo, extra);
            }
        },
        {
            key: "clearInner",
            value: function clearInner(keepLoadedData, emitEvt) {
                if (!this.videoInfoInner) {
                    return;
                }
                var videoNode = this.getVideoNode();
                if (!videoNode) {
                    return;
                }
                this.logger.log("clear(), uid=".concat(this.videoInfoInner.uid, "/keep=").concat(keepLoadedData));
                this.setVideoNodeEvents(false);
                if (!keepLoadedData) {
                    this.videoInfoInner.extraVars.preloadVideoNode = null;
                    videoNode.stop();
                }
                if (emitEvt) {
                    this.evtDispatcher.emit(PlayEvent.PRELOAD_VIDEONODE_CLEAR, {
                        videoInfo: this.videoInfoInner
                    });
                }
            }
        },
        {
            key: "clear",
            value: function clear(keepLoadedData) {
                this.clearInner(keepLoadedData, true);
            }
        }
    ]);
    return OrgPreLoader;
}();
_$7([
    logMethodCall$2,
    _$8("design:type", Function),
    _$8("design:paramtypes", [
        Boolean,
        typeof EvtEmitter === "undefined" ? Object : EvtEmitter,
        typeof IVideoInfo === "undefined" ? Object : IVideoInfo,
        Object
    ]),
    _$8("design:returntype", void 0)
], OrgPreLoader.prototype, "load", null);
_$7([
    logMethodCall$2,
    _$8("design:type", Function),
    _$8("design:paramtypes", [
        Boolean
    ]),
    _$8("design:returntype", void 0)
], OrgPreLoader.prototype, "clear", null);

var logMethodCall$1 = logMethodCallDecoratorCreator('MultiPlayer');
var MultiPlayer = /*#__PURE__*/ function(BasePlayer) {
    _$9(MultiPlayer, BasePlayer);
    var _super = _$a(MultiPlayer);
    function MultiPlayer(conf) {
        _$5(this, MultiPlayer);
        var _this;
        _this = _super.call(this, mergeKernelConfig(conf));
        _$1(_$b(_this), "_needHideVideoNode", null);
        _$1(_$b(_this), "_prePlayNext", void 0);
        _$1(_$b(_this), "_setLevelVideoNode", void 0);
        _$1(_$b(_this), "_videonodeEventMap", void 0);
        _$1(_$b(_this), "_firstVideoNode", void 0);
        _$1(_$b(_this), "playStartTime", void 0);
        _this._videonodeEventMap = _$1({}, VideoNodeEvent.STATE_CHANGE, _this.onCurVideoNodeStateChange.bind(_$b(_this)));
        return _this;
    }
    _$4(MultiPlayer, [
        {
            key: "supportPreload",
            get: function get() {
                return videoTool.supportSameTimePlay();
            }
        },
        {
            key: "kernelName",
            get: // eslint-disable-next-line @typescript-eslint/class-literal-property-style
            function get() {
                return KernelName.ORIGIN;
            }
        },
        {
            key: "seek",
            value: function seek(time) {
                if (this.getLevelSwitching()) {
                    // multiplayer内切换清晰度为soft切换，这种也是暂停切换，过程中无法seek
                    return false;
                }
                return _$g(_$h(MultiPlayer.prototype), "seek", this).call(this, time);
            }
        },
        {
            key: "createVideoNodes",
            value: function createVideoNodes(count) {
                _$g(_$h(MultiPlayer.prototype), "createVideoNodes", this).call(this, count);
                for(var i = 0; i < this._vnList.length; i++){
                    var vn = this._vnList[i];
                    if (i === 0) {
                        // 第一个video标签直接显示出来（如果有设置poster，可以展示）
                        this._firstVideoNode = vn;
                    } else {
                        this.visibleVideoNode(vn, false);
                    }
                }
            }
        },
        {
            key: "videonodeEventHandler",
            value: function videonodeEventHandler(e) {
                // 先进行内部事件处理，完了以后再发出事件（因为发出事件以后外部可能stop或者销毁事件）
                if (this._videonodeEventMap[e.type]) {
                    this._videonodeEventMap[e.type](e);
                }
                _$g(_$h(MultiPlayer.prototype), "videonodeEventHandler", this).call(this, e);
            }
        },
        {
            key: "onCurVideoNodeStateChange",
            value: function onCurVideoNodeStateChange(e) {
                if (e.data.new !== VideoState.PLAYING) {
                    return;
                }
                this.switchVideoNode();
                // 通知外部当前视频已经开播了
                if (!this.currentVideoInfo.extraVars.isStartPlay) {
                    this.currentVideoInfo.extraVars.isStartPlay = true;
                    var uid = this.currentVideoInfo ? this.currentVideoInfo.uid : null;
                    this._logger.log("videoNodeStartPlay: uid[".concat(uid, "]"));
                    this.emit(PlayEvent.VIDEONODE_START_PLAY, {
                        videoInfo: this.currentVideoInfo
                    });
                }
            }
        },
        {
            key: "onVideoNodeStateChange",
            value: function onVideoNodeStateChange(e) {
                if (this.getLevelSwitching() && !VALID_STATE_IN_LEVEL_SWITCHING.includes(e.data.new)) {
                    // 在multiplayer里切换清晰度触发时，已经将下一个VideoNode设置为currentVideoNode（开始监听此VideoNode事件）。在切换过程中，需要
                    // 过滤掉currentVideoNode的状态变化。
                    return false;
                }
                return _$g(_$h(MultiPlayer.prototype), "onVideoNodeStateChange", this).call(this, e);
            }
        },
        {
            key: "pauseInner",
            value: function pauseInner() {
                var type = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : PauseType.INNER;
                if (this._prePlayNext) {
                    // 提前开始播放下一个，就是在准备切换了。这个极短的时间里面，不允许暂停了
                    this._logger.warn('pause when preplaynext, return!!');
                    return;
                }
                _$g(_$h(MultiPlayer.prototype), "pauseInner", this).call(this, type);
            }
        },
        {
            key: "resumeInner",
            value: function resumeInner() {
                if (this.getLevelSwitching()) {
                    // 如果正在切清晰度的时候被暂停了（比如在手机上切到后台，系统暂停了所有video的播放），恢复play的时候只恢复切清晰度的
                    this._setLevelVideoNode.play();
                    return;
                }
                _$g(_$h(MultiPlayer.prototype), "resumeInner", this).call(this);
            }
        },
        {
            key: "loadInner",
            value: function loadInner(value, extra) {
                var _this__vnList;
                var vnLen = ((_this__vnList = this._vnList) === null || _this__vnList === void 0 ? void 0 : _this__vnList.length) || 0;
                for(var i = 0; i < vnLen; i++){
                    this.visibleVideoNode(this._vnList[i], false);
                }
                return _$g(_$h(MultiPlayer.prototype), "loadInner", this).call(this, value, extra);
            }
        },
        {
            key: "playInner",
            value: function playInner(startTime) {
                if (!this.checkBeforePlay()) {
                    return;
                }
                this.playStartTime = startTime;
                var videoInfo = this._videoInfos[this._curUrlIdx];
                var preloaderIdx = this.findPreloadIdxByVideoInfo(videoInfo);
                if (preloaderIdx !== -1) {
                    // 如果有预加载，处理preload后进入play
                    this.preloadToPlay(videoInfo, preloaderIdx);
                } else if (videoInfo.error) {
                    // 如果加载出错，进入错误处理
                    this._logger.log('play(), got preload error');
                    this.stopInner(EndState.ERROR, true, videoInfo);
                } else {
                    // 如果没有预加载，直接进入播放调用
                    this.enterVideoNodePlay(videoInfo);
                }
            }
        },
        {
            key: "visibleVideoNode",
            value: function visibleVideoNode(vn, value) {
                var _vn_currentVideoInfo;
                if (!(vn === null || vn === void 0 ? void 0 : vn.videoElement)) {
                    return;
                }
                this.setVideoElementState(vn.videoElement, value);
                this._logger.log(">>>visibleVideoNode<<<, value=".concat(value, "/uid=").concat((_vn_currentVideoInfo = vn.currentVideoInfo) === null || _vn_currentVideoInfo === void 0 ? void 0 : _vn_currentVideoInfo.uid));
            }
        },
        {
            key: "setVideoElementState",
            value: function setVideoElementState(videoElement, value) {
                var tarVolume = value ? this._volume : 0;
                if (videoElement.volume !== tarVolume) {
                    videoElement.volume = tarVolume;
                }
                // 当video标签切换到前台准备播放，此时需要恢复静音，但一定要先看看当前音量是不是本来就是静音的（用户设置了静音）
                // 此时不需要恢复静音，而是继续保持静音状态
                var tarMuted = this._volume <= 0 || !value;
                if (videoElement.muted !== tarMuted) {
                    videoElement.muted = tarMuted;
                }
                domTool.css(videoElement, 'zIndex', value ? '0' : '-1');
                domTool.css(videoElement, 'visibility', value ? 'inherit' : 'hidden');
            }
        },
        {
            key: "switchVideoNode",
            value: function switchVideoNode() {
                // 有需要隐藏的video标签 && 隐藏的目标video标签不是当前播放的video标签，才进行切换
                if (!this._needHideVideoNode || this._curVideoNode === this._needHideVideoNode) {
                    return;
                }
                this._logger.log('>>>>>switchVideoNode<<<<<');
                this.visibleVideoNode(this._curVideoNode, true);
                // 被隐藏的延迟一下隐藏，不然ios可能会黑闪
                var vnn = this._needHideVideoNode;
                this.visibleVideoNode(vnn, false);
                if (vnn) {
                    vnn.stop();
                }
                this._needHideVideoNode = null;
            }
        },
        {
            key: "playNextInner",
            value: function playNextInner(opts) {
                // 先记录一下需要隐藏的上一个播放控件（不立即隐藏的原因是移动端等平台可能会在切换video标签的过程中出现一下黑屏）
                this._needHideVideoNode = this._curVideoNode;
                this._prePlayNext = false;
                _$g(_$h(MultiPlayer.prototype), "playNextInner", this).call(this, opts);
            }
        },
        {
            key: "appendAfter",
            value: function appendAfter(videoInfo) {
                // 只需要检查被append进来的数组的第一个视频信息，看看是否需要马上播放她或者干点别的
                var isIdle = this._curVideoNode ? this._curVideoNode.state === VideoState.IDLE : true;
                // 如果被检查的视频信息就是当前播放的下一个视频信息
                if (this._played && this._curUrlIdx + 1 === this._videoInfos.indexOf(videoInfo) && isIdle) {
                    this.playNextInner();
                }
            }
        },
        {
            key: "preparePreloader",
            value: function preparePreloader(isFirstLoad, videoInfo) {
                this._logger.log('preparePreloader(), isFirstLoad=', isFirstLoad);
                var videoNode = this.getIdleVideoNode();
                if (!videoNode) {
                    // 已经找不到空闲的IVideoNode了
                    return null;
                }
                videoInfo.extraVars.preloadVideoNode = videoNode;
                // 如果是第一个预加载，直接显示出来并设置成当前播放的VideoNode(用于派发事件出去)
                if (isFirstLoad) {
                    this.setCurVideoNode(videoNode);
                    this.visibleVideoNode(videoNode, true);
                }
                return new OrgPreLoader(this._config);
            }
        },
        {
            key: "getIdleVideoNode",
            value: function getIdleVideoNode() {
                if (this._firstVideoNode) {
                    // 有指定第一个使用的videonode，就直接返回
                    var vn = this._firstVideoNode;
                    this._firstVideoNode = null;
                    return vn;
                }
                var ret = null;
                var len = this._vnList.length;
                for(var i = 0; i < len; i++){
                    if (this._vnList[i].state === VideoState.IDLE && this._vnList[i] !== this._curVideoNode) {
                        var arr = this._vnList.splice(i, 1);
                        var ref;
                        ref = _$e(arr, 1), ret = ref[0];
                        break;
                    }
                }
                if (ret) {
                    this._vnList.push(ret);
                }
                return ret;
            }
        },
        {
            key: "getLevelSwitching",
            value: /** 是否正在切换清晰度（在multi-player中实现的soft切换）*/ function getLevelSwitching() {
                return !!this._setLevelVideoNode;
            }
        },
        {
            key: "setLevelInner",
            value: function setLevelInner(value) {
                var setLevelMode = this.decideSetLevelMode(value === null || value === void 0 ? void 0 : value.setLevelMode);
                this._logger.log("setLevelMode=".concat(setLevelMode));
                if (setLevelMode === SetLevelMode.HARD || setLevelMode === SetLevelMode.SMOOTH) {
                    // VideoNode自行处理硬切还是平滑切换
                    return this._curVideoNode.setLevel(setLevelMode);
                }
                return this.setLevelSoftMode();
            }
        },
        {
            key: "switchVideoNodeWhenSetLevelSucc",
            value: /**
   * 下一个清晰度的VideoNode播放ok以后，切换到前台开始播放
   * @param preVideoNode 上一个清晰度播放时使用的VideoNode
   */ function switchVideoNodeWhenSetLevelSucc(preVideoNode) {
                this._logger.log('>>>>>switchLevelVideoNode<<<<<');
                if (preVideoNode === this._curVideoNode) {
                    // 下一个清晰度的VideoNode就是当前的VideoNode，直接显示出来
                    this.visibleVideoNode(this._curVideoNode, true);
                } else {
                    this.visibleVideoNode(this._curVideoNode, true);
                    this.visibleVideoNode(preVideoNode, false);
                    preVideoNode === null || preVideoNode === void 0 ? void 0 : preVideoNode.stop();
                }
            }
        },
        {
            key: "checkAccuratePlaytime",
            value: function checkAccuratePlaytime(videoElementTime, videoElementDuration) {
                var prePlayNextTime = this._config.originKernelConfig.prePlayNextTime;
                var leftTime = Math.abs(videoElementDuration - videoElementTime);
                if (prePlayNextTime > 0 && leftTime < prePlayNextTime && !this._prePlayNext) {
                    this._prePlayNext = true;
                    var preloaderIdx = this.findPreloadIdxByVideoInfo(this.nextVideoInfo);
                    if (this.nextVideoInfo && preloaderIdx !== -1) {
                        var _this__preloaders_preloaderIdx_videoInfo, _this__preloaders_preloaderIdx;
                        var existPreloadVideoNode = (_this__preloaders_preloaderIdx = this._preloaders[preloaderIdx]) === null || _this__preloaders_preloaderIdx === void 0 ? void 0 : (_this__preloaders_preloaderIdx_videoInfo = _this__preloaders_preloaderIdx.videoInfo) === null || _this__preloaders_preloaderIdx_videoInfo === void 0 ? void 0 : _this__preloaders_preloaderIdx_videoInfo.extraVars.preloadVideoNode;
                        if (existPreloadVideoNode) {
                            this._logger.log("preplay next!! idx/state: ".concat(existPreloadVideoNode.idx, "/").concat(existPreloadVideoNode.state));
                            existPreloadVideoNode.play();
                        }
                    }
                }
                this.checkAutoPreloadNext(leftTime);
            }
        },
        {
            key: "stopInner",
            value: function stopInner() {
                var endState = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : EndState.NORMAL, dispatchEvt = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false, videoInfo = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
                this._firstVideoNode = null;
                this._prePlayNext = false;
                this.playStartTime = 0;
                // 如果有正在切换清晰度的videoNode，也得清理
                this.clearSetLevelThings(true);
                _$g(_$h(MultiPlayer.prototype), "stopInner", this).call(this, endState, dispatchEvt, videoInfo);
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                this._needHideVideoNode = null;
                this._setLevelVideoNode = null;
                this._firstVideoNode = null;
                this.playStartTime = 0;
                // 缓存一下，避免super.destroy以后为空
                var videoElement = this.videoElements;
                _$g(_$h(MultiPlayer.prototype), "destroy", this).call(this);
                // 因video标签是外部传入并且复用的，不是本对象自己创建的，因此需要恢复原样
                videoElement.forEach(function(e) {
                    if (!_$2(e, HTMLVideoElement)) {
                        return;
                    }
                    // 切换video标签到后台预加载等逻辑时，可能会修改video标签的如下属性，恢复修改
                    e.volume = 1;
                    e.muted = false;
                    domTool.css(e, {
                        zIndex: '0',
                        visibility: 'inherit'
                    });
                    e.dataset.idx = '0';
                });
            }
        },
        {
            key: "checkBeforePlay",
            value: /** 播放接口调用前置检查 */ function checkBeforePlay() {
                if (this.getLevelSwitching()) {
                    // todo： 如果正在切换清晰度的时候，触发了打断式加载，怎么做？
                    // 如果正在切清晰度的时候被暂停了（比如在手机上切到后台，系统暂停了所有video的播放），恢复play的时候只恢复切清晰度的
                    this._setLevelVideoNode.play();
                    this._logger.log('play(), setlevel');
                    return false;
                }
                if (this._videoInfos.length <= 0 || !this._videoInfos[this._curUrlIdx]) {
                    this._logger.warn('play(), !videoInfo');
                    return false;
                }
                return true;
            }
        },
        {
            key: "emitStateChange",
            value: /**
   * 发送STATE_CHANGE事件
   * @param videoInfo 发送对应的IVideoInfo信息对象
   * @param newState Change后播放状态
   */ function emitStateChange(videoInfo, newState) {
                this.emit(PlayEvent.STATE_CHANGE, {
                    videoInfo: videoInfo,
                    new: newState,
                    old: this._curVideoNode ? this._curVideoNode.state : VideoState.IDLE
                });
            }
        },
        {
            key: "preloadToPlay",
            value: /**
   * 处理下一个视频从preload状态转化为play
   * @param videoInfo 预加载videoInfo对象
   * @param preloaderIdx 预加载loader序号
   */ function preloadToPlay(videoInfo, preloaderIdx) {
                var _this = this;
                var DELAY_BUFFERING_TIME = 200;
                var preloadBufferingTimeoutID = 0;
                // 如果即将播放下一个视频，但是又处于预加载中，需要给一个buffering事件出去
                if (videoInfo.hasFirstPlaying) {
                    preloadBufferingTimeoutID = window.setTimeout(function() {
                        _this.emitStateChange(videoInfo, VideoState.BUFFERING);
                    }, DELAY_BUFFERING_TIME);
                }
                this._preloaders[preloaderIdx].promise.then(function() {
                    clearTimeout(preloadBufferingTimeoutID);
                    _this._logger.log("play(), preloadVideoNode succ, uid=".concat(videoInfo.uid));
                    _this.enterVideoNodePlay(videoInfo, preloaderIdx);
                }).catch(function(error) {
                    _this._logger.log("play(), preloadVideoNode error, uid=".concat(videoInfo.uid, "/error="), error);
                    if (!(error.code in ErrorCode)) {
                        // 所谓鸭子类型判断，因为可能有各种其他的不是播放器定义的错误
                        return;
                    }
                    clearTimeout(preloadBufferingTimeoutID);
                    // 预加载时候已经把备份地址重试完了，没必要继续了
                    // 所以下面直接抛出错误
                    videoInfo.error = error;
                    _this.stopInner(EndState.ERROR, true, videoInfo);
                });
            }
        },
        {
            key: "enterVideoNodePlay",
            value: /**
   * 最终进入调用videonode的play逻辑
   * @param videoInfo 进入播放videoInfo对象
   * @param preloaderIdx 已经预加载序号
   */ function enterVideoNodePlay(videoInfo) {
                var preloaderIdx = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : -1;
                var _this__preloaders_preloaderIdx_videoInfo, _this__preloaders_preloaderIdx, _this_currentVideoInfo;
                var preloadSucc = preloaderIdx !== -1;
                this._logger.log("enterVideoNodePlay(), preloadSucc=".concat(preloadSucc));
                var existPreloadVideoNode = preloaderIdx !== -1 ? (_this__preloaders_preloaderIdx = this._preloaders[preloaderIdx]) === null || _this__preloaders_preloaderIdx === void 0 ? void 0 : (_this__preloaders_preloaderIdx_videoInfo = _this__preloaders_preloaderIdx.videoInfo) === null || _this__preloaders_preloaderIdx_videoInfo === void 0 ? void 0 : _this__preloaders_preloaderIdx_videoInfo.extraVars.preloadVideoNode : null;
                this.findIdleVideoNode(existPreloadVideoNode);
                // 如果被预加载过，清理预加载信息，但是保留video上已加载的数据
                if (preloaderIdx !== -1) {
                    var _this__preloaders_splice = _$e(this._preloaders.splice(preloaderIdx, 1), 1), preloader = _this__preloaders_splice[0];
                    preloader.clear(true);
                }
                // 如果是自动播放的场景，这里有个注意点哦！
                // 我们需要在调用play之前就把videonode显示出来（调用visibleVideoNode传true使volume设置为正常状态），否则是静音状态的时候调用了
                // play方法（见下面代码的videonode.play方法）。如果是静音状态时候调用play就无法catch到自动播放被阻止的异常了。而是调用play再恢复音
                // 量时，会收到类似如下警告（chrome）：
                // Unmuting failed and the element was paused instead because the user didn't interact with the document before
                // 这种情况不是我们预期的检测自动播放结果。因此把下面这一段代码移上来了。
                if (!this._needHideVideoNode) {
                    // 不需要等上一个隐藏，那就直接显示。否则需要等一定时机显示出来
                    this.visibleVideoNode(this._curVideoNode, true);
                    this._logger.log('visibleVideoNode, null need');
                } else if (this._needHideVideoNode === this._curVideoNode) {
                    this.visibleVideoNode(this._curVideoNode, true);
                    this._logger.log('visibleVideoNode, need==current');
                } else if (preloadSucc) {
                    this.switchVideoNode();
                }
                if (this._curVideoNode.state !== VideoState.PLAYING) {
                    this._curVideoNode.play(videoInfo, {
                        startTime: this.playStartTime
                    });
                }
                this.emit(PlayEvent.VIDEONODE_CHANGE, {
                    videoInfo: this.currentVideoInfo
                });
                this._logger.log("enterMultiPlay(), uid=".concat((_this_currentVideoInfo = this.currentVideoInfo) === null || _this_currentVideoInfo === void 0 ? void 0 : _this_currentVideoInfo.uid, "/") + "urlIdx=".concat(this._curUrlIdx, "/state=").concat(this._curVideoNode.state));
                if (!preloadSucc) {
                    // 如果没有预加载，不需要补发事件了
                    return;
                }
                // 如果不是第一个视频播放，并且被预加载过，可能需要补发一些事件
                if (this._videoInfos.indexOf(this.currentVideoInfo) !== 0) {
                    // 如果url有预加载，duration变化事件已经错过了，这里补发一个事件给外部（放在videoNode.play以后触发，才能取到currentVideoInfo属性）
                    this.emit(PlayEvent.DURATION_CHANGE, {
                        videoInfo: this.currentVideoInfo
                    });
                    // 因为可能提前开播了，补一个playing事件
                    this.emitStateChange(this.currentVideoInfo, this._curVideoNode.state);
                }
                // 通知外部当前视频已经开播了
                if (!this.currentVideoInfo.extraVars.isStartPlay) {
                    this.currentVideoInfo.extraVars.isStartPlay = true;
                    this._logger.log("videoNodeStartPlay: uid[".concat(this.currentVideoInfo.uid, "]"));
                    this.emit(PlayEvent.VIDEONODE_START_PLAY, {
                        videoInfo: this.currentVideoInfo
                    });
                }
            }
        },
        {
            key: "findIdleVideoNode",
            value: /** 查找当前空闲的VideoNode */ function findIdleVideoNode(existPreloadVideoNode) {
                // 下面开始选择一个播放控件
                var idleVideoNode;
                var forceSetVideoNode = false;
                // 先看是否有预加载
                idleVideoNode = existPreloadVideoNode;
                // 如果为空，再看是否有空闲videonode
                if (!idleVideoNode) {
                    idleVideoNode = this.getIdleVideoNode();
                }
                // 如果为空，再看当前videonode是否是空闲状态
                if (!idleVideoNode && this._curVideoNode && this._curVideoNode.state === VideoState.IDLE) {
                    idleVideoNode = this._curVideoNode;
                    // 此时需要强制替换当前videonode
                    forceSetVideoNode = true;
                }
                if (!idleVideoNode) {
                    this._logger.warn('can not find idle videonode!');
                    throw new Error('can not find idle videonode!');
                }
                this.setCurVideoNode(idleVideoNode, forceSetVideoNode);
            }
        },
        {
            key: "setLevelSoftMode",
            value: /**
   * 实现soft模式的清晰度切换
   */ function setLevelSoftMode() {
                var _this = this;
                // 以下逻辑为multi-player实现soft模式的清晰度切换：
                var levelSwitchingDefer = new SimpleDefer();
                // 先把当前的VideoInfo存起来。因为如果找不到可以使用的空闲VideoNode，可能会销毁当前的VideoNode来实现清晰度切换，这样会导致
                // currentVideoInfo变量为空
                var videoInfo = this.currentVideoInfo;
                this._logger.log("setLevelInner(), uid: ".concat(videoInfo.uid));
                this.pauseInner();
                this.setPlayEvents(this._curVideoNode, false);
                this.emit(PlayEvent.SETLEVEL_START, {
                    videoInfo: videoInfo,
                    mode: SetLevelMode.SMOOTH
                });
                // multi-player切换清晰度不使用VideoNode的setLevel方法，而是自己实现的多video切换，因此切换前先显示loading动画
                this.setLoading(true);
                var targetPlaytime = this._curVideoNode.playtime;
                var videoNode = this.getIdleVideoNode();
                // 找一个空闲的videoNode来加载下一个清晰度，如果没有，只能清理当前的videoNode了（会黑屏）
                if (!videoNode) {
                    this._curVideoNode.stop();
                    videoNode = this._curVideoNode;
                } else {
                    this.visibleVideoNode(videoNode, false);
                }
                // url需要重新加载
                videoInfo.extraVars.isLoadstarted = false;
                this._setLevelVideoNode = videoNode;
                this._setLevelVideoNode.setLevelEvtMap = {}; // 切换清晰度事件
                // 在触发切换的时候，就设置下一个清晰度的VideoNode为currentVideoNode，开始监听下一个清晰度的事件。而上一个清晰度的VideoNode仅为了保
                // 留画面，不再开始监听事件、控制其行为。
                var preVideoNode = this._curVideoNode;
                this.setCurVideoNode(videoNode, true);
                videoNode.setLevelEvtMap[VideoNodeEvent.STATE_CHANGE] = function(e) {
                    // 下一个清晰度视频开播，代表切换成功
                    if (e.data.new === VideoState.PLAYING) {
                        _this.setLevelSoftModeHandler(videoInfo, levelSwitchingDefer, preVideoNode);
                    }
                };
                videoNode.setLevelEvtMap[VideoNodeEvent.ERROR] = function() {
                    _this.setLevelSoftModeHandler(videoInfo, levelSwitchingDefer);
                };
                // timeupdate是等待新的清晰度时间超过切换清晰度的时间时结束，这样可能会比较慢
                videoNode.on(VideoNodeEvent.STATE_CHANGE, videoNode.setLevelEvtMap[VideoNodeEvent.STATE_CHANGE]);
                videoNode.on(VideoNodeEvent.ERROR, videoNode.setLevelEvtMap[VideoNodeEvent.ERROR]);
                // 直接播放下一个清晰度的视频
                videoNode.play(videoInfo, {
                    startTime: targetPlaytime
                });
                return levelSwitchingDefer.promise;
            }
        },
        {
            key: "clearSetLevelThings",
            value: /** 清除预加载相关资源，包括移除事件和相关数据等，注意如果正在切换清晰度中不会执行清理  */ function clearSetLevelThings(keepdata) {
                if (!this.getLevelSwitching()) {
                    return;
                }
                var videoNode = this._setLevelVideoNode;
                if (videoNode.setLevelEvtMap) {
                    Object.keys(videoNode.setLevelEvtMap).forEach(function(evt) {
                        videoNode.off(evt, videoNode.setLevelEvtMap[evt]);
                    });
                    videoNode.setLevelEvtMap = null;
                }
                if (!keepdata) {
                    videoNode.stop();
                }
                // 清晰度切换成功以后，强制清理掉所有的预加载数据
                this.clearAllPreloadInner();
                this._setLevelVideoNode = null;
            }
        },
        {
            key: "setLevelSoftModeHandler",
            value: function setLevelSoftModeHandler(videoInfo, levelDefer) {
                var preVNode = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
                var succ = !!preVNode;
                this._logger.log("setLevel succ>>>>>> ".concat(succ, " uid: ").concat(videoInfo.uid));
                this.clearSetLevelThings(succ);
                if (succ) {
                    this.switchVideoNodeWhenSetLevelSucc(preVNode);
                    levelDefer.resolve();
                } else {
                    var _videoInfo_error;
                    this.rollbackLevelVideoNode();
                    levelDefer.reject(new Error("setLevel failed, ".concat((_videoInfo_error = videoInfo.error) === null || _videoInfo_error === void 0 ? void 0 : _videoInfo_error.message)));
                }
                this.emit(PlayEvent.SETLEVEL_OVER, {
                    videoInfo: videoInfo,
                    fail: !succ
                });
                this.setLoading(false);
            }
        },
        {
            key: "rollbackLevelVideoNode",
            value: /** 清晰度切失败了得回滚，不然就卡死了 */ function rollbackLevelVideoNode() {
                this._logger.log('>>>>>rollbackLevelVideoNode<<<<<');
                if (this._urlBeforeSetLevel) {
                    // 回滚时候恢复切换之前的url地址（并重置loadingUrl等）
                    Object.assign(this.currentVideoInfo.config, this._urlBeforeSetLevel);
                    this.currentVideoInfo.reset();
                    this._urlBeforeSetLevel = null;
                }
                this.setPlayEvents(this._curVideoNode, true);
                this.resumeInner();
            }
        }
    ], [
        {
            key: "canPlayType",
            get: function get() {
                return videoTool.supportVideoFormat();
            }
        }
    ]);
    return MultiPlayer;
}(BasePlayer);
// 原生播放返回true，如果继承MultiPlayer的内核需要重写该方法
_$1(MultiPlayer, "isEnvSupport", true);
_$7([
    logMethodCall$1,
    _$8("design:type", Function),
    _$8("design:paramtypes", [
        Number
    ]),
    _$8("design:returntype", void 0)
], MultiPlayer.prototype, "playInner", null);
_$7([
    logMethodCall$1,
    _$8("design:type", Function),
    _$8("design:paramtypes", []),
    _$8("design:returntype", void 0)
], MultiPlayer.prototype, "switchVideoNode", null);

/**
 * webpack编译时注入变量
 */ function getEnvVals() {
    var CHANNEL = 'npm';
    try {
        CHANNEL = "npm";
    } catch (e) {}
    var VERSION = '';
    try {
        VERSION = "1.38.5";
    } catch (e) {}
    var BUILD_TIME = '';
    try {
        BUILD_TIME = 1736151878762;
    } catch (e) {}
    var LOCAL_DEV = false;
    try {
        LOCAL_DEV = "" === '1';
    } catch (e) {}
    return {
        CHANNEL: CHANNEL,
        VERSION: VERSION,
        BUILD_TIME: BUILD_TIME,
        LOCAL_DEV: LOCAL_DEV
    };
}
var _getEnvVals = getEnvVals(), CHANNEL = _getEnvVals.CHANNEL, BUILD_TIME = _getEnvVals.BUILD_TIME, VERSION = _getEnvVals.VERSION, LOCAL_DEV = _getEnvVals.LOCAL_DEV;

var BaseLivePlayer = /*#__PURE__*/ function(BasePlayer) {
    _$9(BaseLivePlayer, BasePlayer);
    var _super = _$a(BaseLivePlayer);
    function BaseLivePlayer() {
        _$5(this, BaseLivePlayer);
        return _super.apply(this, arguments);
    }
    _$4(BaseLivePlayer, [
        {
            key: "playInner",
            value: function playInner(_startTime) {
                var videoInfo = this._videoInfos[0];
                this.setPlayEvents(this._curVideoNode, true);
                this._curVideoNode.play(videoInfo);
                this.emit(PlayEvent.VIDEONODE_CHANGE, {
                    videoInfo: videoInfo
                });
            }
        },
        {
            key: "resumeInner",
            value: function resumeInner() {
                var _this__curVideoNode;
                if (!this._played) {
                    return;
                }
                if ((_this__curVideoNode = this._curVideoNode) === null || _this__curVideoNode === void 0 ? void 0 : _this__curVideoNode.currentVideoInfo) {
                    this._curVideoNode.videoplay();
                }
            }
        },
        {
            key: "loadInner",
            value: function loadInner(value, extra) {
                var ret = _$g(_$h(BaseLivePlayer.prototype), "loadInner", this).call(this, value, extra);
                if (!ret) {
                    return false;
                }
                this.setCurVideoNode(this._vnList[0]);
                // videoInfos 由 super.loadInner 创建，这里没有了 preloader 手动 load
                this._curVideoNode.load(this._videoInfos[0]);
                return true;
            }
        },
        {
            key: "appendAfter",
            value: function appendAfter(_videoInfo) {
            // do nothing
            }
        },
        {
            key: "checkAccuratePlaytime",
            value: function checkAccuratePlaytime(_videoElementTime, _videoElementDuration) {
            // do nothing
            }
        },
        {
            key: "preparePreloader",
            value: function preparePreloader(_isFirstLoad, _videoInfo) {
                // do nothing
                return null;
            }
        },
        {
            key: "getIdleVideoNode",
            value: function getIdleVideoNode() {
                return this._vnList[0];
            }
        },
        {
            key: "setLevelInner",
            value: function setLevelInner(value) {
                return this._curVideoNode.setLevel(value.setLevelMode);
            }
        },
        {
            key: "playBlocked",
            value: function playBlocked() {
                _$g(_$h(BaseLivePlayer.prototype), "playBlocked", this).call(this);
                this.pause();
            }
        },
        {
            key: "supportPreload",
            get: // eslint-disable-next-line @typescript-eslint/class-literal-property-style
            function get() {
                return false;
            }
        },
        {
            key: "supportPlaybackRate",
            get: // eslint-disable-next-line @typescript-eslint/class-literal-property-style
            function get() {
                return false;
            }
        },
        {
            key: "nextVideoInfo",
            get: function get() {
                return this.currentVideoInfo;
            }
        }
    ]);
    return BaseLivePlayer;
}(BasePlayer);
// 禁用直播用不到的一些方法
[
    'seek',
    'hasAppended',
    'hasPreloaded',
    'playNext',
    'appendNext',
    'preloadNext',
    'clearAllPreload',
    'appendAfter',
    'checkPlayNext',
    'playNextInner',
    'checkAutoPreloadNext',
    'clearAllPreloadInner'
].forEach(function(keyName) {
    BaseLivePlayer.prototype[keyName] = function() {
        console.warn("[thumbplayer] ".concat(keyName, "() is not support due to live stream"));
    };
});

var LivePlayer = /*#__PURE__*/ function(BaseLivePlayer) {
    _$9(LivePlayer, BaseLivePlayer);
    var _super = _$a(LivePlayer);
    function LivePlayer(conf) {
        _$5(this, LivePlayer);
        return _super.call(this, mergeKernelConfig(conf));
    }
    _$4(LivePlayer, [
        {
            key: "kernelName",
            get: // eslint-disable-next-line @typescript-eslint/class-literal-property-style
            function get() {
                return KernelName.ORIGIN;
            }
        }
    ]);
    return LivePlayer;
}(BaseLivePlayer);

var OrgPlayer = /*#__PURE__*/ function() {
    function OrgPlayer(opts) {
        _$5(this, OrgPlayer);
        return opts.type === PlayMode.LIVE ? new LivePlayer(opts) : new MultiPlayer(opts);
    }
    _$4(OrgPlayer, null, [
        {
            key: "canPlayType",
            get: function get() {
                return videoTool.supportVideoFormat();
            }
        }
    ]);
    return OrgPlayer;
}();
_$1(OrgPlayer, "isEnvSupport", true);
// 历史原因，命名不符合tslint规范，但变量名可能已被外部使用。
// eslint-disable-next-line @typescript-eslint/naming-convention
_$1(OrgPlayer, "VERSION", VERSION);
// 历史原因，命名不符合tslint规范，但变量名可能已被外部使用。
// eslint-disable-next-line @typescript-eslint/naming-convention
_$1(OrgPlayer, "BUILD_TIME", BUILD_TIME);

var defaultPlayerConfig = {
    type: PlayMode.VOD,
    interruptPlayNextMinTime: 1,
    backupUrlsMaxRetryCount: 0,
    maxPreloadTimeout: 30000,
    maxBufferingTimeout: 30000,
    maxStateStalledTime: 30000,
    maxPlaytimeStalledTime: 10000,
    isPlayList: false,
    preloadType: PreloadType.AUTO_LOAD,
    maxVideoNodeCount: 1,
    minFillBlackBorder: 10,
    minFragmentCountForSmoothLevelSwitching: 3,
    ignoreEndedWhenLive: true,
    rptRate: 0.2,
    videoContainerStyle: VIDEO_CONTAINER_STYLE,
    ignoreVideoError: uaTool.os.android && commonTool.compareVersion(uaTool.os.version, '9.0') < 0,
    kernelJsMaxAgeS: 86400
};

/**
 * 补齐用户传入的配置项
 */ function patchConfig(config) {
    var _config_originKernelConfig;
    var // 播放器实例id，有外部传入的实例id则无需创建
    _config, // 兼容一下旧的配置项
    _config1, // 最后创建video标签数组（最后是因为会依赖其他配置项去创建）
    // video标签需要提前在播放内核创建之前初始化。因为load或者play接口才会创建播放内核。但是触发自动播放等行为可能先于load或者
    // play接口，而这些行为依赖video标签的实例。这里创建的video标签在各种播放内核切换中，会做到复用。
    _config2;
    var _instanceId;
    (_instanceId = (_config = config).instanceId) !== null && _instanceId !== void 0 ? _instanceId : _config.instanceId = commonTool.createGUID();
    var _maxVideoNodeCount;
    (_maxVideoNodeCount = (_config1 = config).maxVideoNodeCount) !== null && _maxVideoNodeCount !== void 0 ? _maxVideoNodeCount : _config1.maxVideoNodeCount = (_config_originKernelConfig = config.originKernelConfig) === null || _config_originKernelConfig === void 0 ? void 0 : _config_originKernelConfig.maxVideoNodeCount;
    // 补齐默认配置项
    Object.keys(defaultPlayerConfig).forEach(function(key) {
        if (typeof config[key] === 'undefined') {
            config[key] = defaultPlayerConfig[key];
        }
    });
    var _videoElements;
    (_videoElements = (_config2 = config).videoElements) !== null && _videoElements !== void 0 ? _videoElements : _config2.videoElements = createVideoElements(config);
    return config;
}
/**
 * 根据用户传入的video标签配置项，转换为生成video标签属性和样式的配置
 * @param videoConfig 用户video标签配置项
 * @returns attrOpts为生成的attribute属性，cssOpts为生成的样式属性
 */ function convertVideoElementConfig(videoConfig) {
    var presetStyleMap = {
        position: 'absolute',
        width: '100%',
        height: '100%',
        top: 0,
        left: 0,
        objectFit: 'contain'
    };
    var vaildStyleKeys = Object.keys(presetStyleMap);
    var presetAttrMap = {
        playsinline: {
            playsinline: 'isiPhoneShowPlaysinline',
            'webkit-playsinline': 'isiPhoneShowPlaysinline'
        },
        airplay: {
            airplay: 'allow',
            'x-webkit-airplay': 'allow'
        },
        crossorigin: {
            crossOrigin: 'anonymous'
        },
        'h5-page': {
            'x5-video-player-type': 'h5-page'
        }
    };
    var presetAttrOpts = {
        playsinline: true,
        'h5-page': true
    };
    Object.keys(videoConfig).forEach(function(key) {
        if (vaildStyleKeys.indexOf(key) === -1) {
            // 不是css属性，才加入
            presetAttrOpts[key] = videoConfig[key];
        }
    });
    var attrOpts = Object.keys(presetAttrOpts).reduce(function(res, key) {
        if (presetAttrMap[key] && typeof presetAttrOpts[key] === 'boolean') {
            // 如果用户传入的key是预设里的某一个，并且为true，我们不添加用户的key而是展开预设内的属性
            res = _$6({}, res, presetAttrOpts[key] ? presetAttrMap[key] : {});
        } else {
            // 用户传入了预设参数外的值，直接赋值不做检查
            res[key] = presetAttrOpts[key];
        }
        return res;
    }, {});
    var cssOpts = vaildStyleKeys.reduce(function(res, key) {
        var _videoConfig_key;
        res[key] = (_videoConfig_key = videoConfig[key]) !== null && _videoConfig_key !== void 0 ? _videoConfig_key : presetStyleMap[key];
        return res;
    }, {});
    return {
        attrOpts: attrOpts,
        cssOpts: cssOpts
    };
}
/**
 * 创建video组件数组
 */ function createVideoElements(config) {
    var instanceId = config.instanceId, videoElementConfig = config.videoElementConfig, maxVideoNodeCount = config.maxVideoNodeCount;
    var createVideoDomOptions = convertVideoElementConfig(_$f(_$6({
        preload: config.preloadType === PreloadType.META_DATA ? 'metadata' : 'auto'
    }, videoElementConfig), {
        playerid: instanceId
    }));
    var elements = [];
    for(var i = 0; i < maxVideoNodeCount; i++){
        var videoElement = domTool.createVideoDom(createVideoDomOptions);
        elements.push(videoElement);
    }
    return elements;
}

var ChannelMap;
/** 引用方式枚举 */ (function(ChannelMap) {
    ChannelMap[ChannelMap["npm"] = 0] = "npm";
    ChannelMap[ChannelMap["cdn"] = 1] = "cdn";
})(ChannelMap || (ChannelMap = {}));
var ReferenceReport = /*#__PURE__*/ function() {
    function ReferenceReport() {
        _$5(this, ReferenceReport);
        // 只上报一次
        _$1(this, "isCollected", false);
        // 上报使用的atta信息
        _$1(this, "attaid", '05700050920');
        _$1(this, "token", '3619167286');
        _$1(this, "timeout", 3000);
        /** 上报率，1为全量上报 */ _$1(this, "rptRate", 1);
    }
    _$4(ReferenceReport, [
        {
            key: "collectUsage",
            value: /**
   * 引用上报，对多层只上报一次，只是取不同值用于上报区分
   * @param from 引用来源
   * @param channel 引用方式
   * @param platform 平台号
   */ function collectUsage() {
                var from = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, channel = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : CHANNEL, platform = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : '';
                if (this.isCollected) return;
                this.isCollected = true;
                if (Math.random() > this.rptRate) {
                    // 仅采样上报
                    return;
                }
                // 取URL相关信息
                var topUrl = urlTool.getTopFrameUrl();
                var urlWithoutQuery = topUrl === null || topUrl === void 0 ? void 0 : topUrl.split('?')[0];
                var domain = urlTool.getDomainOfURL(topUrl);
                var reportInfo = {
                    attaid: this.attaid,
                    token: this.token,
                    topUrl: "".concat(encodeURIComponent(topUrl)),
                    pageUrl: "".concat(encodeURIComponent(urlWithoutQuery)),
                    domain: "".concat(encodeURIComponent(domain)),
                    channel: "".concat(ChannelMap[channel] || 0),
                    from: "".concat(from),
                    version: VERSION,
                    platform: platform,
                    kernel: Object.keys(KernelFactory.kernelMap).join('$'),
                    _dc: "".concat(Math.random())
                };
                this.send(reportInfo);
            }
        },
        {
            key: "send",
            value: /**
   * 初始化时统计信息，这种不太重要的上报动作延迟到3S后，因为初始时候请求太多了
   */ function send(args) {
                setTimeout(function() {
                    var img = new Image();
                    // 这里用atta的单字段批量上报接口
                    img.src = "https://h.trace.qq.com/kv?".concat(urlTool.object2string(_$6({}, args), '&'));
                }, this.timeout);
            }
        }
    ], [
        {
            key: "getReporter",
            value: /**
   * 获取引用上报ReferenceReport实例
   * @returns 引用上报ReferenceReport实例
   */ function getReporter() {
                if (!this.reporter) {
                    this.reporter = new ReferenceReport();
                }
                return this.reporter;
            }
        }
    ]);
    return ReferenceReport;
}();
// 上报对象静态实例
_$1(ReferenceReport, "reporter", void 0);

var logMethodCall = logMethodCallDecoratorCreator('KernelProxy');
var performanceCost = performanceCostDecoratorCreator('KernelProxy');
/** 全局的内核加载map，用于记录内核的js加载。加载初记录到map中，加载完成后resolve */ var loadKernelDeferMap = {};
/** player.dataset[KEY] 的 key，用于判断是否重复创建了播放器 */ var CONTAINER_DATASET_KEY = 'tp';
/**
 * 代理播放内核，在内部实现播放内核的创建、切换、销毁，事件转发等。这里已经创建了一组video标签，然后通过config传给正在使用的播放内核。而且播放
 * 内核之间切换，video标签是复用的。
 */ var KernelProxy = /*#__PURE__*/ function(EvtEmitter) {
    _$9(KernelProxy, EvtEmitter);
    var _super = _$a(KernelProxy);
    function KernelProxy(conf) {
        _$5(this, KernelProxy);
        var _this;
        _this = _super.call(this);
        _$1(_$b(_this), "kernel", void 0);
        _$1(_$b(_this), "playerConfig", void 0);
        // 以下几个 inner 值用于没有创建或者切换内核也允许设置的临时保存
        /** 音量值 */ _$1(_$b(_this), "volumeInner", 1);
        /** 播放速度值 */ _$1(_$b(_this), "playbackRateInner", void 0);
        /** 音量增益 */ _$1(_$b(_this), "volumeGainInner", 0);
        /** 音效 */ _$1(_$b(_this), "audioEffectInner", 'default');
        _$1(_$b(_this), "kernelEvtFuncs", void 0);
        /** 是否是内部默认创建的video组件 */ _$1(_$b(_this), "isSelfVideoElements", false);
        _$1(_$b(_this), "logger", void 0);
        _$1(_$b(_this), "addedEvts", []);
        _$1(_$b(_this), "setLevelWhenKernelSwitchedDefer", void 0);
        _$1(_$b(_this), "isDestroyed", false);
        /** 播放器的容器元素 */ _$1(_$b(_this), "containerEl", void 0);
        /** video标签容器 */ _$1(_$b(_this), "videoElementsContainer", void 0);
        _this.isSelfVideoElements = !conf.videoElements; // 外部没传video标签，代表为自己创建，后续需要判断这个变量销毁
        _this.playerConfig = patchConfig(conf);
        _this.logger = new Logger(_this.playerConfig.instanceId, 'KernelProxy');
        if (+lsTool.getData('dHAtbG9nLWxldmVs') > 0) {
            // 不传入参数时启用所有控制台输出
            enable();
        }
        _this.setPlayerContainer();
        _this.createVideoElementsContainer();
        _this.kernelEvtFuncs = _this.kernelEvtHandler.bind(_$b(_this));
        // 引用上报
        if (!_this.playerConfig.isPrivateDeployment) {
            ReferenceReport.getReporter().rptRate = _this.playerConfig.rptRate;
            ReferenceReport.getReporter().collectUsage();
        }
        return _this;
    }
    _$4(KernelProxy, [
        {
            key: "container",
            get: function get() {
                return this.containerEl;
            }
        },
        {
            key: "config",
            get: function get() {
                return this.playerConfig;
            }
        },
        {
            key: "useWorker",
            get: function get() {
                var _this_kernel;
                return !!((_this_kernel = this.kernel) === null || _this_kernel === void 0 ? void 0 : _this_kernel.useWorker);
            }
        },
        {
            key: "kernelName",
            get: function get() {
                var _this_kernel;
                return (_this_kernel = this.kernel) === null || _this_kernel === void 0 ? void 0 : _this_kernel.kernelName;
            }
        },
        {
            key: "videoElements",
            get: function get() {
                var _this_kernel;
                return ((_this_kernel = this.kernel) === null || _this_kernel === void 0 ? void 0 : _this_kernel.videoElements) || [];
            }
        },
        {
            key: "currentVideoElement",
            get: function get() {
                var _this_kernel;
                return (_this_kernel = this.kernel) === null || _this_kernel === void 0 ? void 0 : _this_kernel.currentVideoElement;
            }
        },
        {
            key: "supportPreload",
            get: function get() {
                var _this_kernel;
                return !!((_this_kernel = this.kernel) === null || _this_kernel === void 0 ? void 0 : _this_kernel.supportPreload);
            }
        },
        {
            key: "duration",
            get: function get() {
                var _this_kernel;
                return ((_this_kernel = this.kernel) === null || _this_kernel === void 0 ? void 0 : _this_kernel.duration) || 0;
            }
        },
        {
            key: "playtime",
            get: function get() {
                var _this_kernel;
                return ((_this_kernel = this.kernel) === null || _this_kernel === void 0 ? void 0 : _this_kernel.playtime) || 0;
            }
        },
        {
            key: "videoInfos",
            get: function get() {
                var _this_kernel;
                return ((_this_kernel = this.kernel) === null || _this_kernel === void 0 ? void 0 : _this_kernel.videoInfos) || [];
            }
        },
        {
            key: "preloadVideoInfos",
            get: function get() {
                var _this_kernel;
                return (_this_kernel = this.kernel) === null || _this_kernel === void 0 ? void 0 : _this_kernel.preloadVideoInfos;
            }
        },
        {
            key: "currentVideoInfo",
            get: function get() {
                var _this_kernel;
                return (_this_kernel = this.kernel) === null || _this_kernel === void 0 ? void 0 : _this_kernel.currentVideoInfo;
            }
        },
        {
            key: "currentVideoInfoIdx",
            get: function get() {
                var _this_kernel;
                return ((_this_kernel = this.kernel) === null || _this_kernel === void 0 ? void 0 : _this_kernel.currentVideoInfoIdx) || 0;
            }
        },
        {
            key: "totalVideoInfoCount",
            get: function get() {
                var _this_kernel;
                return ((_this_kernel = this.kernel) === null || _this_kernel === void 0 ? void 0 : _this_kernel.totalVideoInfoCount) || 0;
            }
        },
        {
            key: "supportPlaybackRate",
            get: function get() {
                var _this_kernel;
                return !!((_this_kernel = this.kernel) === null || _this_kernel === void 0 ? void 0 : _this_kernel.supportPlaybackRate);
            }
        },
        {
            key: "played",
            get: function get() {
                var _this_kernel;
                return !!((_this_kernel = this.kernel) === null || _this_kernel === void 0 ? void 0 : _this_kernel.played);
            }
        },
        {
            key: "state",
            get: function get() {
                var _this_kernel;
                return ((_this_kernel = this.kernel) === null || _this_kernel === void 0 ? void 0 : _this_kernel.state) || VideoState.IDLE;
            }
        },
        {
            key: "videoSize",
            get: function get() {
                var _this_kernel;
                return ((_this_kernel = this.kernel) === null || _this_kernel === void 0 ? void 0 : _this_kernel.videoSize) || {
                    width: 0,
                    height: 0
                };
            }
        },
        {
            key: "videoBuffered",
            get: function get() {
                var _this_kernel;
                return ((_this_kernel = this.kernel) === null || _this_kernel === void 0 ? void 0 : _this_kernel.videoBuffered) || [];
            }
        },
        {
            key: "captureVideo",
            value: function captureVideo(dx, dy, dw, dh, extra) {
                var _this_kernel;
                return (_this_kernel = this.kernel) === null || _this_kernel === void 0 ? void 0 : _this_kernel.captureVideo(dx, dy, dw, dh, extra);
            }
        },
        {
            key: "log",
            value: function log() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                var _this_logger;
                var _this_logger1;
                (_this_logger1 = this.logger) === null || _this_logger1 === void 0 ? void 0 : (_this_logger = _this_logger1).log.apply(_this_logger, _(args));
            }
        },
        {
            key: "warn",
            value: function warn() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                var _this_logger;
                var _this_logger1;
                (_this_logger1 = this.logger) === null || _this_logger1 === void 0 ? void 0 : (_this_logger = _this_logger1).warn.apply(_this_logger, _(args));
            }
        },
        {
            key: "error",
            value: function error() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                var _this_logger;
                var _this_logger1;
                (_this_logger1 = this.logger) === null || _this_logger1 === void 0 ? void 0 : (_this_logger = _this_logger1).error.apply(_this_logger, _(args));
            }
        },
        {
            key: "hasAppended",
            value: function hasAppended(value) {
                var _this_kernel;
                return !!((_this_kernel = this.kernel) === null || _this_kernel === void 0 ? void 0 : _this_kernel.hasAppended(value));
            }
        },
        {
            key: "hasPreloaded",
            value: function hasPreloaded(value) {
                var _this_kernel;
                return !!((_this_kernel = this.kernel) === null || _this_kernel === void 0 ? void 0 : _this_kernel.hasPreloaded(value));
            }
        },
        {
            key: "volume",
            get: function get() {
                var _this_kernel;
                return ((_this_kernel = this.kernel) === null || _this_kernel === void 0 ? void 0 : _this_kernel.volume) || this.volumeInner;
            },
            set: function set(value) {
                var checkRet = checkVolumeValidWithMessage(value);
                if (!checkRet.valid) {
                    this.logger.warn(checkRet.message);
                    return;
                }
                this.volumeInner = value;
                if (this.kernel) {
                    this.kernel.volume = value;
                } else {
                    // load前设置音量补充发出事件，但没有videoInfo
                    this.emit(PlayEvent.VOLUME_CHANGE, {
                        volume: value
                    });
                }
            }
        },
        {
            key: "volumeGain",
            get: function get() {
                var _this_kernel;
                return ((_this_kernel = this.kernel) === null || _this_kernel === void 0 ? void 0 : _this_kernel.volumeGain) || this.volumeGainInner;
            },
            set: function set(gain) {
                this.volumeGainInner = gain;
                if (this.kernel) {
                    this.kernel.volumeGain = gain;
                }
            }
        },
        {
            key: "audioEffect",
            get: function get() {
                var _this_kernel;
                return ((_this_kernel = this.kernel) === null || _this_kernel === void 0 ? void 0 : _this_kernel.audioEffect) || this.audioEffectInner;
            },
            set: function set(effectName) {
                this.audioEffectInner = effectName;
                if (this.kernel) {
                    this.kernel.audioEffect = effectName;
                }
            }
        },
        {
            key: "playbackRate",
            get: function get() {
                var _this_kernel;
                return ((_this_kernel = this.kernel) === null || _this_kernel === void 0 ? void 0 : _this_kernel.playbackRate) || this.playbackRateInner;
            },
            set: function set(value) {
                this.playbackRateInner = value;
                if (this.kernel) {
                    this.kernel.playbackRate = value;
                } else {
                    // load前设置倍速补充发出事件，但没有videoInfo
                    this.emit(PlayEvent.RATE_CHANGE, {
                        playbackRate: value
                    });
                }
            }
        },
        {
            key: "resizeVideoElements",
            value: function resizeVideoElements(value) {
                var _this_kernel;
                (_this_kernel = this.kernel) === null || _this_kernel === void 0 ? void 0 : _this_kernel.resizeVideoElements(value);
            }
        },
        {
            key: "resize",
            value: function resize(value) {
                var _this_kernel;
                (_this_kernel = this.kernel) === null || _this_kernel === void 0 ? void 0 : _this_kernel.resize(value);
            }
        },
        {
            key: "seek",
            value: function seek(time) {
                var _this_kernel;
                return (_this_kernel = this.kernel) === null || _this_kernel === void 0 ? void 0 : _this_kernel.seek(time);
            }
        },
        {
            key: "play",
            value: function play(urlConfig, extra) {
                var _this = this;
                return _$c(function() {
                    var _this_kernel;
                    return _$d(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this.logger.log('play(urlConfig, ', extra, ')');
                                return [
                                    4,
                                    _this.checkConfigBeforeLoad(urlConfig, extra)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2,
                                    (_this_kernel = _this.kernel) === null || _this_kernel === void 0 ? void 0 : _this_kernel.play(urlConfig, extra)
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "load",
            value: function load(urlConfig, extra) {
                var _this = this;
                return _$c(function() {
                    var _this_kernel;
                    return _$d(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.checkConfigBeforeLoad(urlConfig, extra)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2,
                                    (_this_kernel = _this.kernel) === null || _this_kernel === void 0 ? void 0 : _this_kernel.load(urlConfig, extra)
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "playNext",
            value: function playNext(opts) {
                var _this_kernel;
                (_this_kernel = this.kernel) === null || _this_kernel === void 0 ? void 0 : _this_kernel.playNext(opts);
            }
        },
        {
            key: "pause",
            value: function pause(pauseType) {
                var _this_kernel;
                (_this_kernel = this.kernel) === null || _this_kernel === void 0 ? void 0 : _this_kernel.pause(pauseType);
            }
        },
        {
            key: "stop",
            value: function stop(endState) {
                var _this_kernel;
                (_this_kernel = this.kernel) === null || _this_kernel === void 0 ? void 0 : _this_kernel.stop(endState);
            }
        },
        {
            key: "appendNext",
            value: function appendNext(value) {
                var _this_kernel;
                return !!((_this_kernel = this.kernel) === null || _this_kernel === void 0 ? void 0 : _this_kernel.appendNext(value));
            }
        },
        {
            key: "preloadNext",
            value: function preloadNext() {
                for(var _len = arguments.length, confs = new Array(_len), _key = 0; _key < _len; _key++){
                    confs[_key] = arguments[_key];
                }
                var _this_kernel;
                var _this_kernel1;
                return (_this_kernel1 = this.kernel) === null || _this_kernel1 === void 0 ? void 0 : (_this_kernel = _this_kernel1).preloadNext.apply(_this_kernel, _(confs));
            }
        },
        {
            key: "clearAllPreload",
            value: function clearAllPreload() {
                var _this_kernel;
                (_this_kernel = this.kernel) === null || _this_kernel === void 0 ? void 0 : _this_kernel.clearAllPreload();
            }
        },
        {
            key: "triggerAutoplay",
            value: function triggerAutoplay() {
                var _this = this;
                var _this_kernel;
                if (!this.kernel) {
                    this.logger.log('triggerAutoplay(), start');
                    var func = function(el) {
                        var autoplay = new AutoPlayPolicy(el, {
                            instanceId: _this.playerConfig.instanceId
                        });
                        return autoplay.userTrigger();
                    };
                    var triggerPromises = this.playerConfig.videoElements.map(func);
                    return Promise.all(triggerPromises);
                }
                return (_this_kernel = this.kernel) === null || _this_kernel === void 0 ? void 0 : _this_kernel.triggerAutoplay();
            }
        },
        {
            key: "setAudioTrack",
            value: function setAudioTrack(id) {
                if (!this.kernel) {
                    return Promise.reject(new Error(AudioTrackErrorMsg.KERNEL_NOT_EXISTS));
                }
                return this.kernel.setAudioTrack(id);
            }
        },
        {
            key: "getAudioTrackList",
            value: function getAudioTrackList() {
                if (!this.currentVideoInfo) return [];
                return this.currentVideoInfo.audioTracks;
            }
        },
        {
            key: "getCurrentAudioTrack",
            value: function getCurrentAudioTrack() {
                if (!this.currentVideoInfo) return NaN;
                return this.currentVideoInfo.currentAudioTrack;
            }
        },
        {
            key: "setLevel",
            value: function setLevel(urlOrUrlConfig, backupUrls, extraConfig) {
                var _this = this;
                return _$c(function() {
                    var nextLevelUrlConfig, preVideoInfo, _ref, isKernelSwitched, error;
                    return _$d(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!_this.kernel) {
                                    return [
                                        2,
                                        Promise.reject(compile(i18nConfig.core.ERROR_KERNEL_NOT_FOUND))
                                    ];
                                }
                                // 切换清晰度时如果当前清晰度和下一个清晰度url类型不一样，可能会重新创建内核。
                                nextLevelUrlConfig = typeof urlOrUrlConfig === 'string' ? _$f(_$6({}, extraConfig), {
                                    url: urlOrUrlConfig
                                }) : urlOrUrlConfig;
                                preVideoInfo = _this.currentVideoInfo; // 检查时候可能销毁上一个内核，所以先缓存当前播放信息
                                return [
                                    4,
                                    _this.checkWhetherNeedToSwitchKernel(nextLevelUrlConfig, null, false)
                                ];
                            case 1:
                                _ref = _state.sent(), isKernelSwitched = _ref.isKernelSwitched, error = _ref.error;
                                if (error === null || error === void 0 ? void 0 : error.message) {
                                    return [
                                        2,
                                        Promise.reject(error === null || error === void 0 ? void 0 : error.message)
                                    ];
                                }
                                if (isKernelSwitched) {
                                    return [
                                        2,
                                        _this.setLevelWhenKernelSwitched(_$6(_$f(_$6({}, nextLevelUrlConfig), {
                                            backupUrls: backupUrls
                                        }), extraConfig), preVideoInfo)
                                    ];
                                }
                                // 直接在老的内核上切换清晰度
                                if (typeof urlOrUrlConfig === 'string') {
                                    return [
                                        2,
                                        _this.kernel.setLevel(urlOrUrlConfig, backupUrls, extraConfig)
                                    ];
                                }
                                return [
                                    2,
                                    _this.kernel.setLevel(urlOrUrlConfig)
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "on",
            value: function on(type, listener, priority) {
                _$g(_$h(KernelProxy.prototype), "on", this).call(this, type, listener, priority);
                this.proxyEvent(type);
                return this;
            }
        },
        {
            key: "once",
            value: function once(type, listener, priority) {
                _$g(_$h(KernelProxy.prototype), "once", this).call(this, type, listener, priority);
                this.proxyEvent(type, true);
                return this;
            }
        },
        {
            key: "destroy",
            value: /**
   * 销毁当前proxy
   */ function destroy() {
                var _this = this;
                var _this_videoElementsContainer, _this_playerConfig;
                if (this.isDestroyed) {
                    return;
                }
                this.unsetPlayerContainer();
                this.playerConfig.videoElements.forEach(function(videoElement) {
                    var _this_playerConfig_audioEffectController, _this_playerConfig;
                    (_this_playerConfig = _this.playerConfig) === null || _this_playerConfig === void 0 ? void 0 : (_this_playerConfig_audioEffectController = _this_playerConfig.audioEffectController) === null || _this_playerConfig_audioEffectController === void 0 ? void 0 : _this_playerConfig_audioEffectController.closeAudioSourceNode(videoElement);
                    if (_this.isSelfVideoElements) {
                        // 如果是内部创建的video组件，需要销毁。（外部传入的则由外部负责销毁）
                        videoTool.destroyElement(videoElement);
                    }
                });
                this.playerConfig.videoElements = null;
                if ((_this_videoElementsContainer = this.videoElementsContainer) === null || _this_videoElementsContainer === void 0 ? void 0 : _this_videoElementsContainer.parentNode) {
                    this.videoElementsContainer.remove();
                }
                NetTiming.disconnect((_this_playerConfig = this.playerConfig) === null || _this_playerConfig === void 0 ? void 0 : _this_playerConfig.instanceId);
                this.destroyKernel();
                this.removeAllListeners();
                this.kernelEvtFuncs = null;
                this.playerConfig = null;
                this.isDestroyed = true;
            }
        },
        {
            key: "checkWhetherNeedToSwitchKernel",
            value: /**
   * 检查是否需要切换内核。如果需要，则会销毁旧的内核，并创建新的内核。
   * @param urlConfig 传入的播放地址
   * @param emitStopEvent 是否需要派发Stop事件
   * @returns 是否有切换内核，如果没有旧的内核而创建了新的内核，也算切换。
   */ function checkWhetherNeedToSwitchKernel(urlConfig, extra) {
                var emitStopEvent = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
                var _this = this;
                return _$c(function() {
                    var checkUrlConfig, forceKernelName, selectedKernelName, kernelName;
                    return _$d(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this.logger.log('check switch kernel');
                                checkUrlConfig = _$2(urlConfig, Array) ? urlConfig[0] : urlConfig;
                                // 强制指定的内核优先取play/load接口的第二个参数中指定的，然后再取IUrlConfig上的
                                forceKernelName = (extra === null || extra === void 0 ? void 0 : extra.kernelName) || checkUrlConfig.kernelName;
                                selectedKernelName = KernelFactory.selectKernel(urlConfig, forceKernelName, _this.playerConfig.kernelPriority);
                                // KernelFactory.selectKernel返回类型是IVideoERROR，意味着强制内核是无法播放当前视频，直接提示错误
                                if (typeof selectedKernelName !== 'string') {
                                    return [
                                        2,
                                        {
                                            isKernelSwitched: false,
                                            error: selectedKernelName
                                        }
                                    ];
                                }
                                _this.logger.log('kernel select:', selectedKernelName);
                                if (!(selectedKernelName && !KernelFactory.kernelMap[selectedKernelName])) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    _this.loadKernel(selectedKernelName)
                                ];
                            case 1:
                                _state.sent();
                                _state.label = 2;
                            case 2:
                                // 被选中的内核不存在（未选中合适内核，或者被选中的内核加载失败），使用原生内核兜底播放
                                kernelName = KernelFactory.kernelMap[selectedKernelName] ? selectedKernelName : KernelName.ORIGIN;
                                // 1.如果kernelName不一样，需要先销毁旧的
                                if (_this.kernel && _this.kernel.kernelName !== kernelName) {
                                    // 如果已经触发播放（播放中），KernelProxy层需要补发STOPED事件出去，因为销毁当前内核的操作外部无法感知
                                    if (_this.kernel.played && emitStopEvent) {
                                        _this.emit(PlayEvent.STOPED, {
                                            videoInfo: _this.kernel.currentVideoInfo,
                                            endState: EndState.INTERRUPT
                                        });
                                    }
                                    _this.destroyKernel();
                                }
                                if (!!_this.kernel) return [
                                    3,
                                    4
                                ];
                                return [
                                    4,
                                    _this.createKernel(kernelName)
                                ];
                            case 3:
                                _state.sent();
                                return [
                                    2,
                                    {
                                        isKernelSwitched: true
                                    }
                                ];
                            case 4:
                                return [
                                    2,
                                    {
                                        isKernelSwitched: false
                                    }
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "loadKernel",
            value: /**
   * 尝试从远程加载内核文件。加载成功后会自动注册到window.ThumbplayerCore.KernelFactory
   * @param kernelName 内核名称
   * @param retryTimes 失败时重试次数
   * @returns 是否成功加载
   */ function loadKernel(kernelName) {
                var retryTimes = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 3;
                var _this = this;
                return _$c(function() {
                    var kernelCdnPath, loadSucc, loadSucc1, loadOption, maxAgeStr, scriptUrl, i;
                    return _$d(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                // 私有部署时不自动下载内核
                                if (_this.config.isPrivateDeployment) {
                                    return [
                                        2,
                                        false
                                    ];
                                }
                                kernelCdnPath = getKernelCdnPath(kernelName, _this.playerConfig.autoLoadKernelVerMap);
                                if (!kernelCdnPath) {
                                    return [
                                        2,
                                        false
                                    ];
                                }
                                if (!loadKernelDeferMap[kernelName]) return [
                                    3,
                                    2
                                ];
                                _this.logger.log("auto download kernel [".concat(kernelCdnPath, "] has been started!"));
                                return [
                                    4,
                                    loadKernelDeferMap[kernelName].promise
                                ];
                            case 1:
                                loadSucc = _state.sent();
                                _this.logger.log("auto download kernel [".concat(kernelCdnPath, "] succ=").concat(loadSucc));
                                return [
                                    2,
                                    loadSucc
                                ];
                            case 2:
                                loadKernelDeferMap[kernelName] = new SimpleDefer();
                                _this.logger.log("auto download kernel [".concat(kernelCdnPath, "]"));
                                // 开始加载js文件，使用for循环实现失败重试
                                loadSucc1 = false;
                                loadOption = {};
                                if (_this.playerConfig.crossOriginForScript) {
                                    loadOption.crossOrigin = _this.playerConfig.crossOriginForScript;
                                }
                                maxAgeStr = getMaxAgeStr(_this.playerConfig.kernelJsMaxAgeS);
                                scriptUrl = "".concat(CDN_PATH_PREFIX + kernelCdnPath).concat(maxAgeStr ? '?' : '').concat(maxAgeStr);
                                i = 0;
                                _state.label = 3;
                            case 3:
                                if (!(i < retryTimes)) return [
                                    3,
                                    9
                                ];
                                _state.label = 4;
                            case 4:
                                _state.trys.push([
                                    4,
                                    6,
                                    ,
                                    7
                                ]);
                                return [
                                    4,
                                    domTool.loadScript(scriptUrl, null, 10000, loadOption)
                                ];
                            case 5:
                                _state.sent();
                                if (_this.isDestroyed) {
                                    return [
                                        2,
                                        new Promise(function() {})
                                    ];
                                }
                                _this.logger.log("auto download kernel [".concat(kernelCdnPath, "] succ=true"));
                                loadSucc1 = true;
                                return [
                                    3,
                                    7
                                ];
                            case 6:
                                _state.sent();
                                loadSucc1 = false;
                                // 理论上加载失败也会走原生内核尝试播放，所以这里设计成不需要抛出异常，仅返回加载失败。
                                _this.logger.error("auto download kernel [".concat(kernelCdnPath, "] failed"));
                                return [
                                    3,
                                    7
                                ];
                            case 7:
                                if (loadSucc1) {
                                    return [
                                        3,
                                        9
                                    ];
                                }
                                _state.label = 8;
                            case 8:
                                i++;
                                return [
                                    3,
                                    3
                                ];
                            case 9:
                                loadKernelDeferMap[kernelName].resolve(loadSucc1);
                                return [
                                    2,
                                    loadSucc1
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "createKernel",
            value: /**
   * 创建内核实例。
   */ function createKernel(kernelName) {
                this.kernel = KernelFactory.createKernel(kernelName, this.playerConfig);
                if (typeof this.volumeInner !== 'undefined') {
                    this.kernel.volume = this.volumeInner;
                }
                if (typeof this.playbackRateInner !== 'undefined') {
                    this.kernel.playbackRate = this.playbackRateInner;
                }
                this.kernel.volumeGain = this.volumeGainInner;
                this.kernel.audioEffect = this.audioEffectInner;
                this.setKernelEvts(true);
            }
        },
        {
            key: "setPlayerContainer",
            value: /**
   * 从初始化播放器的配置中获取播放器的容器元素实例，并设置到 this.container 中
   * 创建时，检测 container 是否存在有其他实例，如果有，则抛出异常
   */ function setPlayerContainer() {
                var _this_playerConfig = this.playerConfig, container = _this_playerConfig.container, instanceId = _this_playerConfig.instanceId;
                var containerEl = typeof container === 'string' ? document.querySelector(container) : container;
                // 检查下能不能找到这个元素
                if (!containerEl) {
                    throw new Error("Container ".concat(container, " is not found."));
                }
                // 检测是否有其他实例正在使用这个容器
                if (containerEl.dataset[CONTAINER_DATASET_KEY]) {
                    // 有，抛出异常，终止此次初始化
                    var msg = "Container ".concat(container, " is used by another player instance. Canceling initialization...");
                    this.logger.error("@setPlayerContainer(): ".concat(msg));
                    throw new Error(msg);
                }
                // 设置标记，用于防止多次初始化
                containerEl.dataset[CONTAINER_DATASET_KEY] = instanceId;
                this.containerEl = containerEl;
            }
        },
        {
            key: "unsetPlayerContainer",
            value: /**
   * 回滚所有对 Container 的操作，移除事件监听器，清理 Container 容器
   */ function unsetPlayerContainer() {
                delete this.container.dataset[CONTAINER_DATASET_KEY];
                // ergou 遗留代码，本意是用于移除 container 上的所有事件监听器，但存在副作用以及其他问题（整合 Vue / React 时）
                // 这里最好的办法还是包装 container 上的 addEventListener 方法，记录下所有监听器的 callback，然后在这里 remove 掉
                // 这里先判断下，这个 DOM 在不在文档中，如果不在什么也不用做
                if (this.container.isConnected) {
                    var newEmptyDom = this.container.cloneNode();
                    this.container.parentNode.replaceChild(newEmptyDom, this.container);
                    this.containerEl = newEmptyDom;
                }
                // 清理容器
                this.containerEl.innerHTML = '';
            }
        },
        {
            key: "createVideoElementsContainer",
            value: /**
   * 创建包裹video标签的容器。
   */ function createVideoElementsContainer() {
                var _this = this, container = _this.container, playerConfig = _this.playerConfig;
                this.videoElementsContainer = domTool.createDom('\n      <div class="'.concat(VIDEO_CONTAINER_CLASS, '" style="').concat(playerConfig.videoContainerStyle, '">\n      </div>\n    ').trim());
                playerConfig.videoElementsContainer = this.videoElementsContainer;
                domTool.append(container, this.videoElementsContainer);
            }
        },
        {
            key: "setKernelEvts",
            value: /**
   * 代理kernel的事件，监听以后进行转发。（调用KernelProxy的once方法也完全没问题）
   */ function setKernelEvts(value) {
                var _this = this;
                if (!this.kernel) {
                    return;
                }
                if (value) {
                    // 保证kernel对任何事件只监听一次
                    this.setKernelEvts(false);
                }
                var func = value ? this.kernel.on : this.kernel.off;
                this.addedEvts.forEach(function(evtName) {
                    func.apply(_this.kernel, [
                        evtName,
                        _this.kernelEvtFuncs
                    ]);
                });
            }
        },
        {
            key: "kernelEvtHandler",
            value: function kernelEvtHandler(e) {
                if (this.setLevelWhenKernelSwitchedDefer) {
                    // 如果是新内核播放实现切换清晰度的情况下，切换中所有事件都不发出去，等切换成功
                    var isSetLevelOver = this.checkSetLevelOverWhenKernelSwitched(e);
                    if (isSetLevelOver) {
                        this.setLevelWhenKernelSwitchedDefer = null;
                    }
                } else {
                    var isIgnoreEvent = this.handlerInnerEvts(e);
                    if (!isIgnoreEvent) {
                        this.emit(e.type, e.data);
                    }
                }
            }
        },
        {
            key: "setLevelWhenKernelSwitched",
            value: /**
   * 需要换内核场景下的切清晰度。此情况下使用新内核直接播放视频，而不是在老的内核上执行setLevel逻辑，因为老的内核已经被销毁。
   */ function setLevelWhenKernelSwitched(urlConfig, preVideoInfo) {
                this.emit(PlayEvent.SETLEVEL_START, {
                    videoInfo: preVideoInfo,
                    mode: SetLevelMode.HARD
                });
                // 考虑以下case:
                // A内核在播放到中间切换到B内核，B内核未成功起播，然后再切回C内核，此时C内核起播已经丢失startTime（A内核的播放进度）。
                // 因此切换清晰度如果换了内核，那需要拿上一次播放内核的“被继承起播时间”，而不是上一个内核的playtime
                this.kernel.play(urlConfig, {
                    startTime: (preVideoInfo === null || preVideoInfo === void 0 ? void 0 : preVideoInfo.inheritedStartTimeS) || 0
                });
                this.setLevelWhenKernelSwitchedDefer = new SimpleDefer();
                return this.setLevelWhenKernelSwitchedDefer.promise;
            }
        },
        {
            key: "checkSetLevelOverWhenKernelSwitched",
            value: /**
   * 检查换内核方式下切换清晰度是否完成。
   * @returns 是否切换完成（无论成功还是失败）
   */ function checkSetLevelOverWhenKernelSwitched(e) {
                if (e.type === PlayEvent.STATE_CHANGE && e.data.new === VideoState.PLAYING) {
                    // 播放成功，代表切换成功
                    this.setLevelWhenKernelSwitchedDefer.resolve();
                    this.emit(PlayEvent.SETLEVEL_OVER, {
                        videoInfo: this.currentVideoInfo
                    });
                    return true;
                }
                if (e.type === PlayEvent.ERROR) {
                    var _e_data_videoInfo;
                    // 播放出错，代表切换失败
                    this.setLevelWhenKernelSwitchedDefer.reject((_e_data_videoInfo = e.data.videoInfo) === null || _e_data_videoInfo === void 0 ? void 0 : _e_data_videoInfo.error);
                    this.emit(PlayEvent.SETLEVEL_OVER, {
                        videoInfo: this.currentVideoInfo,
                        fail: true
                    });
                    return true;
                }
                return false;
            }
        },
        {
            key: "proxyEvent",
            value: /**
   * 代理事件
   * @param type 事件类型
   * @param isOnce 是否只执行一次
   */ function proxyEvent(type) {
                var isOnce = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
                // 1. 只要外部添加监听某个事件：
                // 首先会缓存事件名到数组中，其次当前播放内核就会添加该事件名的监听并在事件监听器中进行转发。转发者为kernel-proxy。
                // 2. 外部移除某个事件的监听：
                // 移除的是kernel-proxy上的监听，而不是kernel上的。kernel上的监听只在kernel被销毁的时候移除。
                if (this.addedEvts.includes(type)) return;
                this.addedEvts.push(type);
                if (!this.kernel) return;
                if (isOnce) {
                    this.kernel.once(type, this.kernelEvtFuncs);
                    return;
                }
                this.kernel.on(type, this.kernelEvtFuncs);
            }
        },
        {
            key: "checkConfigBeforeLoad",
            value: /**
   * 执行urlConfig播放前的内核检查，如果更换了格式，需要切换内核否则抛错
   */ function checkConfigBeforeLoad(urlConfig, extra) {
                var _this = this;
                return _$c(function() {
                    var error;
                    return _$d(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!urlConfig) {
                                    return [
                                        2
                                    ];
                                }
                                _this.timeStart(CoreStepKey.SEL_KERNEL);
                                return [
                                    4,
                                    _this.checkWhetherNeedToSwitchKernel(urlConfig, extra)
                                ];
                            case 1:
                                error = _state.sent().error;
                                _this.timeEnd(CoreStepKey.SEL_KERNEL);
                                if (error) {
                                    _this.emit(PlayEvent.ERROR, {
                                        videoInfo: {
                                            error: error
                                        }
                                    });
                                }
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "destroyKernel",
            value: /**
  * 销毁当前内核
  */ function destroyKernel() {
                if (this.kernel) {
                    this.emit(PlayEvent.KERNEL_DESTROY, {
                        kernelName: this.kernel.kernelName
                    });
                    this.setKernelEvts(false);
                    this.kernel.destroy();
                    this.kernel = null;
                }
            }
        },
        {
            key: "handlerInnerEvts",
            value: /**
   * 内部处理内核事件
   * @returns isIgnoreEvent 是否忽略事件，不对外转发
   */ function handlerInnerEvts(e) {
                if (e.type === PlayEvent.ERROR && this.kernel.kernelName === KernelName.DEMUX_2_FMP4) {
                    // 注意：这个demux2fmp4内核的回滚逻辑只能单个video播放有效，列表播放会有问题
                    var videoInfo = e.data.videoInfo;
                    var autoFallbackKernel = videoInfo.config.autoFallbackKernel;
                    if (!!autoFallbackKernel) {
                        this.logger.error("play err with ".concat(KernelName.DEMUX_2_FMP4, ", fallback to ").concat(KernelName.ORIGIN));
                        // demux2fmp4和origin内核功能相等，如果demux2fmp4内核失败，回退到origin内核再播放一次
                        this.play(videoInfo.config, {
                            startTime: videoInfo.playtime,
                            kernelName: KernelName.ORIGIN
                        });
                        return true;
                    }
                }
                return false;
            }
        }
    ]);
    return KernelProxy;
}(EvtEmitter);
_$7([
    performanceCost,
    _$8("design:type", Function),
    _$8("design:paramtypes", [
        Object,
        Object
    ]),
    _$8("design:returntype", Promise)
], KernelProxy.prototype, "play", null);
_$7([
    logMethodCall,
    _$8("design:type", Function),
    _$8("design:paramtypes", [
        Object,
        Object
    ]),
    _$8("design:returntype", Promise)
], KernelProxy.prototype, "load", null);
_$7([
    logMethodCall,
    _$8("design:type", Function),
    _$8("design:paramtypes", [
        Object
    ]),
    _$8("design:returntype", void 0)
], KernelProxy.prototype, "setAudioTrack", null);
_$7([
    logMethodCall,
    _$8("design:type", Function),
    _$8("design:paramtypes", [
        Object,
        Array,
        typeof IUrlConfig === "undefined" ? Object : IUrlConfig
    ]),
    _$8("design:returntype", Promise)
], KernelProxy.prototype, "setLevel", null);
_$7([
    logMethodCall,
    _$8("design:type", Function),
    _$8("design:paramtypes", []),
    _$8("design:returntype", void 0)
], KernelProxy.prototype, "destroy", null);
_$7([
    logMethodCall,
    _$8("design:type", Function),
    _$8("design:paramtypes", [
        String
    ]),
    _$8("design:returntype", void 0)
], KernelProxy.prototype, "createKernel", null);
KernelProxy = _$7([
    stepTimerClassDecorator,
    _$8("design:type", Function),
    _$8("design:paramtypes", [
        typeof IPlayerConfig === "undefined" ? Object : IPlayerConfig
    ])
], KernelProxy);
var KernelProxy$1 = KernelProxy;

/**
 * 结合浏览器环境能力和视频Meta信息判断内核类型是否可用，也控制在某些环境是否启用该内核，未引用内核也无需加载
 */ var kernelAvailable = {
    isHlsjsAvailable: function isHlsjsAvailable(metadata) {
        if (!metadata) {
            return false;
        }
        // 非hls格式无法播放，如果加密内容是Fairplay目前只能使用原生内核所以HLSjs也无法播放
        if (metadata.videoType !== VideoType.HLS || metadata.drmType === DrmType.FAIRPLAY) {
            return false;
        }
        // 如果是视频265编码，必须检查浏览器是否支持HEVC
        if (metadata.vcodec === Codec.H265 && !videoTool.supportHevc()) {
            return false;
        }
        // 如果是视频AV1编码，必须检查浏览器是否支持AV1
        if (metadata.vcodec === Codec.AV1 && !videoTool.supportAV1()) {
            return false;
        }
        // 如果环境是否支持MSE就可以使用hls
        return videoTool.supportMSE();
    },
    /**
   * 判断当前视频在Flvjs是否可播
   * @param metadata 视频播放数据信息
   * @returns 是否可播
   */ isFlvjsAvailable: function isFlvjsAvailable(metadata) {
        // 移动端不启用flv内核，尚无该场景使用需求，且没有验证过兼容性
        if (!metadata || uaTool.mobile) {
            return false;
        }
        // 非flv格式、加密内容播放均无法播放
        if (metadata.videoType !== VideoType.FLV || metadata.drmType !== DrmType.NONE) {
            return false;
        }
        // 如果是视频265编码，必须检查浏览器是否支持HEVC
        if (metadata.vcodec === Codec.H265 && !videoTool.supportHevc()) {
            return false;
        }
        // 如果是视频AV1编码，必须检查浏览器是否支持AV1
        if (metadata.vcodec === Codec.AV1 && !videoTool.supportAV1()) {
            return false;
        }
        // 如果环境是否支持MSE就可以使用flv
        return videoTool.supportMSE();
    },
    /**
   * 判断当前视频在Demux2fmp4内核是否可播
   * @param metadata 视频播放数据信息
   * @returns 是否可播
   */ isDemux2fmp4Available: function isDemux2fmp4Available(metadata) {
        if (!metadata) {
            return false;
        }
        // 只能播放MP4和MOV格式视频
        if (metadata.videoType !== VideoType.MP4 && metadata.videoType !== VideoType.MOV) {
            return false;
        }
        // 如果是视频265编码，必须检查浏览器是否支持HEVC
        if (metadata.vcodec !== undefined && metadata.vcodec !== Codec.H264) {
            return false;
        }
        // 如果环境支持MSE和流式fetch请求就可以使用2fmp4内核
        return videoTool.supportMSE() && videoTool.supportFetchStream();
    },
    /**
   * 判断当前视频在Webrtcplayer内核是否可播
   * @param metadata 视频播放数据信息
   * @returns 是否可播
   */ isWebrtcplayerAvailable: function isWebrtcplayerAvailable(metadata) {
        if (!metadata) {
            return false;
        }
        // 只能Webrtc协议能播放
        if (metadata.videoType !== VideoType.WEBRTC) {
            return false;
        }
        return videoTool.isWebRTCSupported();
    },
    /**
   * 判断当前视频在Wasmplayer是否可播
   * @param metadata 视频播放信息
   * @returns 是否可播
   */ isWasmplayerAvailble: function isWasmplayerAvailble(metadata) {
        // 移动端不能启用WASM，尚未验证兼容性
        if (!metadata || uaTool.mobile) {
            return false;
        }
        // WASM理论上能播放所有格式，所以无需判断videoType
        return videoTool.isWasmKernelSupported();
    },
    /**
   *判断当前视频在Electron环境是否可播，原则上Electron能播放所有格式，所以判断环境即可
   * @param metadata
   */ isElectronPlayerAailble: function isElectronPlayerAailble() {
        return /electron\//i.test(navigator.userAgent);
    }
};

/**
 * 通过urlConfig计算对应Metadata
 * @param urlConfig
 */ function createMetadata(urlConfig) {
    var metadata = {
        urlConfig: urlConfig,
        videoType: getUrlConfigVideoType(urlConfig),
        drmType: getDrmType(urlConfig),
        vcodec: urlConfig === null || urlConfig === void 0 ? void 0 : urlConfig.vcodec
    };
    return metadata;
}
/**
 * 通过urlConfig检查当前的加密类型，以便于选择对应内核
 */ function getDrmType(urlConfig) {
    var _urlConfig_drmConfig;
    // 如果带有chacha参数，则是自研加密
    if (urlConfig === null || urlConfig === void 0 ? void 0 : urlConfig.chachaParam) {
        return DrmType.CHACHA;
    }
    var keySystem = urlConfig === null || urlConfig === void 0 ? void 0 : (_urlConfig_drmConfig = urlConfig.drmConfig) === null || _urlConfig_drmConfig === void 0 ? void 0 : _urlConfig_drmConfig.keySystem;
    // KeySystems包含FairPlay
    if ([
        KeySystems.FairPlay,
        KeySystems.FairPlayWebKit
    ].includes(keySystem)) {
        return DrmType.FAIRPLAY;
    }
    // KeySystems包含Widevine
    if (KeySystems.Widevine === keySystem) {
        return DrmType.WIDEVINE;
    }
    return DrmType.NONE;
}

var UrlParamKey;
/** URL注入参数key名 */ (function(UrlParamKey) {
    UrlParamKey["forceKernel"] = "__forceKernel";
})(UrlParamKey || (UrlParamKey = {}));
/**
 * 按优先级顺序排列的内核名称数组，从高到低依次判断
 * ORIGIN作为兜底内核使用，原则上来说没有匹配上的，都尝试使用origin方式播放
 * WASM内核很特殊且使用有限制，所以不在列表里，如果需要使用只能外部指定
 */ var KERNEL_NAME_BY_PRIORITY = [
    KernelName.HLS_JS,
    KernelName.FLV_JS,
    KernelName.WEBRTC,
    KernelName.ORIGIN
];
var _obj;
/**
 * 从视频格式到内核名称的映射，这里是全量内核列表
 */ var VIDEO_TYPE_2_AVAILABEL_MAP = (_obj = {}, _$1(_obj, KernelName.HLS_JS, kernelAvailable.isHlsjsAvailable), _$1(_obj, KernelName.FLV_JS, kernelAvailable.isFlvjsAvailable), _$1(_obj, KernelName.WEBRTC, kernelAvailable.isWebrtcplayerAvailable), _$1(_obj, KernelName.DEMUX_2_FMP4, kernelAvailable.isDemux2fmp4Available), _$1(_obj, KernelName.ORIGIN, function() {
    return true;
}), _$1(_obj, KernelName.WASM, kernelAvailable.isWasmplayerAvailble), _$1(_obj, KernelName.WASM_AUDIOVIVID, kernelAvailable.isWasmplayerAvailble), _$1(_obj, KernelName.ELECTRON, kernelAvailable.isElectronPlayerAailble), _obj);
/*
 * 从视频格式到内核名称的映射
 */ ({
    flv: KernelName.FLV_JS,
    hls: KernelName.HLS_JS,
    webrtc: KernelName.WEBRTC
});
/**
 * 用于根据当前播放配置信息选择合适的播放内核名称
 */ var KernelSelector = /*#__PURE__*/ function() {
    function KernelSelector() {
        _$5(this, KernelSelector);
    }
    _$4(KernelSelector, [
        {
            key: "selectByURLConfig",
            value: /**
  * 根据播放配置自动选择选择播放内核。也可以强行指定播放内核名称，但仍然需要通过一些校验才会决定是否使用。
  * @param urlConfig 播放配置信息
  * @param forceKernelName 强制使用某种内核
  * @param kernelPriority 自定义内核选择时的优先级
  * @returns 被选择的内核名称
  */ function selectByURLConfig(urlConfig, forceKernelName, kernelPriority) {
                var metadata = createMetadata(urlConfig);
                // 优先级1：如果外部指定使用内核，一般用于debug或者引用方指定，所以优先级最高
                return this.selectKernelWithAssign(metadata, forceKernelName) || this.selectKernelInPresetMap(metadata, kernelPriority);
            }
        },
        {
            key: "selectKernelWithAssign",
            value: /**
   * 如果外部指定使用内核，无论如何都立即返回该内核
   */ function selectKernelWithAssign(metadata, forceKernelName) {
                var _VIDEO_TYPE_2_AVAILABEL_MAP_kernelName;
                var kernelName = forceKernelName;
                // 如果有通过url参数指定，无论如何都立即返回该内核，优先级比forceKernelName更高
                var kernelNameFromUrlParam = urlTool.getUrlParamByKey(location.href, "__forceKernel");
                // 指定内核在预设列表里才可以用
                if (kernelNameFromUrlParam && Object.keys(VIDEO_TYPE_2_AVAILABEL_MAP).includes(kernelNameFromUrlParam)) {
                    kernelName = kernelNameFromUrlParam;
                }
                // 外部指定了内核名称，并且是因为播放地址无法确定后缀而指定的，直接返回（否则通不过`VIDEO_TYPE_2_AVAILABEL_MAP`的校验）
                if (forceKernelName && metadata.videoType === VideoType.OTHER) {
                    return forceKernelName;
                }
                // forceKernel和URL都没有强制指定参数，直接返回走自动设定
                if (!kernelName) {
                    return null;
                }
                // 如果指定的内核可以播放该视频
                if ((_VIDEO_TYPE_2_AVAILABEL_MAP_kernelName = VIDEO_TYPE_2_AVAILABEL_MAP[kernelName]) === null || _VIDEO_TYPE_2_AVAILABEL_MAP_kernelName === void 0 ? void 0 : _VIDEO_TYPE_2_AVAILABEL_MAP_kernelName.call(VIDEO_TYPE_2_AVAILABEL_MAP, metadata)) {
                    return kernelName;
                }
                // 强制指定内核不能播放，返回错误
                var suggestKernelName = this.suggestKernelNameByMetadata(metadata, KERNEL_NAME_BY_PRIORITY);
                var isHEVCSupportIssue = metadata.vcodec === Codec.H265 && !videoTool.supportHevc() && (kernelName === KernelName.HLS_JS || kernelName === KernelName.FLV_JS); // 仅在HLS和FLV内核下才会出现HEVC支持问题
                var message = "".concat(kernelName !== KernelName.ORIGIN ? "".concat(kernelName, "内核") : '', "无法播放当前格式") + "".concat(suggestKernelName && suggestKernelName !== KernelName.ORIGIN ? "，请尝试使用".concat(suggestKernelName, "内核播放") : '');
                var hevcMessage = '当前浏览器不支持HEVC编码, 请尝试使用最新版本Google Chrome进行播放并检查硬件加速是否开启';
                return {
                    code: ErrorCode.MISSING_KERNEL,
                    message: isHEVCSupportIssue ? hevcMessage : message
                };
            }
        },
        {
            key: "selectKernelInPresetMap",
            value: /**
   * 根据视频信息选择可用的内核
   * @param metadata 视频信息
   * @param kernelPriority 外部有要求调整制定的内核顺序
   * @returns 内核名称
   */ function selectKernelInPresetMap(metadata, kernelPriority) {
                var kernelNames;
                // 如果有外部干预内核列表
                if (kernelPriority) {
                    kernelNames = kernelPriority;
                    // 把用户自定义列表中没有包含的内核也补上
                    for(var i = 0; i < KERNEL_NAME_BY_PRIORITY.length; i++){
                        if (kernelPriority.indexOf(KERNEL_NAME_BY_PRIORITY[i]) === -1) {
                            kernelNames.push(KERNEL_NAME_BY_PRIORITY[i]);
                        }
                    }
                } else {
                    kernelNames = KERNEL_NAME_BY_PRIORITY;
                }
                // 遍历当前所有的播放内核，看看哪个支持当前的视频类型
                return this.suggestKernelNameByMetadata(metadata, kernelNames);
            }
        },
        {
            key: "suggestKernelNameByMetadata",
            value: /**
  * 遍历当前所有的播放内核，看看哪个内核支持当前的视频类型
  * @param metadata 视频信息
  * @param kernelNames 内核列表
  */ function suggestKernelNameByMetadata(metadata, kernelNames) {
                if (!metadata) {
                    return null;
                }
                // 遍历当前所有的播放内核，看看哪个支持当前的视频类型
                for(var i = 0; i < kernelNames.length; i++){
                    var _VIDEO_TYPE_2_AVAILABEL_MAP_kernelName;
                    var kernelName = kernelNames[i];
                    if ((_VIDEO_TYPE_2_AVAILABEL_MAP_kernelName = VIDEO_TYPE_2_AVAILABEL_MAP[kernelName]) === null || _VIDEO_TYPE_2_AVAILABEL_MAP_kernelName === void 0 ? void 0 : _VIDEO_TYPE_2_AVAILABEL_MAP_kernelName.call(VIDEO_TYPE_2_AVAILABEL_MAP, metadata)) {
                        return kernelName;
                    }
                }
                return null;
            }
        },
        {
            key: "isKernelSupportByUrlConfig",
            value: /**
   * 根据kernelName和urlConfig验证该内核是否支持
   * @param kernelName 目标内核名称
   * @param urlConfig 视频信息
   * @returns 是否支持
   */ function isKernelSupportByUrlConfig(kernelName, urlConfig) {
                var isKernelAvailable = VIDEO_TYPE_2_AVAILABEL_MAP[kernelName];
                if (!isKernelAvailable) {
                    return false;
                }
                var metadata = createMetadata(urlConfig);
                return isKernelAvailable(metadata);
            }
        }
    ], [
        {
            key: "getSelector",
            value: function getSelector() {
                if (!this.selector) {
                    this.selector = new KernelSelector();
                }
                return this.selector;
            }
        }
    ]);
    return KernelSelector;
}();
// 提供静态实例，以便kernelFactory使用
_$1(KernelSelector, "selector", void 0);

var KernelFactory = /*#__PURE__*/ function() {
    function KernelFactory() {
        _$5(this, KernelFactory);
    }
    _$4(KernelFactory, null, [
        {
            key: "registerKernel",
            value: /**
   * 注册播放内核
   * @param kernelName 内核名称
   * @param kernel 内核的实现（类对象），可传入undefined相当于取消注册
   */ function registerKernel(kernelName, kernel) {
                if (this.kernelMap[kernelName]) {
                    var // 替换注册，执行注销 hook
                    _this_kernelMap_kernelName_unregister, _this_kernelMap_kernelName;
                    (_this_kernelMap_kernelName_unregister = (_this_kernelMap_kernelName = this.kernelMap[kernelName]).unregister) === null || _this_kernelMap_kernelName_unregister === void 0 ? void 0 : _this_kernelMap_kernelName_unregister.call(_this_kernelMap_kernelName);
                } else if (!this.kernelMap[kernelName] && kernel) {
                    var // 新注册播放内核时，执行内核注册 hook 方法
                    _kernel_register;
                    (_kernel_register = kernel.register) === null || _kernel_register === void 0 ? void 0 : _kernel_register.call(kernel);
                }
                // 修改为可以重复注册、替换注册
                this.kernelMap[kernelName] = kernel;
            }
        },
        {
            key: "createKernel",
            value: /**
 * 创建播放内核
 * @ignore
 */ function createKernel(kernelName, conf) {
                // 如果强制指定流类型的话
                if (kernelName) {
                    // eslint-disable-next-line @typescript-eslint/naming-convention
                    var KernelClass = KernelFactory.kernelMap[kernelName];
                    // 先检查是否有播放内核
                    if (!KernelClass) {
                        throw new Error("Can't find [".concat(kernelName, "] kernel"));
                    }
                    // 再检查播放环境是否支持播放内核
                    if (KernelClass.isEnvSupport) {
                        var inst = new KernelClass(conf);
                        if (KernelClass.exportApis) {
                            commonTool.assignApiToPrototype(inst, KernelProxy$1.prototype, KernelClass.exportApis);
                        }
                        return inst;
                    }
                    // 浏览器不支持
                    window.console.log("Browser does not support kernelName[".concat(kernelName, "]"));
                }
                return new KernelFactory.kernelMap.origin(conf);
            }
        },
        {
            key: "create",
            value: /**
   * @deprecated 创建thumbplayer-core实例，请使用new KernelProxy创建
   */ function create(conf) {
                // 较早设计，因为目前有外部调用，先使用废弃方式提示
                return new KernelProxy$1(conf);
            }
        },
        {
            key: "getKernelByName",
            value: /**
   * 根据播放内核名称获取播放内核的类对象
   */ function getKernelByName(kernelName) {
                return KernelFactory.kernelMap[kernelName];
            }
        },
        {
            key: "isKernelSupportByUrlConfig",
            value: /**
   * 检查某个播放内核是否支持指定的UrlConfig播放
   * @param kernelName 播放内核名称
   * @param urlConfig 指定的视频播放地址
   */ function isKernelSupportByUrlConfig(kernelName, urlConfig) {
                return KernelSelector.getSelector().isKernelSupportByUrlConfig(kernelName, urlConfig);
            }
        },
        {
            key: "selectKernel",
            value: /**
   * 根据播放配置自动选择选择播放内核。也可以强行指定播放内核名称，但仍然需要通过一些校验才会决定是否使用。
   * @param value 播放配置信息
   * @param forceKernelName 强制使用某种内核
   * @param kernelPriority 自定义内核选择时的优先级
   * @returns 被选择的内核名称
   */ function selectKernel(value, forceKernelName, kernelPriority) {
                var checkValue = _$2(value, Array) ? value[0] : value;
                return KernelSelector.getSelector().selectByURLConfig(checkValue, forceKernelName, kernelPriority);
            }
        }
    ]);
    return KernelFactory;
}();
_$1(KernelFactory, "kernelMap", {});
/**
 * 根据内核名称获取内核的cdn文件地址
 */ function getKernelCdnPath(kernelName) {
    var autoLoadKernelVerMap = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var version = autoLoadKernelVerMap[kernelName] || VERSION;
    var kernelCdnPrefix = "core/".concat(version);
    var _obj;
    var kernelName2CdnPathMap = (_obj = {}, _$1(_obj, KernelName.HLS_JS, 'txhlsjs-kernel.js'), _$1(_obj, KernelName.FLV_JS, 'flvjs-kernel.js'), _$1(_obj, KernelName.DEMUX_2_FMP4, 'demux2fmp4-kernel.js'), _$1(_obj, KernelName.WASM, 'wasm-kernel.js'), _$1(_obj, KernelName.WASM_AUDIOVIVID, 'wasm-audiovivid-kernel.js'), _$1(_obj, KernelName.WEBRTC, 'webrtc-kernel.js'), _obj);
    if (!kernelName2CdnPathMap[kernelName]) {
        return null;
    }
    return "".concat(kernelCdnPrefix, "/").concat(kernelName2CdnPathMap[kernelName]);
}

// 原生播放内核相关模块导出

var ThumbPlayerCore = /*#__PURE__*/Object.freeze({
  __proto__: null,
  MultiPlayer: MultiPlayer,
  OrgPlayer: OrgPlayer,
  OrgVideoNode: OrgVideoNode,
  OrgPreloader: OrgPreLoader,
  originDefaultConfig: defaultOriginKernelConfig,
  VideoInfo: VideoInfo,
  BaseVideoNode: BaseVideoNode,
  BasePlayer: BasePlayer,
  BaseLivePlayer: BaseLivePlayer,
  defaultPlayerConfig: defaultPlayerConfig,
  patchConfig: patchConfig,
  getUrlConfigVideoType: getUrlConfigVideoType,
  get DrmErrorCode () { return DrmErrorCode; },
  t: compile,
  compileI18n: compile,
  i18nTool: i18nTool,
  lsTool: lsTool,
  videoTool: videoTool,
  logTool: logTool,
  netTool: netTool,
  domTool: domTool,
  jsonTool: jsonTool,
  cookieTool: cookieTool,
  hashTool: hashTool,
  encodingTool: encodingTool,
  stringTool: stringTool,
  urlTool: urlTool,
  commonTool: commonTool,
  uaTool: uaTool,
  DrmKeySystems: KeySystems,
  HDR_CAPABILITY: HDR_CAPABILITY,
  EvtEmitter: EvtEmitter,
  SimpleDefer: SimpleDefer,
  costTimeEmitter: costTimeEmitter,
  performanceCostDecoratorCreator: performanceCostDecoratorCreator,
  logMethodCallDecoratorCreator: logMethodCallDecoratorCreator,
  destroyProtectDecorator: destroyProtectDecorator,
  logMethodCallDecoratorCreater: logMethodCallDecoratorCreator,
  stepTimerClassDecorator: stepTimerClassDecorator,
  onceDecorator: once,
  StepTimer: StepTimer,
  KernelStepKey: KernelStepKey,
  requireModule: requireModule,
  mountGlobal: mountGlobal,
  getEventEmitterBinder: getEventEmitterBinder,
  getEventTargetBinder: getEventTargetBinder,
  TaskLoop: TaskLoop,
  LoopMode: LoopMode,
  ResizeObserver: ResizeObserver,
  ResizeObserverPolyfilled: ResizeObserverPolyfilled,
  checkVolumeValidWithMessage: checkVolumeValidWithMessage,
  KernelFactory: KernelFactory,
  KernelProxy: KernelProxy$1,
  ReferenceReport: ReferenceReport,
  Logger: Logger,
  get LogMode () { return LogMode; },
  dumpLog: dumpLog,
  kernelEvtBus: kernelEvtBus,
  preloadEvtBus: preloadEvtBus,
  CAN_PLAY_ALL: CAN_PLAY_ALL,
  VIDEO_CONTAINER_CLASS: VIDEO_CONTAINER_CLASS,
  VIDEO_CONTAINER_STYLE: VIDEO_CONTAINER_STYLE,
  get PlaybackErrorCode () { return PlaybackErrorCode; },
  get VideoElementNetworkErrorCode () { return VideoElementNetworkErrorCode; },
  CDN_PATH_PREFIX: CDN_PATH_PREFIX,
  get CoreStepKey () { return CoreStepKey; },
  get AUDIO_TRACK_ERROR_MSG () { return AudioTrackErrorMsg; },
  get SET_LEVEL_MODE () { return SetLevelMode; },
  get PLAY_MODE () { return PlayMode; },
  get END_STATE () { return EndState; },
  get VIDEO_READY_STATE () { return VideoReadyState; },
  get VIDEO_EVTS () { return VideoEvts; },
  get VIDEO_STATE () { return VideoState; },
  get ERROR_CODE () { return ErrorCode; },
  get ERROR_MSG () { return ErrorMsg; },
  get PLAY_EVENT () { return PlayEvent; },
  get PRELOAD_EVENT () { return PreloadEvent; },
  get VIDEO_NODE_EVENT () { return VideoNodeEvent; },
  get PAUSE_TYPE () { return PauseType; },
  get PLAYER_LOG_LEVEL () { return PlayerLogLevel; },
  get PRELOAD_TYPE () { return PreloadType; },
  get CODEC () { return Codec; },
  get VIDEO_CODEC () { return VideoCodec; },
  get AUDIO_CODEC () { return AudioCodec; },
  get CONTAINER_FORMAT () { return ContainerFormat; },
  get VIDEO_ELEMENT_STATE () { return VideoElementState; },
  get CACHE_SIZE_KEY () { return CacheSizeKey; },
  get DRM_TYPE () { return DrmType; },
  get VIDEO_TYPE () { return VideoType; },
  get KERNEL_NAME () { return KernelName; },
  get TPColorPrimaries () { return TPColorPrimaries; },
  get TPTransferCharacteristics () { return TPTransferCharacteristics; },
  defaultI18nConfig: defaultI18nConfig,
  i18nConfig: i18nConfig,
  commonErrorParse: commonErrorParse,
  getVideoError: getVideoError,
  CHANNEL: CHANNEL,
  BUILD_TIME: BUILD_TIME,
  VERSION: VERSION,
  LOCAL_DEV: LOCAL_DEV,
  ErrorTypeCodeMap: ErrorTypeCodeMap,
  get MediaElementNativeDetail () { return MediaElementNativeDetail; },
  PlayerError: PlayerError,
  ErrorBase: ErrorBase,
  get TpCoreError () { return BuiltInErrorType; },
  NetTimingObserver: NetTimingObserver,
  NetTiming: NetTiming,
  getVideoNetworkDetail: getVideoNetworkDetail
});

// 播放器自带原生播放内核
KernelFactory.registerKernel(KernelName.ORIGIN, OrgPlayer);
// 只在 npm 打包后挂载，给 CDN 内核获取 Core
{
    mountGlobal({
        globalName: 'ThumbPlayerCore',
        target: ThumbPlayerCore,
        onDuplicate: function onDuplicate() {
            console.warn('Possible duplicated ThumbPlayerCore detected. Avoid to import this package multiple times.');
        }
    });
}

export { AudioCodec as AUDIO_CODEC, AudioTrackErrorMsg as AUDIO_TRACK_ERROR_MSG, BUILD_TIME, BaseLivePlayer, BasePlayer, BaseVideoNode, CacheSizeKey as CACHE_SIZE_KEY, CAN_PLAY_ALL, CDN_PATH_PREFIX, CHANNEL, Codec as CODEC, ContainerFormat as CONTAINER_FORMAT, CoreStepKey, DrmType as DRM_TYPE, DrmErrorCode, EndState as END_STATE, ErrorCode as ERROR_CODE, ErrorMsg as ERROR_MSG, ErrorBase, ErrorTypeCodeMap, KernelName as KERNEL_NAME, KernelFactory, KernelProxy$1 as KernelProxy, LOCAL_DEV, LogMode, Logger, MediaElementNativeDetail, MultiPlayer, NetTiming, NetTimingObserver, OrgPlayer, OrgPreLoader as OrgPreloader, OrgVideoNode, PauseType as PAUSE_TYPE, PlayerLogLevel as PLAYER_LOG_LEVEL, PlayEvent as PLAY_EVENT, PlayMode as PLAY_MODE, PreloadEvent as PRELOAD_EVENT, PreloadType as PRELOAD_TYPE, PlaybackErrorCode, PlayerError, ReferenceReport, SetLevelMode as SET_LEVEL_MODE, TPColorPrimaries, TPTransferCharacteristics, BuiltInErrorType as TpCoreError, VERSION, VideoCodec as VIDEO_CODEC, VIDEO_CONTAINER_CLASS, VIDEO_CONTAINER_STYLE, VideoElementState as VIDEO_ELEMENT_STATE, VideoEvts as VIDEO_EVTS, VideoNodeEvent as VIDEO_NODE_EVENT, VideoReadyState as VIDEO_READY_STATE, VideoState as VIDEO_STATE, VideoType as VIDEO_TYPE, VideoElementNetworkErrorCode, VideoInfo, clearLogCache, commonErrorParse, commonTool, compile as compileI18n, cookieTool, ThumbPlayerCore as default, defaultI18nConfig, defaultPlayerConfig, domTool, dumpLog, encodingTool, getLogCache, getUrlConfigVideoType, getVideoError, getVideoNetworkDetail, hashTool, i18nConfig, i18nTool, jsonTool, kernelEvtBus, logTool, lsTool, netTool, defaultOriginKernelConfig as originDefaultConfig, patchConfig, preloadEvtBus, stringTool, compile as t, uaTool, urlTool, videoTool };
